//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
export class SnapshotsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    getInitialData(query) {
        let url_ = this.baseUrl + "/api/snapshots/getinitialdata";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetInitialData(_response);
        });
    }
    processGetInitialData(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SnapshotDataModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSystemData(query) {
        let url_ = this.baseUrl + "/api/snapshots/getsystemdata";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemData(_response);
        });
    }
    processGetSystemData(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SnapshotDataModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getDateData(query) {
        let url_ = this.baseUrl + "/api/snapshots/getdatedata";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetDateData(_response);
        });
    }
    processGetDateData(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SnapshotDataModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getStringDetail(query) {
        let url_ = this.baseUrl + "/api/snapshots/getstringdetail";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStringDetail(_response);
        });
    }
    processGetStringDetail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SnapshotDataModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ProgressMessagesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * The signed-in user's background tasks, newest first.
     */
    getForUser() {
        let url_ = this.baseUrl + "/api/progressmessages/getforuser";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetForUser(_response);
        });
    }
    processGetForUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ProgressMessageModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Asks one of the signed-in user's queued or running background tasks to stop. Work it already finished is kept; the task's entry shows the outcome when it has stopped.
     */
    cancel(id) {
        let url_ = this.baseUrl + "/api/progressmessages/cancel/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCancel(_response);
        });
    }
    processCancel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Dismisses one of the signed-in user's finished background tasks.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/progressmessages/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Dismisses all of the signed-in user's finished background tasks.
     */
    deleteFinished() {
        let url_ = this.baseUrl + "/api/progressmessages/deletefinished";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteFinished(_response);
        });
    }
    processDeleteFinished(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class TimeZonesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of IANA time zones available on the server.
     */
    getList() {
        let url_ = this.baseUrl + "/api/timezones/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(TimeZoneListItemModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class StatisticsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get saved settings for Battery Life Prediction.
     * @param companyId (optional)
     */
    getBatteryLifePredictionSettings(companyId) {
        let url_ = this.baseUrl + "/api/statistics/getbatterylifepredictionsettings?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetBatteryLifePredictionSettings(_response);
        });
    }
    processGetBatteryLifePredictionSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(BatteryLifePredictionSettingsModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Upload predictions for components.
     */
    predictions(model) {
        let url_ = this.baseUrl + "/api/statistics/predictions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processPredictions(_response);
        });
    }
    processPredictions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class SMTPImportSettingsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of SMTP Importer Settings.
     */
    getList() {
        let url_ = this.baseUrl + "/api/smtpimportsettings/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SMTPImporterSettingsModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated of SMTP Importer Settings.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/smtpimportsettings/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfSMTPImporterSettingsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new SMTP Importer Setting.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/smtpimportsettings/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update SMTP Importer Setting.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/smtpimportsettings/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete SMTP Importer Setting. Record will be permanently deleted.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/smtpimportsettings/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SettingsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get saved settings for Ohmic Trend Report.
     * @param systemId (optional)
     */
    getOhmicTrendReportSettingsForSystem(systemId) {
        let url_ = this.baseUrl + "/api/settings/getohmictrendreportsettingsforsystem?";
        if (systemId === null)
            throw new globalThis.Error("The parameter 'systemId' cannot be null.");
        else if (systemId !== undefined)
            url_ += "systemId=" + encodeURIComponent("" + systemId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetOhmicTrendReportSettingsForSystem(_response);
        });
    }
    processGetOhmicTrendReportSettingsForSystem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OhmicTrendReportSettings.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get saved settings for String Life Report.
     * @param companyId (optional)
     */
    getStringLifeReportSettingsForCompany(companyId) {
        let url_ = this.baseUrl + "/api/settings/getstringlifereportsettingsforcompany?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStringLifeReportSettingsForCompany(_response);
        });
    }
    processGetStringLifeReportSettingsForCompany(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = StringLifeReportSettings.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get saved settings for Issue Site Summary Settings.
     * @param companyId (optional)
     */
    getIssueSiteSummaryReportSettingsForCompany(companyId) {
        let url_ = this.baseUrl + "/api/settings/getissuesitesummaryreportsettingsforcompany?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetIssueSiteSummaryReportSettingsForCompany(_response);
        });
    }
    processGetIssueSiteSummaryReportSettingsForCompany(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = IssueSiteSummarySettingsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get saved settings for Battery Replacement Report.
     * @param companyId (optional)
     */
    getBatteryReplacementEstimationSettingsForCompany(companyId) {
        let url_ = this.baseUrl + "/api/settings/getbatteryreplacementestimationsettingsforcompany?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetBatteryReplacementEstimationSettingsForCompany(_response);
        });
    }
    processGetBatteryReplacementEstimationSettingsForCompany(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BatteryReplacementEstimationSettings.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ReportClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a List of reports available.
     */
    getReportList(query) {
        let url_ = this.baseUrl + "/api/report/getreportlist";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetReportList(_response);
        });
    }
    processGetReportList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ReportModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a List of Users Ids allowed to access the report.
     */
    getReportCompanyPermissions(query) {
        let url_ = this.baseUrl + "/api/report/getreportcompanypermissions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetReportCompanyPermissions(_response);
        });
    }
    processGetReportCompanyPermissions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReportPermissionUsersModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Save Report Permissions.
     */
    saveReportPermissions(command) {
        let url_ = this.baseUrl + "/api/report/savereportpermissions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSaveReportPermissions(_response);
        });
    }
    processSaveReportPermissions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ReportModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a List of scheduled reports for a particular report.
     */
    getScheduledReportList(query) {
        let url_ = this.baseUrl + "/api/report/getscheduledreportlist";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetScheduledReportList(_response);
        });
    }
    processGetScheduledReportList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ReportScheduleModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new Scheduled Report.
     */
    createScheduledReport(command) {
        let url_ = this.baseUrl + "/api/report/createscheduledreport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateScheduledReport(_response);
        });
    }
    processCreateScheduledReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Update a Scheduled Report.
     */
    updateScheduledReport(id, command) {
        let url_ = this.baseUrl + "/api/report/updatescheduledreport/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateScheduledReport(_response);
        });
    }
    processUpdateScheduledReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a Scheduled Report.
     */
    deleteScheduledReport(id) {
        let url_ = this.baseUrl + "/api/report/deletescheduledreport/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteScheduledReport(_response);
        });
    }
    processDeleteScheduledReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore a Scheduled Report.
     */
    restoreScheduledReport(id) {
        let url_ = this.baseUrl + "/api/report/restorescheduledreport/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestoreScheduledReport(_response);
        });
    }
    processRestoreScheduledReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of contacts for the companies that the current user belongs to.
     * @param companyId (optional)
     */
    getContactListForScheduledReport(companyId) {
        let url_ = this.baseUrl + "/api/report/getcontactlistforscheduledreport?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetContactListForScheduledReport(_response);
        });
    }
    processGetContactListForScheduledReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContactsForScheduleReportModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Upsert Automatic Discharge Report Settings.
     */
    upsertAutomaticDischargeReportSettings(command) {
        let url_ = this.baseUrl + "/api/report/upsertautomaticdischargereportsettings";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpsertAutomaticDischargeReportSettings(_response);
        });
    }
    processUpsertAutomaticDischargeReportSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Get the Automatic Discharge Report Settings for a company
     */
    getAutomaticDischargeReportSettingsForCompany(companyId) {
        let url_ = this.baseUrl + "/api/report/getautomaticdischargereportsettingsforcompany/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAutomaticDischargeReportSettingsForCompany(_response);
        });
    }
    processGetAutomaticDischargeReportSettingsForCompany(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AutomaticDischargeReportModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Report Logs
     */
    getReportScheduledLogs(query) {
        let url_ = this.baseUrl + "/api/report/getreportscheduledlogs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetReportScheduledLogs(_response);
        });
    }
    processGetReportScheduledLogs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfReportLogModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the PDF file in a Report Log
     */
    getReportLogFile(id) {
        let url_ = this.baseUrl + "/api/report/getreportlogfile/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetReportLogFile(_response);
        });
    }
    processGetReportLogFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class MeClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get personal user profile.
     */
    get() {
        let url_ = this.baseUrl + "/api/me/get";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the group-controlled features the signed-in user can use.
     */
    features() {
        let url_ = this.baseUrl + "/api/me/features";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFeatures(_response);
        });
    }
    processFeatures(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update personal user profile.
     */
    update(model) {
        let url_ = this.baseUrl + "/api/me/update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Update personal user password.
     */
    updatePassword(model) {
        let url_ = this.baseUrl + "/api/me/updatepassword";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdatePassword(_response);
        });
    }
    processUpdatePassword(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Accept terms of use.
     */
    acceptTerms() {
        let url_ = this.baseUrl + "/api/me/acceptterms";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAcceptTerms(_response);
        });
    }
    processAcceptTerms(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Get Administrator users for the user Company.
     */
    getClientAdminUserListForClientUser() {
        let url_ = this.baseUrl + "/api/me/getclientadminuserlistforclientuser";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetClientAdminUserListForClientUser(_response);
        });
    }
    processGetClientAdminUserListForClientUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(UserModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class LookupsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get alarm scopes.
     */
    getAlarmScopes() {
        let url_ = this.baseUrl + "/api/lookups/getalarmscopes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAlarmScopes(_response);
        });
    }
    processGetAlarmScopes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AlarmScopeModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get alarm severities.
     */
    getAlarmSeverities() {
        let url_ = this.baseUrl + "/api/lookups/getalarmseverities";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAlarmSeverities(_response);
        });
    }
    processGetAlarmSeverities(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AlarmSeverityModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get manufacturers.
     * @param companyId (optional)
     */
    getManufacturers(companyId) {
        let url_ = this.baseUrl + "/api/lookups/getmanufacturers?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetManufacturers(_response);
        });
    }
    processGetManufacturers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ManufacturerModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get measurement types.
     */
    getMeasurementTypes() {
        let url_ = this.baseUrl + "/api/lookups/getmeasurementtypes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetMeasurementTypes(_response);
        });
    }
    processGetMeasurementTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MeasurementTypeModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get measurement categories.
     */
    getMeasurementCategories() {
        let url_ = this.baseUrl + "/api/lookups/getmeasurementcategories";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetMeasurementCategories(_response);
        });
    }
    processGetMeasurementCategories(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MeasurementCategoryModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get measurement categories with measurement types.
     * @param multipleAmbientTemperature (optional)
     */
    getMeasurementCategoriesWithMeasurementTypes(multipleAmbientTemperature) {
        let url_ = this.baseUrl + "/api/lookups/getmeasurementcategorieswithmeasurementtypes?";
        if (multipleAmbientTemperature === null)
            throw new globalThis.Error("The parameter 'multipleAmbientTemperature' cannot be null.");
        else if (multipleAmbientTemperature !== undefined)
            url_ += "multipleAmbientTemperature=" + encodeURIComponent("" + multipleAmbientTemperature) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetMeasurementCategoriesWithMeasurementTypes(_response);
        });
    }
    processGetMeasurementCategoriesWithMeasurementTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MeasurementCategoryModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get models.
     * @param companyId (optional)
     * @param manufacturerId (optional)
     */
    getModels(companyId, manufacturerId) {
        let url_ = this.baseUrl + "/api/lookups/getmodels?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (manufacturerId !== undefined && manufacturerId !== null)
            url_ += "manufacturerId=" + encodeURIComponent("" + manufacturerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetModels(_response);
        });
    }
    processGetModels(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(Model.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get component types.
     */
    getComponentTypes() {
        let url_ = this.baseUrl + "/api/lookups/getcomponenttypes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetComponentTypes(_response);
        });
    }
    processGetComponentTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ComponentTypeModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get maintenance log types.
     */
    getMaintenanceLogTypes() {
        let url_ = this.baseUrl + "/api/lookups/getmaintenancelogtypes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetMaintenanceLogTypes(_response);
        });
    }
    processGetMaintenanceLogTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MaintenanceLogTypeModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get string states.
     */
    getStringStates() {
        let url_ = this.baseUrl + "/api/lookups/getstringstates";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStringStates(_response);
        });
    }
    processGetStringStates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(StringStatusModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get limit layouts.
     */
    getLimitLayouts() {
        let url_ = this.baseUrl + "/api/lookups/getlimitlayouts";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetLimitLayouts(_response);
        });
    }
    processGetLimitLayouts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(LimitLayoutModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get notification channels
     */
    getNotificationChannels() {
        let url_ = this.baseUrl + "/api/lookups/getnotificationchannels";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetNotificationChannels(_response);
        });
    }
    processGetNotificationChannels(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(NotificationChannelModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getEnums() {
        let url_ = this.baseUrl + "/api/lookups/getenums";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetEnums(_response);
        });
    }
    processGetEnums(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EnumModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of users for companies that the current user has access to.
     * @param companyId (optional)
     */
    getUsersForMyCompanies(companyId) {
        let url_ = this.baseUrl + "/api/lookups/getusersformycompanies?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetUsersForMyCompanies(_response);
        });
    }
    processGetUsersForMyCompanies(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(UserModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of battery types
     */
    getBatteryTypes() {
        let url_ = this.baseUrl + "/api/lookups/getbatterytypes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetBatteryTypes(_response);
        });
    }
    processGetBatteryTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(KeyValueModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of lithium battery types
     */
    getLithiumBatteryTypes() {
        let url_ = this.baseUrl + "/api/lookups/getlithiumbatterytypes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetLithiumBatteryTypes(_response);
        });
    }
    processGetLithiumBatteryTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(KeyValueModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class MeasurementErrorCodesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    getAll() {
        let url_ = this.baseUrl + "/api/measurementerrorcodes/getall";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAll(_response);
        });
    }
    processGetAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ErrorCodeDescription.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    get(errorCode, alarmDefinitionName) {
        let url_ = this.baseUrl + "/api/measurementerrorcodes/get/{errorCode}?";
        if (errorCode === undefined || errorCode === null)
            throw new globalThis.Error("The parameter 'errorCode' must be defined.");
        url_ = url_.replace("{errorCode}", encodeURIComponent("" + errorCode));
        if (alarmDefinitionName !== undefined && alarmDefinitionName !== null)
            url_ += "alarmDefinitionName=" + encodeURIComponent("" + alarmDefinitionName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ErrorCodeDescription.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getRange(minCode, maxCode, alarmDefinitionName) {
        let url_ = this.baseUrl + "/api/measurementerrorcodes/getrange/range?";
        if (minCode === null)
            throw new globalThis.Error("The parameter 'minCode' cannot be null.");
        else if (minCode !== undefined)
            url_ += "minCode=" + encodeURIComponent("" + minCode) + "&";
        if (maxCode === null)
            throw new globalThis.Error("The parameter 'maxCode' cannot be null.");
        else if (maxCode !== undefined)
            url_ += "maxCode=" + encodeURIComponent("" + maxCode) + "&";
        if (alarmDefinitionName !== undefined && alarmDefinitionName !== null)
            url_ += "alarmDefinitionName=" + encodeURIComponent("" + alarmDefinitionName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetRange(_response);
        });
    }
    processGetRange(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SMTPImporterClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Add a new Log into SMTP Import Logs.
     */
    addLog(command) {
        let url_ = this.baseUrl + "/api/smtpimporter/addlog";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddLog(_response);
        });
    }
    processAddLog(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Add a new Email Log into SMTP Import Logs.
     */
    addEmailLog(command) {
        let url_ = this.baseUrl + "/api/smtpimporter/addemaillog";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddEmailLog(_response);
        });
    }
    processAddEmailLog(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Add a new File Log into SMTP Import Logs.
     */
    addFileLog(command) {
        let url_ = this.baseUrl + "/api/smtpimporter/addfilelog";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddFileLog(_response);
        });
    }
    processAddFileLog(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Update a Log in the SMTP Import Logs.
     */
    updateLog(command) {
        let url_ = this.baseUrl + "/api/smtpimporter/updatelog";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateLog(_response);
        });
    }
    processUpdateLog(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Update a Email Log in the SMTP Import Logs.
     */
    updateEmailLog(command) {
        let url_ = this.baseUrl + "/api/smtpimporter/updateemaillog";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateEmailLog(_response);
        });
    }
    processUpdateEmailLog(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Update a File Log in the SMTP Import Logs.
     */
    updateFileLog(command) {
        let url_ = this.baseUrl + "/api/smtpimporter/updatefilelog";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateFileLog(_response);
        });
    }
    processUpdateFileLog(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Add a Message Log into SMTP Import Logs.
     */
    addMessageLog(command) {
        let url_ = this.baseUrl + "/api/smtpimporter/addmessagelog";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddMessageLog(_response);
        });
    }
    processAddMessageLog(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Get the Date/Time that the SMTP Importer process was executed
     */
    getLastProcessDateTime() {
        let url_ = this.baseUrl + "/api/smtpimporter/getlastprocessdatetime";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetLastProcessDateTime(_response);
        });
    }
    processGetLastProcessDateTime(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Set the Date/Time that the SMTP Importer process was executed
     */
    setLastProcessDateTime(date) {
        let url_ = this.baseUrl + "/api/smtpimporter/setlastprocessdatetime";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(date);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetLastProcessDateTime(_response);
        });
    }
    processSetLastProcessDateTime(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Set the Date/Time that the SMTP Importer process was executed
     * @param mailbox (optional)
     */
    getLastUniqueIdForMailbox(mailbox) {
        let url_ = this.baseUrl + "/api/smtpimporter/getlastuniqueidformailbox?";
        if (mailbox !== undefined && mailbox !== null)
            url_ += "mailbox=" + encodeURIComponent("" + mailbox) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetLastUniqueIdForMailbox(_response);
        });
    }
    processGetLastUniqueIdForMailbox(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Get Duplicated Messages based on MessageId
     */
    getDuplicatedMessages(query) {
        let url_ = this.baseUrl + "/api/smtpimporter/getduplicatedmessages";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetDuplicatedMessages(_response);
        });
    }
    processGetDuplicatedMessages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Get a Paginated List of SMTP Import Logs
     */
    getLogs(query) {
        let url_ = this.baseUrl + "/api/smtpimporter/getlogs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetLogs(_response);
        });
    }
    processGetLogs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfSMTPImportLogModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a Paginated List of SMTP Import Logs
     */
    getLogDetails(query) {
        let url_ = this.baseUrl + "/api/smtpimporter/getlogdetails";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetLogDetails(_response);
        });
    }
    processGetLogDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SMTPImportLogDetailModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Check for Alarms already Uploaded.
     */
    getDuplicatedAlarms(alarms) {
        let url_ = this.baseUrl + "/api/smtpimporter/getduplicatedalarms";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(alarms);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetDuplicatedAlarms(_response);
        });
    }
    processGetDuplicatedAlarms(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class DataTransferClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Register system configuration based on data received from on-site device.
     */
    system(command) {
        let url_ = this.baseUrl + "/api/datatransfer/system";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSystem(_response);
        });
    }
    processSystem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RegisterSystemResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Upload alarms.
     */
    alarms(command) {
        let url_ = this.baseUrl + "/api/datatransfer/alarms";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAlarms(_response);
        });
    }
    processAlarms(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UploadAlarmsResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Upload limits and assign them to specified components.
     */
    limits(command) {
        let url_ = this.baseUrl + "/api/datatransfer/limits";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processLimits(_response);
        });
    }
    processLimits(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UploadLimitsResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Upload measurements for system components.
     */
    measurements(command) {
        let url_ = this.baseUrl + "/api/datatransfer/measurements";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processMeasurements(_response);
        });
    }
    processMeasurements(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UploadMeasurementsResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Sign that all measurements for a charge/discharge event are uploaded
     */
    measurementsUploaded(alarmGroupId) {
        let url_ = this.baseUrl + "/api/datatransfer/measurementsuploaded/{alarmGroupId}";
        if (alarmGroupId === undefined || alarmGroupId === null)
            throw new globalThis.Error("The parameter 'alarmGroupId' must be defined.");
        url_ = url_.replace("{alarmGroupId}", encodeURIComponent("" + alarmGroupId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processMeasurementsUploaded(_response);
        });
    }
    processMeasurementsUploaded(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UploadStringSnapshotsResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Upload block snapshots for system components.
     */
    blocksnapshots(command) {
        let url_ = this.baseUrl + "/api/datatransfer/blocksnapshots";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processBlocksnapshots(_response);
        });
    }
    processBlocksnapshots(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UploadBlockSnapshotsResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Upload string snapshots for system components.
     */
    stringsnapshots(command) {
        let url_ = this.baseUrl + "/api/datatransfer/stringsnapshots";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processStringsnapshots(_response);
        });
    }
    processStringsnapshots(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UploadStringSnapshotsResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Upload system snapshots for lithium batteries system
     */
    systemsnapshots(command) {
        let url_ = this.baseUrl + "/api/datatransfer/systemsnapshots";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSystemsnapshots(_response);
        });
    }
    processSystemsnapshots(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UploadSystemSnapshotsResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Upload measurement snapshots for system components.
     */
    measurementsnapshots(command) {
        let url_ = this.baseUrl + "/api/datatransfer/measurementsnapshots";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processMeasurementsnapshots(_response);
        });
    }
    processMeasurementsnapshots(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UploadBlockSnapshotsResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Update system communication statistics.
     */
    systemcommunication(command) {
        let url_ = this.baseUrl + "/api/datatransfer/systemcommunication";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSystemcommunication(_response);
        });
    }
    processSystemcommunication(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateCommunicationsResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Report the outcome of a UDP connectivity test received from a Controller.
     */
    connectivitytest(command) {
        let url_ = this.baseUrl + "/api/datatransfer/connectivitytest";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processConnectivitytest(_response);
        });
    }
    processConnectivitytest(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ConnectivityTestResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Replace registration key of system component.
     * @param requestId (optional) Identifies the registration key request id. Refer to command_uuid in PowerShield Data Collection API
     * @param serialNumber (optional) Identifies the new serial number.
     */
    registrationkey(requestId, serialNumber) {
        let url_ = this.baseUrl + "/api/datatransfer/registrationkey?";
        if (requestId === null)
            throw new globalThis.Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "RequestId=" + encodeURIComponent("" + requestId) + "&";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRegistrationkey(_response);
        });
    }
    processRegistrationkey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Update setting keep alive value of the system.
     */
    keepalive(command) {
        let url_ = this.baseUrl + "/api/datatransfer/keepalive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processKeepalive(_response);
        });
    }
    processKeepalive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DataTransferResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Get a Charge or Discharge Event start/end date/time. It is used to check if an event already exists to avoid sending a duplicated event.
     */
    getchargedischargeevent(query) {
        let url_ = this.baseUrl + "/api/datatransfer/getchargedischargeevent";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetchargedischargeevent(_response);
        });
    }
    processGetchargedischargeevent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetChargeDischargeEventResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Request to Force Ohmic Measurements
     */
    forceOhmicMeasurements(query) {
        let url_ = this.baseUrl + "/api/datatransfer/forceohmicmeasurements";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processForceOhmicMeasurements(_response);
        });
    }
    processForceOhmicMeasurements(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class AlarmsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get alarm definitions.
     */
    getAlarmDefinitions() {
        let url_ = this.baseUrl + "/api/alarms/getalarmdefinitions";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAlarmDefinitions(_response);
        });
    }
    processGetAlarmDefinitions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AlarmDefinitionModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get alarm scopes.
     */
    getAlarmScopes() {
        let url_ = this.baseUrl + "/api/alarms/getalarmscopes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAlarmScopes(_response);
        });
    }
    processGetAlarmScopes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AlarmScopeModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get alarm severities.
     */
    getAlarmSeverities() {
        let url_ = this.baseUrl + "/api/alarms/getalarmseverities";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAlarmSeverities(_response);
        });
    }
    processGetAlarmSeverities(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AlarmSeverityModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get alarm types.
     */
    getAlarmTypes() {
        let url_ = this.baseUrl + "/api/alarms/getalarmtypes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAlarmTypes(_response);
        });
    }
    processGetAlarmTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AlarmTypeModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get alarm summary.
     */
    getAlarmSummary(query) {
        let url_ = this.baseUrl + "/api/alarms/getalarmsummary";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAlarmSummary(_response);
        });
    }
    processGetAlarmSummary(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AlarmSummaryModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search alarm records.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/alarms/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfAlarmQuery.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Acknowledge a list of alarms
     */
    acknowledgeAlarms(command) {
        let url_ = this.baseUrl + "/api/alarms/acknowledgealarms";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAcknowledgeAlarms(_response);
        });
    }
    processAcknowledgeAlarms(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Clear a list of alarms
     */
    clearAlarms(command) {
        let url_ = this.baseUrl + "/api/alarms/clearalarms";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processClearAlarms(_response);
        });
    }
    processClearAlarms(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ApiRequestsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Mark api request as read.
     */
    markRequestAsRead(command) {
        let url_ = this.baseUrl + "/api/apirequests/markrequestasread";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processMarkRequestAsRead(_response);
        });
    }
    processMarkRequestAsRead(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class BatteryLifeClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Download String Life report data - PDF format.
     */
    downloadStringLifeAsPDF(query) {
        let url_ = this.baseUrl + "/api/batterylife/downloadstringlifeaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadStringLifeAsPDF(_response);
        });
    }
    processDownloadStringLifeAsPDF(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download String Life report data - CSV format.
     */
    downloadStringLifeAsCsv(query) {
        let url_ = this.baseUrl + "/api/batterylife/downloadstringlifeascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadStringLifeAsCsv(_response);
        });
    }
    processDownloadStringLifeAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class BatteryReplacementEstimationClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Download Battery Replacement report data - PDF format.
     */
    downloadBatteryReplacementEstimationAsPDF(query) {
        let url_ = this.baseUrl + "/api/batteryreplacementestimation/downloadbatteryreplacementestimationaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadBatteryReplacementEstimationAsPDF(_response);
        });
    }
    processDownloadBatteryReplacementEstimationAsPDF(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download Battery Replacement report data - CSV format.
     */
    downloadBatteryReplacementEstimationAsCsv(query) {
        let url_ = this.baseUrl + "/api/batteryreplacementestimation/downloadbatteryreplacementestimationascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadBatteryReplacementEstimationAsCsv(_response);
        });
    }
    processDownloadBatteryReplacementEstimationAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class BlockStatusClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Download Block Status report data - PDF format.
     */
    downloadBlockStatusAsPDF(query) {
        let url_ = this.baseUrl + "/api/blockstatus/downloadblockstatusaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadBlockStatusAsPDF(_response);
        });
    }
    processDownloadBlockStatusAsPDF(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download Block Status report data - CSV format.
     */
    downloadBlockStatusAsCsv(query) {
        let url_ = this.baseUrl + "/api/blockstatus/downloadblockstatusascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadBlockStatusAsCsv(_response);
        });
    }
    processDownloadBlockStatusAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class BlockTypesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of block types.
     */
    getList() {
        let url_ = this.baseUrl + "/api/blocktypes/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(BlockTypeModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of block types.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/blocktypes/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfBlockTypeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a block type.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/blocktypes/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BlockTypeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new block type.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/blocktypes/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update block type.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/blocktypes/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete block type.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/blocktypes/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CompaniesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of companies.
     */
    getListGET() {
        let url_ = this.baseUrl + "/api/companies/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListGET(_response);
        });
    }
    processGetListGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CompanyModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of companies matching provided query parameters.
     */
    getListPOST(query) {
        let url_ = this.baseUrl + "/api/companies/getlist";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPOST(_response);
        });
    }
    processGetListPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CompanyModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of companies.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/companies/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfCompanyModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search company records.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/companies/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfCompanyQuery.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a company by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/companies/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get an overview of current system states for company.
     */
    getSystemOverview(id) {
        let url_ = this.baseUrl + "/api/companies/getsystemoverview/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemOverview(_response);
        });
    }
    processGetSystemOverview(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanySystemOverviewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new company.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/companies/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Update company.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/companies/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete company.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/companies/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore company.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/companies/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download company systems report data - PDF format.
     */
    downloadCompanySystemsAsPdf(query) {
        let url_ = this.baseUrl + "/api/companies/downloadcompanysystemsaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadCompanySystemsAsPdf(_response);
        });
    }
    processDownloadCompanySystemsAsPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download company systems report data - CSV format.
     */
    downloadCompanySystemsAsCsv(query) {
        let url_ = this.baseUrl + "/api/companies/downloadcompanysystemsascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadCompanySystemsAsCsv(_response);
        });
    }
    processDownloadCompanySystemsAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get company payment status.
     */
    getCompanyPaymentStatus() {
        let url_ = this.baseUrl + "/api/companies/getcompanypaymentstatus";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetCompanyPaymentStatus(_response);
        });
    }
    processGetCompanyPaymentStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyPaymentStatus.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download company summary report data - PDF format.
     */
    downloadCompanySummaryAsPdf(query) {
        let url_ = this.baseUrl + "/api/companies/downloadcompanysummaryaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadCompanySummaryAsPdf(_response);
        });
    }
    processDownloadCompanySummaryAsPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get company edition by company id.
     */
    getEdition(id) {
        let url_ = this.baseUrl + "/api/companies/getedition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetEdition(_response);
        });
    }
    processGetEdition(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyEditionModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update or create company edition.
     */
    updateEdition(id, command) {
        let url_ = this.baseUrl + "/api/companies/updateedition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateEdition(_response);
        });
    }
    processUpdateEdition(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Archive Impact.
     * @param companyId (optional)
     */
    getArchiveImpact(companyId) {
        let url_ = this.baseUrl + "/api/companies/getarchiveimpact?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetArchiveImpact(_response);
        });
    }
    processGetArchiveImpact(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyArchiveImpactModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Company Services Settings
     * @param companyId (optional)
     */
    getServicesSettings(companyId) {
        let url_ = this.baseUrl + "/api/companies/getservicessettings?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetServicesSettings(_response);
        });
    }
    processGetServicesSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyServicesSettingsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Alarms Settings
     * @param companyId (optional)
     */
    getAlarmsSettings(companyId) {
        let url_ = this.baseUrl + "/api/companies/getalarmssettings?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAlarmsSettings(_response);
        });
    }
    processGetAlarmsSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AlarmsSettingsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ComponentTypesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of component types.
     */
    getList() {
        let url_ = this.baseUrl + "/api/componenttypes/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ComponentTypeModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of component types.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/componenttypes/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfComponentTypeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a component type by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/componenttypes/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ComponentTypeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new component type.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/componenttypes/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update component type.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/componenttypes/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete type. Record will be permanently deleted.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/componenttypes/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CountriesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of countries.
     */
    getList() {
        let url_ = this.baseUrl + "/api/countries/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CountryModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of countries.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/countries/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfCountryModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a country by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/countries/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CountryModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CurrenciesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of currencies.
     */
    getList() {
        let url_ = this.baseUrl + "/api/currencies/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CurrencyModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DataCollectorRegisterClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a paginated list of DataCollector Register Files.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/datacollectorregister/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfDataCollectorRegisterModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new DataCollector register.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/datacollectorregister/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Add multiple DataCollector register files in one batch.
     */
    addBatch(command) {
        let url_ = this.baseUrl + "/api/datacollectorregister/addbatch";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddBatch(_response);
        });
    }
    processAddBatch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DataCollectorRegisterBatchResultModel.fromJS(resultData200);
                return result200;
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Retry a failed DataCollector register upload with a new file.
     */
    retry(command) {
        let url_ = this.baseUrl + "/api/datacollectorregister/retry";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRetry(_response);
        });
    }
    processRetry(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Get a DataCollector register record.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/datacollectorregister/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DataCollectorRegisterModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DischargeClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get detailed data of a Discharge Event
     */
    downloadSystemDischargeAsPdf(query) {
        let url_ = this.baseUrl + "/api/discharge/downloadsystemdischargeaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadSystemDischargeAsPdf(_response);
        });
    }
    processDownloadSystemDischargeAsPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download discharge activity report data - PDF format.
     */
    downloadDischargeActivityAsPDF(query) {
        let url_ = this.baseUrl + "/api/discharge/downloaddischargeactivityaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadDischargeActivityAsPDF(_response);
        });
    }
    processDownloadDischargeActivityAsPDF(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download discharge activity report data - CSV format.
     */
    downloadDischargeActivityAsCsv(query) {
        let url_ = this.baseUrl + "/api/discharge/downloaddischargeactivityascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadDischargeActivityAsCsv(_response);
        });
    }
    processDownloadDischargeActivityAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class EventsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Search events.
     */
    searchEvents(query) {
        let url_ = this.baseUrl + "/api/events/searchevents";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearchEvents(_response);
        });
    }
    processSearchEvents(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfEventQuery.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get an event by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/events/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EventModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update an event.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/events/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get charge cycle event.
     */
    getChargeCycleEvent(alarmId, companyId) {
        let url_ = this.baseUrl + "/api/events/getchargecycleevent";
        if (alarmId === undefined || alarmId === null)
            throw new globalThis.Error("The parameter 'alarmId' must be defined.");
        url_ = url_.replace("{alarmId}", encodeURIComponent("" + alarmId));
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetChargeCycleEvent(_response);
        });
    }
    processGetChargeCycleEvent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ChargeCycleEventModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search charge cycle events.
     */
    searchChargeCycleEvents(query) {
        let url_ = this.baseUrl + "/api/events/searchchargecycleevents";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearchChargeCycleEvents(_response);
        });
    }
    processSearchChargeCycleEvents(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfChargeCycleEventModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search charge cycle snapshots.
     */
    searchChargeCycleSnapshots(query) {
        let url_ = this.baseUrl + "/api/events/searchchargecyclesnapshots";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearchChargeCycleSnapshots(_response);
        });
    }
    processSearchChargeCycleSnapshots(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfChargeCycleSnapshotModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of events of a charge cycle snapshots.
     */
    getChargCycleEventsForSnapshot(query) {
        let url_ = this.baseUrl + "/api/events/getchargcycleeventsforsnapshot";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetChargCycleEventsForSnapshot(_response);
        });
    }
    processGetChargCycleEventsForSnapshot(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ChargeCycleEventModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class EventTypesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Search event type records.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/eventtypes/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfEventTypeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get an event type.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/eventtypes/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EventTypeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new event type.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/eventtypes/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update event type.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/eventtypes/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete event type.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/eventtypes/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore event type.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/eventtypes/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of Alarm Definition Ids already in use by another Event Type.
     */
    getAlarmDefinitionsInUse(query) {
        let url_ = this.baseUrl + "/api/eventtypes/getalarmdefinitionsinuse";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAlarmDefinitionsInUse(_response);
        });
    }
    processGetAlarmDefinitionsInUse(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class IssuesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Search issues with pagination.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/issues/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfIssueModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get an issue by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/issues/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = IssueModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new issue.
     */
    create(model) {
        let url_ = this.baseUrl + "/api/issues/create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update an existing issue.
     */
    update(id, model) {
        let url_ = this.baseUrl + "/api/issues/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete an issue.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/issues/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore a deleted issue.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/issues/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get auto-complete suggestions for description or task fields.
     */
    getSuggestions(query) {
        let url_ = this.baseUrl + "/api/issues/getsuggestions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSuggestions(_response);
        });
    }
    processGetSuggestions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Issues Settings
     * @param companyId (optional)
     */
    getSettings(companyId) {
        let url_ = this.baseUrl + "/api/issues/getsettings?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSettings(_response);
        });
    }
    processGetSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = IssueSettingsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download Issue Site Summary report - PDF
     */
    downloadIssueSiteSummaryAsPdf(query) {
        let url_ = this.baseUrl + "/api/issues/downloadissuesitesummaryaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadIssueSiteSummaryAsPdf(_response);
        });
    }
    processDownloadIssueSiteSummaryAsPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download Issue Site Summary report - CSV
     */
    downloadIssueSiteSummaryAsCsv(query) {
        let url_ = this.baseUrl + "/api/issues/downloadissuesitesummaryascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadIssueSiteSummaryAsCsv(_response);
        });
    }
    processDownloadIssueSiteSummaryAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download Issues report - PDF
     */
    downloadIssuesAsPdf(query) {
        let url_ = this.baseUrl + "/api/issues/downloadissuesaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadIssuesAsPdf(_response);
        });
    }
    processDownloadIssuesAsPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download Issue report - CSV
     */
    downloadIssuesAsCsv(query) {
        let url_ = this.baseUrl + "/api/issues/downloadissuesascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadIssuesAsCsv(_response);
        });
    }
    processDownloadIssuesAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class MaintenanceLogsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a maintenance log by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/maintenancelogs/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaintenanceLogModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search maintenance logs.
     */
    searchMaintenanceLogs(query) {
        let url_ = this.baseUrl + "/api/maintenancelogs/searchmaintenancelogs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearchMaintenanceLogs(_response);
        });
    }
    processSearchMaintenanceLogs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfMaintenanceLogQuery.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all comments for alarms.
     */
    getAlarmsComments(query) {
        let url_ = this.baseUrl + "/api/maintenancelogs/getalarmscomments";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAlarmsComments(_response);
        });
    }
    processGetAlarmsComments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfMaintenanceLogModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new maintenance log.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/maintenancelogs/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Update maintenance log.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/maintenancelogs/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete maintenance log.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/maintenancelogs/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore maintenance log.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/maintenancelogs/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ManufacturersClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Search manufacturer records.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/manufacturers/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfManufacturerModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a manufacturer.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/manufacturers/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ManufacturerModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create manufacturer.
     */
    create(requestModel) {
        let url_ = this.baseUrl + "/api/manufacturers/create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(requestModel);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update manufacturer.
     */
    update(id, model) {
        let url_ = this.baseUrl + "/api/manufacturers/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete manufacturer.
     * @param forceDelete (optional)
     */
    delete(id, forceDelete) {
        let url_ = this.baseUrl + "/api/manufacturers/delete/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (forceDelete === null)
            throw new globalThis.Error("The parameter 'forceDelete' cannot be null.");
        else if (forceDelete !== undefined)
            url_ += "forceDelete=" + encodeURIComponent("" + forceDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ModelsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Search model records.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/models/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a model.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/models/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Model.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create model.
     */
    create(requestModel) {
        let url_ = this.baseUrl + "/api/models/create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(requestModel);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update model.
     */
    update(id, model) {
        let url_ = this.baseUrl + "/api/models/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete model.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/models/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class NotificationPreferencesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get notification summary details for a company.
     * @param snapshotDate (optional)
     */
    getCompanyNotificationSummary(companyId, snapshotDate) {
        let url_ = this.baseUrl + "/api/notificationpreferences/getcompanynotificationsummary/{companyId}?";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (snapshotDate !== undefined && snapshotDate !== null)
            url_ += "snapshotDate=" + encodeURIComponent("" + snapshotDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetCompanyNotificationSummary(_response);
        });
    }
    processGetCompanyNotificationSummary(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyNotificationSummaryModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search artificial notification address records.
     */
    searchArtificialNotificationAddresses(query) {
        let url_ = this.baseUrl + "/api/notificationpreferences/searchartificialnotificationaddresses";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearchArtificialNotificationAddresses(_response);
        });
    }
    processSearchArtificialNotificationAddresses(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ArtificialNotificationAddressModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update notification preferences of a company.
     */
    updateCompanyNotificationPreferences(command) {
        let url_ = this.baseUrl + "/api/notificationpreferences/updatecompanynotificationpreferences";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateCompanyNotificationPreferences(_response);
        });
    }
    processUpdateCompanyNotificationPreferences(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Reset notification limits for a company.
     */
    resetCompanyNotificationLimits(command) {
        let url_ = this.baseUrl + "/api/notificationpreferences/resetcompanynotificationlimits";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processResetCompanyNotificationLimits(_response);
        });
    }
    processResetCompanyNotificationLimits(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyNotificationSummaryModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class NotificationsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a notification by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/notifications/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NotificationModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search notifications.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/notifications/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfNotificationModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    testSMSNotification(companyId, toNumber) {
        let url_ = this.baseUrl + "/api/notifications/testsmsnotification?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (toNumber !== undefined && toNumber !== null)
            url_ += "toNumber=" + encodeURIComponent("" + toNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTestSMSNotification(_response);
        });
    }
    processTestSMSNotification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    testEmailNotification(toAddress) {
        let url_ = this.baseUrl + "/api/notifications/testemailnotification?";
        if (toAddress !== undefined && toAddress !== null)
            url_ += "toAddress=" + encodeURIComponent("" + toAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTestEmailNotification(_response);
        });
    }
    processTestEmailNotification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class RegionsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of regions.
     */
    getList() {
        let url_ = this.baseUrl + "/api/regions/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(RegionModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated of regions.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/regions/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfRegionModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a region by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/regions/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RegionModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new region.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/regions/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update region.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/regions/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete region. Record will be permanently deleted.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/regions/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SitesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of sites.
     */
    getListGET() {
        let url_ = this.baseUrl + "/api/sites/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListGET(_response);
        });
    }
    processGetListGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SiteModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of sites matching provided query parameters.
     */
    getListPOST(query) {
        let url_ = this.baseUrl + "/api/sites/getlist";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPOST(_response);
        });
    }
    processGetListPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SiteModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of sites for user.
     */
    getListForUser() {
        let url_ = this.baseUrl + "/api/sites/getlistforuser";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListForUser(_response);
        });
    }
    processGetListForUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SiteModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of sites.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/sites/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfSiteModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a site by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/sites/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SiteModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new site.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/sites/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Update site.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/sites/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete site.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/sites/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore site.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/sites/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Archive Impact.
     * @param siteId (optional)
     */
    getArchiveImpact(siteId) {
        let url_ = this.baseUrl + "/api/sites/getarchiveimpact?";
        if (siteId === null)
            throw new globalThis.Error("The parameter 'siteId' cannot be null.");
        else if (siteId !== undefined)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetArchiveImpact(_response);
        });
    }
    processGetArchiveImpact(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SiteArchiveImpactModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download the Assure Connection Profile for a site. The profile is applied to a Controller when enabling Assure Cloud so that its data is routed to the correct site.
     */
    getConnectionProfile(id) {
        let url_ = this.baseUrl + "/api/sites/getconnectionprofile/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetConnectionProfile(_response);
        });
    }
    processGetConnectionProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class StringLifeStatusClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Download String Status report data - PDF format.
     */
    downloadStringStatusReportAsPDF(query) {
        let url_ = this.baseUrl + "/api/stringlifestatus/downloadstringstatusreportaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadStringStatusReportAsPDF(_response);
        });
    }
    processDownloadStringStatusReportAsPDF(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download String Status report data - CSV format.
     */
    downloadStringStatusReportAsCsv(query) {
        let url_ = this.baseUrl + "/api/stringlifestatus/downloadstringstatusreportascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadStringStatusReportAsCsv(_response);
        });
    }
    processDownloadStringStatusReportAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class StringSnapshotClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get last string snapshot.
     */
    getLastStringSnapshot(query) {
        let url_ = this.baseUrl + "/api/stringsnapshot/getlaststringsnapshot";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetLastStringSnapshot(_response);
        });
    }
    processGetLastStringSnapshot(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = StringSnapshotModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get last string snapshot status.
     */
    getLastStringSnapshotStatus(query) {
        let url_ = this.baseUrl + "/api/stringsnapshot/getlaststringsnapshotstatus";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetLastStringSnapshotStatus(_response);
        });
    }
    processGetLastStringSnapshotStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = StringSnapshotStatusModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get string snapshots.
     */
    getStringSnapshots(query) {
        let url_ = this.baseUrl + "/api/stringsnapshot/getstringsnapshots";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStringSnapshots(_response);
        });
    }
    processGetStringSnapshots(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(StringSnapshotModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get string snapshots grouped by measurement date timestamp.
     */
    getStringSnapshotsGroupedByTimestamp(query) {
        let url_ = this.baseUrl + "/api/stringsnapshot/getstringsnapshotsgroupedbytimestamp";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStringSnapshotsGroupedByTimestamp(_response);
        });
    }
    processGetStringSnapshotsGroupedByTimestamp(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(DateSnapshotModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get string snapshot charts.
     */
    getStringSnapshotCharts(query) {
        let url_ = this.baseUrl + "/api/stringsnapshot/getstringsnapshotcharts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStringSnapshotCharts(_response);
        });
    }
    processGetStringSnapshotCharts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(Chart.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get string snapshot table.
     */
    getStringSnapshotTable(query) {
        let url_ = this.baseUrl + "/api/stringsnapshot/getstringsnapshottable";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStringSnapshotTable(_response);
        });
    }
    processGetStringSnapshotTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SystemCommunicationsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get system sample rate.
     */
    getSystemSampleRate(id) {
        let url_ = this.baseUrl + "/api/systemcommunications/getsystemsamplerate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemSampleRate(_response);
        });
    }
    processGetSystemSampleRate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemSampleRateModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search system communication records.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/systemcommunications/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfSystemQuery.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update sample rate for system.
     */
    updateSystemSampleRate(command, id) {
        let url_ = this.baseUrl + "/api/systemcommunications/updatesystemsamplerate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateSystemSampleRate(_response);
        });
    }
    processUpdateSystemSampleRate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Request measurement data from controller.
     */
    requestControllerData(command) {
        let url_ = this.baseUrl + "/api/systemcommunications/requestcontrollerdata";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRequestControllerData(_response);
        });
    }
    processRequestControllerData(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RequestControllerDataResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Check whether a UDP connectivity test has been received from a controller.
     */
    checkConnectivityTest(query) {
        let url_ = this.baseUrl + "/api/systemcommunications/checkconnectivitytest";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCheckConnectivityTest(_response);
        });
    }
    processCheckConnectivityTest(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ConnectivityTestLookupModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SystemComponentsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get system controller registration keys. Archived controllers are excluded.
     */
    getSystemControllerRegistrationKeys(id) {
        let url_ = this.baseUrl + "/api/systemcomponents/getsystemcontrollerregistrationkeys/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemControllerRegistrationKeys(_response);
        });
    }
    processGetSystemControllerRegistrationKeys(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get system strings.
     */
    getSystemStrings(id) {
        let url_ = this.baseUrl + "/api/systemcomponents/getsystemstrings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemStrings(_response);
        });
    }
    processGetSystemStrings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SystemComponentQueryModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get system components.
     */
    getSystemComponents(id) {
        let url_ = this.baseUrl + "/api/systemcomponents/getsystemcomponents/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemComponents(_response);
        });
    }
    processGetSystemComponents(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SystemComponentQueryModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get string for block component.
     */
    getStringForBlock(systemId, blockId) {
        let url_ = this.baseUrl + "/api/systemcomponents/getstringforblock/{systemId}/{blockId}";
        if (systemId === undefined || systemId === null)
            throw new globalThis.Error("The parameter 'systemId' must be defined.");
        url_ = url_.replace("{systemId}", encodeURIComponent("" + systemId));
        if (blockId === undefined || blockId === null)
            throw new globalThis.Error("The parameter 'blockId' must be defined.");
        url_ = url_.replace("{blockId}", encodeURIComponent("" + blockId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStringForBlock(_response);
        });
    }
    processGetStringForBlock(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemComponentQueryModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get string for sensor component.
     */
    getStringForSensor(systemId, sensorId) {
        let url_ = this.baseUrl + "/api/systemcomponents/getstringforsensor/{systemId}/{sensorId}";
        if (systemId === undefined || systemId === null)
            throw new globalThis.Error("The parameter 'systemId' must be defined.");
        url_ = url_.replace("{systemId}", encodeURIComponent("" + systemId));
        if (sensorId === undefined || sensorId === null)
            throw new globalThis.Error("The parameter 'sensorId' must be defined.");
        url_ = url_.replace("{sensorId}", encodeURIComponent("" + sensorId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStringForSensor(_response);
        });
    }
    processGetStringForSensor(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemComponentQueryModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getReplacementKey(systemId, deviceId) {
        let url_ = this.baseUrl + "/api/systemcomponents/getreplacementkey/{systemId}/{deviceId}";
        if (systemId === undefined || systemId === null)
            throw new globalThis.Error("The parameter 'systemId' must be defined.");
        url_ = url_.replace("{systemId}", encodeURIComponent("" + systemId));
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetReplacementKey(_response);
        });
    }
    processGetReplacementKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RegistrationKeyResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get component matching serial number.
     */
    getComponentBySerialNumber(query) {
        let url_ = this.baseUrl + "/api/systemcomponents/getcomponentbyserialnumber";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetComponentBySerialNumber(_response);
        });
    }
    processGetComponentBySerialNumber(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetComponentBySerialNumberResultModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search system component records.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/systemcomponents/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SystemComponentQueryModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add system component.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/systemcomponents/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update system component.
     */
    update(command) {
        let url_ = this.baseUrl + "/api/systemcomponents/update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Request registration key for system component.
     */
    requestRegistrationKey(command) {
        let url_ = this.baseUrl + "/api/systemcomponents/requestregistrationkey";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRequestRegistrationKey(_response);
        });
    }
    processRequestRegistrationKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RegistrationKeyResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    delete(systemId, componentId) {
        let url_ = this.baseUrl + "/api/systemcomponents/delete/{systemId}/{componentId}";
        if (systemId === undefined || systemId === null)
            throw new globalThis.Error("The parameter 'systemId' must be defined.");
        url_ = url_.replace("{systemId}", encodeURIComponent("" + systemId));
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    restore(systemId, componentId) {
        let url_ = this.baseUrl + "/api/systemcomponents/restore/{systemId}/{componentId}";
        if (systemId === undefined || systemId === null)
            throw new globalThis.Error("The parameter 'systemId' must be defined.");
        url_ = url_.replace("{systemId}", encodeURIComponent("" + systemId));
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SystemComponentTreeNodesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get component tree. Strings and blocks only.
     */
    getStringsAndBlocks(id) {
        let url_ = this.baseUrl + "/api/systemcomponenttreenodes/getstringsandblocks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStringsAndBlocks(_response);
        });
    }
    processGetStringsAndBlocks(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemComponentTreeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get component tree. Strings and blocks only.
     */
    getSystemLocations(id) {
        let url_ = this.baseUrl + "/api/systemcomponenttreenodes/getsystemlocations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemLocations(_response);
        });
    }
    processGetSystemLocations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemComponentTreeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get component tree.
     */
    getTree(query) {
        let url_ = this.baseUrl + "/api/systemcomponenttreenodes/gettree";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetTree(_response);
        });
    }
    processGetTree(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemComponentTreeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add a new component node.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/systemcomponenttreenodes/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Move component node to expected parent within the component tree.
     */
    move(command) {
        let url_ = this.baseUrl + "/api/systemcomponenttreenodes/move";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processMove(_response);
        });
    }
    processMove(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    delete(parentComponentId, childComponentId) {
        let url_ = this.baseUrl + "/api/systemcomponenttreenodes/delete/{parentComponentId}/{childComponentId}";
        if (parentComponentId === undefined || parentComponentId === null)
            throw new globalThis.Error("The parameter 'parentComponentId' must be defined.");
        url_ = url_.replace("{parentComponentId}", encodeURIComponent("" + parentComponentId));
        if (childComponentId === undefined || childComponentId === null)
            throw new globalThis.Error("The parameter 'childComponentId' must be defined.");
        url_ = url_.replace("{childComponentId}", encodeURIComponent("" + childComponentId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SystemsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get systems that user is authorized to access.
     * @param onlyRealTimeSystems (optional)
     * @param feature (optional)
     */
    getSystems(onlyRealTimeSystems, feature) {
        let url_ = this.baseUrl + "/api/systems/getsystems?";
        if (onlyRealTimeSystems === null)
            throw new globalThis.Error("The parameter 'onlyRealTimeSystems' cannot be null.");
        else if (onlyRealTimeSystems !== undefined)
            url_ += "onlyRealTimeSystems=" + encodeURIComponent("" + onlyRealTimeSystems) + "&";
        if (feature !== undefined && feature !== null)
            url_ += "feature=" + encodeURIComponent("" + feature) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystems(_response);
        });
    }
    processGetSystems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SystemAccessQueryModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get system states.
     */
    getSystemStates() {
        let url_ = this.baseUrl + "/api/systems/getsystemstates";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemStates(_response);
        });
    }
    processGetSystemStates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemStatesModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get system states.
     */
    getSystemStatesByString() {
        let url_ = this.baseUrl + "/api/systems/getsystemstatesbystring";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemStatesByString(_response);
        });
    }
    processGetSystemStatesByString(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SystemStatesByStringModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search system records.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/systems/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfSystemQuery.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a system by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/systems/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new system.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/systems/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Register new system.
     */
    register(command) {
        let url_ = this.baseUrl + "/api/systems/register";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRegister(_response);
        });
    }
    processRegister(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RegisterSystemResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Update system.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/systems/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete system.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/systems/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore system.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/systems/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download Summary Status report - PDF
     */
    downloadSystemSummaryStatusAsPdf(query) {
        let url_ = this.baseUrl + "/api/systems/downloadsystemsummarystatusaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadSystemSummaryStatusAsPdf(_response);
        });
    }
    processDownloadSystemSummaryStatusAsPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download Summary Status report - CSV
     */
    downloadSystemSummaryStatusAsCsv(query) {
        let url_ = this.baseUrl + "/api/systems/downloadsystemsummarystatusascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadSystemSummaryStatusAsCsv(_response);
        });
    }
    processDownloadSystemSummaryStatusAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Upload System Attachments
     */
    uploadSystemAttachments(command) {
        let url_ = this.baseUrl + "/api/systems/uploadsystemattachments/attachments";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUploadSystemAttachments(_response);
        });
    }
    processUploadSystemAttachments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get System Attachments
     */
    getSystemAttachments(systemId) {
        let url_ = this.baseUrl + "/api/systems/getsystemattachments/{systemId}/attachments";
        if (systemId === undefined || systemId === null)
            throw new globalThis.Error("The parameter 'systemId' must be defined.");
        url_ = url_.replace("{systemId}", encodeURIComponent("" + systemId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemAttachments(_response);
        });
    }
    processGetSystemAttachments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemAttachmentsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download a System Attachment
     */
    downloadSystemAttachment(systemId, attachmentId) {
        let url_ = this.baseUrl + "/api/systems/downloadsystemattachment/{systemId}/attachments/{attachmentId}/file";
        if (systemId === undefined || systemId === null)
            throw new globalThis.Error("The parameter 'systemId' must be defined.");
        url_ = url_.replace("{systemId}", encodeURIComponent("" + systemId));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadSystemAttachment(_response);
        });
    }
    processDownloadSystemAttachment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Check one controller ZIP file before importing it: validates the file, finds the system it would update, and keeps it on the server for enqueue-import-from-zip. Changes nothing.
     */
    previewImportFromZip(command) {
        let url_ = this.baseUrl + "/api/systems/previewimportfromzip/preview-import-from-zip";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processPreviewImportFromZip(_response);
        });
    }
    processPreviewImportFromZip(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PreviewControllerImportResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Queue reviewed controller ZIP files, all for one company and site, for import in the background. Progress is reported as a background task.
     */
    enqueueImportFromZip(command) {
        let url_ = this.baseUrl + "/api/systems/enqueueimportfromzip/enqueue-import-from-zip";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processEnqueueImportFromZip(_response);
        });
    }
    processEnqueueImportFromZip(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EnqueueControllerImportResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class SystemSnapshotClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get system snapshot charts.
     */
    getSystemSnapshotCharts(query) {
        let url_ = this.baseUrl + "/api/systemsnapshot/getsystemsnapshotcharts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemSnapshotCharts(_response);
        });
    }
    processGetSystemSnapshotCharts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(Chart.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download system snapshot report data - CSV format.
     */
    downloadSystemSnapshotAsCsv(query) {
        let url_ = this.baseUrl + "/api/systemsnapshot/downloadsystemsnapshotascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadSystemSnapshotAsCsv(_response);
        });
    }
    processDownloadSystemSnapshotAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download system snapshot report data - PDF format.
     */
    downloadSystemSnapshotAsPdf(query) {
        let url_ = this.baseUrl + "/api/systemsnapshot/downloadsystemsnapshotaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadSystemSnapshotAsPdf(_response);
        });
    }
    processDownloadSystemSnapshotAsPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SystemStatusClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get string state at a point in time.
     */
    getStringStatesAtPointInTime(query) {
        let url_ = this.baseUrl + "/api/systemstatus/getstringstatesatpointintime";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStringStatesAtPointInTime(_response);
        });
    }
    processGetStringStatesAtPointInTime(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PointInTimeStatusModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SystemTrendClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get system trend chart.
     */
    getSystemTrendChart(query) {
        let url_ = this.baseUrl + "/api/systemtrend/getsystemtrendchart";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemTrendChart(_response);
        });
    }
    processGetSystemTrendChart(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TimeseriesChart.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get system discharge chart.
     */
    getSystemDischargeChart(query) {
        let url_ = this.baseUrl + "/api/systemtrend/getsystemdischargechart";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemDischargeChart(_response);
        });
    }
    processGetSystemDischargeChart(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TimeseriesChart.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download system trend data -  CSV Data
     */
    downloadSystemTrendChartAsCsv(query) {
        let url_ = this.baseUrl + "/api/systemtrend/downloadsystemtrendchartascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadSystemTrendChartAsCsv(_response);
        });
    }
    processDownloadSystemTrendChartAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download trend report data - PDF format.
     */
    downloadSystemTrendAsPdf(query) {
        let url_ = this.baseUrl + "/api/systemtrend/downloadsystemtrendaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadSystemTrendAsPdf(_response);
        });
    }
    processDownloadSystemTrendAsPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download dischart report data - CSV Data
     */
    downloadSystemDischargeAsCsv(query) {
        let url_ = this.baseUrl + "/api/systemtrend/downloadsystemdischargeascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadSystemDischargeAsCsv(_response);
        });
    }
    processDownloadSystemDischargeAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download dischart report data - PDF Data
     */
    downloadSystemDischargeAsPdf(query) {
        let url_ = this.baseUrl + "/api/systemtrend/downloadsystemdischargeaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadSystemDischargeAsPdf(_response);
        });
    }
    processDownloadSystemDischargeAsPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download ohmic trend report data - PDF format.
     */
    downloadOhmicTrendReportAsPdf(query) {
        let url_ = this.baseUrl + "/api/systemtrend/downloadohmictrendreportaspdf";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadOhmicTrendReportAsPdf(_response);
        });
    }
    processDownloadOhmicTrendReportAsPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getElementXPlotForPrediction(blockId) {
        let url_ = this.baseUrl + "/api/systemtrend/getelementxplotforprediction?";
        if (blockId === null)
            throw new globalThis.Error("The parameter 'blockId' cannot be null.");
        else if (blockId !== undefined)
            url_ += "blockId=" + encodeURIComponent("" + blockId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetElementXPlotForPrediction(_response);
        });
    }
    processGetElementXPlotForPrediction(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getElementXPredictionPoints(query) {
        let url_ = this.baseUrl + "/api/systemtrend/getelementxpredictionpoints";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetElementXPredictionPoints(_response);
        });
    }
    processGetElementXPredictionPoints(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BlockPredictionModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AuthClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Login with a username and password.
     */
    login(login) {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(login);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processLogin(_response);
        });
    }
    processLogin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserAuthModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Initiate SSO login for a specific company (multi-tenant support).
     * @param companyId (optional)
     * @param subdomain (optional)
     * @param returnUrl (optional)
     */
    ssoLogin(companyId, subdomain, returnUrl) {
        let url_ = this.baseUrl + "/api/auth/ssologin/sso/login?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (subdomain !== undefined && subdomain !== null)
            url_ += "subdomain=" + encodeURIComponent("" + subdomain) + "&";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSsoLogin(_response);
        });
    }
    processSsoLogin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 302) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get current authenticated user state after SSO login.
     * @param returnUrl (optional)
     * @param companyId (optional)
     */
    ssoCallback(returnUrl, companyId) {
        let url_ = this.baseUrl + "/api/auth/ssocallback/sso/callback?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSsoCallback(_response);
        });
    }
    processSsoCallback(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserAuthModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Get list of companies with SSO enabled for company selection.
     */
    getSsoEnabledCompanies() {
        let url_ = this.baseUrl + "/api/auth/getssoenabledcompanies/sso/companies";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSsoEnabledCompanies(_response);
        });
    }
    processGetSsoEnabledCompanies(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SsoCompanyDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Check if SSO is enabled for the current domain or a specific subdomain.
     * @param subdomain (optional)
     */
    checkSsoAvailability(subdomain) {
        let url_ = this.baseUrl + "/api/auth/checkssoavailability/sso/check?";
        if (subdomain !== undefined && subdomain !== null)
            url_ += "subdomain=" + encodeURIComponent("" + subdomain) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCheckSsoAvailability(_response);
        });
    }
    processCheckSsoAvailability(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SsoCheckResponse.fromJS(resultData200);
                return result200;
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Login as a client application using basic authentication.
     * @param authorization (optional)
     */
    appLogin(authorization) {
        let url_ = this.baseUrl + "/api/auth/applogin";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAppLogin(_response);
        });
    }
    processAppLogin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccessTokenModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Login as a user using basic authentication.
     * @param authorization (optional)
     */
    userLogin(authorization) {
        let url_ = this.baseUrl + "/api/auth/userlogin";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUserLogin(_response);
        });
    }
    processUserLogin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccessTokenModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Refresh authentication token.
     */
    refreshToken(command) {
        let url_ = this.baseUrl + "/api/auth/refreshtoken";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRefreshToken(_response);
        });
    }
    processRefreshToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccessTokenModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Logout
     */
    logout() {
        let url_ = this.baseUrl + "/api/auth/logout";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processLogout(_response);
        });
    }
    processLogout(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Request forgotten password reset.
     */
    requestPasswordReset(command) {
        let url_ = this.baseUrl + "/api/auth/requestpasswordreset";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRequestPasswordReset(_response);
        });
    }
    processRequestPasswordReset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Validate forgotten password request token.
     */
    validatePasswordResetToken(token) {
        let url_ = this.baseUrl + "/api/auth/validatepasswordresettoken";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(token);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processValidatePasswordResetToken(_response);
        });
    }
    processValidatePasswordResetToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Confirm forgotten password reset.
     */
    confirmPasswordReset(command) {
        let url_ = this.baseUrl + "/api/auth/confirmpasswordreset";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processConfirmPasswordReset(_response);
        });
    }
    processConfirmPasswordReset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Save user Two Factor Authenticon Method.
     */
    saveTwoFactorAuthMethod(verification) {
        let url_ = this.baseUrl + "/api/auth/savetwofactorauthmethod";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(verification);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSaveTwoFactorAuthMethod(_response);
        });
    }
    processSaveTwoFactorAuthMethod(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TwoFactorAuthModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Login with a username and password.
     * @param userToken (optional)
     */
    twoFactorAuthetication(userToken) {
        let url_ = this.baseUrl + "/api/auth/twofactorauthetication?";
        if (userToken !== undefined && userToken !== null)
            url_ += "userToken=" + encodeURIComponent("" + userToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTwoFactorAuthetication(_response);
        });
    }
    processTwoFactorAuthetication(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TwoFactorAuthModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Login with a username and password.
     * @param userToken (optional)
     * @param timezoneOffset (optional)
     */
    twoFactorAuthSendEmailCode(userToken, timezoneOffset) {
        let url_ = this.baseUrl + "/api/auth/twofactorauthsendemailcode?";
        if (userToken !== undefined && userToken !== null)
            url_ += "userToken=" + encodeURIComponent("" + userToken) + "&";
        if (timezoneOffset === null)
            throw new globalThis.Error("The parameter 'timezoneOffset' cannot be null.");
        else if (timezoneOffset !== undefined)
            url_ += "timezoneOffset=" + encodeURIComponent("" + timezoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTwoFactorAuthSendEmailCode(_response);
        });
    }
    processTwoFactorAuthSendEmailCode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
    /**
     * Login with a username and password.
     */
    verifyTwoFactorAuthetication(verification) {
        let url_ = this.baseUrl + "/api/auth/verifytwofactorauthetication";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(verification);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processVerifyTwoFactorAuthetication(_response);
        });
    }
    processVerifyTwoFactorAuthetication(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserAuthModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class RecaptchaClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    validate(model) {
        let url_ = this.baseUrl + "/api/recaptcha/validate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processValidate(_response);
        });
    }
    processValidate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RecaptchaResponseViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else {
            return response.text().then((_responseText) => {
                let resultdefault = null;
                let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = ProblemDetails.fromJS(resultDatadefault);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}
export class AboutClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get static information about the host running the web application.
     */
    getSystemInfo() {
        let url_ = this.baseUrl + "/api/about/getsysteminfo/system-info";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemInfo(_response);
        });
    }
    processGetSystemInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AboutSystemInfoModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get live CPU and memory usage for the host running the web application.
     */
    getSystemStats() {
        let url_ = this.baseUrl + "/api/about/getsystemstats/system-stats";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemStats(_response);
        });
    }
    processGetSystemStats(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AboutSystemStatsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download a ZIP bundle of recent diagnostic logs and host information.
     */
    downloadDiagnosticLogs() {
        let url_ = this.baseUrl + "/api/about/downloaddiagnosticlogs/diagnostic-logs";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadDiagnosticLogs(_response);
        });
    }
    processDownloadDiagnosticLogs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ActivityAuditClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a paginated, filtered page of the Audit Log.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/activityaudit/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfActivityAuditModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a single Audit Log entry, including its field-level changes.
     * @param whenCreated (optional)
     */
    get(id, whenCreated) {
        let url_ = this.baseUrl + "/api/activityaudit/get/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (whenCreated !== undefined && whenCreated !== null)
            url_ += "whenCreated=" + encodeURIComponent(whenCreated ? "" + whenCreated.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActivityAuditModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the Audit Log history for a single record.
     */
    forEntity(query) {
        let url_ = this.baseUrl + "/api/activityaudit/forentity";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processForEntity(_response);
        });
    }
    processForEntity(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfActivityAuditModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Export the current Audit Log view as a CSV file.
     */
    exportCsv(query) {
        let url_ = this.baseUrl + "/api/activityaudit/exportcsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processExportCsv(_response);
        });
    }
    processExportCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the Audit Log retention settings for a company.
     * @param companyId (optional)
     */
    getSettings(companyId) {
        let url_ = this.baseUrl + "/api/activityaudit/getsettings?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSettings(_response);
        });
    }
    processGetSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActivityAuditSettingsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Set the Audit Log retention period for a company.
     */
    upsertSettings(model) {
        let url_ = this.baseUrl + "/api/activityaudit/upsertsettings";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpsertSettings(_response);
        });
    }
    processUpsertSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the application-wide Audit Log retention defaults.
     */
    getApplicationSettings() {
        let url_ = this.baseUrl + "/api/activityaudit/getapplicationsettings";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetApplicationSettings(_response);
        });
    }
    processGetApplicationSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActivityAuditApplicationSettingsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Set the application-wide Audit Log retention defaults.
     */
    upsertApplicationSettings(model) {
        let url_ = this.baseUrl + "/api/activityaudit/upsertapplicationsettings";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpsertApplicationSettings(_response);
        });
    }
    processUpsertApplicationSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Report what a proposed Audit Log retention change would affect.
     * @param companyId (optional)
     * @param proposedDaysToRetain (optional)
     */
    retentionImpact(companyId, proposedDaysToRetain) {
        let url_ = this.baseUrl + "/api/activityaudit/retentionimpact?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (proposedDaysToRetain === null)
            throw new globalThis.Error("The parameter 'proposedDaysToRetain' cannot be null.");
        else if (proposedDaysToRetain !== undefined)
            url_ += "proposedDaysToRetain=" + encodeURIComponent("" + proposedDaysToRetain) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRetentionImpact(_response);
        });
    }
    processRetentionImpact(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActivityAuditRetentionImpactModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the filter options available to the current user.
     */
    filterOptions(query) {
        let url_ = this.baseUrl + "/api/activityaudit/filteroptions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFilterOptions(_response);
        });
    }
    processFilterOptions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActivityAuditFilterOptionsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AddressesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of addresses by company id.
     */
    getList(companyId) {
        let url_ = this.baseUrl + "/api/addresses/getlist/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AddressModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of addresses.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/addresses/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfAddressModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get an address by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/addresses/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddressModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new address.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/addresses/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update address.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/addresses/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete address.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/addresses/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore address.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/addresses/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AlarmDefinitionsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of alarm definitions.
     */
    getList() {
        let url_ = this.baseUrl + "/api/alarmdefinitions/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AlarmDefinitionModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of alarm definitions for alarm type.
     */
    getAlarmTypeDefinitions(alarmTypeId) {
        let url_ = this.baseUrl + "/api/alarmdefinitions/getalarmtypedefinitions/{alarmTypeId}";
        if (alarmTypeId === undefined || alarmTypeId === null)
            throw new globalThis.Error("The parameter 'alarmTypeId' must be defined.");
        url_ = url_.replace("{alarmTypeId}", encodeURIComponent("" + alarmTypeId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAlarmTypeDefinitions(_response);
        });
    }
    processGetAlarmTypeDefinitions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AlarmDefinitionModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get alarm definition.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/alarmdefinitions/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AlarmDefinitionModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new alarm definition.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/alarmdefinitions/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update alarm definition.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/alarmdefinitions/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete alarm definition.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/alarmdefinitions/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore alarm definition.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/alarmdefinitions/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AlarmTypesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of alarm types.
     */
    getList() {
        let url_ = this.baseUrl + "/api/alarmtypes/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AlarmTypeModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search alarm type records.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/alarmtypes/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfAlarmTypeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get an alarm type.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/alarmtypes/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AlarmTypeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new alarm type.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/alarmtypes/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update alarm type.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/alarmtypes/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete alarm type.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/alarmtypes/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore alarm type.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/alarmtypes/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ApplicationsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get an application by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/applications/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ApplicationModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search application records.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/applications/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfApplicationModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new application.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/applications/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ApplicationModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update application.
     */
    update(command) {
        let url_ = this.baseUrl + "/api/applications/update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Rotate application authentication key.
     */
    rotateKey(id) {
        let url_ = this.baseUrl + "/api/applications/rotatekey/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRotateKey(_response);
        });
    }
    processRotateKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete application.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/applications/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore application.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/applications/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CompanyPermissionsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Search company permissions.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/companypermissions/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfUserCompanyAccessQuery.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add company permission to user.
     */
    add(id, command) {
        let url_ = this.baseUrl + "/api/companypermissions/add/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update company permission for user.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/companypermissions/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete company permission for user.
     */
    delete(id, command) {
        let url_ = this.baseUrl + "/api/companypermissions/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CompanyTypesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of company types.
     */
    getList() {
        let url_ = this.baseUrl + "/api/companytypes/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CompanyTypeModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of company types.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/companytypes/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfCompanyTypeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a company type by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/companytypes/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyTypeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new company type.
     */
    add() {
        let url_ = this.baseUrl + "/api/companytypes/add";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update company type.
     */
    update() {
        let url_ = this.baseUrl + "/api/companytypes/update";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete company type. Record will be permanently deleted.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/companytypes/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ComponentLimitsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    getComponentLimitList(query) {
        let url_ = this.baseUrl + "/api/componentlimits/getcomponentlimitlist";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetComponentLimitList(_response);
        });
    }
    processGetComponentLimitList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ComponentLimitModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ComponentsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of components matching provided query.
     */
    getList(query) {
        let url_ = this.baseUrl + "/api/components/getlist";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ComponentModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of components.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/components/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfComponentModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a component by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/components/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ComponentModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new component.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/components/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update component.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/components/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete component.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/components/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore component.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/components/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update components manufactured and replacment dates.
     */
    updateComponentDates(command) {
        let url_ = this.baseUrl + "/api/components/updatecomponentdates";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateComponentDates(_response);
        });
    }
    processUpdateComponentDates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ComponentStatesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of component states.
     */
    getList() {
        let url_ = this.baseUrl + "/api/componentstates/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ComponentStatusModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of component states.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/componentstates/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfComponentStatusModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a component state by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/componentstates/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ComponentStatusModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new component status.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/componentstates/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update component status.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/componentstates/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete component status. Record will be permanently deleted.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/componentstates/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ContactGroupClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of contact groups.
     */
    getListGET() {
        let url_ = this.baseUrl + "/api/contactgroup/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListGET(_response);
        });
    }
    processGetListGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ContactGroupModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of contact groups matching provided query.
     */
    getListPOST(query) {
        let url_ = this.baseUrl + "/api/contactgroup/getlist";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPOST(_response);
        });
    }
    processGetListPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ContactGroupModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of contact groups.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/contactgroup/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfContactGroupModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a contact group by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/contactgroup/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContactGroupModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new contact group.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/contactgroup/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update contact group.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/contactgroup/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete contact group.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/contactgroup/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore contact group.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/contactgroup/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class LicenseClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get full license information.
     */
    getLicense() {
        let url_ = this.baseUrl + "/api/license/getlicense";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetLicense(_response);
        });
    }
    processGetLicense(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LicenseDetailsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get license summary for UI feature visibility.
     */
    getLicenseSummary() {
        let url_ = this.baseUrl + "/api/license/getlicensesummary/summary";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetLicenseSummary(_response);
        });
    }
    processGetLicenseSummary(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LicenseSummaryModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get information about features subject to string quota constraints.
     */
    getFeatureConstraints() {
        let url_ = this.baseUrl + "/api/license/getfeatureconstraints/feature-constraints";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetFeatureConstraints(_response);
        });
    }
    processGetFeatureConstraints(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FeatureConstraintsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get list of all systems with their license coverage status.
     */
    getSystemCoverage() {
        let url_ = this.baseUrl + "/api/license/getsystemcoverage/system-coverage";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSystemCoverage(_response);
        });
    }
    processGetSystemCoverage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemCoverageModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class MaintenanceLogTypesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of maintenance log types.
     */
    getList() {
        let url_ = this.baseUrl + "/api/maintenancelogtypes/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MaintenanceLogTypeModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class MeasurementCategoriesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of measurement categories.
     */
    getList() {
        let url_ = this.baseUrl + "/api/measurementcategories/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MeasurementCategoryModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class MeasurementsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    getDataGap(query) {
        let url_ = this.baseUrl + "/api/measurements/getdatagap";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetDataGap(_response);
        });
    }
    processGetDataGap(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DataGapModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    upsertDataGapsSetting(query) {
        let url_ = this.baseUrl + "/api/measurements/upsertdatagapssetting";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpsertDataGapsSetting(_response);
        });
    }
    processUpsertDataGapsSetting(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DataGapModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getGapsSetting() {
        let url_ = this.baseUrl + "/api/measurements/getgapssetting";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetGapsSetting(_response);
        });
    }
    processGetGapsSetting(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DataGapSettingsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class MeasurementTypesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of measurement types.
     */
    getList() {
        let url_ = this.baseUrl + "/api/measurementtypes/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MeasurementTypeModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of measurement types.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/measurementtypes/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfMeasurementTypeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a measurement type by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/measurementtypes/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MeasurementTypeModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new measurement type.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/measurementtypes/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update measurement type.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/measurementtypes/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete measurement type. Record will be permanently deleted.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/measurementtypes/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class PersonsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of persons.
     */
    getListGET() {
        let url_ = this.baseUrl + "/api/persons/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListGET(_response);
        });
    }
    processGetListGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PersonModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of persons matching provided query.
     */
    getListPOST(query) {
        let url_ = this.baseUrl + "/api/persons/getlist";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPOST(_response);
        });
    }
    processGetListPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PersonModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of persons.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/persons/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfPersonModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a person by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/persons/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PersonModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new person.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/persons/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update person.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/persons/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete person.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/persons/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore person.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/persons/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class RegistrationKeysClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of registration keys.
     */
    getList() {
        let url_ = this.baseUrl + "/api/registrationkeys/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(RegistrationKeyModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of registration keys.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/registrationkeys/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfRegistrationKeyModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a registration key by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/registrationkeys/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RegistrationKeyModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new registration key.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/registrationkeys/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Request new registration key.
     */
    requestKey(command) {
        let url_ = this.baseUrl + "/api/registrationkeys/requestkey";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRequestKey(_response);
        });
    }
    processRequestKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RegistrationKeyResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete registration key. Record will be permanently deleted.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/registrationkeys/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class RolesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of roles.
     * @param isNewUser (optional)
     */
    getList(isNewUser) {
        let url_ = this.baseUrl + "/api/roles/getlist?";
        if (isNewUser === null)
            throw new globalThis.Error("The parameter 'isNewUser' cannot be null.");
        else if (isNewUser !== undefined)
            url_ += "isNewUser=" + encodeURIComponent("" + isNewUser) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(RoleModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of roles.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/roles/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfRoleModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a role by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/roles/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RoleModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SystemCategoriesClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of system categories.
     */
    getListGET() {
        let url_ = this.baseUrl + "/api/systemcategories/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListGET(_response);
        });
    }
    processGetListGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SystemCategoryModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of SystemCategorys matching provided query.
     */
    getListPOST(query) {
        let url_ = this.baseUrl + "/api/systemcategories/getlist";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPOST(_response);
        });
    }
    processGetListPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SystemCategoryModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of SystemCategorys.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/systemcategories/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfSystemCategoryModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a SystemCategory by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/systemcategories/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SystemCategoryModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new SystemCategory.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/systemcategories/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update SystemCategory.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/systemcategories/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete SystemCategory.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/systemcategories/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore SystemCategory.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/systemcategories/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SystemPermissionsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Search system access permissions. Systems without any access permissions will be retrieved.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/systempermissions/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfSystemAccessQueryModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add system permission to user.
     */
    add(id, command) {
        let url_ = this.baseUrl + "/api/systempermissions/add/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete system permission for user.
     */
    delete(id, command) {
        let url_ = this.baseUrl + "/api/systempermissions/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UserGroupsClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get the list of user groups.
     */
    getList() {
        let url_ = this.baseUrl + "/api/usergroups/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetList(_response);
        });
    }
    processGetList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(UserGroupListItemModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a user group with its features and members.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/usergroups/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserGroupModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the features a user group can switch on.
     */
    getFeatures() {
        let url_ = this.baseUrl + "/api/usergroups/getfeatures";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetFeatures(_response);
        });
    }
    processGetFeatures(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GroupControlledFeatureModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search the users who can be added to a user group.
     * @param search (optional)
     */
    getEligibleUsers(search) {
        let url_ = this.baseUrl + "/api/usergroups/geteligibleusers?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetEligibleUsers(_response);
        });
    }
    processGetEligibleUsers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(UserGroupMemberModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a user group.
     */
    create(model) {
        let url_ = this.baseUrl + "/api/usergroups/create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreate(_response);
        });
    }
    processCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Rename a user group or change its description.
     */
    update(model) {
        let url_ = this.baseUrl + "/api/usergroups/update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a user group, with its features and memberships.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/usergroups/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Replace the features switched on for a user group.
     */
    setFeatures(model) {
        let url_ = this.baseUrl + "/api/usergroups/setfeatures";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetFeatures(_response);
        });
    }
    processSetFeatures(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add a user to a user group.
     */
    addMember(model) {
        let url_ = this.baseUrl + "/api/usergroups/addmember";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddMember(_response);
        });
    }
    processAddMember(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Remove a user from a user group.
     */
    removeMember(model) {
        let url_ = this.baseUrl + "/api/usergroups/removemember";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRemoveMember(_response);
        });
    }
    processRemoveMember(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UsersClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Get a list of users.
     */
    getListGET() {
        let url_ = this.baseUrl + "/api/users/getlist";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListGET(_response);
        });
    }
    processGetListGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(UserModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of users matching provided query.
     */
    getListPOST(query) {
        let url_ = this.baseUrl + "/api/users/getlist";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPOST(_response);
        });
    }
    processGetListPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(UserModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a paginated list of users.
     */
    getListPaginated(query) {
        let url_ = this.baseUrl + "/api/users/getlistpaginated";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetListPaginated(_response);
        });
    }
    processGetListPaginated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfUserModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Search user records.
     */
    search(query) {
        let url_ = this.baseUrl + "/api/users/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearch(_response);
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatedEnumerableOfUserQuery.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a user by id.
     */
    get(id) {
        let url_ = this.baseUrl + "/api/users/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGet(_response);
        });
    }
    processGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add new user.
     */
    add(command) {
        let url_ = this.baseUrl + "/api/users/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAdd(_response);
        });
    }
    processAdd(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update user.
     */
    update(id, command) {
        let url_ = this.baseUrl + "/api/users/update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdate(_response);
        });
    }
    processUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update user password.
     */
    updatePassword(id, command) {
        let url_ = this.baseUrl + "/api/users/updatepassword/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdatePassword(_response);
        });
    }
    processUpdatePassword(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete user.
     */
    delete(id) {
        let url_ = this.baseUrl + "/api/users/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDelete(_response);
        });
    }
    processDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore user.
     */
    restore(id) {
        let url_ = this.baseUrl + "/api/users/restore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRestore(_response);
        });
    }
    processRestore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Unlock user.
     */
    unlock(id) {
        let url_ = this.baseUrl + "/api/users/unlock/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUnlock(_response);
        });
    }
    processUnlock(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Clear Two Factor Authentication Method.
     */
    clear2FAMethod(id) {
        let url_ = this.baseUrl + "/api/users/clear2famethod/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processClear2FAMethod(_response);
        });
    }
    processClear2FAMethod(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download users/contacts report data - CSV Data
     */
    downloadUsersContactsAsCsv(query) {
        let url_ = this.baseUrl + "/api/users/downloaduserscontactsascsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadUsersContactsAsCsv(_response);
        });
    }
    processDownloadUsersContactsAsCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Lock or unlock multiple users.
     */
    lockUnlockUsers(command) {
        let url_ = this.baseUrl + "/api/users/lockunlockusers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(command);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processLockUnlockUsers(_response);
        });
    }
    processLockUnlockUsers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SnapshotDataModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["systems"])) {
                this.systems = [];
                for (let item of _data["systems"])
                    this.systems.push(SystemAccessQueryModel.fromJS(item));
            }
            else {
                this.systems = null;
            }
            this.selectedSystemId = _data["selectedSystemId"] !== undefined ? _data["selectedSystemId"] : null;
            this.stringIdx = _data["stringIdx"] !== undefined ? _data["stringIdx"] : null;
            if (Array.isArray(_data["strings"])) {
                this.strings = [];
                for (let item of _data["strings"])
                    this.strings.push(SystemComponentQueryModel.fromJS(item));
            }
            else {
                this.strings = null;
            }
            this.lastSnapshot = _data["lastSnapshot"] ? StringSnapshotStatusModel.fromJS(_data["lastSnapshot"]) : null;
            if (Array.isArray(_data["availableSnapshots"])) {
                this.availableSnapshots = [];
                for (let item of _data["availableSnapshots"])
                    this.availableSnapshots.push(DateSnapshotModel.fromJS(item));
            }
            else {
                this.availableSnapshots = null;
            }
            this.selectedSnapshot = _data["selectedSnapshot"] ? DateSnapshotModel.fromJS(_data["selectedSnapshot"]) : null;
            if (Array.isArray(_data["stringStates"])) {
                this.stringStates = [];
                for (let item of _data["stringStates"])
                    this.stringStates.push(PointInTimeStatusModel.fromJS(item));
            }
            else {
                this.stringStates = null;
            }
            if (Array.isArray(_data["charts"])) {
                this.charts = [];
                for (let item of _data["charts"])
                    this.charts.push(Chart.fromJS(item));
            }
            else {
                this.charts = null;
            }
            if (Array.isArray(_data["tableData"])) {
                this.tableData = [];
                for (let item of _data["tableData"])
                    this.tableData.push(item);
            }
            else {
                this.tableData = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SnapshotDataModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systems)) {
            data["systems"] = [];
            for (let item of this.systems)
                data["systems"].push(item ? item.toJSON() : null);
        }
        data["selectedSystemId"] = this.selectedSystemId !== undefined ? this.selectedSystemId : null;
        data["stringIdx"] = this.stringIdx !== undefined ? this.stringIdx : null;
        if (Array.isArray(this.strings)) {
            data["strings"] = [];
            for (let item of this.strings)
                data["strings"].push(item ? item.toJSON() : null);
        }
        data["lastSnapshot"] = this.lastSnapshot ? this.lastSnapshot.toJSON() : null;
        if (Array.isArray(this.availableSnapshots)) {
            data["availableSnapshots"] = [];
            for (let item of this.availableSnapshots)
                data["availableSnapshots"].push(item ? item.toJSON() : null);
        }
        data["selectedSnapshot"] = this.selectedSnapshot ? this.selectedSnapshot.toJSON() : null;
        if (Array.isArray(this.stringStates)) {
            data["stringStates"] = [];
            for (let item of this.stringStates)
                data["stringStates"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.charts)) {
            data["charts"] = [];
            for (let item of this.charts)
                data["charts"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.tableData)) {
            data["tableData"] = [];
            for (let item of this.tableData)
                data["tableData"].push(item);
        }
        return data;
    }
}
export class SystemAccessQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.systemCode = _data["systemCode"] !== undefined ? _data["systemCode"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.systemPermissionUserId = _data["systemPermissionUserId"] !== undefined ? _data["systemPermissionUserId"] : null;
            this.companyPermissionUserId = _data["companyPermissionUserId"] !== undefined ? _data["companyPermissionUserId"] : null;
            this.controllerKeepAlive = _data["controllerKeepAlive"] !== undefined ? _data["controllerKeepAlive"] : null;
            this.monitorTypeId = _data["monitorTypeId"] !== undefined ? _data["monitorTypeId"] : null;
            this.batteryTypeId = _data["batteryTypeId"] !== undefined ? _data["batteryTypeId"] : null;
            this.lithiumBatteryTypeId = _data["lithiumBatteryTypeId"] !== undefined ? _data["lithiumBatteryTypeId"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemAccessQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["systemCode"] = this.systemCode !== undefined ? this.systemCode : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["systemPermissionUserId"] = this.systemPermissionUserId !== undefined ? this.systemPermissionUserId : null;
        data["companyPermissionUserId"] = this.companyPermissionUserId !== undefined ? this.companyPermissionUserId : null;
        data["controllerKeepAlive"] = this.controllerKeepAlive !== undefined ? this.controllerKeepAlive : null;
        data["monitorTypeId"] = this.monitorTypeId !== undefined ? this.monitorTypeId : null;
        data["batteryTypeId"] = this.batteryTypeId !== undefined ? this.batteryTypeId : null;
        data["lithiumBatteryTypeId"] = this.lithiumBatteryTypeId !== undefined ? this.lithiumBatteryTypeId : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : null;
        return data;
    }
}
export class SystemAccessQueryModel extends SystemAccessQuery {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.hasAccessToSystem = _data["hasAccessToSystem"] !== undefined ? _data["hasAccessToSystem"] : null;
            this.hasAccessToCompanySystems = _data["hasAccessToCompanySystems"] !== undefined ? _data["hasAccessToCompanySystems"] : null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemAccessQueryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["hasAccessToSystem"] = this.hasAccessToSystem !== undefined ? this.hasAccessToSystem : null;
        data["hasAccessToCompanySystems"] = this.hasAccessToCompanySystems !== undefined ? this.hasAccessToCompanySystems : null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null;
        super.toJSON(data);
        return data;
    }
}
export class SystemComponentQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.authorId = _data["authorId"] !== undefined ? _data["authorId"] : null;
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : null;
            this.modelId = _data["modelId"] !== undefined ? _data["modelId"] : null;
            this.registrationKey = _data["registrationKey"] !== undefined ? _data["registrationKey"] : null;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.stringStatusId = _data["stringStatusId"] !== undefined ? _data["stringStatusId"] : null;
            this.componentTypeId = _data["componentTypeId"] !== undefined ? _data["componentTypeId"] : null;
            this.componentCode = _data["componentCode"] !== undefined ? _data["componentCode"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.componentTypeName = _data["componentTypeName"] !== undefined ? _data["componentTypeName"] : null;
            this.componentStatusName = _data["componentStatusName"] !== undefined ? _data["componentStatusName"] : null;
            this.stringStatusName = _data["stringStatusName"] !== undefined ? _data["stringStatusName"] : null;
            this.manufacturerName = _data["manufacturerName"] !== undefined ? _data["manufacturerName"] : null;
            this.modelName = _data["modelName"] !== undefined ? _data["modelName"] : null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : null;
            this.whenComponentDeleted = _data["whenComponentDeleted"] ? new Date(_data["whenComponentDeleted"].toString()) : null;
            this.whenFirstOhmicReadingTaken = _data["whenFirstOhmicReadingTaken"] ? new Date(_data["whenFirstOhmicReadingTaken"].toString()) : null;
            this.whenInstalled = _data["whenInstalled"] ? new Date(_data["whenInstalled"].toString()) : null;
            this.whenManufactured = _data["whenManufactured"] ? new Date(_data["whenManufactured"].toString()) : null;
            this.whenLastReplacement = _data["whenLastReplacement"] ? new Date(_data["whenLastReplacement"].toString()) : null;
            this.whenNextReplacement = _data["whenNextReplacement"] ? new Date(_data["whenNextReplacement"].toString()) : null;
            this.blockTargetFloatVoltage = _data["blockTargetFloatVoltage"] !== undefined ? _data["blockTargetFloatVoltage"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemComponentQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["authorId"] = this.authorId !== undefined ? this.authorId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["modelId"] = this.modelId !== undefined ? this.modelId : null;
        data["registrationKey"] = this.registrationKey !== undefined ? this.registrationKey : null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["stringStatusId"] = this.stringStatusId !== undefined ? this.stringStatusId : null;
        data["componentTypeId"] = this.componentTypeId !== undefined ? this.componentTypeId : null;
        data["componentCode"] = this.componentCode !== undefined ? this.componentCode : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["componentTypeName"] = this.componentTypeName !== undefined ? this.componentTypeName : null;
        data["componentStatusName"] = this.componentStatusName !== undefined ? this.componentStatusName : null;
        data["stringStatusName"] = this.stringStatusName !== undefined ? this.stringStatusName : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["modelName"] = this.modelName !== undefined ? this.modelName : null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : null;
        data["whenComponentDeleted"] = this.whenComponentDeleted ? this.whenComponentDeleted.toISOString() : null;
        data["whenFirstOhmicReadingTaken"] = this.whenFirstOhmicReadingTaken ? this.whenFirstOhmicReadingTaken.toISOString() : null;
        data["whenInstalled"] = this.whenInstalled ? this.whenInstalled.toISOString() : null;
        data["whenManufactured"] = this.whenManufactured ? this.whenManufactured.toISOString() : null;
        data["whenLastReplacement"] = this.whenLastReplacement ? this.whenLastReplacement.toISOString() : null;
        data["whenNextReplacement"] = this.whenNextReplacement ? this.whenNextReplacement.toISOString() : null;
        data["blockTargetFloatVoltage"] = this.blockTargetFloatVoltage !== undefined ? this.blockTargetFloatVoltage : null;
        return data;
    }
}
export class SystemComponentQueryModel extends SystemComponentQuery {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null;
            this.componentRef = _data["componentRef"] !== undefined ? _data["componentRef"] : null;
            this.isOrphaned = _data["isOrphaned"] !== undefined ? _data["isOrphaned"] : null;
            if (Array.isArray(_data["children"])) {
                this.children = [];
                for (let item of _data["children"])
                    this.children.push(SystemComponentQueryModel.fromJS(item));
            }
            else {
                this.children = null;
            }
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemComponentQueryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName !== undefined ? this.displayName : null;
        data["componentRef"] = this.componentRef !== undefined ? this.componentRef : null;
        data["isOrphaned"] = this.isOrphaned !== undefined ? this.isOrphaned : null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : null);
        }
        data["isActive"] = this.isActive !== undefined ? this.isActive : null;
        super.toJSON(data);
        return data;
    }
}
export class StringSnapshotStatusModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.snapshot = _data["snapshot"] ? StringSnapshotModel.fromJS(_data["snapshot"]) : null;
            this.apiRequest = _data["apiRequest"] ? ApiRequestModel.fromJS(_data["apiRequest"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StringSnapshotStatusModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["snapshot"] = this.snapshot ? this.snapshot.toJSON() : null;
        data["apiRequest"] = this.apiRequest ? this.apiRequest.toJSON() : null;
        return data;
    }
}
export class StringSnapshotModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.snapshotId = _data["snapshotId"] !== undefined ? _data["snapshotId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.current = _data["current"] !== undefined ? _data["current"] : null;
            this.rippleCurrent = _data["rippleCurrent"] !== undefined ? _data["rippleCurrent"] : null;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null;
            this.humidity = _data["humidity"] !== undefined ? _data["humidity"] : null;
            this.ambientTemperature = _data["ambientTemperature"] !== undefined ? _data["ambientTemperature"] : null;
            this.ambientTemperature2 = _data["ambientTemperature2"] !== undefined ? _data["ambientTemperature2"] : null;
            this.ambientTemperatureMedian = _data["ambientTemperatureMedian"] !== undefined ? _data["ambientTemperatureMedian"] : null;
            this.ambientMedianToBlockMedianVariation = _data["ambientMedianToBlockMedianVariation"] !== undefined ? _data["ambientMedianToBlockMedianVariation"] : null;
            this.blockVoltageVariation = _data["blockVoltageVariation"] !== undefined ? _data["blockVoltageVariation"] : null;
            this.blockVoltageMedian = _data["blockVoltageMedian"] !== undefined ? _data["blockVoltageMedian"] : null;
            this.blockOhmicMin = _data["blockOhmicMin"] !== undefined ? _data["blockOhmicMin"] : null;
            this.blockOhmicMinLocation = _data["blockOhmicMinLocation"] !== undefined ? _data["blockOhmicMinLocation"] : null;
            this.blockOhmicMax = _data["blockOhmicMax"] !== undefined ? _data["blockOhmicMax"] : null;
            this.blockOhmicMaxLocation = _data["blockOhmicMaxLocation"] !== undefined ? _data["blockOhmicMaxLocation"] : null;
            this.blockOhmicVariation = _data["blockOhmicVariation"] !== undefined ? _data["blockOhmicVariation"] : null;
            this.blockOhmicMedian = _data["blockOhmicMedian"] !== undefined ? _data["blockOhmicMedian"] : null;
            this.blockOhmicRiseMin = _data["blockOhmicRiseMin"] !== undefined ? _data["blockOhmicRiseMin"] : null;
            this.blockOhmicRiseMinLocation = _data["blockOhmicRiseMinLocation"] !== undefined ? _data["blockOhmicRiseMinLocation"] : null;
            this.blockOhmicRiseMax = _data["blockOhmicRiseMax"] !== undefined ? _data["blockOhmicRiseMax"] : null;
            this.blockOhmicRiseMaxLocation = _data["blockOhmicRiseMaxLocation"] !== undefined ? _data["blockOhmicRiseMaxLocation"] : null;
            this.blockOhmicRiseVariation = _data["blockOhmicRiseVariation"] !== undefined ? _data["blockOhmicRiseVariation"] : null;
            this.blockOhmicRiseMedian = _data["blockOhmicRiseMedian"] !== undefined ? _data["blockOhmicRiseMedian"] : null;
            this.blockTemperatureVariation = _data["blockTemperatureVariation"] !== undefined ? _data["blockTemperatureVariation"] : null;
            this.blockTemperatureMedian = _data["blockTemperatureMedian"] !== undefined ? _data["blockTemperatureMedian"] : null;
            this.ambientTemperatureVariation = _data["ambientTemperatureVariation"] !== undefined ? _data["ambientTemperatureVariation"] : null;
            this.cellSummationVoltage = _data["cellSummationVoltage"] !== undefined ? _data["cellSummationVoltage"] : null;
            this.soc = _data["soc"] !== undefined ? _data["soc"] : null;
            this.soh = _data["soh"] !== undefined ? _data["soh"] : null;
            this.cellVoltageMax1 = _data["cellVoltageMax1"] !== undefined ? _data["cellVoltageMax1"] : null;
            this.cellVoltageMax1Location = _data["cellVoltageMax1Location"] !== undefined ? _data["cellVoltageMax1Location"] : null;
            this.cellVoltageMax1LocationRaw = _data["cellVoltageMax1LocationRaw"] !== undefined ? _data["cellVoltageMax1LocationRaw"] : null;
            this.cellVoltageMax1Module = _data["cellVoltageMax1Module"] !== undefined ? _data["cellVoltageMax1Module"] : null;
            this.cellVoltageMax1Sensor = _data["cellVoltageMax1Sensor"] !== undefined ? _data["cellVoltageMax1Sensor"] : null;
            this.cellVoltageMax2 = _data["cellVoltageMax2"] !== undefined ? _data["cellVoltageMax2"] : null;
            this.cellVoltageMax2Location = _data["cellVoltageMax2Location"] !== undefined ? _data["cellVoltageMax2Location"] : null;
            this.cellVoltageMax2LocationRaw = _data["cellVoltageMax2LocationRaw"] !== undefined ? _data["cellVoltageMax2LocationRaw"] : null;
            this.cellVoltageMax2Module = _data["cellVoltageMax2Module"] !== undefined ? _data["cellVoltageMax2Module"] : null;
            this.cellVoltageMax2Sensor = _data["cellVoltageMax2Sensor"] !== undefined ? _data["cellVoltageMax2Sensor"] : null;
            this.cellVoltageMin1 = _data["cellVoltageMin1"] !== undefined ? _data["cellVoltageMin1"] : null;
            this.cellVoltageMin1Location = _data["cellVoltageMin1Location"] !== undefined ? _data["cellVoltageMin1Location"] : null;
            this.cellVoltageMin1LocationRaw = _data["cellVoltageMin1LocationRaw"] !== undefined ? _data["cellVoltageMin1LocationRaw"] : null;
            this.cellVoltageMin1Module = _data["cellVoltageMin1Module"] !== undefined ? _data["cellVoltageMin1Module"] : null;
            this.cellVoltageMin1Sensor = _data["cellVoltageMin1Sensor"] !== undefined ? _data["cellVoltageMin1Sensor"] : null;
            this.cellVoltageMin2 = _data["cellVoltageMin2"] !== undefined ? _data["cellVoltageMin2"] : null;
            this.cellVoltageMin2Location = _data["cellVoltageMin2Location"] !== undefined ? _data["cellVoltageMin2Location"] : null;
            this.cellVoltageMin2Module = _data["cellVoltageMin2Module"] !== undefined ? _data["cellVoltageMin2Module"] : null;
            this.cellVoltageMin2Sensor = _data["cellVoltageMin2Sensor"] !== undefined ? _data["cellVoltageMin2Sensor"] : null;
            this.cellVoltageMin2LocationRaw = _data["cellVoltageMin2LocationRaw"] !== undefined ? _data["cellVoltageMin2LocationRaw"] : null;
            this.cellVoltageAverage = _data["cellVoltageAverage"] !== undefined ? _data["cellVoltageAverage"] : null;
            this.cellTemperatureMax1 = _data["cellTemperatureMax1"] !== undefined ? _data["cellTemperatureMax1"] : null;
            this.cellTemperatureMax1Location = _data["cellTemperatureMax1Location"] !== undefined ? _data["cellTemperatureMax1Location"] : null;
            this.cellTemperatureMax1LocationRaw = _data["cellTemperatureMax1LocationRaw"] !== undefined ? _data["cellTemperatureMax1LocationRaw"] : null;
            this.cellTemperatureMax1ModuleLocation = _data["cellTemperatureMax1ModuleLocation"] !== undefined ? _data["cellTemperatureMax1ModuleLocation"] : null;
            this.cellTemperatureMax1SensorLocation = _data["cellTemperatureMax1SensorLocation"] !== undefined ? _data["cellTemperatureMax1SensorLocation"] : null;
            this.cellTemperatureMax2 = _data["cellTemperatureMax2"] !== undefined ? _data["cellTemperatureMax2"] : null;
            this.cellTemperatureMax2Location = _data["cellTemperatureMax2Location"] !== undefined ? _data["cellTemperatureMax2Location"] : null;
            this.cellTemperatureMax2ModuleLocation = _data["cellTemperatureMax2ModuleLocation"] !== undefined ? _data["cellTemperatureMax2ModuleLocation"] : null;
            this.cellTemperatureMax2SensorLocation = _data["cellTemperatureMax2SensorLocation"] !== undefined ? _data["cellTemperatureMax2SensorLocation"] : null;
            this.cellTemperatureMax2LocationRaw = _data["cellTemperatureMax2LocationRaw"] !== undefined ? _data["cellTemperatureMax2LocationRaw"] : null;
            this.cellTemperatureMin1 = _data["cellTemperatureMin1"] !== undefined ? _data["cellTemperatureMin1"] : null;
            this.cellTemperatureMin1Location = _data["cellTemperatureMin1Location"] !== undefined ? _data["cellTemperatureMin1Location"] : null;
            this.cellTemperatureMin1Module = _data["cellTemperatureMin1Module"] !== undefined ? _data["cellTemperatureMin1Module"] : null;
            this.cellTemperatureMin1Sensor = _data["cellTemperatureMin1Sensor"] !== undefined ? _data["cellTemperatureMin1Sensor"] : null;
            this.cellTemperatureMin1LocationRaw = _data["cellTemperatureMin1LocationRaw"] !== undefined ? _data["cellTemperatureMin1LocationRaw"] : null;
            this.cellTemperatureMin2 = _data["cellTemperatureMin2"] !== undefined ? _data["cellTemperatureMin2"] : null;
            this.cellTemperatureMin2Location = _data["cellTemperatureMin2Location"] !== undefined ? _data["cellTemperatureMin2Location"] : null;
            this.cellTemperatureMin2LocationRaw = _data["cellTemperatureMin2LocationRaw"] !== undefined ? _data["cellTemperatureMin2LocationRaw"] : null;
            this.cellTemperatureMin2Module = _data["cellTemperatureMin2Module"] !== undefined ? _data["cellTemperatureMin2Module"] : null;
            this.cellTemperatureMin2Sensor = _data["cellTemperatureMin2Sensor"] !== undefined ? _data["cellTemperatureMin2Sensor"] : null;
            this.cellTemperatureAverage = _data["cellTemperatureAverage"] !== undefined ? _data["cellTemperatureAverage"] : null;
            this.terminalTemperatureMax = _data["terminalTemperatureMax"] !== undefined ? _data["terminalTemperatureMax"] : null;
            this.terminalTemperatureMaxModule = _data["terminalTemperatureMaxModule"] !== undefined ? _data["terminalTemperatureMaxModule"] : null;
            this.terminalTemperatureMaxSensor = _data["terminalTemperatureMaxSensor"] !== undefined ? _data["terminalTemperatureMaxSensor"] : null;
            this.terminalTemperatureMaxLocation = _data["terminalTemperatureMaxLocation"] !== undefined ? _data["terminalTemperatureMaxLocation"] : null;
            this.terminalTemperatureMin = _data["terminalTemperatureMin"] !== undefined ? _data["terminalTemperatureMin"] : null;
            this.terminalTemperatureMinModule = _data["terminalTemperatureMinModule"] !== undefined ? _data["terminalTemperatureMinModule"] : null;
            this.terminalTemperatureMinSensor = _data["terminalTemperatureMinSensor"] !== undefined ? _data["terminalTemperatureMinSensor"] : null;
            this.terminalTemperatureMinLocation = _data["terminalTemperatureMinLocation"] !== undefined ? _data["terminalTemperatureMinLocation"] : null;
            this.mccbOn = _data["mccbOn"] !== undefined ? _data["mccbOn"] : null;
            this.fuseOn = _data["fuseOn"] !== undefined ? _data["fuseOn"] : null;
            this.minorProtection1 = _data["minorProtection1"] !== undefined ? _data["minorProtection1"] : null;
            this.minorProtection2 = _data["minorProtection2"] !== undefined ? _data["minorProtection2"] : null;
            this.minorProtection3 = _data["minorProtection3"] !== undefined ? _data["minorProtection3"] : null;
            this.minorProtection4 = _data["minorProtection4"] !== undefined ? _data["minorProtection4"] : null;
            this.alarm1Summary = _data["alarm1Summary"] !== undefined ? _data["alarm1Summary"] : null;
            this.alarm2Summary = _data["alarm2Summary"] !== undefined ? _data["alarm2Summary"] : null;
            this.alarm3Summary = _data["alarm3Summary"] !== undefined ? _data["alarm3Summary"] : null;
            this.alarm4Summary = _data["alarm4Summary"] !== undefined ? _data["alarm4Summary"] : null;
            this.stringSumVoltage = _data["stringSumVoltage"] !== undefined ? _data["stringSumVoltage"] : null;
            this.stringVoltageSenseVariation = _data["stringVoltageSenseVariation"] !== undefined ? _data["stringVoltageSenseVariation"] : null;
            this.yearMonth = _data["yearMonth"] !== undefined ? _data["yearMonth"] : null;
            this.ambientTemperatures = _data["ambientTemperatures"] !== undefined ? _data["ambientTemperatures"] : null;
            this.temperatureUnitOfMeasurement = _data["temperatureUnitOfMeasurement"] !== undefined ? _data["temperatureUnitOfMeasurement"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.stringStatusId = _data["stringStatusId"] !== undefined ? _data["stringStatusId"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.stringStatus = _data["stringStatus"] !== undefined ? _data["stringStatus"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StringSnapshotModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["snapshotId"] = this.snapshotId !== undefined ? this.snapshotId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["current"] = this.current !== undefined ? this.current : null;
        data["rippleCurrent"] = this.rippleCurrent !== undefined ? this.rippleCurrent : null;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null;
        data["humidity"] = this.humidity !== undefined ? this.humidity : null;
        data["ambientTemperature"] = this.ambientTemperature !== undefined ? this.ambientTemperature : null;
        data["ambientTemperature2"] = this.ambientTemperature2 !== undefined ? this.ambientTemperature2 : null;
        data["ambientTemperatureMedian"] = this.ambientTemperatureMedian !== undefined ? this.ambientTemperatureMedian : null;
        data["ambientMedianToBlockMedianVariation"] = this.ambientMedianToBlockMedianVariation !== undefined ? this.ambientMedianToBlockMedianVariation : null;
        data["blockVoltageVariation"] = this.blockVoltageVariation !== undefined ? this.blockVoltageVariation : null;
        data["blockVoltageMedian"] = this.blockVoltageMedian !== undefined ? this.blockVoltageMedian : null;
        data["blockOhmicMin"] = this.blockOhmicMin !== undefined ? this.blockOhmicMin : null;
        data["blockOhmicMinLocation"] = this.blockOhmicMinLocation !== undefined ? this.blockOhmicMinLocation : null;
        data["blockOhmicMax"] = this.blockOhmicMax !== undefined ? this.blockOhmicMax : null;
        data["blockOhmicMaxLocation"] = this.blockOhmicMaxLocation !== undefined ? this.blockOhmicMaxLocation : null;
        data["blockOhmicVariation"] = this.blockOhmicVariation !== undefined ? this.blockOhmicVariation : null;
        data["blockOhmicMedian"] = this.blockOhmicMedian !== undefined ? this.blockOhmicMedian : null;
        data["blockOhmicRiseMin"] = this.blockOhmicRiseMin !== undefined ? this.blockOhmicRiseMin : null;
        data["blockOhmicRiseMinLocation"] = this.blockOhmicRiseMinLocation !== undefined ? this.blockOhmicRiseMinLocation : null;
        data["blockOhmicRiseMax"] = this.blockOhmicRiseMax !== undefined ? this.blockOhmicRiseMax : null;
        data["blockOhmicRiseMaxLocation"] = this.blockOhmicRiseMaxLocation !== undefined ? this.blockOhmicRiseMaxLocation : null;
        data["blockOhmicRiseVariation"] = this.blockOhmicRiseVariation !== undefined ? this.blockOhmicRiseVariation : null;
        data["blockOhmicRiseMedian"] = this.blockOhmicRiseMedian !== undefined ? this.blockOhmicRiseMedian : null;
        data["blockTemperatureVariation"] = this.blockTemperatureVariation !== undefined ? this.blockTemperatureVariation : null;
        data["blockTemperatureMedian"] = this.blockTemperatureMedian !== undefined ? this.blockTemperatureMedian : null;
        data["ambientTemperatureVariation"] = this.ambientTemperatureVariation !== undefined ? this.ambientTemperatureVariation : null;
        data["cellSummationVoltage"] = this.cellSummationVoltage !== undefined ? this.cellSummationVoltage : null;
        data["soc"] = this.soc !== undefined ? this.soc : null;
        data["soh"] = this.soh !== undefined ? this.soh : null;
        data["cellVoltageMax1"] = this.cellVoltageMax1 !== undefined ? this.cellVoltageMax1 : null;
        data["cellVoltageMax1Location"] = this.cellVoltageMax1Location !== undefined ? this.cellVoltageMax1Location : null;
        data["cellVoltageMax1LocationRaw"] = this.cellVoltageMax1LocationRaw !== undefined ? this.cellVoltageMax1LocationRaw : null;
        data["cellVoltageMax1Module"] = this.cellVoltageMax1Module !== undefined ? this.cellVoltageMax1Module : null;
        data["cellVoltageMax1Sensor"] = this.cellVoltageMax1Sensor !== undefined ? this.cellVoltageMax1Sensor : null;
        data["cellVoltageMax2"] = this.cellVoltageMax2 !== undefined ? this.cellVoltageMax2 : null;
        data["cellVoltageMax2Location"] = this.cellVoltageMax2Location !== undefined ? this.cellVoltageMax2Location : null;
        data["cellVoltageMax2LocationRaw"] = this.cellVoltageMax2LocationRaw !== undefined ? this.cellVoltageMax2LocationRaw : null;
        data["cellVoltageMax2Module"] = this.cellVoltageMax2Module !== undefined ? this.cellVoltageMax2Module : null;
        data["cellVoltageMax2Sensor"] = this.cellVoltageMax2Sensor !== undefined ? this.cellVoltageMax2Sensor : null;
        data["cellVoltageMin1"] = this.cellVoltageMin1 !== undefined ? this.cellVoltageMin1 : null;
        data["cellVoltageMin1Location"] = this.cellVoltageMin1Location !== undefined ? this.cellVoltageMin1Location : null;
        data["cellVoltageMin1LocationRaw"] = this.cellVoltageMin1LocationRaw !== undefined ? this.cellVoltageMin1LocationRaw : null;
        data["cellVoltageMin1Module"] = this.cellVoltageMin1Module !== undefined ? this.cellVoltageMin1Module : null;
        data["cellVoltageMin1Sensor"] = this.cellVoltageMin1Sensor !== undefined ? this.cellVoltageMin1Sensor : null;
        data["cellVoltageMin2"] = this.cellVoltageMin2 !== undefined ? this.cellVoltageMin2 : null;
        data["cellVoltageMin2Location"] = this.cellVoltageMin2Location !== undefined ? this.cellVoltageMin2Location : null;
        data["cellVoltageMin2Module"] = this.cellVoltageMin2Module !== undefined ? this.cellVoltageMin2Module : null;
        data["cellVoltageMin2Sensor"] = this.cellVoltageMin2Sensor !== undefined ? this.cellVoltageMin2Sensor : null;
        data["cellVoltageMin2LocationRaw"] = this.cellVoltageMin2LocationRaw !== undefined ? this.cellVoltageMin2LocationRaw : null;
        data["cellVoltageAverage"] = this.cellVoltageAverage !== undefined ? this.cellVoltageAverage : null;
        data["cellTemperatureMax1"] = this.cellTemperatureMax1 !== undefined ? this.cellTemperatureMax1 : null;
        data["cellTemperatureMax1Location"] = this.cellTemperatureMax1Location !== undefined ? this.cellTemperatureMax1Location : null;
        data["cellTemperatureMax1LocationRaw"] = this.cellTemperatureMax1LocationRaw !== undefined ? this.cellTemperatureMax1LocationRaw : null;
        data["cellTemperatureMax1ModuleLocation"] = this.cellTemperatureMax1ModuleLocation !== undefined ? this.cellTemperatureMax1ModuleLocation : null;
        data["cellTemperatureMax1SensorLocation"] = this.cellTemperatureMax1SensorLocation !== undefined ? this.cellTemperatureMax1SensorLocation : null;
        data["cellTemperatureMax2"] = this.cellTemperatureMax2 !== undefined ? this.cellTemperatureMax2 : null;
        data["cellTemperatureMax2Location"] = this.cellTemperatureMax2Location !== undefined ? this.cellTemperatureMax2Location : null;
        data["cellTemperatureMax2ModuleLocation"] = this.cellTemperatureMax2ModuleLocation !== undefined ? this.cellTemperatureMax2ModuleLocation : null;
        data["cellTemperatureMax2SensorLocation"] = this.cellTemperatureMax2SensorLocation !== undefined ? this.cellTemperatureMax2SensorLocation : null;
        data["cellTemperatureMax2LocationRaw"] = this.cellTemperatureMax2LocationRaw !== undefined ? this.cellTemperatureMax2LocationRaw : null;
        data["cellTemperatureMin1"] = this.cellTemperatureMin1 !== undefined ? this.cellTemperatureMin1 : null;
        data["cellTemperatureMin1Location"] = this.cellTemperatureMin1Location !== undefined ? this.cellTemperatureMin1Location : null;
        data["cellTemperatureMin1Module"] = this.cellTemperatureMin1Module !== undefined ? this.cellTemperatureMin1Module : null;
        data["cellTemperatureMin1Sensor"] = this.cellTemperatureMin1Sensor !== undefined ? this.cellTemperatureMin1Sensor : null;
        data["cellTemperatureMin1LocationRaw"] = this.cellTemperatureMin1LocationRaw !== undefined ? this.cellTemperatureMin1LocationRaw : null;
        data["cellTemperatureMin2"] = this.cellTemperatureMin2 !== undefined ? this.cellTemperatureMin2 : null;
        data["cellTemperatureMin2Location"] = this.cellTemperatureMin2Location !== undefined ? this.cellTemperatureMin2Location : null;
        data["cellTemperatureMin2LocationRaw"] = this.cellTemperatureMin2LocationRaw !== undefined ? this.cellTemperatureMin2LocationRaw : null;
        data["cellTemperatureMin2Module"] = this.cellTemperatureMin2Module !== undefined ? this.cellTemperatureMin2Module : null;
        data["cellTemperatureMin2Sensor"] = this.cellTemperatureMin2Sensor !== undefined ? this.cellTemperatureMin2Sensor : null;
        data["cellTemperatureAverage"] = this.cellTemperatureAverage !== undefined ? this.cellTemperatureAverage : null;
        data["terminalTemperatureMax"] = this.terminalTemperatureMax !== undefined ? this.terminalTemperatureMax : null;
        data["terminalTemperatureMaxModule"] = this.terminalTemperatureMaxModule !== undefined ? this.terminalTemperatureMaxModule : null;
        data["terminalTemperatureMaxSensor"] = this.terminalTemperatureMaxSensor !== undefined ? this.terminalTemperatureMaxSensor : null;
        data["terminalTemperatureMaxLocation"] = this.terminalTemperatureMaxLocation !== undefined ? this.terminalTemperatureMaxLocation : null;
        data["terminalTemperatureMin"] = this.terminalTemperatureMin !== undefined ? this.terminalTemperatureMin : null;
        data["terminalTemperatureMinModule"] = this.terminalTemperatureMinModule !== undefined ? this.terminalTemperatureMinModule : null;
        data["terminalTemperatureMinSensor"] = this.terminalTemperatureMinSensor !== undefined ? this.terminalTemperatureMinSensor : null;
        data["terminalTemperatureMinLocation"] = this.terminalTemperatureMinLocation !== undefined ? this.terminalTemperatureMinLocation : null;
        data["mccbOn"] = this.mccbOn !== undefined ? this.mccbOn : null;
        data["fuseOn"] = this.fuseOn !== undefined ? this.fuseOn : null;
        data["minorProtection1"] = this.minorProtection1 !== undefined ? this.minorProtection1 : null;
        data["minorProtection2"] = this.minorProtection2 !== undefined ? this.minorProtection2 : null;
        data["minorProtection3"] = this.minorProtection3 !== undefined ? this.minorProtection3 : null;
        data["minorProtection4"] = this.minorProtection4 !== undefined ? this.minorProtection4 : null;
        data["alarm1Summary"] = this.alarm1Summary !== undefined ? this.alarm1Summary : null;
        data["alarm2Summary"] = this.alarm2Summary !== undefined ? this.alarm2Summary : null;
        data["alarm3Summary"] = this.alarm3Summary !== undefined ? this.alarm3Summary : null;
        data["alarm4Summary"] = this.alarm4Summary !== undefined ? this.alarm4Summary : null;
        data["stringSumVoltage"] = this.stringSumVoltage !== undefined ? this.stringSumVoltage : null;
        data["stringVoltageSenseVariation"] = this.stringVoltageSenseVariation !== undefined ? this.stringVoltageSenseVariation : null;
        data["yearMonth"] = this.yearMonth !== undefined ? this.yearMonth : null;
        data["ambientTemperatures"] = this.ambientTemperatures !== undefined ? this.ambientTemperatures : null;
        data["temperatureUnitOfMeasurement"] = this.temperatureUnitOfMeasurement !== undefined ? this.temperatureUnitOfMeasurement : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["stringStatusId"] = this.stringStatusId !== undefined ? this.stringStatusId : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["stringStatus"] = this.stringStatus !== undefined ? this.stringStatus : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        return data;
    }
}
export class ApiRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestId = _data["requestId"] !== undefined ? _data["requestId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.deviceId = _data["deviceId"] !== undefined ? _data["deviceId"] : null;
            this.apiRequestId = _data["apiRequestId"] !== undefined ? _data["apiRequestId"] : null;
            this.requestTypeId = _data["requestTypeId"] !== undefined ? _data["requestTypeId"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.hasTimedOut = _data["hasTimedOut"] !== undefined ? _data["hasTimedOut"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenSent = _data["whenSent"] ? new Date(_data["whenSent"].toString()) : null;
            this.whenReceived = _data["whenReceived"] ? new Date(_data["whenReceived"].toString()) : null;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : null;
            this.whenRead = _data["whenRead"] ? new Date(_data["whenRead"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ApiRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId !== undefined ? this.requestId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : null;
        data["apiRequestId"] = this.apiRequestId !== undefined ? this.apiRequestId : null;
        data["requestTypeId"] = this.requestTypeId !== undefined ? this.requestTypeId : null;
        data["message"] = this.message !== undefined ? this.message : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["hasTimedOut"] = this.hasTimedOut !== undefined ? this.hasTimedOut : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenSent"] = this.whenSent ? this.whenSent.toISOString() : null;
        data["whenReceived"] = this.whenReceived ? this.whenReceived.toISOString() : null;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : null;
        data["whenRead"] = this.whenRead ? this.whenRead.toISOString() : null;
        return data;
    }
}
export class DateSnapshotModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.measurementTime = _data["measurementTime"] ? new Date(_data["measurementTime"].toString()) : null;
            this.systemSnapshot = _data["systemSnapshot"] ? SystemSnapshotModel.fromJS(_data["systemSnapshot"]) : null;
            if (Array.isArray(_data["stringSnapshots"])) {
                this.stringSnapshots = [];
                for (let item of _data["stringSnapshots"])
                    this.stringSnapshots.push(StringSnapshotModel.fromJS(item));
            }
            else {
                this.stringSnapshots = null;
            }
            this.measurementTimeText = _data["measurementTimeText"] !== undefined ? _data["measurementTimeText"] : null;
            this.batteryType = _data["batteryType"] !== undefined ? _data["batteryType"] : null;
            this.lithiumBatteryType = _data["lithiumBatteryType"] !== undefined ? _data["lithiumBatteryType"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DateSnapshotModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["measurementTime"] = this.measurementTime ? this.measurementTime.toISOString() : null;
        data["systemSnapshot"] = this.systemSnapshot ? this.systemSnapshot.toJSON() : null;
        if (Array.isArray(this.stringSnapshots)) {
            data["stringSnapshots"] = [];
            for (let item of this.stringSnapshots)
                data["stringSnapshots"].push(item ? item.toJSON() : null);
        }
        data["measurementTimeText"] = this.measurementTimeText !== undefined ? this.measurementTimeText : null;
        data["batteryType"] = this.batteryType !== undefined ? this.batteryType : null;
        data["lithiumBatteryType"] = this.lithiumBatteryType !== undefined ? this.lithiumBatteryType : null;
        return data;
    }
}
export class SystemSnapshotModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.snapshotId = _data["snapshotId"] !== undefined ? _data["snapshotId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null;
            this.current = _data["current"] !== undefined ? _data["current"] : null;
            this.soc = _data["soc"] !== undefined ? _data["soc"] : null;
            this.soh = _data["soh"] !== undefined ? _data["soh"] : null;
            this.maxVoltage = _data["maxVoltage"] !== undefined ? _data["maxVoltage"] : null;
            this.minVoltage = _data["minVoltage"] !== undefined ? _data["minVoltage"] : null;
            this.maxTemperature = _data["maxTemperature"] !== undefined ? _data["maxTemperature"] : null;
            this.minTemperature = _data["minTemperature"] !== undefined ? _data["minTemperature"] : null;
            this.temperatureUnitOfMeasurement = _data["temperatureUnitOfMeasurement"] !== undefined ? _data["temperatureUnitOfMeasurement"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemSnapshotModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["snapshotId"] = this.snapshotId !== undefined ? this.snapshotId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null;
        data["current"] = this.current !== undefined ? this.current : null;
        data["soc"] = this.soc !== undefined ? this.soc : null;
        data["soh"] = this.soh !== undefined ? this.soh : null;
        data["maxVoltage"] = this.maxVoltage !== undefined ? this.maxVoltage : null;
        data["minVoltage"] = this.minVoltage !== undefined ? this.minVoltage : null;
        data["maxTemperature"] = this.maxTemperature !== undefined ? this.maxTemperature : null;
        data["minTemperature"] = this.minTemperature !== undefined ? this.minTemperature : null;
        data["temperatureUnitOfMeasurement"] = this.temperatureUnitOfMeasurement !== undefined ? this.temperatureUnitOfMeasurement : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        return data;
    }
}
export var BatteryTypeEnum;
(function (BatteryTypeEnum) {
    BatteryTypeEnum[BatteryTypeEnum["LeadAcid"] = 1] = "LeadAcid";
    BatteryTypeEnum[BatteryTypeEnum["Lithium"] = 2] = "Lithium";
})(BatteryTypeEnum || (BatteryTypeEnum = {}));
export var LithiumBatteryTypeEnum;
(function (LithiumBatteryTypeEnum) {
    LithiumBatteryTypeEnum[LithiumBatteryTypeEnum["SamsungGen1AndGen2"] = 1] = "SamsungGen1AndGen2";
    LithiumBatteryTypeEnum[LithiumBatteryTypeEnum["SamsungGen3"] = 2] = "SamsungGen3";
})(LithiumBatteryTypeEnum || (LithiumBatteryTypeEnum = {}));
export class PointInTimeStatusModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.componentStatusId = _data["componentStatusId"] !== undefined ? _data["componentStatusId"] : null;
            this.componentStatusName = _data["componentStatusName"] !== undefined ? _data["componentStatusName"] : null;
            this.stringStatusId = _data["stringStatusId"] !== undefined ? _data["stringStatusId"] : null;
            this.stringStatusName = _data["stringStatusName"] !== undefined ? _data["stringStatusName"] : null;
            if (Array.isArray(_data["measurementStates"])) {
                this.measurementStates = [];
                for (let item of _data["measurementStates"])
                    this.measurementStates.push(MeasurementStatusModel.fromJS(item));
            }
            else {
                this.measurementStates = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PointInTimeStatusModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["componentStatusId"] = this.componentStatusId !== undefined ? this.componentStatusId : null;
        data["componentStatusName"] = this.componentStatusName !== undefined ? this.componentStatusName : null;
        data["stringStatusId"] = this.stringStatusId !== undefined ? this.stringStatusId : null;
        data["stringStatusName"] = this.stringStatusName !== undefined ? this.stringStatusName : null;
        if (Array.isArray(this.measurementStates)) {
            data["measurementStates"] = [];
            for (let item of this.measurementStates)
                data["measurementStates"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class MeasurementStatusModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.measurementTypeId = _data["measurementTypeId"] !== undefined ? _data["measurementTypeId"] : null;
            this.measurementTypeName = _data["measurementTypeName"] !== undefined ? _data["measurementTypeName"] : null;
            this.componentCode = _data["componentCode"] !== undefined ? _data["componentCode"] : null;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null;
            this.limit = _data["limit"] ? LimitModel.fromJS(_data["limit"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementStatusModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["measurementTypeId"] = this.measurementTypeId !== undefined ? this.measurementTypeId : null;
        data["measurementTypeName"] = this.measurementTypeName !== undefined ? this.measurementTypeName : null;
        data["componentCode"] = this.componentCode !== undefined ? this.componentCode : null;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null;
        data["limit"] = this.limit ? this.limit.toJSON() : null;
        return data;
    }
}
export class BaseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BaseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : null;
        return data;
    }
}
export class BaseAuthoredModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.authorId = _data["authorId"] !== undefined ? _data["authorId"] : null;
            this.authorName = _data["authorName"] !== undefined ? _data["authorName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BaseAuthoredModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["authorId"] = this.authorId !== undefined ? this.authorId : null;
        data["authorName"] = this.authorName !== undefined ? this.authorName : null;
        super.toJSON(data);
        return data;
    }
}
export class LimitModel extends BaseAuthoredModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.limitId = _data["limitId"] !== undefined ? _data["limitId"] : null;
            this.alarmTypeId = _data["alarmTypeId"] !== undefined ? _data["alarmTypeId"] : null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null;
            this.limitName = _data["limitName"] !== undefined ? _data["limitName"] : null;
            this.lowerCriticalLimit = _data["lowerCriticalLimit"] !== undefined ? _data["lowerCriticalLimit"] : null;
            this.lowerWarningLimit = _data["lowerWarningLimit"] !== undefined ? _data["lowerWarningLimit"] : null;
            this.upperCriticalLimit = _data["upperCriticalLimit"] !== undefined ? _data["upperCriticalLimit"] : null;
            this.upperWarningLimit = _data["upperWarningLimit"] !== undefined ? _data["upperWarningLimit"] : null;
            this.floatThreshold = _data["floatThreshold"] !== undefined ? _data["floatThreshold"] : null;
            this.floatHysteresis = _data["floatHysteresis"] !== undefined ? _data["floatHysteresis"] : null;
            this.chargeThreshold = _data["chargeThreshold"] !== undefined ? _data["chargeThreshold"] : null;
            this.chargeHysteresis = _data["chargeHysteresis"] !== undefined ? _data["chargeHysteresis"] : null;
            this.dischargeThreshold = _data["dischargeThreshold"] !== undefined ? _data["dischargeThreshold"] : null;
            this.dischargeHysteresis = _data["dischargeHysteresis"] !== undefined ? _data["dischargeHysteresis"] : null;
            this.layout = _data["layout"] ? LimitLayoutModel.fromJS(_data["layout"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LimitModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["limitId"] = this.limitId !== undefined ? this.limitId : null;
        data["alarmTypeId"] = this.alarmTypeId !== undefined ? this.alarmTypeId : null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null;
        data["limitName"] = this.limitName !== undefined ? this.limitName : null;
        data["lowerCriticalLimit"] = this.lowerCriticalLimit !== undefined ? this.lowerCriticalLimit : null;
        data["lowerWarningLimit"] = this.lowerWarningLimit !== undefined ? this.lowerWarningLimit : null;
        data["upperCriticalLimit"] = this.upperCriticalLimit !== undefined ? this.upperCriticalLimit : null;
        data["upperWarningLimit"] = this.upperWarningLimit !== undefined ? this.upperWarningLimit : null;
        data["floatThreshold"] = this.floatThreshold !== undefined ? this.floatThreshold : null;
        data["floatHysteresis"] = this.floatHysteresis !== undefined ? this.floatHysteresis : null;
        data["chargeThreshold"] = this.chargeThreshold !== undefined ? this.chargeThreshold : null;
        data["chargeHysteresis"] = this.chargeHysteresis !== undefined ? this.chargeHysteresis : null;
        data["dischargeThreshold"] = this.dischargeThreshold !== undefined ? this.dischargeThreshold : null;
        data["dischargeHysteresis"] = this.dischargeHysteresis !== undefined ? this.dischargeHysteresis : null;
        data["layout"] = this.layout ? this.layout.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class LimitLayoutModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.layoutId = _data["layoutId"] !== undefined ? _data["layoutId"] : null;
            this.layoutName = _data["layoutName"] !== undefined ? _data["layoutName"] : null;
            this.showLowCritical = _data["showLowCritical"] !== undefined ? _data["showLowCritical"] : null;
            this.showLowWarning = _data["showLowWarning"] !== undefined ? _data["showLowWarning"] : null;
            this.showHighCritical = _data["showHighCritical"] !== undefined ? _data["showHighCritical"] : null;
            this.showHighWarning = _data["showHighWarning"] !== undefined ? _data["showHighWarning"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LimitLayoutModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["layoutId"] = this.layoutId !== undefined ? this.layoutId : null;
        data["layoutName"] = this.layoutName !== undefined ? this.layoutName : null;
        data["showLowCritical"] = this.showLowCritical !== undefined ? this.showLowCritical : null;
        data["showLowWarning"] = this.showLowWarning !== undefined ? this.showLowWarning : null;
        data["showHighCritical"] = this.showHighCritical !== undefined ? this.showHighCritical : null;
        data["showHighWarning"] = this.showHighWarning !== undefined ? this.showHighWarning : null;
        return data;
    }
}
export class Chart {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.componentType = _data["componentType"] !== undefined ? _data["componentType"] : null;
            this.imperialMeasurementSystem = _data["imperialMeasurementSystem"] !== undefined ? _data["imperialMeasurementSystem"] : null;
            this.zeroToHundredPercentScale = _data["zeroToHundredPercentScale"] !== undefined ? _data["zeroToHundredPercentScale"] : null;
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : null;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : null;
            if (Array.isArray(_data["labels"])) {
                this.labels = [];
                for (let item of _data["labels"])
                    this.labels.push(item);
            }
            else {
                this.labels = null;
            }
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [];
                for (let item of _data["annotations"])
                    this.annotations.push(Annotation.fromJS(item));
            }
            else {
                this.annotations = null;
            }
            if (Array.isArray(_data["datasets"])) {
                this.datasets = [];
                for (let item of _data["datasets"])
                    this.datasets.push(Dataset.fromJS(item));
            }
            else {
                this.datasets = null;
            }
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [];
                for (let item of _data["measurements"])
                    this.measurements.push(AxisData.fromJS(item));
            }
            else {
                this.measurements = null;
            }
            if (Array.isArray(_data["ranges"])) {
                this.ranges = [];
                for (let item of _data["ranges"])
                    this.ranges.push(AxisDataRange.fromJS(item));
            }
            else {
                this.ranges = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Chart();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["componentType"] = this.componentType !== undefined ? this.componentType : null;
        data["imperialMeasurementSystem"] = this.imperialMeasurementSystem !== undefined ? this.imperialMeasurementSystem : null;
        data["zeroToHundredPercentScale"] = this.zeroToHundredPercentScale !== undefined ? this.zeroToHundredPercentScale : null;
        data["minValue"] = this.minValue !== undefined ? this.minValue : null;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : null;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.datasets)) {
            data["datasets"] = [];
            for (let item of this.datasets)
                data["datasets"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.ranges)) {
            data["ranges"] = [];
            for (let item of this.ranges)
                data["ranges"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class Annotation {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.yScaleID = _data["yScaleID"] !== undefined ? _data["yScaleID"] : null;
            this.xScaleID = _data["xScaleID"] !== undefined ? _data["xScaleID"] : null;
            this.type = _data["type"] !== undefined ? _data["type"] : null;
            this.borderColor = _data["borderColor"] !== undefined ? _data["borderColor"] : null;
            this.borderWidth = _data["borderWidth"] !== undefined ? _data["borderWidth"] : null;
            this.xMin = _data["xMin"] !== undefined ? _data["xMin"] : null;
            this.xMax = _data["xMax"] !== undefined ? _data["xMax"] : null;
            this.yMin = _data["yMin"] !== undefined ? _data["yMin"] : null;
            this.yMax = _data["yMax"] !== undefined ? _data["yMax"] : null;
            this.value = _data["value"] !== undefined ? _data["value"] : null;
            this.xValue = _data["xValue"] !== undefined ? _data["xValue"] : null;
            this.yValue = _data["yValue"] !== undefined ? _data["yValue"] : null;
            this.content = _data["content"] !== undefined ? _data["content"] : null;
            this.position = _data["position"] !== undefined ? _data["position"] : null;
            this.font = _data["font"] ? AnnotationFont.fromJS(_data["font"]) : null;
            this.color = _data["color"] !== undefined ? _data["color"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Annotation();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["yScaleID"] = this.yScaleID !== undefined ? this.yScaleID : null;
        data["xScaleID"] = this.xScaleID !== undefined ? this.xScaleID : null;
        data["type"] = this.type !== undefined ? this.type : null;
        data["borderColor"] = this.borderColor !== undefined ? this.borderColor : null;
        data["borderWidth"] = this.borderWidth !== undefined ? this.borderWidth : null;
        data["xMin"] = this.xMin !== undefined ? this.xMin : null;
        data["xMax"] = this.xMax !== undefined ? this.xMax : null;
        data["yMin"] = this.yMin !== undefined ? this.yMin : null;
        data["yMax"] = this.yMax !== undefined ? this.yMax : null;
        data["value"] = this.value !== undefined ? this.value : null;
        data["xValue"] = this.xValue !== undefined ? this.xValue : null;
        data["yValue"] = this.yValue !== undefined ? this.yValue : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["position"] = this.position !== undefined ? this.position : null;
        data["font"] = this.font ? this.font.toJSON() : null;
        data["color"] = this.color !== undefined ? this.color : null;
        return data;
    }
}
export class AnnotationFont {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.family = _data["family"] !== undefined ? _data["family"] : null;
            this.size = _data["size"] !== undefined ? _data["size"] : null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AnnotationFont();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["family"] = this.family !== undefined ? this.family : null;
        data["size"] = this.size !== undefined ? this.size : null;
        data["weight"] = this.weight !== undefined ? this.weight : null;
        return data;
    }
}
export class Dataset {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.datasetId = _data["datasetId"] !== undefined ? _data["datasetId"] : null;
            this.measurementTypeId = _data["measurementTypeId"] !== undefined ? _data["measurementTypeId"] : null;
            if (Array.isArray(_data["ids"])) {
                this.ids = [];
                for (let item of _data["ids"])
                    this.ids.push(item);
            }
            else {
                this.ids = null;
            }
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(item);
            }
            else {
                this.data = null;
            }
            this.yAxisID = _data["yAxisID"] !== undefined ? _data["yAxisID"] : null;
            this.xAxisID = _data["xAxisID"] !== undefined ? _data["xAxisID"] : null;
            this.label = _data["label"] !== undefined ? _data["label"] : null;
            this.unitOfMeasurement = _data["unitOfMeasurement"] !== undefined ? _data["unitOfMeasurement"] : null;
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            if (Array.isArray(_data["borderDash"])) {
                this.borderDash = [];
                for (let item of _data["borderDash"])
                    this.borderDash.push(item);
            }
            else {
                this.borderDash = null;
            }
            if (Array.isArray(_data["backgroundColor"])) {
                this.backgroundColor = [];
                for (let item of _data["backgroundColor"])
                    this.backgroundColor.push(item);
            }
            else {
                this.backgroundColor = null;
            }
            this.borderColor = _data["borderColor"] !== undefined ? _data["borderColor"] : null;
            this.fill = _data["fill"] !== undefined ? _data["fill"] : null;
            this.lineTension = _data["lineTension"] !== undefined ? _data["lineTension"] : null;
            this.borderWidth = _data["borderWidth"] !== undefined ? _data["borderWidth"] : null;
            this.pointRadius = _data["pointRadius"] !== undefined ? _data["pointRadius"] : null;
            this.barPercentage = _data["barPercentage"] !== undefined ? _data["barPercentage"] : null;
            this.categoryPercentage = _data["categoryPercentage"] !== undefined ? _data["categoryPercentage"] : null;
            this.maxBarThickness = _data["maxBarThickness"] !== undefined ? _data["maxBarThickness"] : null;
            this.spanGaps = _data["spanGaps"] !== undefined ? _data["spanGaps"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Dataset();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["datasetId"] = this.datasetId !== undefined ? this.datasetId : null;
        data["measurementTypeId"] = this.measurementTypeId !== undefined ? this.measurementTypeId : null;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["yAxisID"] = this.yAxisID !== undefined ? this.yAxisID : null;
        data["xAxisID"] = this.xAxisID !== undefined ? this.xAxisID : null;
        data["label"] = this.label !== undefined ? this.label : null;
        data["unitOfMeasurement"] = this.unitOfMeasurement !== undefined ? this.unitOfMeasurement : null;
        data["title"] = this.title !== undefined ? this.title : null;
        if (Array.isArray(this.borderDash)) {
            data["borderDash"] = [];
            for (let item of this.borderDash)
                data["borderDash"].push(item);
        }
        if (Array.isArray(this.backgroundColor)) {
            data["backgroundColor"] = [];
            for (let item of this.backgroundColor)
                data["backgroundColor"].push(item);
        }
        data["borderColor"] = this.borderColor !== undefined ? this.borderColor : null;
        data["fill"] = this.fill !== undefined ? this.fill : null;
        data["lineTension"] = this.lineTension !== undefined ? this.lineTension : null;
        data["borderWidth"] = this.borderWidth !== undefined ? this.borderWidth : null;
        data["pointRadius"] = this.pointRadius !== undefined ? this.pointRadius : null;
        data["barPercentage"] = this.barPercentage !== undefined ? this.barPercentage : null;
        data["categoryPercentage"] = this.categoryPercentage !== undefined ? this.categoryPercentage : null;
        data["maxBarThickness"] = this.maxBarThickness !== undefined ? this.maxBarThickness : null;
        data["spanGaps"] = this.spanGaps !== undefined ? this.spanGaps : null;
        return data;
    }
}
export class AxisData {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : null;
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [];
                for (let item of _data["measurements"])
                    this.measurements.push(MeasurementModel.fromJS(item));
            }
            else {
                this.measurements = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AxisData();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName !== undefined ? this.groupName : null;
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class MeasurementModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.measurementTypeId = _data["measurementTypeId"] !== undefined ? _data["measurementTypeId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.numericValue = _data["numericValue"] !== undefined ? _data["numericValue"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.measurementTypeName = _data["measurementTypeName"] !== undefined ? _data["measurementTypeName"] : null;
            this.unitOfMeasurement = _data["unitOfMeasurement"] !== undefined ? _data["unitOfMeasurement"] : null;
            this.unitOfMeasurementImperial = _data["unitOfMeasurementImperial"] !== undefined ? _data["unitOfMeasurementImperial"] : null;
            this.unitOfMeasurementCode = _data["unitOfMeasurementCode"] !== undefined ? _data["unitOfMeasurementCode"] : null;
            this.unitOfMeasurementCodeImperial = _data["unitOfMeasurementCodeImperial"] !== undefined ? _data["unitOfMeasurementCodeImperial"] : null;
            this.conversionFactor = _data["conversionFactor"] !== undefined ? _data["conversionFactor"] : null;
            this.conversionAdditionalFactor = _data["conversionAdditionalFactor"] !== undefined ? _data["conversionAdditionalFactor"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["measurementTypeId"] = this.measurementTypeId !== undefined ? this.measurementTypeId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["numericValue"] = this.numericValue !== undefined ? this.numericValue : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["measurementTypeName"] = this.measurementTypeName !== undefined ? this.measurementTypeName : null;
        data["unitOfMeasurement"] = this.unitOfMeasurement !== undefined ? this.unitOfMeasurement : null;
        data["unitOfMeasurementImperial"] = this.unitOfMeasurementImperial !== undefined ? this.unitOfMeasurementImperial : null;
        data["unitOfMeasurementCode"] = this.unitOfMeasurementCode !== undefined ? this.unitOfMeasurementCode : null;
        data["unitOfMeasurementCodeImperial"] = this.unitOfMeasurementCodeImperial !== undefined ? this.unitOfMeasurementCodeImperial : null;
        data["conversionFactor"] = this.conversionFactor !== undefined ? this.conversionFactor : null;
        data["conversionAdditionalFactor"] = this.conversionAdditionalFactor !== undefined ? this.conversionAdditionalFactor : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        return data;
    }
}
export class AxisDataRange {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.axisId = _data["axisId"] !== undefined ? _data["axisId"] : null;
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : null;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AxisDataRange();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["axisId"] = this.axisId !== undefined ? this.axisId : null;
        data["minValue"] = this.minValue !== undefined ? this.minValue : null;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : null;
        return data;
    }
}
export class BaseQueryOfGetInitialSnapshotDataQueryAndSnapshotDataModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetInitialSnapshotDataQueryAndSnapshotDataModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetInitialSnapshotDataQuery extends BaseQueryOfGetInitialSnapshotDataQueryAndSnapshotDataModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
            this.measurementDate = _data["measurementDate"] ? new Date(_data["measurementDate"].toString()) : null;
            this.specificSnapshotTime = _data["specificSnapshotTime"] ? new Date(_data["specificSnapshotTime"].toString()) : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetInitialSnapshotDataQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        data["measurementDate"] = this.measurementDate ? this.measurementDate.toISOString() : null;
        data["specificSnapshotTime"] = this.specificSnapshotTime ? this.specificSnapshotTime.toISOString() : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetSystemSnapshotDataQueryAndSnapshotDataModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemSnapshotDataQueryAndSnapshotDataModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemSnapshotDataQuery extends BaseQueryOfGetSystemSnapshotDataQueryAndSnapshotDataModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemSnapshotDataQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetDateSnapshotDataQueryAndSnapshotDataModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetDateSnapshotDataQueryAndSnapshotDataModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetDateSnapshotDataQuery extends BaseQueryOfGetDateSnapshotDataQueryAndSnapshotDataModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
            this.measurementDate = _data["measurementDate"] ? new Date(_data["measurementDate"].toString()) : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDateSnapshotDataQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        data["measurementDate"] = this.measurementDate ? this.measurementDate.toISOString() : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetStringDetailDataQueryAndSnapshotDataModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetStringDetailDataQueryAndSnapshotDataModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetStringDetailDataQuery extends BaseQueryOfGetStringDetailDataQueryAndSnapshotDataModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
            this.measurementTime = _data["measurementTime"] ? new Date(_data["measurementTime"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStringDetailDataQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        data["measurementTime"] = this.measurementTime ? this.measurementTime.toISOString() : null;
        super.toJSON(data);
        return data;
    }
}
export class ProgressMessageModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.category = _data["category"] !== undefined ? _data["category"] : null;
            this.processName = _data["processName"] !== undefined ? _data["processName"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.progressCurrent = _data["progressCurrent"] !== undefined ? _data["progressCurrent"] : null;
            this.progressTotal = _data["progressTotal"] !== undefined ? _data["progressTotal"] : null;
            this.currentItem = _data["currentItem"] !== undefined ? _data["currentItem"] : null;
            this.stepDescription = _data["stepDescription"] !== undefined ? _data["stepDescription"] : null;
            this.stepCurrent = _data["stepCurrent"] !== undefined ? _data["stepCurrent"] : null;
            this.stepTotal = _data["stepTotal"] !== undefined ? _data["stepTotal"] : null;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : null;
            this.endedAt = _data["endedAt"] ? new Date(_data["endedAt"].toString()) : null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null;
            this.details = _data["details"] !== undefined ? _data["details"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressMessageModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["category"] = this.category !== undefined ? this.category : null;
        data["processName"] = this.processName !== undefined ? this.processName : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["progressCurrent"] = this.progressCurrent !== undefined ? this.progressCurrent : null;
        data["progressTotal"] = this.progressTotal !== undefined ? this.progressTotal : null;
        data["currentItem"] = this.currentItem !== undefined ? this.currentItem : null;
        data["stepDescription"] = this.stepDescription !== undefined ? this.stepDescription : null;
        data["stepCurrent"] = this.stepCurrent !== undefined ? this.stepCurrent : null;
        data["stepTotal"] = this.stepTotal !== undefined ? this.stepTotal : null;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : null;
        data["endedAt"] = this.endedAt ? this.endedAt.toISOString() : null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null;
        data["details"] = this.details !== undefined ? this.details : null;
        return data;
    }
}
export class TimeZoneListItemModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null;
            this.baseUtcOffsetMinutes = _data["baseUtcOffsetMinutes"] !== undefined ? _data["baseUtcOffsetMinutes"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneListItemModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null;
        data["baseUtcOffsetMinutes"] = this.baseUtcOffsetMinutes !== undefined ? this.baseUtcOffsetMinutes : null;
        return data;
    }
}
export class BatteryLifePredictionSettingsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.ohmicRiseLimitForBlockReplacement = _data["ohmicRiseLimitForBlockReplacement"] !== undefined ? _data["ohmicRiseLimitForBlockReplacement"] : null;
            this.percOfBlocksAboveOhmicRiseLimitForStringReplacement = _data["percOfBlocksAboveOhmicRiseLimitForStringReplacement"] !== undefined ? _data["percOfBlocksAboveOhmicRiseLimitForStringReplacement"] : null;
            this.minOhmicRiseToUsePrediction = _data["minOhmicRiseToUsePrediction"] !== undefined ? _data["minOhmicRiseToUsePrediction"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryLifePredictionSettingsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["ohmicRiseLimitForBlockReplacement"] = this.ohmicRiseLimitForBlockReplacement !== undefined ? this.ohmicRiseLimitForBlockReplacement : null;
        data["percOfBlocksAboveOhmicRiseLimitForStringReplacement"] = this.percOfBlocksAboveOhmicRiseLimitForStringReplacement !== undefined ? this.percOfBlocksAboveOhmicRiseLimitForStringReplacement : null;
        data["minOhmicRiseToUsePrediction"] = this.minOhmicRiseToUsePrediction !== undefined ? this.minOhmicRiseToUsePrediction : null;
        return data;
    }
}
export class ProblemDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }
    init(_data) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : null;
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : null;
            if (_data["extensions"]) {
                this.extensions = {};
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions[key] = _data["extensions"][key] !== undefined ? _data["extensions"][key] : null;
                }
            }
            else {
                this.extensions = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["detail"] = this.detail !== undefined ? this.detail : null;
        data["instance"] = this.instance !== undefined ? this.instance : null;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key] !== undefined ? this.extensions[key] : null;
            }
        }
        return data;
    }
}
export class EndOfLifePredictionsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["predictions"])) {
                this.predictions = [];
                for (let item of _data["predictions"])
                    this.predictions.push(EndOfLifePredictionModel.fromJS(item));
            }
            else {
                this.predictions = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EndOfLifePredictionsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.predictions)) {
            data["predictions"] = [];
            for (let item of this.predictions)
                data["predictions"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class EndOfLifePredictionModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.endOfLifePrediction = _data["endOfLifePrediction"] ? new Date(_data["endOfLifePrediction"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EndOfLifePredictionModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["endOfLifePrediction"] = this.endOfLifePrediction ? this.endOfLifePrediction.toISOString() : null;
        return data;
    }
}
export class SMTPImporterSettingsModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.mailbox = _data["mailbox"] !== undefined ? _data["mailbox"] : null;
            this.keyWordLocation = _data["keyWordLocation"] !== undefined ? _data["keyWordLocation"] : null;
            this.keyWord = _data["keyWord"] !== undefined ? _data["keyWord"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SMTPImporterSettingsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["mailbox"] = this.mailbox !== undefined ? this.mailbox : null;
        data["keyWordLocation"] = this.keyWordLocation !== undefined ? this.keyWordLocation : null;
        data["keyWord"] = this.keyWord !== undefined ? this.keyWord : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null;
        super.toJSON(data);
        return data;
    }
}
export var SMTPImporterKeyWordLocation;
(function (SMTPImporterKeyWordLocation) {
    SMTPImporterKeyWordLocation[SMTPImporterKeyWordLocation["Header"] = 0] = "Header";
    SMTPImporterKeyWordLocation[SMTPImporterKeyWordLocation["Subject"] = 1] = "Subject";
    SMTPImporterKeyWordLocation[SMTPImporterKeyWordLocation["Body"] = 2] = "Body";
    SMTPImporterKeyWordLocation[SMTPImporterKeyWordLocation["FileName"] = 3] = "FileName";
})(SMTPImporterKeyWordLocation || (SMTPImporterKeyWordLocation = {}));
export class PaginatedEnumerableOfSMTPImporterSettingsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(SMTPImporterSettingsModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfSMTPImporterSettingsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetSMTPImporterSettingsListPaginatedQueryAndPaginatedEnumerableOfSMTPImporterSettingsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSMTPImporterSettingsListPaginatedQueryAndPaginatedEnumerableOfSMTPImporterSettingsModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSMTPImporterSettingsListPaginatedQuery extends BaseQueryOfGetSMTPImporterSettingsListPaginatedQueryAndPaginatedEnumerableOfSMTPImporterSettingsModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSMTPImporterSettingsListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class SortDescription {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : null;
            this.direction = _data["direction"] !== undefined ? _data["direction"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SortDescription();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : null;
        data["direction"] = this.direction !== undefined ? this.direction : null;
        return data;
    }
}
export var SortDirection;
(function (SortDirection) {
    SortDirection[SortDirection["Unsorted"] = 0] = "Unsorted";
    SortDirection[SortDirection["Ascending"] = 1] = "Ascending";
    SortDirection[SortDirection["Descending"] = -1] = "Descending";
})(SortDirection || (SortDirection = {}));
export class BaseCommandOfSMTPImporterSettingsModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? SMTPImporterSettingsModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfSMTPImporterSettingsModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateSMTPImporterSettingCommand extends BaseCommandOfSMTPImporterSettingsModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSMTPImporterSettingCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateSMTPImporterSettingCommand extends BaseCommandOfSMTPImporterSettingsModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSMTPImporterSettingCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class OhmicTrendReportSettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["stringIds"])) {
                this.stringIds = [];
                for (let item of _data["stringIds"])
                    this.stringIds.push(item);
            }
            else {
                this.stringIds = null;
            }
            this.totalOhmicRiseLimit = _data["totalOhmicRiseLimit"] !== undefined ? _data["totalOhmicRiseLimit"] : null;
            this.quarterOhmicRiseLimit = _data["quarterOhmicRiseLimit"] !== undefined ? _data["quarterOhmicRiseLimit"] : null;
            this.fourWeeksOhmicRiseLimit = _data["fourWeeksOhmicRiseLimit"] !== undefined ? _data["fourWeeksOhmicRiseLimit"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OhmicTrendReportSettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stringIds)) {
            data["stringIds"] = [];
            for (let item of this.stringIds)
                data["stringIds"].push(item);
        }
        data["totalOhmicRiseLimit"] = this.totalOhmicRiseLimit !== undefined ? this.totalOhmicRiseLimit : null;
        data["quarterOhmicRiseLimit"] = this.quarterOhmicRiseLimit !== undefined ? this.quarterOhmicRiseLimit : null;
        data["fourWeeksOhmicRiseLimit"] = this.fourWeeksOhmicRiseLimit !== undefined ? this.fourWeeksOhmicRiseLimit : null;
        return data;
    }
}
export class StringLifeReportSettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ageMethod = _data["ageMethod"] !== undefined ? _data["ageMethod"] : null;
            this.ageColumn1Parameter = _data["ageColumn1Parameter"] !== undefined ? _data["ageColumn1Parameter"] : null;
            this.ageColumn2Parameter = _data["ageColumn2Parameter"] !== undefined ? _data["ageColumn2Parameter"] : null;
            this.ageColumn3Parameter = _data["ageColumn3Parameter"] !== undefined ? _data["ageColumn3Parameter"] : null;
            this.replacementColumn1Parameter = _data["replacementColumn1Parameter"] !== undefined ? _data["replacementColumn1Parameter"] : null;
            this.replacementColumn2Parameter = _data["replacementColumn2Parameter"] !== undefined ? _data["replacementColumn2Parameter"] : null;
            this.replacementColumn3Parameter = _data["replacementColumn3Parameter"] !== undefined ? _data["replacementColumn3Parameter"] : null;
            this.ohmicRiseColumn1Parameter = _data["ohmicRiseColumn1Parameter"] !== undefined ? _data["ohmicRiseColumn1Parameter"] : null;
            this.ohmicRiseColumn2Parameter = _data["ohmicRiseColumn2Parameter"] !== undefined ? _data["ohmicRiseColumn2Parameter"] : null;
            this.ohmicRiseColumn3Parameter = _data["ohmicRiseColumn3Parameter"] !== undefined ? _data["ohmicRiseColumn3Parameter"] : null;
            this.predictedColumn1Parameter = _data["predictedColumn1Parameter"] !== undefined ? _data["predictedColumn1Parameter"] : null;
            this.predictedColumn2Parameter = _data["predictedColumn2Parameter"] !== undefined ? _data["predictedColumn2Parameter"] : null;
            this.predictedColumn3Parameter = _data["predictedColumn3Parameter"] !== undefined ? _data["predictedColumn3Parameter"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StringLifeReportSettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ageMethod"] = this.ageMethod !== undefined ? this.ageMethod : null;
        data["ageColumn1Parameter"] = this.ageColumn1Parameter !== undefined ? this.ageColumn1Parameter : null;
        data["ageColumn2Parameter"] = this.ageColumn2Parameter !== undefined ? this.ageColumn2Parameter : null;
        data["ageColumn3Parameter"] = this.ageColumn3Parameter !== undefined ? this.ageColumn3Parameter : null;
        data["replacementColumn1Parameter"] = this.replacementColumn1Parameter !== undefined ? this.replacementColumn1Parameter : null;
        data["replacementColumn2Parameter"] = this.replacementColumn2Parameter !== undefined ? this.replacementColumn2Parameter : null;
        data["replacementColumn3Parameter"] = this.replacementColumn3Parameter !== undefined ? this.replacementColumn3Parameter : null;
        data["ohmicRiseColumn1Parameter"] = this.ohmicRiseColumn1Parameter !== undefined ? this.ohmicRiseColumn1Parameter : null;
        data["ohmicRiseColumn2Parameter"] = this.ohmicRiseColumn2Parameter !== undefined ? this.ohmicRiseColumn2Parameter : null;
        data["ohmicRiseColumn3Parameter"] = this.ohmicRiseColumn3Parameter !== undefined ? this.ohmicRiseColumn3Parameter : null;
        data["predictedColumn1Parameter"] = this.predictedColumn1Parameter !== undefined ? this.predictedColumn1Parameter : null;
        data["predictedColumn2Parameter"] = this.predictedColumn2Parameter !== undefined ? this.predictedColumn2Parameter : null;
        data["predictedColumn3Parameter"] = this.predictedColumn3Parameter !== undefined ? this.predictedColumn3Parameter : null;
        return data;
    }
}
export var AgeMethodEnum;
(function (AgeMethodEnum) {
    AgeMethodEnum[AgeMethodEnum["StringInstalledOnAge"] = 1] = "StringInstalledOnAge";
    AgeMethodEnum[AgeMethodEnum["BatteryManufacturedOnAverage"] = 2] = "BatteryManufacturedOnAverage";
})(AgeMethodEnum || (AgeMethodEnum = {}));
export class IssueSiteSummarySettingsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.rangeColumn1 = _data["rangeColumn1"] !== undefined ? _data["rangeColumn1"] : null;
            this.rangeColumn2 = _data["rangeColumn2"] !== undefined ? _data["rangeColumn2"] : null;
            this.rangeColumn3 = _data["rangeColumn3"] !== undefined ? _data["rangeColumn3"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSiteSummarySettingsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["rangeColumn1"] = this.rangeColumn1 !== undefined ? this.rangeColumn1 : null;
        data["rangeColumn2"] = this.rangeColumn2 !== undefined ? this.rangeColumn2 : null;
        data["rangeColumn3"] = this.rangeColumn3 !== undefined ? this.rangeColumn3 : null;
        return data;
    }
}
export class BatteryReplacementEstimationSettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ohmicRiseThreshold = _data["ohmicRiseThreshold"] !== undefined ? _data["ohmicRiseThreshold"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryReplacementEstimationSettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ohmicRiseThreshold"] = this.ohmicRiseThreshold !== undefined ? this.ohmicRiseThreshold : null;
        return data;
    }
}
export class ReportModel extends BaseAuthoredModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : null;
            this.reportName = _data["reportName"] !== undefined ? _data["reportName"] : null;
            this.reportType = _data["reportType"] !== undefined ? _data["reportType"] : null;
            this.reportTypeName = _data["reportTypeName"] !== undefined ? _data["reportTypeName"] : null;
            this.description = _data["description"] !== undefined ? _data["description"] : null;
            this.canBeScheduled = _data["canBeScheduled"] !== undefined ? _data["canBeScheduled"] : null;
            this.numberOfScheduledReports = _data["numberOfScheduledReports"] !== undefined ? _data["numberOfScheduledReports"] : null;
            this.denyAccessToUsers = _data["denyAccessToUsers"] !== undefined ? _data["denyAccessToUsers"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReportModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId !== undefined ? this.reportId : null;
        data["reportName"] = this.reportName !== undefined ? this.reportName : null;
        data["reportType"] = this.reportType !== undefined ? this.reportType : null;
        data["reportTypeName"] = this.reportTypeName !== undefined ? this.reportTypeName : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["canBeScheduled"] = this.canBeScheduled !== undefined ? this.canBeScheduled : null;
        data["numberOfScheduledReports"] = this.numberOfScheduledReports !== undefined ? this.numberOfScheduledReports : null;
        data["denyAccessToUsers"] = this.denyAccessToUsers !== undefined ? this.denyAccessToUsers : null;
        super.toJSON(data);
        return data;
    }
}
export var ReportTypeEnum;
(function (ReportTypeEnum) {
    ReportTypeEnum[ReportTypeEnum["Dashboard"] = 1] = "Dashboard";
    ReportTypeEnum[ReportTypeEnum["Discharge"] = 2] = "Discharge";
    ReportTypeEnum[ReportTypeEnum["OhmicTrend"] = 3] = "OhmicTrend";
    ReportTypeEnum[ReportTypeEnum["DischargeActivity"] = 4] = "DischargeActivity";
    ReportTypeEnum[ReportTypeEnum["StringLife"] = 5] = "StringLife";
    ReportTypeEnum[ReportTypeEnum["BlockStatus"] = 6] = "BlockStatus";
    ReportTypeEnum[ReportTypeEnum["StringStatus"] = 7] = "StringStatus";
    ReportTypeEnum[ReportTypeEnum["AssurePlus"] = 8] = "AssurePlus";
    ReportTypeEnum[ReportTypeEnum["SiteIssueSummary"] = 9] = "SiteIssueSummary";
    ReportTypeEnum[ReportTypeEnum["CompanySystems"] = 10] = "CompanySystems";
    ReportTypeEnum[ReportTypeEnum["BatteryReplacement"] = 11] = "BatteryReplacement";
})(ReportTypeEnum || (ReportTypeEnum = {}));
export class BaseQueryOfGetReportListQueryAndIListOfReportModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetReportListQueryAndIListOfReportModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetReportListQuery extends BaseQueryOfGetReportListQueryAndIListOfReportModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportListQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class ReportPermissionUsersModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.denyAcccesToUsers = _data["denyAcccesToUsers"] !== undefined ? _data["denyAcccesToUsers"] : null;
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [];
                for (let item of _data["userIds"])
                    this.userIds.push(item);
            }
            else {
                this.userIds = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPermissionUsersModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["denyAcccesToUsers"] = this.denyAcccesToUsers !== undefined ? this.denyAcccesToUsers : null;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}
export class BaseQueryOfGetReportPermissionUsersQueryAndReportPermissionUsersModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetReportPermissionUsersQueryAndReportPermissionUsersModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetReportPermissionUsersQuery extends BaseQueryOfGetReportPermissionUsersQueryAndReportPermissionUsersModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportPermissionUsersQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfUpsertReportsUserPermissionsModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? UpsertReportsUserPermissionsModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfUpsertReportsUserPermissionsModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpsertReportUserPermissionsCommand extends BaseCommandOfUpsertReportsUserPermissionsModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertReportUserPermissionsCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpsertReportsUserPermissionsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            if (Array.isArray(_data["reports"])) {
                this.reports = [];
                for (let item of _data["reports"])
                    this.reports.push(UpsertReportUserPermissionsModel.fromJS(item));
            }
            else {
                this.reports = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertReportsUserPermissionsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class UpsertReportUserPermissionsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.report = _data["report"] ? ReportModel.fromJS(_data["report"]) : null;
            this.denyAccessToUsers = _data["denyAccessToUsers"] !== undefined ? _data["denyAccessToUsers"] : null;
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [];
                for (let item of _data["userIds"])
                    this.userIds.push(item);
            }
            else {
                this.userIds = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertReportUserPermissionsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["report"] = this.report ? this.report.toJSON() : null;
        data["denyAccessToUsers"] = this.denyAccessToUsers !== undefined ? this.denyAccessToUsers : null;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}
export class ReportScheduleModel extends BaseAuthoredModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.description = _data["description"] !== undefined ? _data["description"] : null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null;
            this.body = _data["body"] !== undefined ? _data["body"] : null;
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : null;
            this.reportType = _data["reportType"] !== undefined ? _data["reportType"] : null;
            this.reportName = _data["reportName"] !== undefined ? _data["reportName"] : null;
            this.reportFormatType = _data["reportFormatType"] !== undefined ? _data["reportFormatType"] : null;
            this.reportFileName = _data["reportFileName"] !== undefined ? _data["reportFileName"] : null;
            this.period = _data["period"] !== undefined ? _data["period"] : null;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : null;
            this.dayOfTheWeek = _data["dayOfTheWeek"] !== undefined ? _data["dayOfTheWeek"] : null;
            this.query = _data["query"] !== undefined ? _data["query"] : null;
            this.lastExecution = _data["lastExecution"] ? new Date(_data["lastExecution"].toString()) : null;
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [];
                for (let item of _data["contactIds"])
                    this.contactIds.push(item);
            }
            else {
                this.contactIds = null;
            }
            if (Array.isArray(_data["contactGroupIds"])) {
                this.contactGroupIds = [];
                for (let item of _data["contactGroupIds"])
                    this.contactGroupIds.push(item);
            }
            else {
                this.contactGroupIds = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReportScheduleModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["subject"] = this.subject !== undefined ? this.subject : null;
        data["body"] = this.body !== undefined ? this.body : null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : null;
        data["reportType"] = this.reportType !== undefined ? this.reportType : null;
        data["reportName"] = this.reportName !== undefined ? this.reportName : null;
        data["reportFormatType"] = this.reportFormatType !== undefined ? this.reportFormatType : null;
        data["reportFileName"] = this.reportFileName !== undefined ? this.reportFileName : null;
        data["period"] = this.period !== undefined ? this.period : null;
        data["start"] = this.start ? this.start.toISOString() : null;
        data["dayOfTheWeek"] = this.dayOfTheWeek !== undefined ? this.dayOfTheWeek : null;
        data["query"] = this.query !== undefined ? this.query : null;
        data["lastExecution"] = this.lastExecution ? this.lastExecution.toISOString() : null;
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        if (Array.isArray(this.contactGroupIds)) {
            data["contactGroupIds"] = [];
            for (let item of this.contactGroupIds)
                data["contactGroupIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export var ReportFormatTypeEnum;
(function (ReportFormatTypeEnum) {
    ReportFormatTypeEnum[ReportFormatTypeEnum["PDF"] = 0] = "PDF";
    ReportFormatTypeEnum[ReportFormatTypeEnum["CSV"] = 1] = "CSV";
    ReportFormatTypeEnum[ReportFormatTypeEnum["Both"] = 2] = "Both";
})(ReportFormatTypeEnum || (ReportFormatTypeEnum = {}));
export var ReportSchedulePeriodEnum;
(function (ReportSchedulePeriodEnum) {
    ReportSchedulePeriodEnum[ReportSchedulePeriodEnum["Once"] = 1] = "Once";
    ReportSchedulePeriodEnum[ReportSchedulePeriodEnum["Daily"] = 2] = "Daily";
    ReportSchedulePeriodEnum[ReportSchedulePeriodEnum["Weekely"] = 3] = "Weekely";
    ReportSchedulePeriodEnum[ReportSchedulePeriodEnum["Monthly"] = 4] = "Monthly";
})(ReportSchedulePeriodEnum || (ReportSchedulePeriodEnum = {}));
export class BaseQueryOfGetReportScheduleListQueryAndIListOfReportScheduleModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetReportScheduleListQueryAndIListOfReportScheduleModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetReportScheduleListQuery extends BaseQueryOfGetReportScheduleListQueryAndIListOfReportScheduleModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportScheduleListQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfReportScheduleModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? ReportScheduleModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfReportScheduleModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateReportScheduleCommand extends BaseCommandOfReportScheduleModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportScheduleCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateReportScheduleCommand extends BaseCommandOfReportScheduleModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportScheduleCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ContactsForScheduleReportModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [];
                for (let item of _data["contacts"])
                    this.contacts.push(PersonModel.fromJS(item));
            }
            else {
                this.contacts = null;
            }
            this.isUserAllowedToScheduleReportsToOtherUsers = _data["isUserAllowedToScheduleReportsToOtherUsers"] !== undefined ? _data["isUserAllowedToScheduleReportsToOtherUsers"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsForScheduleReportModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : null);
        }
        data["isUserAllowedToScheduleReportsToOtherUsers"] = this.isUserAllowedToScheduleReportsToOtherUsers !== undefined ? this.isUserAllowedToScheduleReportsToOtherUsers : null;
        return data;
    }
}
export class PersonModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.position = _data["position"] !== undefined ? _data["position"] : null;
            this.mobilePhone = _data["mobilePhone"] !== undefined ? _data["mobilePhone"] : null;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : null;
            this.homePhone = _data["homePhone"] !== undefined ? _data["homePhone"] : null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PersonModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : null;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["position"] = this.position !== undefined ? this.position : null;
        data["mobilePhone"] = this.mobilePhone !== undefined ? this.mobilePhone : null;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : null;
        data["homePhone"] = this.homePhone !== undefined ? this.homePhone : null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfAutomaticDischargeReportModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? AutomaticDischargeReportModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfAutomaticDischargeReportModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpsertAutomaticDischargeReportCommand extends BaseCommandOfAutomaticDischargeReportModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAutomaticDischargeReportCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class AutomaticDischargeReportModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null;
            this.automaticDuration = _data["automaticDuration"] !== undefined ? _data["automaticDuration"] : null;
            this.imperialMeasurements = _data["imperialMeasurements"] !== undefined ? _data["imperialMeasurements"] : null;
            this.minDurationSeconds = _data["minDurationSeconds"] !== undefined ? _data["minDurationSeconds"] : null;
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [];
                for (let item of _data["contactIds"])
                    this.contactIds.push(item);
            }
            else {
                this.contactIds = null;
            }
            if (Array.isArray(_data["contactGroupIds"])) {
                this.contactGroupIds = [];
                for (let item of _data["contactGroupIds"])
                    this.contactGroupIds.push(item);
            }
            else {
                this.contactGroupIds = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AutomaticDischargeReportModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null;
        data["automaticDuration"] = this.automaticDuration !== undefined ? this.automaticDuration : null;
        data["imperialMeasurements"] = this.imperialMeasurements !== undefined ? this.imperialMeasurements : null;
        data["minDurationSeconds"] = this.minDurationSeconds !== undefined ? this.minDurationSeconds : null;
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        if (Array.isArray(this.contactGroupIds)) {
            data["contactGroupIds"] = [];
            for (let item of this.contactGroupIds)
                data["contactGroupIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfReportLogModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(ReportLogModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfReportLogModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class ReportLogModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.reportLogType = _data["reportLogType"] !== undefined ? _data["reportLogType"] : null;
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : null;
            this.reportScheduleId = _data["reportScheduleId"] !== undefined ? _data["reportScheduleId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.emails = _data["emails"] !== undefined ? _data["emails"] : null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null;
            this.reportFile = _data["reportFile"] !== undefined ? _data["reportFile"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReportLogModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["reportLogType"] = this.reportLogType !== undefined ? this.reportLogType : null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : null;
        data["reportScheduleId"] = this.reportScheduleId !== undefined ? this.reportScheduleId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["emails"] = this.emails !== undefined ? this.emails : null;
        data["subject"] = this.subject !== undefined ? this.subject : null;
        data["reportFile"] = this.reportFile !== undefined ? this.reportFile : null;
        super.toJSON(data);
        return data;
    }
}
export var ReportLogTypeEnum;
(function (ReportLogTypeEnum) {
    ReportLogTypeEnum[ReportLogTypeEnum["ScheduledReport"] = 1] = "ScheduledReport";
    ReportLogTypeEnum[ReportLogTypeEnum["AutomaticReport"] = 2] = "AutomaticReport";
})(ReportLogTypeEnum || (ReportLogTypeEnum = {}));
export class BaseQueryOfGetReportLogListPaginatedQueryAndPaginatedEnumerableOfReportLogModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetReportLogListPaginatedQueryAndPaginatedEnumerableOfReportLogModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetReportLogListPaginatedQuery extends BaseQueryOfGetReportLogListPaginatedQueryAndPaginatedEnumerableOfReportLogModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.reportScheduleId = _data["reportScheduleId"] !== undefined ? _data["reportScheduleId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : null;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportLogListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["reportScheduleId"] = this.reportScheduleId !== undefined ? this.reportScheduleId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["start"] = this.start ? this.start.toISOString() : null;
        data["end"] = this.end ? this.end.toISOString() : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class UserModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null;
            this.authorId = _data["authorId"] !== undefined ? _data["authorId"] : null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null;
            this.position = _data["position"] !== undefined ? _data["position"] : null;
            this.mobilePhone = _data["mobilePhone"] !== undefined ? _data["mobilePhone"] : null;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : null;
            this.useImperialMeasurementSystem = _data["useImperialMeasurementSystem"] !== undefined ? _data["useImperialMeasurementSystem"] : null;
            this.whenLastLoggedIn = _data["whenLastLoggedIn"] ? new Date(_data["whenLastLoggedIn"].toString()) : null;
            this.whenLastSeen = _data["whenLastSeen"] ? new Date(_data["whenLastSeen"].toString()) : null;
            this.whenAcceptedTerms = _data["whenAcceptedTerms"] ? new Date(_data["whenAcceptedTerms"].toString()) : null;
            this.twoFactorAuthEnabled = _data["twoFactorAuthEnabled"] !== undefined ? _data["twoFactorAuthEnabled"] : null;
            this.twoFactorAuthMethod = _data["twoFactorAuthMethod"] !== undefined ? _data["twoFactorAuthMethod"] : null;
            this.userToken = _data["userToken"] !== undefined ? _data["userToken"] : null;
            this.whenLockout = _data["whenLockout"] ? new Date(_data["whenLockout"].toString()) : null;
            this.whoLockoutUserId = _data["whoLockoutUserId"] !== undefined ? _data["whoLockoutUserId"] : null;
            this.hidden = _data["hidden"] !== undefined ? _data["hidden"] : null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null;
            this.useMetricMeasurementSystem = _data["useMetricMeasurementSystem"] !== undefined ? _data["useMetricMeasurementSystem"] : null;
            this.mustAcceptTerms = _data["mustAcceptTerms"] !== undefined ? _data["mustAcceptTerms"] : null;
            this.leftMenuState = _data["leftMenuState"] !== undefined ? _data["leftMenuState"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null;
        data["authorId"] = this.authorId !== undefined ? this.authorId : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null;
        data["position"] = this.position !== undefined ? this.position : null;
        data["mobilePhone"] = this.mobilePhone !== undefined ? this.mobilePhone : null;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : null;
        data["useImperialMeasurementSystem"] = this.useImperialMeasurementSystem !== undefined ? this.useImperialMeasurementSystem : null;
        data["whenLastLoggedIn"] = this.whenLastLoggedIn ? this.whenLastLoggedIn.toISOString() : null;
        data["whenLastSeen"] = this.whenLastSeen ? this.whenLastSeen.toISOString() : null;
        data["whenAcceptedTerms"] = this.whenAcceptedTerms ? this.whenAcceptedTerms.toISOString() : null;
        data["twoFactorAuthEnabled"] = this.twoFactorAuthEnabled !== undefined ? this.twoFactorAuthEnabled : null;
        data["twoFactorAuthMethod"] = this.twoFactorAuthMethod !== undefined ? this.twoFactorAuthMethod : null;
        data["userToken"] = this.userToken !== undefined ? this.userToken : null;
        data["whenLockout"] = this.whenLockout ? this.whenLockout.toISOString() : null;
        data["whoLockoutUserId"] = this.whoLockoutUserId !== undefined ? this.whoLockoutUserId : null;
        data["hidden"] = this.hidden !== undefined ? this.hidden : null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null;
        data["useMetricMeasurementSystem"] = this.useMetricMeasurementSystem !== undefined ? this.useMetricMeasurementSystem : null;
        data["mustAcceptTerms"] = this.mustAcceptTerms !== undefined ? this.mustAcceptTerms : null;
        data["leftMenuState"] = this.leftMenuState !== undefined ? this.leftMenuState : null;
        super.toJSON(data);
        return data;
    }
}
export var TwoFactorAuthMethodEnum;
(function (TwoFactorAuthMethodEnum) {
    TwoFactorAuthMethodEnum[TwoFactorAuthMethodEnum["None"] = 0] = "None";
    TwoFactorAuthMethodEnum[TwoFactorAuthMethodEnum["Email"] = 1] = "Email";
    TwoFactorAuthMethodEnum[TwoFactorAuthMethodEnum["App"] = 2] = "App";
})(TwoFactorAuthMethodEnum || (TwoFactorAuthMethodEnum = {}));
export class BaseCommandOfUserModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? UserModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfUserModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpdateUserProfileCommand extends BaseCommandOfUserModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserProfileCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfUserPasswordChangeModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? UserPasswordChangeModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfUserPasswordChangeModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpdateUserPasswordCommand extends BaseCommandOfUserPasswordChangeModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPasswordCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UserPasswordChangeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.currentPassword = _data["currentPassword"] !== undefined ? _data["currentPassword"] : null;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : null;
            this.newPasswordConfirmation = _data["newPasswordConfirmation"] !== undefined ? _data["newPasswordConfirmation"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordChangeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["currentPassword"] = this.currentPassword !== undefined ? this.currentPassword : null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        data["newPasswordConfirmation"] = this.newPasswordConfirmation !== undefined ? this.newPasswordConfirmation : null;
        return data;
    }
}
export class AlarmScopeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.alarmScopeId = _data["alarmScopeId"] !== undefined ? _data["alarmScopeId"] : null;
            this.alarmScopeName = _data["alarmScopeName"] !== undefined ? _data["alarmScopeName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmScopeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["alarmScopeId"] = this.alarmScopeId !== undefined ? this.alarmScopeId : null;
        data["alarmScopeName"] = this.alarmScopeName !== undefined ? this.alarmScopeName : null;
        return data;
    }
}
export class AlarmSeverityModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.alarmSeverityId = _data["alarmSeverityId"] !== undefined ? _data["alarmSeverityId"] : null;
            this.alarmSeverityName = _data["alarmSeverityName"] !== undefined ? _data["alarmSeverityName"] : null;
            this.hexColor = _data["hexColor"] !== undefined ? _data["hexColor"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmSeverityModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["alarmSeverityId"] = this.alarmSeverityId !== undefined ? this.alarmSeverityId : null;
        data["alarmSeverityName"] = this.alarmSeverityName !== undefined ? this.alarmSeverityName : null;
        data["hexColor"] = this.hexColor !== undefined ? this.hexColor : null;
        return data;
    }
}
export class ManufacturerModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.manufacturerTypeId = _data["manufacturerTypeId"] !== undefined ? _data["manufacturerTypeId"] : null;
            this.manufacturerName = _data["manufacturerName"] !== undefined ? _data["manufacturerName"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.manufacturerTypeName = _data["manufacturerTypeName"] !== undefined ? _data["manufacturerTypeName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["manufacturerTypeId"] = this.manufacturerTypeId !== undefined ? this.manufacturerTypeId : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["manufacturerTypeName"] = this.manufacturerTypeName !== undefined ? this.manufacturerTypeName : null;
        return data;
    }
}
export var ManufacturerTypeEnum;
(function (ManufacturerTypeEnum) {
    ManufacturerTypeEnum[ManufacturerTypeEnum["ChargerUPS"] = 1] = "ChargerUPS";
    ManufacturerTypeEnum[ManufacturerTypeEnum["Battery"] = 2] = "Battery";
})(ManufacturerTypeEnum || (ManufacturerTypeEnum = {}));
export class MeasurementTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.measurementTypeId = _data["measurementTypeId"] !== undefined ? _data["measurementTypeId"] : null;
            this.componentTypeId = _data["componentTypeId"] !== undefined ? _data["componentTypeId"] : null;
            this.measurementCategoryId = _data["measurementCategoryId"] !== undefined ? _data["measurementCategoryId"] : null;
            this.measurementTypeName = _data["measurementTypeName"] !== undefined ? _data["measurementTypeName"] : null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null;
            this.unitOfMeasurement = _data["unitOfMeasurement"] !== undefined ? _data["unitOfMeasurement"] : null;
            this.unitOfMeasurementImperial = _data["unitOfMeasurementImperial"] !== undefined ? _data["unitOfMeasurementImperial"] : null;
            this.unitOfMeasurementCode = _data["unitOfMeasurementCode"] !== undefined ? _data["unitOfMeasurementCode"] : null;
            this.unitOfMeasurementCodeImperial = _data["unitOfMeasurementCodeImperial"] !== undefined ? _data["unitOfMeasurementCodeImperial"] : null;
            this.conversionFactor = _data["conversionFactor"] !== undefined ? _data["conversionFactor"] : null;
            this.conversionAdditionalFactor = _data["conversionAdditionalFactor"] !== undefined ? _data["conversionAdditionalFactor"] : null;
            this.hexColor = _data["hexColor"] !== undefined ? _data["hexColor"] : null;
            this.visibleForLithium = _data["visibleForLithium"] !== undefined ? _data["visibleForLithium"] : null;
            this.visibleForLithiumSamsungGen3 = _data["visibleForLithiumSamsungGen3"] !== undefined ? _data["visibleForLithiumSamsungGen3"] : null;
            this.visibleForNonLithium = _data["visibleForNonLithium"] !== undefined ? _data["visibleForNonLithium"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["measurementTypeId"] = this.measurementTypeId !== undefined ? this.measurementTypeId : null;
        data["componentTypeId"] = this.componentTypeId !== undefined ? this.componentTypeId : null;
        data["measurementCategoryId"] = this.measurementCategoryId !== undefined ? this.measurementCategoryId : null;
        data["measurementTypeName"] = this.measurementTypeName !== undefined ? this.measurementTypeName : null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null;
        data["unitOfMeasurement"] = this.unitOfMeasurement !== undefined ? this.unitOfMeasurement : null;
        data["unitOfMeasurementImperial"] = this.unitOfMeasurementImperial !== undefined ? this.unitOfMeasurementImperial : null;
        data["unitOfMeasurementCode"] = this.unitOfMeasurementCode !== undefined ? this.unitOfMeasurementCode : null;
        data["unitOfMeasurementCodeImperial"] = this.unitOfMeasurementCodeImperial !== undefined ? this.unitOfMeasurementCodeImperial : null;
        data["conversionFactor"] = this.conversionFactor !== undefined ? this.conversionFactor : null;
        data["conversionAdditionalFactor"] = this.conversionAdditionalFactor !== undefined ? this.conversionAdditionalFactor : null;
        data["hexColor"] = this.hexColor !== undefined ? this.hexColor : null;
        data["visibleForLithium"] = this.visibleForLithium !== undefined ? this.visibleForLithium : null;
        data["visibleForLithiumSamsungGen3"] = this.visibleForLithiumSamsungGen3 !== undefined ? this.visibleForLithiumSamsungGen3 : null;
        data["visibleForNonLithium"] = this.visibleForNonLithium !== undefined ? this.visibleForNonLithium : null;
        return data;
    }
}
export class MeasurementCategoryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.measurementCategoryId = _data["measurementCategoryId"] !== undefined ? _data["measurementCategoryId"] : null;
            this.measurementCategoryName = _data["measurementCategoryName"] !== undefined ? _data["measurementCategoryName"] : null;
            this.order = _data["order"] !== undefined ? _data["order"] : null;
            if (Array.isArray(_data["measurementTypes"])) {
                this.measurementTypes = [];
                for (let item of _data["measurementTypes"])
                    this.measurementTypes.push(MeasurementTypeModel.fromJS(item));
            }
            else {
                this.measurementTypes = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementCategoryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["measurementCategoryId"] = this.measurementCategoryId !== undefined ? this.measurementCategoryId : null;
        data["measurementCategoryName"] = this.measurementCategoryName !== undefined ? this.measurementCategoryName : null;
        data["order"] = this.order !== undefined ? this.order : null;
        if (Array.isArray(this.measurementTypes)) {
            data["measurementTypes"] = [];
            for (let item of this.measurementTypes)
                data["measurementTypes"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class Model {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.modelId = _data["modelId"] !== undefined ? _data["modelId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : null;
            this.componentTypeId = _data["componentTypeId"] !== undefined ? _data["componentTypeId"] : null;
            this.modelName = _data["modelName"] !== undefined ? _data["modelName"] : null;
            this.price = _data["price"] !== undefined ? _data["price"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Model();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId !== undefined ? this.modelId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["componentTypeId"] = this.componentTypeId !== undefined ? this.componentTypeId : null;
        data["modelName"] = this.modelName !== undefined ? this.modelName : null;
        data["price"] = this.price !== undefined ? this.price : null;
        return data;
    }
}
export class ComponentTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.componentTypeId = _data["componentTypeId"] !== undefined ? _data["componentTypeId"] : null;
            this.componentTypeName = _data["componentTypeName"] !== undefined ? _data["componentTypeName"] : null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["componentTypeId"] = this.componentTypeId !== undefined ? this.componentTypeId : null;
        data["componentTypeName"] = this.componentTypeName !== undefined ? this.componentTypeName : null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null;
        return data;
    }
}
export class MaintenanceLogTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.logTypeId = _data["logTypeId"] !== undefined ? _data["logTypeId"] : null;
            this.logTypeName = _data["logTypeName"] !== undefined ? _data["logTypeName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceLogTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["logTypeId"] = this.logTypeId !== undefined ? this.logTypeId : null;
        data["logTypeName"] = this.logTypeName !== undefined ? this.logTypeName : null;
        return data;
    }
}
export class StringStatusModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StringStatusModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null;
        return data;
    }
}
export class NotificationChannelModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.notificationChannelId = _data["notificationChannelId"] !== undefined ? _data["notificationChannelId"] : null;
            this.notificationChannelName = _data["notificationChannelName"] !== undefined ? _data["notificationChannelName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationChannelModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["notificationChannelId"] = this.notificationChannelId !== undefined ? this.notificationChannelId : null;
        data["notificationChannelName"] = this.notificationChannelName !== undefined ? this.notificationChannelName : null;
        super.toJSON(data);
        return data;
    }
}
export class EnumModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.alarmSeverityEnum = _data["alarmSeverityEnum"] !== undefined ? _data["alarmSeverityEnum"] : null;
            this.alarmStatusEnum = _data["alarmStatusEnum"] !== undefined ? _data["alarmStatusEnum"] : null;
            this.alarmTypeEnum = _data["alarmTypeEnum"] !== undefined ? _data["alarmTypeEnum"] : null;
            this.componentStatusEnum = _data["componentStatusEnum"] !== undefined ? _data["componentStatusEnum"] : null;
            this.componentStatusStrategyEnum = _data["componentStatusStrategyEnum"] !== undefined ? _data["componentStatusStrategyEnum"] : null;
            this.componentTypeEnum = _data["componentTypeEnum"] !== undefined ? _data["componentTypeEnum"] : null;
            this.measurementTypeEnum = _data["measurementTypeEnum"] !== undefined ? _data["measurementTypeEnum"] : null;
            this.roleTypeEnum = _data["roleTypeEnum"] !== undefined ? _data["roleTypeEnum"] : null;
            this.stringStatusEnum = _data["stringStatusEnum"] !== undefined ? _data["stringStatusEnum"] : null;
            this.notificationChannelEnum = _data["notificationChannelEnum"] !== undefined ? _data["notificationChannelEnum"] : null;
            this.notificationTypeEnum = _data["notificationTypeEnum"] !== undefined ? _data["notificationTypeEnum"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EnumModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["alarmSeverityEnum"] = this.alarmSeverityEnum !== undefined ? this.alarmSeverityEnum : null;
        data["alarmStatusEnum"] = this.alarmStatusEnum !== undefined ? this.alarmStatusEnum : null;
        data["alarmTypeEnum"] = this.alarmTypeEnum !== undefined ? this.alarmTypeEnum : null;
        data["componentStatusEnum"] = this.componentStatusEnum !== undefined ? this.componentStatusEnum : null;
        data["componentStatusStrategyEnum"] = this.componentStatusStrategyEnum !== undefined ? this.componentStatusStrategyEnum : null;
        data["componentTypeEnum"] = this.componentTypeEnum !== undefined ? this.componentTypeEnum : null;
        data["measurementTypeEnum"] = this.measurementTypeEnum !== undefined ? this.measurementTypeEnum : null;
        data["roleTypeEnum"] = this.roleTypeEnum !== undefined ? this.roleTypeEnum : null;
        data["stringStatusEnum"] = this.stringStatusEnum !== undefined ? this.stringStatusEnum : null;
        data["notificationChannelEnum"] = this.notificationChannelEnum !== undefined ? this.notificationChannelEnum : null;
        data["notificationTypeEnum"] = this.notificationTypeEnum !== undefined ? this.notificationTypeEnum : null;
        return data;
    }
}
export var AlarmSeverityEnum;
(function (AlarmSeverityEnum) {
    AlarmSeverityEnum[AlarmSeverityEnum["Info"] = 0] = "Info";
    AlarmSeverityEnum[AlarmSeverityEnum["Warning"] = 1] = "Warning";
    AlarmSeverityEnum[AlarmSeverityEnum["Critical"] = 2] = "Critical";
})(AlarmSeverityEnum || (AlarmSeverityEnum = {}));
export var AlarmStatusEnum;
(function (AlarmStatusEnum) {
    AlarmStatusEnum[AlarmStatusEnum["Active"] = 0] = "Active";
    AlarmStatusEnum[AlarmStatusEnum["Inactive"] = 1] = "Inactive";
    AlarmStatusEnum[AlarmStatusEnum["ActiveUntilToDateTime"] = 2] = "ActiveUntilToDateTime";
})(AlarmStatusEnum || (AlarmStatusEnum = {}));
export var AlarmTypeEnum;
(function (AlarmTypeEnum) {
    AlarmTypeEnum[AlarmTypeEnum["StringState"] = 1] = "StringState";
    AlarmTypeEnum[AlarmTypeEnum["BlockChargeVoltage"] = 2] = "BlockChargeVoltage";
    AlarmTypeEnum[AlarmTypeEnum["BlockFloatVoltage"] = 3] = "BlockFloatVoltage";
    AlarmTypeEnum[AlarmTypeEnum["BlockDischargeVoltage"] = 4] = "BlockDischargeVoltage";
    AlarmTypeEnum[AlarmTypeEnum["BlockIdleVoltage"] = 5] = "BlockIdleVoltage";
    AlarmTypeEnum[AlarmTypeEnum["BlockFloatRippleVoltage"] = 6] = "BlockFloatRippleVoltage";
    AlarmTypeEnum[AlarmTypeEnum["BlockChargeTemperature"] = 7] = "BlockChargeTemperature";
    AlarmTypeEnum[AlarmTypeEnum["BlockFloatTemperature"] = 8] = "BlockFloatTemperature";
    AlarmTypeEnum[AlarmTypeEnum["BlockDischargeTemperature"] = 9] = "BlockDischargeTemperature";
    AlarmTypeEnum[AlarmTypeEnum["BlockIdleTemperature"] = 10] = "BlockIdleTemperature";
    AlarmTypeEnum[AlarmTypeEnum["BlockOhmic"] = 11] = "BlockOhmic";
    AlarmTypeEnum[AlarmTypeEnum["AmbientTemperature"] = 12] = "AmbientTemperature";
    AlarmTypeEnum[AlarmTypeEnum["BlockFloatVoltageVariation"] = 13] = "BlockFloatVoltageVariation";
    AlarmTypeEnum[AlarmTypeEnum["CanaryAlarm"] = 14] = "CanaryAlarm";
    AlarmTypeEnum[AlarmTypeEnum["BlockDischargeVoltageVariation"] = 15] = "BlockDischargeVoltageVariation";
    AlarmTypeEnum[AlarmTypeEnum["BlockChargeTemperatureVariation"] = 16] = "BlockChargeTemperatureVariation";
    AlarmTypeEnum[AlarmTypeEnum["BlockFloatTemperatureVariation"] = 17] = "BlockFloatTemperatureVariation";
    AlarmTypeEnum[AlarmTypeEnum["BlockDischargeTemperatureVariation"] = 18] = "BlockDischargeTemperatureVariation";
    AlarmTypeEnum[AlarmTypeEnum["BlockIdleTemperatureVariation"] = 19] = "BlockIdleTemperatureVariation";
    AlarmTypeEnum[AlarmTypeEnum["StringFloatCurrent"] = 20] = "StringFloatCurrent";
    AlarmTypeEnum[AlarmTypeEnum["StringChargeCurrent"] = 21] = "StringChargeCurrent";
    AlarmTypeEnum[AlarmTypeEnum["StringDischargeCurrent"] = 22] = "StringDischargeCurrent";
    AlarmTypeEnum[AlarmTypeEnum["StringFloatRippleCurrent"] = 23] = "StringFloatRippleCurrent";
    AlarmTypeEnum[AlarmTypeEnum["StringChargeVoltage"] = 24] = "StringChargeVoltage";
    AlarmTypeEnum[AlarmTypeEnum["StringFloatVoltage"] = 25] = "StringFloatVoltage";
    AlarmTypeEnum[AlarmTypeEnum["StringDischargeVoltage"] = 26] = "StringDischargeVoltage";
    AlarmTypeEnum[AlarmTypeEnum["StringIdleVoltage"] = 27] = "StringIdleVoltage";
    AlarmTypeEnum[AlarmTypeEnum["AmbientTemperatureVariation"] = 28] = "AmbientTemperatureVariation";
    AlarmTypeEnum[AlarmTypeEnum["AmbientBlockTemperature"] = 29] = "AmbientBlockTemperature";
    AlarmTypeEnum[AlarmTypeEnum["Humidity"] = 30] = "Humidity";
    AlarmTypeEnum[AlarmTypeEnum["DischargePeriod"] = 31] = "DischargePeriod";
    AlarmTypeEnum[AlarmTypeEnum["OhmicSchedule"] = 32] = "OhmicSchedule";
    AlarmTypeEnum[AlarmTypeEnum["BlockOhmicVariation"] = 33] = "BlockOhmicVariation";
    AlarmTypeEnum[AlarmTypeEnum["DigitalInput"] = 34] = "DigitalInput";
    AlarmTypeEnum[AlarmTypeEnum["CPUTemperature"] = 35] = "CPUTemperature";
    AlarmTypeEnum[AlarmTypeEnum["DiskSpace"] = 36] = "DiskSpace";
    AlarmTypeEnum[AlarmTypeEnum["HubStatus"] = 37] = "HubStatus";
    AlarmTypeEnum[AlarmTypeEnum["MSensorStatus"] = 38] = "MSensorStatus";
    AlarmTypeEnum[AlarmTypeEnum["DeviceCommsError"] = 39] = "DeviceCommsError";
    AlarmTypeEnum[AlarmTypeEnum["ChargePeriod"] = 40] = "ChargePeriod";
    AlarmTypeEnum[AlarmTypeEnum["BlockVoltageError"] = 41] = "BlockVoltageError";
    AlarmTypeEnum[AlarmTypeEnum["BlockTemperatureError"] = 42] = "BlockTemperatureError";
    AlarmTypeEnum[AlarmTypeEnum["BlockOhmicError"] = 43] = "BlockOhmicError";
    AlarmTypeEnum[AlarmTypeEnum["StringCurrentError"] = 44] = "StringCurrentError";
    AlarmTypeEnum[AlarmTypeEnum["AmbientTemperatureError"] = 45] = "AmbientTemperatureError";
    AlarmTypeEnum[AlarmTypeEnum["StringRippleCurrentError"] = 46] = "StringRippleCurrentError";
    AlarmTypeEnum[AlarmTypeEnum["HumidityError"] = 47] = "HumidityError";
    AlarmTypeEnum[AlarmTypeEnum["VotageProtectionCellBlock"] = 51] = "VotageProtectionCellBlock";
    AlarmTypeEnum[AlarmTypeEnum["VoltageProtectionRackString"] = 52] = "VoltageProtectionRackString";
    AlarmTypeEnum[AlarmTypeEnum["RackCellVoltageImbalanceString"] = 53] = "RackCellVoltageImbalanceString";
    AlarmTypeEnum[AlarmTypeEnum["TemperatureProtection"] = 54] = "TemperatureProtection";
    AlarmTypeEnum[AlarmTypeEnum["TemperatureImbalance"] = 55] = "TemperatureImbalance";
    AlarmTypeEnum[AlarmTypeEnum["MCCBOpen"] = 58] = "MCCBOpen";
    AlarmTypeEnum[AlarmTypeEnum["StringVoltageSenseDiff"] = 59] = "StringVoltageSenseDiff";
    AlarmTypeEnum[AlarmTypeEnum["ModuleVoltageSenseDiff"] = 60] = "ModuleVoltageSenseDiff";
    AlarmTypeEnum[AlarmTypeEnum["ModuleVoltageVariation"] = 63] = "ModuleVoltageVariation";
    AlarmTypeEnum[AlarmTypeEnum["BlockReadyTemperature"] = 76] = "BlockReadyTemperature";
    AlarmTypeEnum[AlarmTypeEnum["BlockReadyTemperatureVariation"] = 77] = "BlockReadyTemperatureVariation";
    AlarmTypeEnum[AlarmTypeEnum["OverTemperatureProtectionTerminal"] = 78] = "OverTemperatureProtectionTerminal";
    AlarmTypeEnum[AlarmTypeEnum["RackToSensorCommunicationFailure"] = 79] = "RackToSensorCommunicationFailure";
    AlarmTypeEnum[AlarmTypeEnum["SMPSFailure1"] = 80] = "SMPSFailure1";
    AlarmTypeEnum[AlarmTypeEnum["SMPSFailure2"] = 81] = "SMPSFailure2";
    AlarmTypeEnum[AlarmTypeEnum["CellChargeTemperature"] = 82] = "CellChargeTemperature";
    AlarmTypeEnum[AlarmTypeEnum["CellChargeTemperatureVariation"] = 83] = "CellChargeTemperatureVariation";
    AlarmTypeEnum[AlarmTypeEnum["CellDischargeTemperature"] = 84] = "CellDischargeTemperature";
    AlarmTypeEnum[AlarmTypeEnum["CellDischargeTemperatureVariation"] = 85] = "CellDischargeTemperatureVariation";
    AlarmTypeEnum[AlarmTypeEnum["CellReadyTemperature"] = 86] = "CellReadyTemperature";
    AlarmTypeEnum[AlarmTypeEnum["CellReadyTemperatureVariation"] = 87] = "CellReadyTemperatureVariation";
    AlarmTypeEnum[AlarmTypeEnum["TerminalChargeTemperature"] = 88] = "TerminalChargeTemperature";
    AlarmTypeEnum[AlarmTypeEnum["TerminalDischargeTemperature"] = 89] = "TerminalDischargeTemperature";
    AlarmTypeEnum[AlarmTypeEnum["TerminalReadyTemperature"] = 90] = "TerminalReadyTemperature";
    AlarmTypeEnum[AlarmTypeEnum["StringSOH"] = 91] = "StringSOH";
    AlarmTypeEnum[AlarmTypeEnum["StringSOCReady"] = 92] = "StringSOCReady";
    AlarmTypeEnum[AlarmTypeEnum["StringSOCDischarge"] = 93] = "StringSOCDischarge";
    AlarmTypeEnum[AlarmTypeEnum["CellReadyVoltageVariation"] = 94] = "CellReadyVoltageVariation";
    AlarmTypeEnum[AlarmTypeEnum["CellChargeVoltageVariation"] = 95] = "CellChargeVoltageVariation";
    AlarmTypeEnum[AlarmTypeEnum["CellDischargeVoltageVariation"] = 96] = "CellDischargeVoltageVariation";
})(AlarmTypeEnum || (AlarmTypeEnum = {}));
export var ComponentStatusEnum;
(function (ComponentStatusEnum) {
    ComponentStatusEnum[ComponentStatusEnum["Healthy"] = 1] = "Healthy";
    ComponentStatusEnum[ComponentStatusEnum["Warning"] = 2] = "Warning";
    ComponentStatusEnum[ComponentStatusEnum["Critical"] = 3] = "Critical";
})(ComponentStatusEnum || (ComponentStatusEnum = {}));
export var ComponentStatusStrategyEnum;
(function (ComponentStatusStrategyEnum) {
    ComponentStatusStrategyEnum[ComponentStatusStrategyEnum["Persisted"] = 0] = "Persisted";
    ComponentStatusStrategyEnum[ComponentStatusStrategyEnum["PointInTime"] = 1] = "PointInTime";
})(ComponentStatusStrategyEnum || (ComponentStatusStrategyEnum = {}));
export var ComponentTypeEnum;
(function (ComponentTypeEnum) {
    ComponentTypeEnum[ComponentTypeEnum["BatteryBank"] = 1] = "BatteryBank";
    ComponentTypeEnum[ComponentTypeEnum["String"] = 2] = "String";
    ComponentTypeEnum[ComponentTypeEnum["Block"] = 3] = "Block";
    ComponentTypeEnum[ComponentTypeEnum["Controller"] = 4] = "Controller";
    ComponentTypeEnum[ComponentTypeEnum["Sensor"] = 5] = "Sensor";
    ComponentTypeEnum[ComponentTypeEnum["Module"] = 6] = "Module";
    ComponentTypeEnum[ComponentTypeEnum["CellTemp"] = 7] = "CellTemp";
    ComponentTypeEnum[ComponentTypeEnum["TerminalTemp"] = 8] = "TerminalTemp";
})(ComponentTypeEnum || (ComponentTypeEnum = {}));
export var MeasurementTypeEnum;
(function (MeasurementTypeEnum) {
    MeasurementTypeEnum[MeasurementTypeEnum["BlockVoltage"] = 1] = "BlockVoltage";
    MeasurementTypeEnum[MeasurementTypeEnum["AmbientTemperatureVariation"] = 2] = "AmbientTemperatureVariation";
    MeasurementTypeEnum[MeasurementTypeEnum["BlockTemperatureMedian"] = 3] = "BlockTemperatureMedian";
    MeasurementTypeEnum[MeasurementTypeEnum["BlockTemperatureVariation"] = 4] = "BlockTemperatureVariation";
    MeasurementTypeEnum[MeasurementTypeEnum["BlockOhmicVariation"] = 5] = "BlockOhmicVariation";
    MeasurementTypeEnum[MeasurementTypeEnum["BlockVoltageMedian"] = 6] = "BlockVoltageMedian";
    MeasurementTypeEnum[MeasurementTypeEnum["BlockVoltageVariation"] = 7] = "BlockVoltageVariation";
    MeasurementTypeEnum[MeasurementTypeEnum["AmbientTemperature"] = 8] = "AmbientTemperature";
    MeasurementTypeEnum[MeasurementTypeEnum["Temperature"] = 9] = "Temperature";
    MeasurementTypeEnum[MeasurementTypeEnum["Humidity"] = 10] = "Humidity";
    MeasurementTypeEnum[MeasurementTypeEnum["RippleCurrent"] = 11] = "RippleCurrent";
    MeasurementTypeEnum[MeasurementTypeEnum["Current"] = 12] = "Current";
    MeasurementTypeEnum[MeasurementTypeEnum["OhmicRise"] = 13] = "OhmicRise";
    MeasurementTypeEnum[MeasurementTypeEnum["Ohmic"] = 14] = "Ohmic";
    MeasurementTypeEnum[MeasurementTypeEnum["StringVoltage"] = 15] = "StringVoltage";
    MeasurementTypeEnum[MeasurementTypeEnum["RippleVoltage"] = 16] = "RippleVoltage";
    MeasurementTypeEnum[MeasurementTypeEnum["AmbientTemperatureMedian"] = 17] = "AmbientTemperatureMedian";
    MeasurementTypeEnum[MeasurementTypeEnum["AmbientTemperatureStringMedianToBlockMedianVariation"] = 18] = "AmbientTemperatureStringMedianToBlockMedianVariation";
    MeasurementTypeEnum[MeasurementTypeEnum["SystemVoltage"] = 19] = "SystemVoltage";
    MeasurementTypeEnum[MeasurementTypeEnum["SystemCurrent"] = 20] = "SystemCurrent";
    MeasurementTypeEnum[MeasurementTypeEnum["SystemSOC"] = 21] = "SystemSOC";
    MeasurementTypeEnum[MeasurementTypeEnum["SystemSOH"] = 22] = "SystemSOH";
    MeasurementTypeEnum[MeasurementTypeEnum["SystemMaxVoltage"] = 23] = "SystemMaxVoltage";
    MeasurementTypeEnum[MeasurementTypeEnum["SystemMinVoltage"] = 24] = "SystemMinVoltage";
    MeasurementTypeEnum[MeasurementTypeEnum["SystemMaxTemperature"] = 25] = "SystemMaxTemperature";
    MeasurementTypeEnum[MeasurementTypeEnum["SystemMinTemperature"] = 26] = "SystemMinTemperature";
    MeasurementTypeEnum[MeasurementTypeEnum["CellSummationVoltage"] = 27] = "CellSummationVoltage";
    MeasurementTypeEnum[MeasurementTypeEnum["StringSOC"] = 28] = "StringSOC";
    MeasurementTypeEnum[MeasurementTypeEnum["StringSOH"] = 29] = "StringSOH";
    MeasurementTypeEnum[MeasurementTypeEnum["CellVoltageMax1"] = 30] = "CellVoltageMax1";
    MeasurementTypeEnum[MeasurementTypeEnum["CellVoltageMax2"] = 31] = "CellVoltageMax2";
    MeasurementTypeEnum[MeasurementTypeEnum["CellVoltageMin1"] = 32] = "CellVoltageMin1";
    MeasurementTypeEnum[MeasurementTypeEnum["CellVoltageMin2"] = 33] = "CellVoltageMin2";
    MeasurementTypeEnum[MeasurementTypeEnum["CellVoltageAverage"] = 34] = "CellVoltageAverage";
    MeasurementTypeEnum[MeasurementTypeEnum["CellTemperatureMax1"] = 35] = "CellTemperatureMax1";
    MeasurementTypeEnum[MeasurementTypeEnum["CellTemperatureMax2"] = 36] = "CellTemperatureMax2";
    MeasurementTypeEnum[MeasurementTypeEnum["CellTemperatureMin1"] = 37] = "CellTemperatureMin1";
    MeasurementTypeEnum[MeasurementTypeEnum["CellTemperatureMin2"] = 38] = "CellTemperatureMin2";
    MeasurementTypeEnum[MeasurementTypeEnum["CellTemperatureAverage"] = 39] = "CellTemperatureAverage";
    MeasurementTypeEnum[MeasurementTypeEnum["CellVoltageMax1Location"] = 52] = "CellVoltageMax1Location";
    MeasurementTypeEnum[MeasurementTypeEnum["CellVoltageMax2Location"] = 53] = "CellVoltageMax2Location";
    MeasurementTypeEnum[MeasurementTypeEnum["CellVoltageMin1Location"] = 54] = "CellVoltageMin1Location";
    MeasurementTypeEnum[MeasurementTypeEnum["CellVoltageMin2Location"] = 55] = "CellVoltageMin2Location";
    MeasurementTypeEnum[MeasurementTypeEnum["CellTemperatureMax1Location"] = 56] = "CellTemperatureMax1Location";
    MeasurementTypeEnum[MeasurementTypeEnum["CellTemperatureMax2Location"] = 57] = "CellTemperatureMax2Location";
    MeasurementTypeEnum[MeasurementTypeEnum["CellTemperatureMin1Location"] = 58] = "CellTemperatureMin1Location";
    MeasurementTypeEnum[MeasurementTypeEnum["CellTemperatureMin2Location"] = 59] = "CellTemperatureMin2Location";
    MeasurementTypeEnum[MeasurementTypeEnum["MCCB"] = 60] = "MCCB";
    MeasurementTypeEnum[MeasurementTypeEnum["FuseOn"] = 61] = "FuseOn";
    MeasurementTypeEnum[MeasurementTypeEnum["ModuleVoltage"] = 62] = "ModuleVoltage";
    MeasurementTypeEnum[MeasurementTypeEnum["ModuleVoltageSenseDiff"] = 63] = "ModuleVoltageSenseDiff";
    MeasurementTypeEnum[MeasurementTypeEnum["StringVoltageVariation"] = 64] = "StringVoltageVariation";
    MeasurementTypeEnum[MeasurementTypeEnum["ModuleVoltageVariation"] = 69] = "ModuleVoltageVariation";
    MeasurementTypeEnum[MeasurementTypeEnum["CellTemperature"] = 70] = "CellTemperature";
    MeasurementTypeEnum[MeasurementTypeEnum["TerminalTemperature"] = 71] = "TerminalTemperature";
    MeasurementTypeEnum[MeasurementTypeEnum["MaxCellVoltage1ModulePosition"] = 72] = "MaxCellVoltage1ModulePosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MaxCellVoltage1CellPosition"] = 73] = "MaxCellVoltage1CellPosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MinCellVoltage1ModulePosition"] = 74] = "MinCellVoltage1ModulePosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MinCellVoltage1CellPosition"] = 75] = "MinCellVoltage1CellPosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MaxCellVoltage2ModulePosition"] = 76] = "MaxCellVoltage2ModulePosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MaxCellVoltage2CellPosition"] = 77] = "MaxCellVoltage2CellPosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MinCellVoltage2ModulePosition"] = 78] = "MinCellVoltage2ModulePosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MinCellVoltage2CellPosition"] = 79] = "MinCellVoltage2CellPosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MaxCellTemp1ModulePosition"] = 80] = "MaxCellTemp1ModulePosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MaxCellTemp1CellPosition"] = 81] = "MaxCellTemp1CellPosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MinCellTemp1ModulePosition"] = 82] = "MinCellTemp1ModulePosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MinCellTemp1CellPosition"] = 83] = "MinCellTemp1CellPosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MaxCellTemp2ModulePosition"] = 84] = "MaxCellTemp2ModulePosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MaxCellTemp2CellPosition"] = 85] = "MaxCellTemp2CellPosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MinCellTemp2ModulePosition"] = 86] = "MinCellTemp2ModulePosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MinCellTemp2CellPosition"] = 87] = "MinCellTemp2CellPosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MaxTerminalTemperature"] = 88] = "MaxTerminalTemperature";
    MeasurementTypeEnum[MeasurementTypeEnum["MaxTerminalTempModulePosition"] = 89] = "MaxTerminalTempModulePosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MaxTerminalTempSensorPosition"] = 90] = "MaxTerminalTempSensorPosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MinTerminalTemperature"] = 91] = "MinTerminalTemperature";
    MeasurementTypeEnum[MeasurementTypeEnum["MinTerminalTempModulePosition"] = 92] = "MinTerminalTempModulePosition";
    MeasurementTypeEnum[MeasurementTypeEnum["MinTerminalTempSensorPosition"] = 93] = "MinTerminalTempSensorPosition";
    MeasurementTypeEnum[MeasurementTypeEnum["ModuleSenseSummation"] = 94] = "ModuleSenseSummation";
    MeasurementTypeEnum[MeasurementTypeEnum["CellVoltageVariation"] = 95] = "CellVoltageVariation";
    MeasurementTypeEnum[MeasurementTypeEnum["CellTemperatureVariation"] = 96] = "CellTemperatureVariation";
})(MeasurementTypeEnum || (MeasurementTypeEnum = {}));
export var RoleTypeEnum;
(function (RoleTypeEnum) {
    RoleTypeEnum[RoleTypeEnum["Administrator"] = 1] = "Administrator";
    RoleTypeEnum[RoleTypeEnum["PowerUser"] = 2] = "PowerUser";
    RoleTypeEnum[RoleTypeEnum["Client"] = 3] = "Client";
    RoleTypeEnum[RoleTypeEnum["ClientAdministrator"] = 4] = "ClientAdministrator";
    RoleTypeEnum[RoleTypeEnum["ClientInstaller"] = 5] = "ClientInstaller";
    RoleTypeEnum[RoleTypeEnum["Integration"] = 6] = "Integration";
})(RoleTypeEnum || (RoleTypeEnum = {}));
export var StringStatusEnum;
(function (StringStatusEnum) {
    StringStatusEnum[StringStatusEnum["Idle"] = 1] = "Idle";
    StringStatusEnum[StringStatusEnum["Float"] = 2] = "Float";
    StringStatusEnum[StringStatusEnum["Charge"] = 3] = "Charge";
    StringStatusEnum[StringStatusEnum["Discharge"] = 4] = "Discharge";
    StringStatusEnum[StringStatusEnum["Unknown"] = 5] = "Unknown";
    StringStatusEnum[StringStatusEnum["Offline"] = 6] = "Offline";
    StringStatusEnum[StringStatusEnum["Ready"] = 7] = "Ready";
})(StringStatusEnum || (StringStatusEnum = {}));
export var NotificationChannelEnum;
(function (NotificationChannelEnum) {
    NotificationChannelEnum[NotificationChannelEnum["Email"] = 1] = "Email";
    NotificationChannelEnum[NotificationChannelEnum["Sms"] = 2] = "Sms";
})(NotificationChannelEnum || (NotificationChannelEnum = {}));
export var NotificationTypeEnum;
(function (NotificationTypeEnum) {
    NotificationTypeEnum[NotificationTypeEnum["Alarm"] = 1] = "Alarm";
    NotificationTypeEnum[NotificationTypeEnum["SystemStatusSummary"] = 2] = "SystemStatusSummary";
    NotificationTypeEnum[NotificationTypeEnum["AlarmInfo"] = 3] = "AlarmInfo";
    NotificationTypeEnum[NotificationTypeEnum["AlarmWarning"] = 4] = "AlarmWarning";
    NotificationTypeEnum[NotificationTypeEnum["AlarmCritical"] = 5] = "AlarmCritical";
    NotificationTypeEnum[NotificationTypeEnum["IssueCreated"] = 6] = "IssueCreated";
    NotificationTypeEnum[NotificationTypeEnum["IssueAssigned"] = 7] = "IssueAssigned";
    NotificationTypeEnum[NotificationTypeEnum["CommentAdded"] = 8] = "CommentAdded";
    NotificationTypeEnum[NotificationTypeEnum["CommentUpdated"] = 9] = "CommentUpdated";
})(NotificationTypeEnum || (NotificationTypeEnum = {}));
export class KeyValueModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null;
            this.value = _data["value"] !== undefined ? _data["value"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValueModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null;
        data["value"] = this.value !== undefined ? this.value : null;
        return data;
    }
}
export class ErrorCodeDescription {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.errorCode = _data["errorCode"] !== undefined ? _data["errorCode"] : null;
            this.description = _data["description"] !== undefined ? _data["description"] : null;
            this.category = _data["category"] !== undefined ? _data["category"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorCodeDescription();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode !== undefined ? this.errorCode : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["category"] = this.category !== undefined ? this.category : null;
        return data;
    }
}
export class BaseCommandOfSMTPImportLogModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? SMTPImportLogModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfSMTPImportLogModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class AddSMTPImportLogCommand extends BaseCommandOfSMTPImportLogModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddSMTPImportLogCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SMTPImportLogModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.numberOfEmailsRead = _data["numberOfEmailsRead"] !== undefined ? _data["numberOfEmailsRead"] : null;
            this.numberOfEmailsFiltered = _data["numberOfEmailsFiltered"] !== undefined ? _data["numberOfEmailsFiltered"] : null;
            this.numberOfEmailsIgnored = _data["numberOfEmailsIgnored"] !== undefined ? _data["numberOfEmailsIgnored"] : null;
            this.numberOfSystemsImported = _data["numberOfSystemsImported"] !== undefined ? _data["numberOfSystemsImported"] : null;
            this.numberOfSnapshotsImported = _data["numberOfSnapshotsImported"] !== undefined ? _data["numberOfSnapshotsImported"] : null;
            this.numberOfAlarmsImported = _data["numberOfAlarmsImported"] !== undefined ? _data["numberOfAlarmsImported"] : null;
            this.numberOfChargeImported = _data["numberOfChargeImported"] !== undefined ? _data["numberOfChargeImported"] : null;
            this.numberOfDischargeImported = _data["numberOfDischargeImported"] !== undefined ? _data["numberOfDischargeImported"] : null;
            this.numberOfFilesImported = _data["numberOfFilesImported"] !== undefined ? _data["numberOfFilesImported"] : null;
            this.numberOfFilesWithWarning = _data["numberOfFilesWithWarning"] !== undefined ? _data["numberOfFilesWithWarning"] : null;
            this.numberOfFilesWithError = _data["numberOfFilesWithError"] !== undefined ? _data["numberOfFilesWithError"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SMTPImportLogModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["numberOfEmailsRead"] = this.numberOfEmailsRead !== undefined ? this.numberOfEmailsRead : null;
        data["numberOfEmailsFiltered"] = this.numberOfEmailsFiltered !== undefined ? this.numberOfEmailsFiltered : null;
        data["numberOfEmailsIgnored"] = this.numberOfEmailsIgnored !== undefined ? this.numberOfEmailsIgnored : null;
        data["numberOfSystemsImported"] = this.numberOfSystemsImported !== undefined ? this.numberOfSystemsImported : null;
        data["numberOfSnapshotsImported"] = this.numberOfSnapshotsImported !== undefined ? this.numberOfSnapshotsImported : null;
        data["numberOfAlarmsImported"] = this.numberOfAlarmsImported !== undefined ? this.numberOfAlarmsImported : null;
        data["numberOfChargeImported"] = this.numberOfChargeImported !== undefined ? this.numberOfChargeImported : null;
        data["numberOfDischargeImported"] = this.numberOfDischargeImported !== undefined ? this.numberOfDischargeImported : null;
        data["numberOfFilesImported"] = this.numberOfFilesImported !== undefined ? this.numberOfFilesImported : null;
        data["numberOfFilesWithWarning"] = this.numberOfFilesWithWarning !== undefined ? this.numberOfFilesWithWarning : null;
        data["numberOfFilesWithError"] = this.numberOfFilesWithError !== undefined ? this.numberOfFilesWithError : null;
        super.toJSON(data);
        return data;
    }
}
export var SMTPImportStatusEnum;
(function (SMTPImportStatusEnum) {
    SMTPImportStatusEnum[SMTPImportStatusEnum["Running"] = 0] = "Running";
    SMTPImportStatusEnum[SMTPImportStatusEnum["GracefulShutdown"] = 1] = "GracefulShutdown";
    SMTPImportStatusEnum[SMTPImportStatusEnum["ForcedShutdown"] = 2] = "ForcedShutdown";
})(SMTPImportStatusEnum || (SMTPImportStatusEnum = {}));
export class BaseCommandOfSMTPImportEmailLogModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? SMTPImportEmailLogModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfSMTPImportEmailLogModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class AddSMTPImportEmailLogCommand extends BaseCommandOfSMTPImportEmailLogModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddSMTPImportEmailLogCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SMTPImportEmailLogModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.emailKey = _data["emailKey"] !== undefined ? _data["emailKey"] : null;
            this.uniqueId = _data["uniqueId"] !== undefined ? _data["uniqueId"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.smtpImportLogId = _data["smtpImportLogId"] !== undefined ? _data["smtpImportLogId"] : null;
            this.from = _data["from"] !== undefined ? _data["from"] : null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null;
            this.messageDateTime = _data["messageDateTime"] ? new Date(_data["messageDateTime"].toString()) : null;
            this.numberOfFilesAttached = _data["numberOfFilesAttached"] !== undefined ? _data["numberOfFilesAttached"] : null;
            this.numberOfFilesWithWarning = _data["numberOfFilesWithWarning"] !== undefined ? _data["numberOfFilesWithWarning"] : null;
            this.numberOfFilesWithError = _data["numberOfFilesWithError"] !== undefined ? _data["numberOfFilesWithError"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SMTPImportEmailLogModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["emailKey"] = this.emailKey !== undefined ? this.emailKey : null;
        data["uniqueId"] = this.uniqueId !== undefined ? this.uniqueId : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["smtpImportLogId"] = this.smtpImportLogId !== undefined ? this.smtpImportLogId : null;
        data["from"] = this.from !== undefined ? this.from : null;
        data["subject"] = this.subject !== undefined ? this.subject : null;
        data["messageDateTime"] = this.messageDateTime ? this.messageDateTime.toISOString() : null;
        data["numberOfFilesAttached"] = this.numberOfFilesAttached !== undefined ? this.numberOfFilesAttached : null;
        data["numberOfFilesWithWarning"] = this.numberOfFilesWithWarning !== undefined ? this.numberOfFilesWithWarning : null;
        data["numberOfFilesWithError"] = this.numberOfFilesWithError !== undefined ? this.numberOfFilesWithError : null;
        super.toJSON(data);
        return data;
    }
}
export var SMTPImportEmailLogStatus;
(function (SMTPImportEmailLogStatus) {
    SMTPImportEmailLogStatus[SMTPImportEmailLogStatus["Processing"] = 0] = "Processing";
    SMTPImportEmailLogStatus[SMTPImportEmailLogStatus["Sucess"] = 1] = "Sucess";
    SMTPImportEmailLogStatus[SMTPImportEmailLogStatus["Warning"] = 2] = "Warning";
    SMTPImportEmailLogStatus[SMTPImportEmailLogStatus["Error"] = 3] = "Error";
})(SMTPImportEmailLogStatus || (SMTPImportEmailLogStatus = {}));
export class BaseCommandOfSMTPImportFileLogModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? SMTPImportFileLogModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfSMTPImportFileLogModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class AddSMTPImportFileLogCommand extends BaseCommandOfSMTPImportFileLogModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddSMTPImportFileLogCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SMTPImportFileLogModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.smtpImportEmailLogId = _data["smtpImportEmailLogId"] !== undefined ? _data["smtpImportEmailLogId"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.attachedFileName = _data["attachedFileName"] !== undefined ? _data["attachedFileName"] : null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
            this.numberOfSystemsImported = _data["numberOfSystemsImported"] !== undefined ? _data["numberOfSystemsImported"] : null;
            this.numberOfSnapshotsImported = _data["numberOfSnapshotsImported"] !== undefined ? _data["numberOfSnapshotsImported"] : null;
            this.numberOfAlarmsImported = _data["numberOfAlarmsImported"] !== undefined ? _data["numberOfAlarmsImported"] : null;
            this.numberOfChargeImported = _data["numberOfChargeImported"] !== undefined ? _data["numberOfChargeImported"] : null;
            this.numberOfDischargeImported = _data["numberOfDischargeImported"] !== undefined ? _data["numberOfDischargeImported"] : null;
            this.numberOfFilesWithWarning = _data["numberOfFilesWithWarning"] !== undefined ? _data["numberOfFilesWithWarning"] : null;
            this.numberOfFilesWithError = _data["numberOfFilesWithError"] !== undefined ? _data["numberOfFilesWithError"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SMTPImportFileLogModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["smtpImportEmailLogId"] = this.smtpImportEmailLogId !== undefined ? this.smtpImportEmailLogId : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["attachedFileName"] = this.attachedFileName !== undefined ? this.attachedFileName : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["numberOfSystemsImported"] = this.numberOfSystemsImported !== undefined ? this.numberOfSystemsImported : null;
        data["numberOfSnapshotsImported"] = this.numberOfSnapshotsImported !== undefined ? this.numberOfSnapshotsImported : null;
        data["numberOfAlarmsImported"] = this.numberOfAlarmsImported !== undefined ? this.numberOfAlarmsImported : null;
        data["numberOfChargeImported"] = this.numberOfChargeImported !== undefined ? this.numberOfChargeImported : null;
        data["numberOfDischargeImported"] = this.numberOfDischargeImported !== undefined ? this.numberOfDischargeImported : null;
        data["numberOfFilesWithWarning"] = this.numberOfFilesWithWarning !== undefined ? this.numberOfFilesWithWarning : null;
        data["numberOfFilesWithError"] = this.numberOfFilesWithError !== undefined ? this.numberOfFilesWithError : null;
        super.toJSON(data);
        return data;
    }
}
export class UpdateSMTPImportLogCommand extends BaseCommandOfSMTPImportLogModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSMTPImportLogCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateSMTPImportEmailLogCommand extends BaseCommandOfSMTPImportEmailLogModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSMTPImportEmailLogCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateSMTPImportFileLogCommand extends BaseCommandOfSMTPImportFileLogModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSMTPImportFileLogCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfSMTPImportFileMessageLogModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? SMTPImportFileMessageLogModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfSMTPImportFileMessageLogModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class AddSMTPImportMessageLogCommand extends BaseCommandOfSMTPImportFileMessageLogModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddSMTPImportMessageLogCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SMTPImportFileMessageLogModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.smtpImportFileLogId = _data["smtpImportFileLogId"] !== undefined ? _data["smtpImportFileLogId"] : null;
            this.messageType = _data["messageType"] !== undefined ? _data["messageType"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            this.errorException = _data["errorException"] !== undefined ? _data["errorException"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SMTPImportFileMessageLogModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["smtpImportFileLogId"] = this.smtpImportFileLogId !== undefined ? this.smtpImportFileLogId : null;
        data["messageType"] = this.messageType !== undefined ? this.messageType : null;
        data["message"] = this.message !== undefined ? this.message : null;
        data["errorException"] = this.errorException !== undefined ? this.errorException : null;
        super.toJSON(data);
        return data;
    }
}
export var SMTPImportFileMessageTypeEnum;
(function (SMTPImportFileMessageTypeEnum) {
    SMTPImportFileMessageTypeEnum[SMTPImportFileMessageTypeEnum["Information"] = 1] = "Information";
    SMTPImportFileMessageTypeEnum[SMTPImportFileMessageTypeEnum["Warning"] = 2] = "Warning";
    SMTPImportFileMessageTypeEnum[SMTPImportFileMessageTypeEnum["Error"] = 3] = "Error";
})(SMTPImportFileMessageTypeEnum || (SMTPImportFileMessageTypeEnum = {}));
export class BaseQueryOfCheckDuplicatedEmailsQueryAndIListOfLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfCheckDuplicatedEmailsQueryAndIListOfLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class CheckDuplicatedEmailsQuery extends BaseQueryOfCheckDuplicatedEmailsQueryAndIListOfLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.emailKey = _data["emailKey"] !== undefined ? _data["emailKey"] : null;
            if (Array.isArray(_data["uniqueIds"])) {
                this.uniqueIds = [];
                for (let item of _data["uniqueIds"])
                    this.uniqueIds.push(item);
            }
            else {
                this.uniqueIds = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDuplicatedEmailsQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["emailKey"] = this.emailKey !== undefined ? this.emailKey : null;
        if (Array.isArray(this.uniqueIds)) {
            data["uniqueIds"] = [];
            for (let item of this.uniqueIds)
                data["uniqueIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfSMTPImportLogModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(SMTPImportLogModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfSMTPImportLogModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetSMTPImportLogsListPaginatedQueryAndPaginatedEnumerableOfSMTPImportLogModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSMTPImportLogsListPaginatedQueryAndPaginatedEnumerableOfSMTPImportLogModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSMTPImportLogsListPaginatedQuery extends BaseQueryOfGetSMTPImportLogsListPaginatedQueryAndPaginatedEnumerableOfSMTPImportLogModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSMTPImportLogsListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        data["from"] = this.from ? this.from.toISOString() : null;
        data["to"] = this.to ? this.to.toISOString() : null;
        super.toJSON(data);
        return data;
    }
}
export class SMTPImportLogDetailModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.importLogId = _data["importLogId"] !== undefined ? _data["importLogId"] : null;
            this.emails = _data["emails"] ? PaginatedEnumerableOfSMTPImportEmailLogModel.fromJS(_data["emails"]) : null;
            if (Array.isArray(_data["files"])) {
                this.files = [];
                for (let item of _data["files"])
                    this.files.push(SMTPImportFileLogModel.fromJS(item));
            }
            else {
                this.files = null;
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [];
                for (let item of _data["messages"])
                    this.messages.push(SMTPImportFileMessageLogModel.fromJS(item));
            }
            else {
                this.messages = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SMTPImportLogDetailModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["importLogId"] = this.importLogId !== undefined ? this.importLogId : null;
        data["emails"] = this.emails ? this.emails.toJSON() : null;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class PaginatedEnumerableOfSMTPImportEmailLogModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(SMTPImportEmailLogModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfSMTPImportEmailLogModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetSMTPImportLogListPaginatedQueryAndSMTPImportLogDetailModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSMTPImportLogListPaginatedQueryAndSMTPImportLogDetailModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSMTPImportLogListPaginatedQuery extends BaseQueryOfGetSMTPImportLogListPaginatedQueryAndSMTPImportLogDetailModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.smtpImportLogId = _data["smtpImportLogId"] !== undefined ? _data["smtpImportLogId"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSMTPImportLogListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["smtpImportLogId"] = this.smtpImportLogId !== undefined ? this.smtpImportLogId : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class UploadAlarmRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.registrationKey = _data["registrationKey"] !== undefined ? _data["registrationKey"] : null;
            this.alarmDefinitionId = _data["alarmDefinitionId"] !== undefined ? _data["alarmDefinitionId"] : null;
            this.alarmGroupId = _data["alarmGroupId"] !== undefined ? _data["alarmGroupId"] : null;
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null;
            this.location = _data["location"] !== undefined ? _data["location"] : null;
            this.details = _data["details"] !== undefined ? _data["details"] : null;
            this.whenRaised = _data["whenRaised"] ? new Date(_data["whenRaised"].toString()) : null;
            this.whenCleared = _data["whenCleared"] ? new Date(_data["whenCleared"].toString()) : null;
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : null;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : null;
            this.minLimitValue = _data["minLimitValue"] !== undefined ? _data["minLimitValue"] : null;
            this.maxLimitValue = _data["maxLimitValue"] !== undefined ? _data["maxLimitValue"] : null;
            this.isOrphaned = _data["isOrphaned"] !== undefined ? _data["isOrphaned"] : null;
            this.controllerSMTPSequence = _data["controllerSMTPSequence"] !== undefined ? _data["controllerSMTPSequence"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadAlarmRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["registrationKey"] = this.registrationKey !== undefined ? this.registrationKey : null;
        data["alarmDefinitionId"] = this.alarmDefinitionId !== undefined ? this.alarmDefinitionId : null;
        data["alarmGroupId"] = this.alarmGroupId !== undefined ? this.alarmGroupId : null;
        data["eventId"] = this.eventId !== undefined ? this.eventId : null;
        data["location"] = this.location !== undefined ? this.location : null;
        data["details"] = this.details !== undefined ? this.details : null;
        data["whenRaised"] = this.whenRaised ? this.whenRaised.toISOString() : null;
        data["whenCleared"] = this.whenCleared ? this.whenCleared.toISOString() : null;
        data["minValue"] = this.minValue !== undefined ? this.minValue : null;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : null;
        data["minLimitValue"] = this.minLimitValue !== undefined ? this.minLimitValue : null;
        data["maxLimitValue"] = this.maxLimitValue !== undefined ? this.maxLimitValue : null;
        data["isOrphaned"] = this.isOrphaned !== undefined ? this.isOrphaned : null;
        data["controllerSMTPSequence"] = this.controllerSMTPSequence !== undefined ? this.controllerSMTPSequence : null;
        return data;
    }
}
export class DataTransferResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null;
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            else {
                this.errors = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DataTransferResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}
export class RegisterSystemResponseModel extends DataTransferResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.component = _data["component"] ? ComponentModel.fromJS(_data["component"]) : null;
            this.system = _data["system"] ? SystemModel.fromJS(_data["system"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterSystemResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["component"] = this.component ? this.component.toJSON() : null;
        data["system"] = this.system ? this.system.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class ComponentModel extends BaseAuthoredModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.componentTypeId = _data["componentTypeId"] !== undefined ? _data["componentTypeId"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.stringStatusId = _data["stringStatusId"] !== undefined ? _data["stringStatusId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : null;
            this.modelId = _data["modelId"] !== undefined ? _data["modelId"] : null;
            this.componentCode = _data["componentCode"] !== undefined ? _data["componentCode"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.componentTypeName = _data["componentTypeName"] !== undefined ? _data["componentTypeName"] : null;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null;
            this.stringStatusName = _data["stringStatusName"] !== undefined ? _data["stringStatusName"] : null;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null;
            this.manufacturerName = _data["manufacturerName"] !== undefined ? _data["manufacturerName"] : null;
            this.modelName = _data["modelName"] !== undefined ? _data["modelName"] : null;
            this.registrationKey = _data["registrationKey"] !== undefined ? _data["registrationKey"] : null;
            this.whenRegistered = _data["whenRegistered"] ? new Date(_data["whenRegistered"].toString()) : null;
            this.whenManufactured = _data["whenManufactured"] ? new Date(_data["whenManufactured"].toString()) : null;
            this.whenLastReplacement = _data["whenLastReplacement"] ? new Date(_data["whenLastReplacement"].toString()) : null;
            this.whenNextReplacement = _data["whenNextReplacement"] ? new Date(_data["whenNextReplacement"].toString()) : null;
            this.blockTargetFloatVoltage = _data["blockTargetFloatVoltage"] !== undefined ? _data["blockTargetFloatVoltage"] : null;
            if (Array.isArray(_data["children"])) {
                this.children = [];
                for (let item of _data["children"])
                    this.children.push(ComponentModel.fromJS(item));
            }
            else {
                this.children = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["componentTypeId"] = this.componentTypeId !== undefined ? this.componentTypeId : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["stringStatusId"] = this.stringStatusId !== undefined ? this.stringStatusId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["modelId"] = this.modelId !== undefined ? this.modelId : null;
        data["componentCode"] = this.componentCode !== undefined ? this.componentCode : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["componentTypeName"] = this.componentTypeName !== undefined ? this.componentTypeName : null;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null;
        data["stringStatusName"] = this.stringStatusName !== undefined ? this.stringStatusName : null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["modelName"] = this.modelName !== undefined ? this.modelName : null;
        data["registrationKey"] = this.registrationKey !== undefined ? this.registrationKey : null;
        data["whenRegistered"] = this.whenRegistered ? this.whenRegistered.toISOString() : null;
        data["whenManufactured"] = this.whenManufactured ? this.whenManufactured.toISOString() : null;
        data["whenLastReplacement"] = this.whenLastReplacement ? this.whenLastReplacement.toISOString() : null;
        data["whenNextReplacement"] = this.whenNextReplacement ? this.whenNextReplacement.toISOString() : null;
        data["blockTargetFloatVoltage"] = this.blockTargetFloatVoltage !== undefined ? this.blockTargetFloatVoltage : null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : null);
        }
        super.toJSON(data);
        return data;
    }
}
export class SystemModel extends BaseAuthoredModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.systemCategoryId = _data["systemCategoryId"] !== undefined ? _data["systemCategoryId"] : null;
            this.systemCategoryName = _data["systemCategoryName"] !== undefined ? _data["systemCategoryName"] : null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null;
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : null;
            this.modelId = _data["modelId"] !== undefined ? _data["modelId"] : null;
            this.blockTypeId = _data["blockTypeId"] !== undefined ? _data["blockTypeId"] : null;
            this.monitorTypeId = _data["monitorTypeId"] !== undefined ? _data["monitorTypeId"] : null;
            this.batteryTypeId = _data["batteryTypeId"] !== undefined ? _data["batteryTypeId"] : null;
            this.lithiumBatteryTypeId = _data["lithiumBatteryTypeId"] !== undefined ? _data["lithiumBatteryTypeId"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.systemCode = _data["systemCode"] !== undefined ? _data["systemCode"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.systemDescription = _data["systemDescription"] !== undefined ? _data["systemDescription"] : null;
            this.upsReference = _data["upsReference"] !== undefined ? _data["upsReference"] : null;
            this.batteryRating = _data["batteryRating"] !== undefined ? _data["batteryRating"] : null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null;
            this.manufacturerName = _data["manufacturerName"] !== undefined ? _data["manufacturerName"] : null;
            this.modelName = _data["modelName"] !== undefined ? _data["modelName"] : null;
            this.cellularConnectionQuality = _data["cellularConnectionQuality"] !== undefined ? _data["cellularConnectionQuality"] : null;
            this.modemFirmwareVersion = _data["modemFirmwareVersion"] !== undefined ? _data["modemFirmwareVersion"] : null;
            this.monitorFirmwareVersion = _data["monitorFirmwareVersion"] !== undefined ? _data["monitorFirmwareVersion"] : null;
            this.serialNumberKeywords = _data["serialNumberKeywords"] !== undefined ? _data["serialNumberKeywords"] : null;
            this.numberOfStrings = _data["numberOfStrings"] !== undefined ? _data["numberOfStrings"] : null;
            this.numberOfCriticalStrings = _data["numberOfCriticalStrings"] !== undefined ? _data["numberOfCriticalStrings"] : null;
            this.numberOfWarningStrings = _data["numberOfWarningStrings"] !== undefined ? _data["numberOfWarningStrings"] : null;
            this.numberOfBlocks = _data["numberOfBlocks"] !== undefined ? _data["numberOfBlocks"] : null;
            this.numberOfCriticalBlocks = _data["numberOfCriticalBlocks"] !== undefined ? _data["numberOfCriticalBlocks"] : null;
            this.numberOfWarningBlocks = _data["numberOfWarningBlocks"] !== undefined ? _data["numberOfWarningBlocks"] : null;
            this.numberOfCriticalAlarms = _data["numberOfCriticalAlarms"] !== undefined ? _data["numberOfCriticalAlarms"] : null;
            this.numberOfWarningAlarms = _data["numberOfWarningAlarms"] !== undefined ? _data["numberOfWarningAlarms"] : null;
            this.whenManufactured = _data["whenManufactured"] ? new Date(_data["whenManufactured"].toString()) : null;
            this.whenInstalled = _data["whenInstalled"] ? new Date(_data["whenInstalled"].toString()) : null;
            this.whenLastInspected = _data["whenLastInspected"] ? new Date(_data["whenLastInspected"].toString()) : null;
            this.whenLastDataReceived = _data["whenLastDataReceived"] ? new Date(_data["whenLastDataReceived"].toString()) : null;
            this.whenFirstDataReceived = _data["whenFirstDataReceived"] ? new Date(_data["whenFirstDataReceived"].toString()) : null;
            this.whenUpdatedSampleConfiguration = _data["whenUpdatedSampleConfiguration"] ? new Date(_data["whenUpdatedSampleConfiguration"].toString()) : null;
            this.lastCommsSourceId = _data["lastCommsSourceId"] !== undefined ? _data["lastCommsSourceId"] : null;
            this.lastSignalStrength = _data["lastSignalStrength"] !== undefined ? _data["lastSignalStrength"] : null;
            this.numberOfDroppedConnections = _data["numberOfDroppedConnections"] !== undefined ? _data["numberOfDroppedConnections"] : null;
            this.sampleRate = _data["sampleRate"] !== undefined ? _data["sampleRate"] : null;
            this.samplePeriod = _data["samplePeriod"] !== undefined ? _data["samplePeriod"] : null;
            this.site = _data["site"] ? SiteModel.fromJS(_data["site"]) : null;
            this.controller = _data["controller"] ? SystemComponentModel.fromJS(_data["controller"]) : null;
            this.controllerKeepAlive = _data["controllerKeepAlive"] !== undefined ? _data["controllerKeepAlive"] : null;
            this.systemOfflineTimeout = _data["systemOfflineTimeout"] !== undefined ? _data["systemOfflineTimeout"] : null;
            this.hostAddressOrName = _data["hostAddressOrName"] !== undefined ? _data["hostAddressOrName"] : null;
            this.allowInsecure = _data["allowInsecure"] !== undefined ? _data["allowInsecure"] : null;
            this.isCritical = _data["isCritical"] !== undefined ? _data["isCritical"] : null;
            this.isWarning = _data["isWarning"] !== undefined ? _data["isWarning"] : null;
            this.isHealthy = _data["isHealthy"] !== undefined ? _data["isHealthy"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["systemCategoryId"] = this.systemCategoryId !== undefined ? this.systemCategoryId : null;
        data["systemCategoryName"] = this.systemCategoryName !== undefined ? this.systemCategoryName : null;
        data["personId"] = this.personId !== undefined ? this.personId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["modelId"] = this.modelId !== undefined ? this.modelId : null;
        data["blockTypeId"] = this.blockTypeId !== undefined ? this.blockTypeId : null;
        data["monitorTypeId"] = this.monitorTypeId !== undefined ? this.monitorTypeId : null;
        data["batteryTypeId"] = this.batteryTypeId !== undefined ? this.batteryTypeId : null;
        data["lithiumBatteryTypeId"] = this.lithiumBatteryTypeId !== undefined ? this.lithiumBatteryTypeId : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["systemCode"] = this.systemCode !== undefined ? this.systemCode : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["systemDescription"] = this.systemDescription !== undefined ? this.systemDescription : null;
        data["upsReference"] = this.upsReference !== undefined ? this.upsReference : null;
        data["batteryRating"] = this.batteryRating !== undefined ? this.batteryRating : null;
        data["notes"] = this.notes !== undefined ? this.notes : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["modelName"] = this.modelName !== undefined ? this.modelName : null;
        data["cellularConnectionQuality"] = this.cellularConnectionQuality !== undefined ? this.cellularConnectionQuality : null;
        data["modemFirmwareVersion"] = this.modemFirmwareVersion !== undefined ? this.modemFirmwareVersion : null;
        data["monitorFirmwareVersion"] = this.monitorFirmwareVersion !== undefined ? this.monitorFirmwareVersion : null;
        data["serialNumberKeywords"] = this.serialNumberKeywords !== undefined ? this.serialNumberKeywords : null;
        data["numberOfStrings"] = this.numberOfStrings !== undefined ? this.numberOfStrings : null;
        data["numberOfCriticalStrings"] = this.numberOfCriticalStrings !== undefined ? this.numberOfCriticalStrings : null;
        data["numberOfWarningStrings"] = this.numberOfWarningStrings !== undefined ? this.numberOfWarningStrings : null;
        data["numberOfBlocks"] = this.numberOfBlocks !== undefined ? this.numberOfBlocks : null;
        data["numberOfCriticalBlocks"] = this.numberOfCriticalBlocks !== undefined ? this.numberOfCriticalBlocks : null;
        data["numberOfWarningBlocks"] = this.numberOfWarningBlocks !== undefined ? this.numberOfWarningBlocks : null;
        data["numberOfCriticalAlarms"] = this.numberOfCriticalAlarms !== undefined ? this.numberOfCriticalAlarms : null;
        data["numberOfWarningAlarms"] = this.numberOfWarningAlarms !== undefined ? this.numberOfWarningAlarms : null;
        data["whenManufactured"] = this.whenManufactured ? this.whenManufactured.toISOString() : null;
        data["whenInstalled"] = this.whenInstalled ? this.whenInstalled.toISOString() : null;
        data["whenLastInspected"] = this.whenLastInspected ? this.whenLastInspected.toISOString() : null;
        data["whenLastDataReceived"] = this.whenLastDataReceived ? this.whenLastDataReceived.toISOString() : null;
        data["whenFirstDataReceived"] = this.whenFirstDataReceived ? this.whenFirstDataReceived.toISOString() : null;
        data["whenUpdatedSampleConfiguration"] = this.whenUpdatedSampleConfiguration ? this.whenUpdatedSampleConfiguration.toISOString() : null;
        data["lastCommsSourceId"] = this.lastCommsSourceId !== undefined ? this.lastCommsSourceId : null;
        data["lastSignalStrength"] = this.lastSignalStrength !== undefined ? this.lastSignalStrength : null;
        data["numberOfDroppedConnections"] = this.numberOfDroppedConnections !== undefined ? this.numberOfDroppedConnections : null;
        data["sampleRate"] = this.sampleRate !== undefined ? this.sampleRate : null;
        data["samplePeriod"] = this.samplePeriod !== undefined ? this.samplePeriod : null;
        data["site"] = this.site ? this.site.toJSON() : null;
        data["controller"] = this.controller ? this.controller.toJSON() : null;
        data["controllerKeepAlive"] = this.controllerKeepAlive !== undefined ? this.controllerKeepAlive : null;
        data["systemOfflineTimeout"] = this.systemOfflineTimeout !== undefined ? this.systemOfflineTimeout : null;
        data["hostAddressOrName"] = this.hostAddressOrName !== undefined ? this.hostAddressOrName : null;
        data["allowInsecure"] = this.allowInsecure !== undefined ? this.allowInsecure : null;
        data["isCritical"] = this.isCritical !== undefined ? this.isCritical : null;
        data["isWarning"] = this.isWarning !== undefined ? this.isWarning : null;
        data["isHealthy"] = this.isHealthy !== undefined ? this.isHealthy : null;
        super.toJSON(data);
        return data;
    }
}
export class SiteModel extends BaseAuthoredModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.addressId = _data["addressId"] !== undefined ? _data["addressId"] : null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.siteCode = _data["siteCode"] !== undefined ? _data["siteCode"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.contactGroupId = _data["contactGroupId"] !== undefined ? _data["contactGroupId"] : null;
            this.numberOfSystems = _data["numberOfSystems"] !== undefined ? _data["numberOfSystems"] : null;
            this.numberOfCriticalSystems = _data["numberOfCriticalSystems"] !== undefined ? _data["numberOfCriticalSystems"] : null;
            this.numberOfWarningSystems = _data["numberOfWarningSystems"] !== undefined ? _data["numberOfWarningSystems"] : null;
            this.numberOfStrings = _data["numberOfStrings"] !== undefined ? _data["numberOfStrings"] : null;
            this.numberOfCriticalStrings = _data["numberOfCriticalStrings"] !== undefined ? _data["numberOfCriticalStrings"] : null;
            this.numberOfWarningStrings = _data["numberOfWarningStrings"] !== undefined ? _data["numberOfWarningStrings"] : null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null;
            this.whenMarkedAsPrimary = _data["whenMarkedAsPrimary"] ? new Date(_data["whenMarkedAsPrimary"].toString()) : null;
            this.timeZoneId = _data["timeZoneId"] !== undefined ? _data["timeZoneId"] : null;
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : null;
            this.isHoldingSite = _data["isHoldingSite"] !== undefined ? _data["isHoldingSite"] : null;
            this.isPrimary = _data["isPrimary"] !== undefined ? _data["isPrimary"] : null;
            this.isCritical = _data["isCritical"] !== undefined ? _data["isCritical"] : null;
            this.isWarning = _data["isWarning"] !== undefined ? _data["isWarning"] : null;
            this.isHealthy = _data["isHealthy"] !== undefined ? _data["isHealthy"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SiteModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["addressId"] = this.addressId !== undefined ? this.addressId : null;
        data["personId"] = this.personId !== undefined ? this.personId : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["siteCode"] = this.siteCode !== undefined ? this.siteCode : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["contactGroupId"] = this.contactGroupId !== undefined ? this.contactGroupId : null;
        data["numberOfSystems"] = this.numberOfSystems !== undefined ? this.numberOfSystems : null;
        data["numberOfCriticalSystems"] = this.numberOfCriticalSystems !== undefined ? this.numberOfCriticalSystems : null;
        data["numberOfWarningSystems"] = this.numberOfWarningSystems !== undefined ? this.numberOfWarningSystems : null;
        data["numberOfStrings"] = this.numberOfStrings !== undefined ? this.numberOfStrings : null;
        data["numberOfCriticalStrings"] = this.numberOfCriticalStrings !== undefined ? this.numberOfCriticalStrings : null;
        data["numberOfWarningStrings"] = this.numberOfWarningStrings !== undefined ? this.numberOfWarningStrings : null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null;
        data["whenMarkedAsPrimary"] = this.whenMarkedAsPrimary ? this.whenMarkedAsPrimary.toISOString() : null;
        data["timeZoneId"] = this.timeZoneId !== undefined ? this.timeZoneId : null;
        data["address"] = this.address ? this.address.toJSON() : null;
        data["isHoldingSite"] = this.isHoldingSite !== undefined ? this.isHoldingSite : null;
        data["isPrimary"] = this.isPrimary !== undefined ? this.isPrimary : null;
        data["isCritical"] = this.isCritical !== undefined ? this.isCritical : null;
        data["isWarning"] = this.isWarning !== undefined ? this.isWarning : null;
        data["isHealthy"] = this.isHealthy !== undefined ? this.isHealthy : null;
        super.toJSON(data);
        return data;
    }
}
export class AddressModel extends BaseAuthoredModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.addressId = _data["addressId"] !== undefined ? _data["addressId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null;
            this.addressName = _data["addressName"] !== undefined ? _data["addressName"] : null;
            this.streetAddress1 = _data["streetAddress1"] !== undefined ? _data["streetAddress1"] : null;
            this.streetAddress2 = _data["streetAddress2"] !== undefined ? _data["streetAddress2"] : null;
            this.streetAddress3 = _data["streetAddress3"] !== undefined ? _data["streetAddress3"] : null;
            this.streetAddress4 = _data["streetAddress4"] !== undefined ? _data["streetAddress4"] : null;
            this.postAddress1 = _data["postAddress1"] !== undefined ? _data["postAddress1"] : null;
            this.postAddress2 = _data["postAddress2"] !== undefined ? _data["postAddress2"] : null;
            this.postAddress3 = _data["postAddress3"] !== undefined ? _data["postAddress3"] : null;
            this.postAddress4 = _data["postAddress4"] !== undefined ? _data["postAddress4"] : null;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null;
            this.regionName = _data["regionName"] !== undefined ? _data["regionName"] : null;
            this.whenMarkedAsPrimary = _data["whenMarkedAsPrimary"] ? new Date(_data["whenMarkedAsPrimary"].toString()) : null;
            this.isPrimary = _data["isPrimary"] !== undefined ? _data["isPrimary"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId !== undefined ? this.addressId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["addressName"] = this.addressName !== undefined ? this.addressName : null;
        data["streetAddress1"] = this.streetAddress1 !== undefined ? this.streetAddress1 : null;
        data["streetAddress2"] = this.streetAddress2 !== undefined ? this.streetAddress2 : null;
        data["streetAddress3"] = this.streetAddress3 !== undefined ? this.streetAddress3 : null;
        data["streetAddress4"] = this.streetAddress4 !== undefined ? this.streetAddress4 : null;
        data["postAddress1"] = this.postAddress1 !== undefined ? this.postAddress1 : null;
        data["postAddress2"] = this.postAddress2 !== undefined ? this.postAddress2 : null;
        data["postAddress3"] = this.postAddress3 !== undefined ? this.postAddress3 : null;
        data["postAddress4"] = this.postAddress4 !== undefined ? this.postAddress4 : null;
        data["postCode"] = this.postCode !== undefined ? this.postCode : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null;
        data["regionName"] = this.regionName !== undefined ? this.regionName : null;
        data["whenMarkedAsPrimary"] = this.whenMarkedAsPrimary ? this.whenMarkedAsPrimary.toISOString() : null;
        data["isPrimary"] = this.isPrimary !== undefined ? this.isPrimary : null;
        super.toJSON(data);
        return data;
    }
}
export class SystemComponentModel extends BaseAuthoredModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.registrationKey = _data["registrationKey"] !== undefined ? _data["registrationKey"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.stringStatusId = _data["stringStatusId"] !== undefined ? _data["stringStatusId"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.componentCode = _data["componentCode"] !== undefined ? _data["componentCode"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.componentTypeName = _data["componentTypeName"] !== undefined ? _data["componentTypeName"] : null;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null;
            this.stringStatusName = _data["stringStatusName"] !== undefined ? _data["stringStatusName"] : null;
            this.component = _data["component"] ? ComponentModel.fromJS(_data["component"]) : null;
            this.whenRegistered = _data["whenRegistered"] ? new Date(_data["whenRegistered"].toString()) : null;
            this.whenInstalled = _data["whenInstalled"] ? new Date(_data["whenInstalled"].toString()) : null;
            this.whenFirstOhmicReadingTaken = _data["whenFirstOhmicReadingTaken"] ? new Date(_data["whenFirstOhmicReadingTaken"].toString()) : null;
            this.replacementRegistrationKey = _data["replacementRegistrationKey"] ? RegistrationKeyResponseModel.fromJS(_data["replacementRegistrationKey"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemComponentModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["registrationKey"] = this.registrationKey !== undefined ? this.registrationKey : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["stringStatusId"] = this.stringStatusId !== undefined ? this.stringStatusId : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["componentCode"] = this.componentCode !== undefined ? this.componentCode : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["componentTypeName"] = this.componentTypeName !== undefined ? this.componentTypeName : null;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null;
        data["stringStatusName"] = this.stringStatusName !== undefined ? this.stringStatusName : null;
        data["component"] = this.component ? this.component.toJSON() : null;
        data["whenRegistered"] = this.whenRegistered ? this.whenRegistered.toISOString() : null;
        data["whenInstalled"] = this.whenInstalled ? this.whenInstalled.toISOString() : null;
        data["whenFirstOhmicReadingTaken"] = this.whenFirstOhmicReadingTaken ? this.whenFirstOhmicReadingTaken.toISOString() : null;
        data["replacementRegistrationKey"] = this.replacementRegistrationKey ? this.replacementRegistrationKey.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class RegistrationKeyResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.registrationKey = _data["registrationKey"] ? RegistrationKeyModel.fromJS(_data["registrationKey"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationKeyResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["registrationKey"] = this.registrationKey ? this.registrationKey.toJSON() : null;
        return data;
    }
}
export class RegistrationKeyModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.registrationKeyId = _data["registrationKeyId"] !== undefined ? _data["registrationKeyId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.deviceKey = _data["deviceKey"] !== undefined ? _data["deviceKey"] : null;
            this.authCode = _data["authCode"] !== undefined ? _data["authCode"] : null;
            this.whenAssigned = _data["whenAssigned"] ? new Date(_data["whenAssigned"].toString()) : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationKeyModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["registrationKeyId"] = this.registrationKeyId !== undefined ? this.registrationKeyId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["deviceKey"] = this.deviceKey !== undefined ? this.deviceKey : null;
        data["authCode"] = this.authCode !== undefined ? this.authCode : null;
        data["whenAssigned"] = this.whenAssigned ? this.whenAssigned.toISOString() : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        return data;
    }
}
export class RegisterSystemChildrenRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.registrationKey = _data["registrationKey"] !== undefined ? _data["registrationKey"] : null;
            this.componentTypeId = _data["componentTypeId"] !== undefined ? _data["componentTypeId"] : null;
            this.componentCode = _data["componentCode"] !== undefined ? _data["componentCode"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.modelName = _data["modelName"] !== undefined ? _data["modelName"] : null;
            if (Array.isArray(_data["children"])) {
                this.children = [];
                for (let item of _data["children"])
                    this.children.push(RegisterSystemChildrenRequestModel.fromJS(item));
            }
            else {
                this.children = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterSystemChildrenRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["registrationKey"] = this.registrationKey !== undefined ? this.registrationKey : null;
        data["componentTypeId"] = this.componentTypeId !== undefined ? this.componentTypeId : null;
        data["componentCode"] = this.componentCode !== undefined ? this.componentCode : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["modelName"] = this.modelName !== undefined ? this.modelName : null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class RegisterSystemRequestModel extends RegisterSystemChildrenRequestModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null;
            this.monitorTypeId = _data["monitorTypeId"] !== undefined ? _data["monitorTypeId"] : null;
            this.batteryTypeId = _data["batteryTypeId"] !== undefined ? _data["batteryTypeId"] : null;
            this.lithiumBatteryTypeId = _data["lithiumBatteryTypeId"] !== undefined ? _data["lithiumBatteryTypeId"] : null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null;
            this.hostAddressOrName = _data["hostAddressOrName"] !== undefined ? _data["hostAddressOrName"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterSystemRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["monitorTypeId"] = this.monitorTypeId !== undefined ? this.monitorTypeId : null;
        data["batteryTypeId"] = this.batteryTypeId !== undefined ? this.batteryTypeId : null;
        data["lithiumBatteryTypeId"] = this.lithiumBatteryTypeId !== undefined ? this.lithiumBatteryTypeId : null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null;
        data["hostAddressOrName"] = this.hostAddressOrName !== undefined ? this.hostAddressOrName : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        super.toJSON(data);
        return data;
    }
}
export class UploadAlarmsResponseModel extends DataTransferResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["alarms"])) {
                this.alarms = [];
                for (let item of _data["alarms"])
                    this.alarms.push(AlarmModel.fromJS(item));
            }
            else {
                this.alarms = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadAlarmsResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.alarms)) {
            data["alarms"] = [];
            for (let item of this.alarms)
                data["alarms"].push(item ? item.toJSON() : null);
        }
        super.toJSON(data);
        return data;
    }
}
export class AlarmModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.alarmId = _data["alarmId"] !== undefined ? _data["alarmId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.systemComponentId = _data["systemComponentId"] !== undefined ? _data["systemComponentId"] : null;
            this.alarmDefinitionId = _data["alarmDefinitionId"] !== undefined ? _data["alarmDefinitionId"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenRaised = _data["whenRaised"] ? new Date(_data["whenRaised"].toString()) : null;
            this.whenCleared = _data["whenCleared"] ? new Date(_data["whenCleared"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["alarmId"] = this.alarmId !== undefined ? this.alarmId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["systemComponentId"] = this.systemComponentId !== undefined ? this.systemComponentId : null;
        data["alarmDefinitionId"] = this.alarmDefinitionId !== undefined ? this.alarmDefinitionId : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenRaised"] = this.whenRaised ? this.whenRaised.toISOString() : null;
        data["whenCleared"] = this.whenCleared ? this.whenCleared.toISOString() : null;
        return data;
    }
}
export class UploadAlarmsRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["alarms"])) {
                this.alarms = [];
                for (let item of _data["alarms"])
                    this.alarms.push(UploadAlarmRequestModel.fromJS(item));
            }
            else {
                this.alarms = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadAlarmsRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.alarms)) {
            data["alarms"] = [];
            for (let item of this.alarms)
                data["alarms"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class UploadLimitsResponseModel extends DataTransferResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadLimitsResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UploadLimitsRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["limits"])) {
                this.limits = [];
                for (let item of _data["limits"])
                    this.limits.push(UploadLimitRequestModel.fromJS(item));
            }
            else {
                this.limits = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadLimitsRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.limits)) {
            data["limits"] = [];
            for (let item of this.limits)
                data["limits"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class UploadLimitRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.alarmTypeId = _data["alarmTypeId"] !== undefined ? _data["alarmTypeId"] : null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null;
            this.limitName = _data["limitName"] !== undefined ? _data["limitName"] : null;
            this.lowerCriticalLimit = _data["lowerCriticalLimit"] !== undefined ? _data["lowerCriticalLimit"] : null;
            this.lowerWarningLimit = _data["lowerWarningLimit"] !== undefined ? _data["lowerWarningLimit"] : null;
            this.upperCriticalLimit = _data["upperCriticalLimit"] !== undefined ? _data["upperCriticalLimit"] : null;
            this.upperWarningLimit = _data["upperWarningLimit"] !== undefined ? _data["upperWarningLimit"] : null;
            this.floatThreshold = _data["floatThreshold"] !== undefined ? _data["floatThreshold"] : null;
            this.floatHysteresis = _data["floatHysteresis"] !== undefined ? _data["floatHysteresis"] : null;
            this.chargeThreshold = _data["chargeThreshold"] !== undefined ? _data["chargeThreshold"] : null;
            this.chargeHysteresis = _data["chargeHysteresis"] !== undefined ? _data["chargeHysteresis"] : null;
            this.dischargeThreshold = _data["dischargeThreshold"] !== undefined ? _data["dischargeThreshold"] : null;
            this.dischargeHysteresis = _data["dischargeHysteresis"] !== undefined ? _data["dischargeHysteresis"] : null;
            if (Array.isArray(_data["registrationKeys"])) {
                this.registrationKeys = [];
                for (let item of _data["registrationKeys"])
                    this.registrationKeys.push(item);
            }
            else {
                this.registrationKeys = null;
            }
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadLimitRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["alarmTypeId"] = this.alarmTypeId !== undefined ? this.alarmTypeId : null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null;
        data["limitName"] = this.limitName !== undefined ? this.limitName : null;
        data["lowerCriticalLimit"] = this.lowerCriticalLimit !== undefined ? this.lowerCriticalLimit : null;
        data["lowerWarningLimit"] = this.lowerWarningLimit !== undefined ? this.lowerWarningLimit : null;
        data["upperCriticalLimit"] = this.upperCriticalLimit !== undefined ? this.upperCriticalLimit : null;
        data["upperWarningLimit"] = this.upperWarningLimit !== undefined ? this.upperWarningLimit : null;
        data["floatThreshold"] = this.floatThreshold !== undefined ? this.floatThreshold : null;
        data["floatHysteresis"] = this.floatHysteresis !== undefined ? this.floatHysteresis : null;
        data["chargeThreshold"] = this.chargeThreshold !== undefined ? this.chargeThreshold : null;
        data["chargeHysteresis"] = this.chargeHysteresis !== undefined ? this.chargeHysteresis : null;
        data["dischargeThreshold"] = this.dischargeThreshold !== undefined ? this.dischargeThreshold : null;
        data["dischargeHysteresis"] = this.dischargeHysteresis !== undefined ? this.dischargeHysteresis : null;
        if (Array.isArray(this.registrationKeys)) {
            data["registrationKeys"] = [];
            for (let item of this.registrationKeys)
                data["registrationKeys"].push(item);
        }
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        return data;
    }
}
export class UploadMeasurementsResponseModel extends DataTransferResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.duplicatesIgnored = _data["duplicatesIgnored"] !== undefined ? _data["duplicatesIgnored"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadMeasurementsResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["duplicatesIgnored"] = this.duplicatesIgnored !== undefined ? this.duplicatesIgnored : null;
        super.toJSON(data);
        return data;
    }
}
export class UploadMeasurementsRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [];
                for (let item of _data["measurements"])
                    this.measurements.push(UploadMeasurementRequestModel.fromJS(item));
            }
            else {
                this.measurements = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadMeasurementsRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class UploadMeasurementRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.measurementTypeId = _data["measurementTypeId"] !== undefined ? _data["measurementTypeId"] : null;
            this.registrationKey = _data["registrationKey"] !== undefined ? _data["registrationKey"] : null;
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null;
            this.rawValue = _data["rawValue"] !== undefined ? _data["rawValue"] : null;
            this.numericValue = _data["numericValue"] !== undefined ? _data["numericValue"] : null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadMeasurementRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["measurementTypeId"] = this.measurementTypeId !== undefined ? this.measurementTypeId : null;
        data["registrationKey"] = this.registrationKey !== undefined ? this.registrationKey : null;
        data["eventId"] = this.eventId !== undefined ? this.eventId : null;
        data["rawValue"] = this.rawValue !== undefined ? this.rawValue : null;
        data["numericValue"] = this.numericValue !== undefined ? this.numericValue : null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null;
        return data;
    }
}
export class UploadStringSnapshotsResponseModel extends DataTransferResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadStringSnapshotsResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UploadBlockSnapshotsResponseModel extends DataTransferResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBlockSnapshotsResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UploadBlockSnapshotsRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["snapshots"])) {
                this.snapshots = [];
                for (let item of _data["snapshots"])
                    this.snapshots.push(UploadBlockSnapshotRequestModel.fromJS(item));
            }
            else {
                this.snapshots = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBlockSnapshotsRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.snapshots)) {
            data["snapshots"] = [];
            for (let item of this.snapshots)
                data["snapshots"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class UploadBlockSnapshotRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.registrationKey = _data["registrationKey"] !== undefined ? _data["registrationKey"] : null;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null;
            this.rippleVoltage = _data["rippleVoltage"] !== undefined ? _data["rippleVoltage"] : null;
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : null;
            this.ohmic = _data["ohmic"] !== undefined ? _data["ohmic"] : null;
            this.ohmicBaseLine = _data["ohmicBaseLine"] !== undefined ? _data["ohmicBaseLine"] : null;
            this.ohmicRise = _data["ohmicRise"] !== undefined ? _data["ohmicRise"] : null;
            this.moduleBlockVoltage = _data["moduleBlockVoltage"] !== undefined ? _data["moduleBlockVoltage"] : null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBlockSnapshotRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["registrationKey"] = this.registrationKey !== undefined ? this.registrationKey : null;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null;
        data["rippleVoltage"] = this.rippleVoltage !== undefined ? this.rippleVoltage : null;
        data["temperature"] = this.temperature !== undefined ? this.temperature : null;
        data["ohmic"] = this.ohmic !== undefined ? this.ohmic : null;
        data["ohmicBaseLine"] = this.ohmicBaseLine !== undefined ? this.ohmicBaseLine : null;
        data["ohmicRise"] = this.ohmicRise !== undefined ? this.ohmicRise : null;
        data["moduleBlockVoltage"] = this.moduleBlockVoltage !== undefined ? this.moduleBlockVoltage : null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null;
        return data;
    }
}
export class UploadStringSnapshotsRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["snapshots"])) {
                this.snapshots = [];
                for (let item of _data["snapshots"])
                    this.snapshots.push(UploadStringSnapshotRequestModel.fromJS(item));
            }
            else {
                this.snapshots = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadStringSnapshotsRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.snapshots)) {
            data["snapshots"] = [];
            for (let item of this.snapshots)
                data["snapshots"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class UploadStringSnapshotRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.registrationKey = _data["registrationKey"] !== undefined ? _data["registrationKey"] : null;
            this.current = _data["current"] !== undefined ? _data["current"] : null;
            this.rippleCurrent = _data["rippleCurrent"] !== undefined ? _data["rippleCurrent"] : null;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null;
            this.humidity = _data["humidity"] !== undefined ? _data["humidity"] : null;
            this.ambientTemperature = _data["ambientTemperature"] !== undefined ? _data["ambientTemperature"] : null;
            this.ambientTemperature2 = _data["ambientTemperature2"] !== undefined ? _data["ambientTemperature2"] : null;
            this.ambientTemperatureMedian = _data["ambientTemperatureMedian"] !== undefined ? _data["ambientTemperatureMedian"] : null;
            this.ambientMedianToBlockMedianVariation = _data["ambientMedianToBlockMedianVariation"] !== undefined ? _data["ambientMedianToBlockMedianVariation"] : null;
            this.blockVoltageVariation = _data["blockVoltageVariation"] !== undefined ? _data["blockVoltageVariation"] : null;
            this.blockVoltageMedian = _data["blockVoltageMedian"] !== undefined ? _data["blockVoltageMedian"] : null;
            this.blockOhmicVariation = _data["blockOhmicVariation"] !== undefined ? _data["blockOhmicVariation"] : null;
            this.blockTemperatureVariation = _data["blockTemperatureVariation"] !== undefined ? _data["blockTemperatureVariation"] : null;
            this.blockTemperatureMedian = _data["blockTemperatureMedian"] !== undefined ? _data["blockTemperatureMedian"] : null;
            this.ambientTemperatureVariation = _data["ambientTemperatureVariation"] !== undefined ? _data["ambientTemperatureVariation"] : null;
            this.ambientTemperatures = _data["ambientTemperatures"] !== undefined ? _data["ambientTemperatures"] : null;
            this.cellSummationVoltage = _data["cellSummationVoltage"] !== undefined ? _data["cellSummationVoltage"] : null;
            this.soc = _data["soc"] !== undefined ? _data["soc"] : null;
            this.soh = _data["soh"] !== undefined ? _data["soh"] : null;
            this.cellVoltageMax1 = _data["cellVoltageMax1"] !== undefined ? _data["cellVoltageMax1"] : null;
            this.cellVoltageMax1Location = _data["cellVoltageMax1Location"] !== undefined ? _data["cellVoltageMax1Location"] : null;
            this.cellVoltageMax2 = _data["cellVoltageMax2"] !== undefined ? _data["cellVoltageMax2"] : null;
            this.cellVoltageMax2Location = _data["cellVoltageMax2Location"] !== undefined ? _data["cellVoltageMax2Location"] : null;
            this.cellVoltageMin1 = _data["cellVoltageMin1"] !== undefined ? _data["cellVoltageMin1"] : null;
            this.cellVoltageMin1Location = _data["cellVoltageMin1Location"] !== undefined ? _data["cellVoltageMin1Location"] : null;
            this.cellVoltageMin2 = _data["cellVoltageMin2"] !== undefined ? _data["cellVoltageMin2"] : null;
            this.cellVoltageMin2Location = _data["cellVoltageMin2Location"] !== undefined ? _data["cellVoltageMin2Location"] : null;
            this.cellVoltageAverage = _data["cellVoltageAverage"] !== undefined ? _data["cellVoltageAverage"] : null;
            this.cellTemperatureMax1 = _data["cellTemperatureMax1"] !== undefined ? _data["cellTemperatureMax1"] : null;
            this.cellTemperatureMax1Location = _data["cellTemperatureMax1Location"] !== undefined ? _data["cellTemperatureMax1Location"] : null;
            this.cellTemperatureMax2 = _data["cellTemperatureMax2"] !== undefined ? _data["cellTemperatureMax2"] : null;
            this.cellTemperatureMax2Location = _data["cellTemperatureMax2Location"] !== undefined ? _data["cellTemperatureMax2Location"] : null;
            this.cellTemperatureMin1 = _data["cellTemperatureMin1"] !== undefined ? _data["cellTemperatureMin1"] : null;
            this.cellTemperatureMin1Location = _data["cellTemperatureMin1Location"] !== undefined ? _data["cellTemperatureMin1Location"] : null;
            this.cellTemperatureMin2 = _data["cellTemperatureMin2"] !== undefined ? _data["cellTemperatureMin2"] : null;
            this.cellTemperatureMin2Location = _data["cellTemperatureMin2Location"] !== undefined ? _data["cellTemperatureMin2Location"] : null;
            this.cellTemperatureAverage = _data["cellTemperatureAverage"] !== undefined ? _data["cellTemperatureAverage"] : null;
            this.mccbOn = _data["mccbOn"] !== undefined ? _data["mccbOn"] : null;
            this.fuseOn = _data["fuseOn"] !== undefined ? _data["fuseOn"] : null;
            this.majorProtection1 = _data["majorProtection1"] !== undefined ? _data["majorProtection1"] : null;
            this.majorProtection2 = _data["majorProtection2"] !== undefined ? _data["majorProtection2"] : null;
            this.majorProtection3 = _data["majorProtection3"] !== undefined ? _data["majorProtection3"] : null;
            this.majorProtection4 = _data["majorProtection4"] !== undefined ? _data["majorProtection4"] : null;
            this.minorProtection1 = _data["minorProtection1"] !== undefined ? _data["minorProtection1"] : null;
            this.minorProtection2 = _data["minorProtection2"] !== undefined ? _data["minorProtection2"] : null;
            this.minorProtection3 = _data["minorProtection3"] !== undefined ? _data["minorProtection3"] : null;
            this.minorProtection4 = _data["minorProtection4"] !== undefined ? _data["minorProtection4"] : null;
            this.alarm1Summary = _data["alarm1Summary"] !== undefined ? _data["alarm1Summary"] : null;
            this.alarm2Summary = _data["alarm2Summary"] !== undefined ? _data["alarm2Summary"] : null;
            this.alarm3Summary = _data["alarm3Summary"] !== undefined ? _data["alarm3Summary"] : null;
            this.alarm4Summary = _data["alarm4Summary"] !== undefined ? _data["alarm4Summary"] : null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadStringSnapshotRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["registrationKey"] = this.registrationKey !== undefined ? this.registrationKey : null;
        data["current"] = this.current !== undefined ? this.current : null;
        data["rippleCurrent"] = this.rippleCurrent !== undefined ? this.rippleCurrent : null;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null;
        data["humidity"] = this.humidity !== undefined ? this.humidity : null;
        data["ambientTemperature"] = this.ambientTemperature !== undefined ? this.ambientTemperature : null;
        data["ambientTemperature2"] = this.ambientTemperature2 !== undefined ? this.ambientTemperature2 : null;
        data["ambientTemperatureMedian"] = this.ambientTemperatureMedian !== undefined ? this.ambientTemperatureMedian : null;
        data["ambientMedianToBlockMedianVariation"] = this.ambientMedianToBlockMedianVariation !== undefined ? this.ambientMedianToBlockMedianVariation : null;
        data["blockVoltageVariation"] = this.blockVoltageVariation !== undefined ? this.blockVoltageVariation : null;
        data["blockVoltageMedian"] = this.blockVoltageMedian !== undefined ? this.blockVoltageMedian : null;
        data["blockOhmicVariation"] = this.blockOhmicVariation !== undefined ? this.blockOhmicVariation : null;
        data["blockTemperatureVariation"] = this.blockTemperatureVariation !== undefined ? this.blockTemperatureVariation : null;
        data["blockTemperatureMedian"] = this.blockTemperatureMedian !== undefined ? this.blockTemperatureMedian : null;
        data["ambientTemperatureVariation"] = this.ambientTemperatureVariation !== undefined ? this.ambientTemperatureVariation : null;
        data["ambientTemperatures"] = this.ambientTemperatures !== undefined ? this.ambientTemperatures : null;
        data["cellSummationVoltage"] = this.cellSummationVoltage !== undefined ? this.cellSummationVoltage : null;
        data["soc"] = this.soc !== undefined ? this.soc : null;
        data["soh"] = this.soh !== undefined ? this.soh : null;
        data["cellVoltageMax1"] = this.cellVoltageMax1 !== undefined ? this.cellVoltageMax1 : null;
        data["cellVoltageMax1Location"] = this.cellVoltageMax1Location !== undefined ? this.cellVoltageMax1Location : null;
        data["cellVoltageMax2"] = this.cellVoltageMax2 !== undefined ? this.cellVoltageMax2 : null;
        data["cellVoltageMax2Location"] = this.cellVoltageMax2Location !== undefined ? this.cellVoltageMax2Location : null;
        data["cellVoltageMin1"] = this.cellVoltageMin1 !== undefined ? this.cellVoltageMin1 : null;
        data["cellVoltageMin1Location"] = this.cellVoltageMin1Location !== undefined ? this.cellVoltageMin1Location : null;
        data["cellVoltageMin2"] = this.cellVoltageMin2 !== undefined ? this.cellVoltageMin2 : null;
        data["cellVoltageMin2Location"] = this.cellVoltageMin2Location !== undefined ? this.cellVoltageMin2Location : null;
        data["cellVoltageAverage"] = this.cellVoltageAverage !== undefined ? this.cellVoltageAverage : null;
        data["cellTemperatureMax1"] = this.cellTemperatureMax1 !== undefined ? this.cellTemperatureMax1 : null;
        data["cellTemperatureMax1Location"] = this.cellTemperatureMax1Location !== undefined ? this.cellTemperatureMax1Location : null;
        data["cellTemperatureMax2"] = this.cellTemperatureMax2 !== undefined ? this.cellTemperatureMax2 : null;
        data["cellTemperatureMax2Location"] = this.cellTemperatureMax2Location !== undefined ? this.cellTemperatureMax2Location : null;
        data["cellTemperatureMin1"] = this.cellTemperatureMin1 !== undefined ? this.cellTemperatureMin1 : null;
        data["cellTemperatureMin1Location"] = this.cellTemperatureMin1Location !== undefined ? this.cellTemperatureMin1Location : null;
        data["cellTemperatureMin2"] = this.cellTemperatureMin2 !== undefined ? this.cellTemperatureMin2 : null;
        data["cellTemperatureMin2Location"] = this.cellTemperatureMin2Location !== undefined ? this.cellTemperatureMin2Location : null;
        data["cellTemperatureAverage"] = this.cellTemperatureAverage !== undefined ? this.cellTemperatureAverage : null;
        data["mccbOn"] = this.mccbOn !== undefined ? this.mccbOn : null;
        data["fuseOn"] = this.fuseOn !== undefined ? this.fuseOn : null;
        data["majorProtection1"] = this.majorProtection1 !== undefined ? this.majorProtection1 : null;
        data["majorProtection2"] = this.majorProtection2 !== undefined ? this.majorProtection2 : null;
        data["majorProtection3"] = this.majorProtection3 !== undefined ? this.majorProtection3 : null;
        data["majorProtection4"] = this.majorProtection4 !== undefined ? this.majorProtection4 : null;
        data["minorProtection1"] = this.minorProtection1 !== undefined ? this.minorProtection1 : null;
        data["minorProtection2"] = this.minorProtection2 !== undefined ? this.minorProtection2 : null;
        data["minorProtection3"] = this.minorProtection3 !== undefined ? this.minorProtection3 : null;
        data["minorProtection4"] = this.minorProtection4 !== undefined ? this.minorProtection4 : null;
        data["alarm1Summary"] = this.alarm1Summary !== undefined ? this.alarm1Summary : null;
        data["alarm2Summary"] = this.alarm2Summary !== undefined ? this.alarm2Summary : null;
        data["alarm3Summary"] = this.alarm3Summary !== undefined ? this.alarm3Summary : null;
        data["alarm4Summary"] = this.alarm4Summary !== undefined ? this.alarm4Summary : null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null;
        return data;
    }
}
export class UploadSystemSnapshotsResponseModel extends DataTransferResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadSystemSnapshotsResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UploadSystemSnapshotsRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["snapshots"])) {
                this.snapshots = [];
                for (let item of _data["snapshots"])
                    this.snapshots.push(UploadSystemSnapshotRequestModel.fromJS(item));
            }
            else {
                this.snapshots = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadSystemSnapshotsRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.snapshots)) {
            data["snapshots"] = [];
            for (let item of this.snapshots)
                data["snapshots"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class UploadSystemSnapshotRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.registrationKey = _data["registrationKey"] !== undefined ? _data["registrationKey"] : null;
            this.voltage = _data["voltage"] !== undefined ? _data["voltage"] : null;
            this.current = _data["current"] !== undefined ? _data["current"] : null;
            this.soc = _data["soc"] !== undefined ? _data["soc"] : null;
            this.soh = _data["soh"] !== undefined ? _data["soh"] : null;
            this.maxVoltage = _data["maxVoltage"] !== undefined ? _data["maxVoltage"] : null;
            this.minVoltage = _data["minVoltage"] !== undefined ? _data["minVoltage"] : null;
            this.maxTemperature = _data["maxTemperature"] !== undefined ? _data["maxTemperature"] : null;
            this.minTemperature = _data["minTemperature"] !== undefined ? _data["minTemperature"] : null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadSystemSnapshotRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["registrationKey"] = this.registrationKey !== undefined ? this.registrationKey : null;
        data["voltage"] = this.voltage !== undefined ? this.voltage : null;
        data["current"] = this.current !== undefined ? this.current : null;
        data["soc"] = this.soc !== undefined ? this.soc : null;
        data["soh"] = this.soh !== undefined ? this.soh : null;
        data["maxVoltage"] = this.maxVoltage !== undefined ? this.maxVoltage : null;
        data["minVoltage"] = this.minVoltage !== undefined ? this.minVoltage : null;
        data["maxTemperature"] = this.maxTemperature !== undefined ? this.maxTemperature : null;
        data["minTemperature"] = this.minTemperature !== undefined ? this.minTemperature : null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null;
        return data;
    }
}
export class UpdateCommunicationsResponseModel extends DataTransferResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommunicationsResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateControllerCommunicationsRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["systemCommunications"])) {
                this.systemCommunications = [];
                for (let item of _data["systemCommunications"])
                    this.systemCommunications.push(UpdateControllerCommunicationRequestModel.fromJS(item));
            }
            else {
                this.systemCommunications = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateControllerCommunicationsRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemCommunications)) {
            data["systemCommunications"] = [];
            for (let item of this.systemCommunications)
                data["systemCommunications"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class UpdateCommunicationRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.lastSignalStrength = _data["lastSignalStrength"] !== undefined ? _data["lastSignalStrength"] : null;
            this.numberOfDroppedConnections = _data["numberOfDroppedConnections"] !== undefined ? _data["numberOfDroppedConnections"] : null;
            this.cellularConnectionQuality = _data["cellularConnectionQuality"] !== undefined ? _data["cellularConnectionQuality"] : null;
            this.modemFirmwareVersion = _data["modemFirmwareVersion"] !== undefined ? _data["modemFirmwareVersion"] : null;
            this.monitorFirmwareVersion = _data["monitorFirmwareVersion"] !== undefined ? _data["monitorFirmwareVersion"] : null;
            this.whenLastDataReceived = _data["whenLastDataReceived"] ? new Date(_data["whenLastDataReceived"].toString()) : null;
            this.whenFirstDataReceived = _data["whenFirstDataReceived"] ? new Date(_data["whenFirstDataReceived"].toString()) : null;
            this.whenFirstOhmicReadingReceived = _data["whenFirstOhmicReadingReceived"] ? new Date(_data["whenFirstOhmicReadingReceived"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommunicationRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["lastSignalStrength"] = this.lastSignalStrength !== undefined ? this.lastSignalStrength : null;
        data["numberOfDroppedConnections"] = this.numberOfDroppedConnections !== undefined ? this.numberOfDroppedConnections : null;
        data["cellularConnectionQuality"] = this.cellularConnectionQuality !== undefined ? this.cellularConnectionQuality : null;
        data["modemFirmwareVersion"] = this.modemFirmwareVersion !== undefined ? this.modemFirmwareVersion : null;
        data["monitorFirmwareVersion"] = this.monitorFirmwareVersion !== undefined ? this.monitorFirmwareVersion : null;
        data["whenLastDataReceived"] = this.whenLastDataReceived ? this.whenLastDataReceived.toISOString() : null;
        data["whenFirstDataReceived"] = this.whenFirstDataReceived ? this.whenFirstDataReceived.toISOString() : null;
        data["whenFirstOhmicReadingReceived"] = this.whenFirstOhmicReadingReceived ? this.whenFirstOhmicReadingReceived.toISOString() : null;
        return data;
    }
}
export class UpdateControllerCommunicationRequestModel extends UpdateCommunicationRequestModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.registrationKey = _data["registrationKey"] !== undefined ? _data["registrationKey"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateControllerCommunicationRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["registrationKey"] = this.registrationKey !== undefined ? this.registrationKey : null;
        super.toJSON(data);
        return data;
    }
}
export class ConnectivityTestResponseModel extends DataTransferResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectivityTestResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ConnectivityTestRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.processedAt = _data["processedAt"] ? new Date(_data["processedAt"].toString()) : null;
            this.isIncomplete = _data["isIncomplete"] !== undefined ? _data["isIncomplete"] : null;
            this.isTrusted = _data["isTrusted"] !== undefined ? _data["isTrusted"] : null;
            this.code = _data["code"] !== undefined ? _data["code"] : null;
            this.label = _data["label"] !== undefined ? _data["label"] : null;
            this.controllerSerialNumber = _data["controllerSerialNumber"] !== undefined ? _data["controllerSerialNumber"] : null;
            this.controllerCreatedAt = _data["controllerCreatedAt"] ? new Date(_data["controllerCreatedAt"].toString()) : null;
            this.controllerName = _data["controllerName"] !== undefined ? _data["controllerName"] : null;
            this.controllerFacility = _data["controllerFacility"] !== undefined ? _data["controllerFacility"] : null;
            this.assureCompanyId = _data["assureCompanyId"] !== undefined ? _data["assureCompanyId"] : null;
            this.assureSiteId = _data["assureSiteId"] !== undefined ? _data["assureSiteId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectivityTestRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["processedAt"] = this.processedAt ? this.processedAt.toISOString() : null;
        data["isIncomplete"] = this.isIncomplete !== undefined ? this.isIncomplete : null;
        data["isTrusted"] = this.isTrusted !== undefined ? this.isTrusted : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["label"] = this.label !== undefined ? this.label : null;
        data["controllerSerialNumber"] = this.controllerSerialNumber !== undefined ? this.controllerSerialNumber : null;
        data["controllerCreatedAt"] = this.controllerCreatedAt ? this.controllerCreatedAt.toISOString() : null;
        data["controllerName"] = this.controllerName !== undefined ? this.controllerName : null;
        data["controllerFacility"] = this.controllerFacility !== undefined ? this.controllerFacility : null;
        data["assureCompanyId"] = this.assureCompanyId !== undefined ? this.assureCompanyId : null;
        data["assureSiteId"] = this.assureSiteId !== undefined ? this.assureSiteId : null;
        return data;
    }
}
export class KeepAliveModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.registrationKeyId = _data["registrationKeyId"] !== undefined ? _data["registrationKeyId"] : null;
            this.keepAlive = _data["keepAlive"] !== undefined ? _data["keepAlive"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new KeepAliveModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["registrationKeyId"] = this.registrationKeyId !== undefined ? this.registrationKeyId : null;
        data["keepAlive"] = this.keepAlive !== undefined ? this.keepAlive : null;
        return data;
    }
}
export class GetChargeDischargeEventResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetChargeDischargeEventResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId !== undefined ? this.eventId : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        return data;
    }
}
export class BaseQueryOfGetChargeDischargeEventQueryAndGetChargeDischargeEventResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetChargeDischargeEventQueryAndGetChargeDischargeEventResponseModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetChargeDischargeEventQuery extends BaseQueryOfGetChargeDischargeEventQueryAndGetChargeDischargeEventResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetChargeDischargeEventQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId !== undefined ? this.eventId : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfRequestControllerForceOhmicRequestModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? RequestControllerForceOhmicRequestModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfRequestControllerForceOhmicRequestModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class RequestControllerForceOhmicCommand extends BaseCommandOfRequestControllerForceOhmicRequestModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RequestControllerForceOhmicCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class RequestControllerForceOhmicRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentShId = _data["componentShId"] !== undefined ? _data["componentShId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RequestControllerForceOhmicRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentShId"] = this.componentShId !== undefined ? this.componentShId : null;
        return data;
    }
}
export class AlarmDefinitionModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.alarmDefinitionId = _data["alarmDefinitionId"] !== undefined ? _data["alarmDefinitionId"] : null;
            this.alarmTypeId = _data["alarmTypeId"] !== undefined ? _data["alarmTypeId"] : null;
            this.alarmSeverityId = _data["alarmSeverityId"] !== undefined ? _data["alarmSeverityId"] : null;
            this.alarmDefinitionName = _data["alarmDefinitionName"] !== undefined ? _data["alarmDefinitionName"] : null;
            this.showValue = _data["showValue"] !== undefined ? _data["showValue"] : null;
            this.showHighValue = _data["showHighValue"] !== undefined ? _data["showHighValue"] : null;
            this.alarmSeverityName = _data["alarmSeverityName"] !== undefined ? _data["alarmSeverityName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDefinitionModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["alarmDefinitionId"] = this.alarmDefinitionId !== undefined ? this.alarmDefinitionId : null;
        data["alarmTypeId"] = this.alarmTypeId !== undefined ? this.alarmTypeId : null;
        data["alarmSeverityId"] = this.alarmSeverityId !== undefined ? this.alarmSeverityId : null;
        data["alarmDefinitionName"] = this.alarmDefinitionName !== undefined ? this.alarmDefinitionName : null;
        data["showValue"] = this.showValue !== undefined ? this.showValue : null;
        data["showHighValue"] = this.showHighValue !== undefined ? this.showHighValue : null;
        data["alarmSeverityName"] = this.alarmSeverityName !== undefined ? this.alarmSeverityName : null;
        super.toJSON(data);
        return data;
    }
}
export class AlarmTypeModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.alarmTypeId = _data["alarmTypeId"] !== undefined ? _data["alarmTypeId"] : null;
            this.alarmScopeId = _data["alarmScopeId"] !== undefined ? _data["alarmScopeId"] : null;
            this.limitLayoutId = _data["limitLayoutId"] !== undefined ? _data["limitLayoutId"] : null;
            this.measurementTypeId = _data["measurementTypeId"] !== undefined ? _data["measurementTypeId"] : null;
            this.stringStatusId = _data["stringStatusId"] !== undefined ? _data["stringStatusId"] : null;
            this.alarmTypeName = _data["alarmTypeName"] !== undefined ? _data["alarmTypeName"] : null;
            this.scopeName = _data["scopeName"] !== undefined ? _data["scopeName"] : null;
            this.measurementTypeName = _data["measurementTypeName"] !== undefined ? _data["measurementTypeName"] : null;
            this.stringStatusName = _data["stringStatusName"] !== undefined ? _data["stringStatusName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["alarmTypeId"] = this.alarmTypeId !== undefined ? this.alarmTypeId : null;
        data["alarmScopeId"] = this.alarmScopeId !== undefined ? this.alarmScopeId : null;
        data["limitLayoutId"] = this.limitLayoutId !== undefined ? this.limitLayoutId : null;
        data["measurementTypeId"] = this.measurementTypeId !== undefined ? this.measurementTypeId : null;
        data["stringStatusId"] = this.stringStatusId !== undefined ? this.stringStatusId : null;
        data["alarmTypeName"] = this.alarmTypeName !== undefined ? this.alarmTypeName : null;
        data["scopeName"] = this.scopeName !== undefined ? this.scopeName : null;
        data["measurementTypeName"] = this.measurementTypeName !== undefined ? this.measurementTypeName : null;
        data["stringStatusName"] = this.stringStatusName !== undefined ? this.stringStatusName : null;
        super.toJSON(data);
        return data;
    }
}
export class AlarmSummaryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.numberOfCriticalAlarmsAck = _data["numberOfCriticalAlarmsAck"] !== undefined ? _data["numberOfCriticalAlarmsAck"] : null;
            this.numberOfWarningsAck = _data["numberOfWarningsAck"] !== undefined ? _data["numberOfWarningsAck"] : null;
            this.numberOfCriticalAlarmsNack = _data["numberOfCriticalAlarmsNack"] !== undefined ? _data["numberOfCriticalAlarmsNack"] : null;
            this.numberOfWarningsNack = _data["numberOfWarningsNack"] !== undefined ? _data["numberOfWarningsNack"] : null;
            this.numberOfInfoMessages = _data["numberOfInfoMessages"] !== undefined ? _data["numberOfInfoMessages"] : null;
            this.numberOfWarnings = _data["numberOfWarnings"] !== undefined ? _data["numberOfWarnings"] : null;
            this.numberOfCriticalAlarms = _data["numberOfCriticalAlarms"] !== undefined ? _data["numberOfCriticalAlarms"] : null;
            this.numberOfSystemAlarms = _data["numberOfSystemAlarms"] !== undefined ? _data["numberOfSystemAlarms"] : null;
            this.snapshotTimestamp = _data["snapshotTimestamp"] ? new Date(_data["snapshotTimestamp"].toString()) : null;
            this.numberOfAlarmsActiveAfterSnapshotTimestamp = _data["numberOfAlarmsActiveAfterSnapshotTimestamp"] !== undefined ? _data["numberOfAlarmsActiveAfterSnapshotTimestamp"] : null;
            this.isLatestSnapshotTimestamp = _data["isLatestSnapshotTimestamp"] !== undefined ? _data["isLatestSnapshotTimestamp"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmSummaryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["numberOfCriticalAlarmsAck"] = this.numberOfCriticalAlarmsAck !== undefined ? this.numberOfCriticalAlarmsAck : null;
        data["numberOfWarningsAck"] = this.numberOfWarningsAck !== undefined ? this.numberOfWarningsAck : null;
        data["numberOfCriticalAlarmsNack"] = this.numberOfCriticalAlarmsNack !== undefined ? this.numberOfCriticalAlarmsNack : null;
        data["numberOfWarningsNack"] = this.numberOfWarningsNack !== undefined ? this.numberOfWarningsNack : null;
        data["numberOfInfoMessages"] = this.numberOfInfoMessages !== undefined ? this.numberOfInfoMessages : null;
        data["numberOfWarnings"] = this.numberOfWarnings !== undefined ? this.numberOfWarnings : null;
        data["numberOfCriticalAlarms"] = this.numberOfCriticalAlarms !== undefined ? this.numberOfCriticalAlarms : null;
        data["numberOfSystemAlarms"] = this.numberOfSystemAlarms !== undefined ? this.numberOfSystemAlarms : null;
        data["snapshotTimestamp"] = this.snapshotTimestamp ? this.snapshotTimestamp.toISOString() : null;
        data["numberOfAlarmsActiveAfterSnapshotTimestamp"] = this.numberOfAlarmsActiveAfterSnapshotTimestamp !== undefined ? this.numberOfAlarmsActiveAfterSnapshotTimestamp : null;
        data["isLatestSnapshotTimestamp"] = this.isLatestSnapshotTimestamp !== undefined ? this.isLatestSnapshotTimestamp : null;
        data["status"] = this.status !== undefined ? this.status : null;
        return data;
    }
}
export class BaseQueryOfGetAlarmSummaryQueryAndAlarmSummaryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetAlarmSummaryQueryAndAlarmSummaryModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetAlarmSummaryQuery extends BaseQueryOfGetAlarmSummaryQueryAndAlarmSummaryModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlarmSummaryQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfAlarmQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(AlarmQuery.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfAlarmQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class AlarmQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.alarmId = _data["alarmId"] !== undefined ? _data["alarmId"] : null;
            this.alarmDefinitionId = _data["alarmDefinitionId"] !== undefined ? _data["alarmDefinitionId"] : null;
            this.alarmTypeId = _data["alarmTypeId"] !== undefined ? _data["alarmTypeId"] : null;
            this.alarmEventId = _data["alarmEventId"] !== undefined ? _data["alarmEventId"] : null;
            this.stringStatusId = _data["stringStatusId"] !== undefined ? _data["stringStatusId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.systemComponentId = _data["systemComponentId"] !== undefined ? _data["systemComponentId"] : null;
            this.componentTypeId = _data["componentTypeId"] !== undefined ? _data["componentTypeId"] : null;
            this.alarmSeverityId = _data["alarmSeverityId"] !== undefined ? _data["alarmSeverityId"] : null;
            this.measurementTypeId = _data["measurementTypeId"] !== undefined ? _data["measurementTypeId"] : null;
            this.unitOfMeasurementCode = _data["unitOfMeasurementCode"] !== undefined ? _data["unitOfMeasurementCode"] : null;
            this.unitOfMeasurementCodeImperial = _data["unitOfMeasurementCodeImperial"] !== undefined ? _data["unitOfMeasurementCodeImperial"] : null;
            this.alarmGroupId = _data["alarmGroupId"] !== undefined ? _data["alarmGroupId"] : null;
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null;
            this.alarmDefinitionName = _data["alarmDefinitionName"] !== undefined ? _data["alarmDefinitionName"] : null;
            this.location = _data["location"] !== undefined ? _data["location"] : null;
            this.details = _data["details"] !== undefined ? _data["details"] : null;
            this.hexColor = _data["hexColor"] !== undefined ? _data["hexColor"] : null;
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : null;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : null;
            this.extremeValue = _data["extremeValue"] !== undefined ? _data["extremeValue"] : null;
            this.minLimitValue = _data["minLimitValue"] !== undefined ? _data["minLimitValue"] : null;
            this.maxLimitValue = _data["maxLimitValue"] !== undefined ? _data["maxLimitValue"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.alarmSeverityName = _data["alarmSeverityName"] !== undefined ? _data["alarmSeverityName"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.city = _data["city"] !== undefined ? _data["city"] : null;
            this.state = _data["state"] !== undefined ? _data["state"] : null;
            this.region = _data["region"] !== undefined ? _data["region"] : null;
            this.country = _data["country"] !== undefined ? _data["country"] : null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null;
            this.isOrphaned = _data["isOrphaned"] !== undefined ? _data["isOrphaned"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenRaised = _data["whenRaised"] ? new Date(_data["whenRaised"].toString()) : null;
            this.whenCleared = _data["whenCleared"] ? new Date(_data["whenCleared"].toString()) : null;
            this.whenSystemDeleted = _data["whenSystemDeleted"] ? new Date(_data["whenSystemDeleted"].toString()) : null;
            this.acknowledgeStatus = _data["acknowledgeStatus"] !== undefined ? _data["acknowledgeStatus"] : null;
            this.whenAcknowledged = _data["whenAcknowledged"] ? new Date(_data["whenAcknowledged"].toString()) : null;
            this.userAcknowledgedId = _data["userAcknowledgedId"] !== undefined ? _data["userAcknowledgedId"] : null;
            this.userAcknowledgedName = _data["userAcknowledgedName"] !== undefined ? _data["userAcknowledgedName"] : null;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : null;
            this.uoM = _data["uoM"] !== undefined ? _data["uoM"] : null;
            this.digits = _data["digits"] !== undefined ? _data["digits"] : null;
            this.hasNotes = _data["hasNotes"] !== undefined ? _data["hasNotes"] : null;
            if (Array.isArray(_data["issueIds"])) {
                this.issueIds = [];
                for (let item of _data["issueIds"])
                    this.issueIds.push(item);
            }
            else {
                this.issueIds = null;
            }
            this.batteryTypeId = _data["batteryTypeId"] !== undefined ? _data["batteryTypeId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["alarmId"] = this.alarmId !== undefined ? this.alarmId : null;
        data["alarmDefinitionId"] = this.alarmDefinitionId !== undefined ? this.alarmDefinitionId : null;
        data["alarmTypeId"] = this.alarmTypeId !== undefined ? this.alarmTypeId : null;
        data["alarmEventId"] = this.alarmEventId !== undefined ? this.alarmEventId : null;
        data["stringStatusId"] = this.stringStatusId !== undefined ? this.stringStatusId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["systemComponentId"] = this.systemComponentId !== undefined ? this.systemComponentId : null;
        data["componentTypeId"] = this.componentTypeId !== undefined ? this.componentTypeId : null;
        data["alarmSeverityId"] = this.alarmSeverityId !== undefined ? this.alarmSeverityId : null;
        data["measurementTypeId"] = this.measurementTypeId !== undefined ? this.measurementTypeId : null;
        data["unitOfMeasurementCode"] = this.unitOfMeasurementCode !== undefined ? this.unitOfMeasurementCode : null;
        data["unitOfMeasurementCodeImperial"] = this.unitOfMeasurementCodeImperial !== undefined ? this.unitOfMeasurementCodeImperial : null;
        data["alarmGroupId"] = this.alarmGroupId !== undefined ? this.alarmGroupId : null;
        data["eventId"] = this.eventId !== undefined ? this.eventId : null;
        data["alarmDefinitionName"] = this.alarmDefinitionName !== undefined ? this.alarmDefinitionName : null;
        data["location"] = this.location !== undefined ? this.location : null;
        data["details"] = this.details !== undefined ? this.details : null;
        data["hexColor"] = this.hexColor !== undefined ? this.hexColor : null;
        data["minValue"] = this.minValue !== undefined ? this.minValue : null;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : null;
        data["extremeValue"] = this.extremeValue !== undefined ? this.extremeValue : null;
        data["minLimitValue"] = this.minLimitValue !== undefined ? this.minLimitValue : null;
        data["maxLimitValue"] = this.maxLimitValue !== undefined ? this.maxLimitValue : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["alarmSeverityName"] = this.alarmSeverityName !== undefined ? this.alarmSeverityName : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["state"] = this.state !== undefined ? this.state : null;
        data["region"] = this.region !== undefined ? this.region : null;
        data["country"] = this.country !== undefined ? this.country : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null;
        data["duration"] = this.duration !== undefined ? this.duration : null;
        data["isOrphaned"] = this.isOrphaned !== undefined ? this.isOrphaned : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenRaised"] = this.whenRaised ? this.whenRaised.toISOString() : null;
        data["whenCleared"] = this.whenCleared ? this.whenCleared.toISOString() : null;
        data["whenSystemDeleted"] = this.whenSystemDeleted ? this.whenSystemDeleted.toISOString() : null;
        data["acknowledgeStatus"] = this.acknowledgeStatus !== undefined ? this.acknowledgeStatus : null;
        data["whenAcknowledged"] = this.whenAcknowledged ? this.whenAcknowledged.toISOString() : null;
        data["userAcknowledgedId"] = this.userAcknowledgedId !== undefined ? this.userAcknowledgedId : null;
        data["userAcknowledgedName"] = this.userAcknowledgedName !== undefined ? this.userAcknowledgedName : null;
        data["selected"] = this.selected !== undefined ? this.selected : null;
        data["uoM"] = this.uoM !== undefined ? this.uoM : null;
        data["digits"] = this.digits !== undefined ? this.digits : null;
        data["hasNotes"] = this.hasNotes !== undefined ? this.hasNotes : null;
        if (Array.isArray(this.issueIds)) {
            data["issueIds"] = [];
            for (let item of this.issueIds)
                data["issueIds"].push(item);
        }
        data["batteryTypeId"] = this.batteryTypeId !== undefined ? this.batteryTypeId : null;
        return data;
    }
}
export var AlarmAcknowledgeStatusEnum;
(function (AlarmAcknowledgeStatusEnum) {
    AlarmAcknowledgeStatusEnum[AlarmAcknowledgeStatusEnum["Unacknowledge"] = 0] = "Unacknowledge";
    AlarmAcknowledgeStatusEnum[AlarmAcknowledgeStatusEnum["Acknowledge"] = 1] = "Acknowledge";
})(AlarmAcknowledgeStatusEnum || (AlarmAcknowledgeStatusEnum = {}));
export class BaseQueryOfGetAlarmViewPaginatedQueryAndPaginatedEnumerableOfAlarmQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetAlarmViewPaginatedQueryAndPaginatedEnumerableOfAlarmQuery' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetAlarmViewPaginatedQuery extends BaseQueryOfGetAlarmViewPaginatedQueryAndPaginatedEnumerableOfAlarmQuery {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.alarmId = _data["alarmId"] !== undefined ? _data["alarmId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.alarmTypeId = _data["alarmTypeId"] !== undefined ? _data["alarmTypeId"] : null;
            this.alarmSeverityId = _data["alarmSeverityId"] !== undefined ? _data["alarmSeverityId"] : null;
            this.stringStatusId = _data["stringStatusId"] !== undefined ? _data["stringStatusId"] : null;
            this.alarmStatusId = _data["alarmStatusId"] !== undefined ? _data["alarmStatusId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
            this.acknowledgeStatus = _data["acknowledgeStatus"] !== undefined ? _data["acknowledgeStatus"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            if (Array.isArray(_data["alarmSeverityIds"])) {
                this.alarmSeverityIds = [];
                for (let item of _data["alarmSeverityIds"])
                    this.alarmSeverityIds.push(item);
            }
            else {
                this.alarmSeverityIds = null;
            }
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlarmViewPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["alarmId"] = this.alarmId !== undefined ? this.alarmId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["alarmTypeId"] = this.alarmTypeId !== undefined ? this.alarmTypeId : null;
        data["alarmSeverityId"] = this.alarmSeverityId !== undefined ? this.alarmSeverityId : null;
        data["stringStatusId"] = this.stringStatusId !== undefined ? this.stringStatusId : null;
        data["alarmStatusId"] = this.alarmStatusId !== undefined ? this.alarmStatusId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        data["acknowledgeStatus"] = this.acknowledgeStatus !== undefined ? this.acknowledgeStatus : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        if (Array.isArray(this.alarmSeverityIds)) {
            data["alarmSeverityIds"] = [];
            for (let item of this.alarmSeverityIds)
                data["alarmSeverityIds"].push(item);
        }
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfAcknowledgeAlarmsRequestModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? AcknowledgeAlarmsRequestModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfAcknowledgeAlarmsRequestModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class AcknowledgeAlarmsCommand extends BaseCommandOfAcknowledgeAlarmsRequestModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AcknowledgeAlarmsCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class AcknowledgeAlarmsRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["alarmIds"])) {
                this.alarmIds = [];
                for (let item of _data["alarmIds"])
                    this.alarmIds.push(item);
            }
            else {
                this.alarmIds = null;
            }
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null;
            this.notifySiteContactGroup = _data["notifySiteContactGroup"] !== undefined ? _data["notifySiteContactGroup"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AcknowledgeAlarmsRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.alarmIds)) {
            data["alarmIds"] = [];
            for (let item of this.alarmIds)
                data["alarmIds"].push(item);
        }
        data["comment"] = this.comment !== undefined ? this.comment : null;
        data["notifySiteContactGroup"] = this.notifySiteContactGroup !== undefined ? this.notifySiteContactGroup : null;
        return data;
    }
}
export class BaseCommandOfListOfAlarmModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["requestModel"])) {
                this.requestModel = [];
                for (let item of _data["requestModel"])
                    this.requestModel.push(AlarmModel.fromJS(item));
            }
            else {
                this.requestModel = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfListOfAlarmModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requestModel)) {
            data["requestModel"] = [];
            for (let item of this.requestModel)
                data["requestModel"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class ClearAlarmsCommand extends BaseCommandOfListOfAlarmModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClearAlarmsCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfApiRequestModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? ApiRequestModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfApiRequestModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class MarkApiRequestAsReadCommand extends BaseCommandOfApiRequestModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MarkApiRequestAsReadCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetStringLifeQueryAndStringEndOfLifeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetStringLifeQueryAndStringEndOfLifeModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetStringLifeQuery extends BaseQueryOfGetStringLifeQueryAndStringEndOfLifeModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.ageMethod = _data["ageMethod"] !== undefined ? _data["ageMethod"] : null;
            this.ageColumn1Parameter = _data["ageColumn1Parameter"] !== undefined ? _data["ageColumn1Parameter"] : null;
            this.ageColumn2Parameter = _data["ageColumn2Parameter"] !== undefined ? _data["ageColumn2Parameter"] : null;
            this.ageColumn3Parameter = _data["ageColumn3Parameter"] !== undefined ? _data["ageColumn3Parameter"] : null;
            this.replacementColumn1Parameter = _data["replacementColumn1Parameter"] !== undefined ? _data["replacementColumn1Parameter"] : null;
            this.replacementColumn2Parameter = _data["replacementColumn2Parameter"] !== undefined ? _data["replacementColumn2Parameter"] : null;
            this.replacementColumn3Parameter = _data["replacementColumn3Parameter"] !== undefined ? _data["replacementColumn3Parameter"] : null;
            this.ohmicRiseColumn1Parameter = _data["ohmicRiseColumn1Parameter"] !== undefined ? _data["ohmicRiseColumn1Parameter"] : null;
            this.ohmicRiseColumn2Parameter = _data["ohmicRiseColumn2Parameter"] !== undefined ? _data["ohmicRiseColumn2Parameter"] : null;
            this.ohmicRiseColumn3Parameter = _data["ohmicRiseColumn3Parameter"] !== undefined ? _data["ohmicRiseColumn3Parameter"] : null;
            this.predictedColumn1Parameter = _data["predictedColumn1Parameter"] !== undefined ? _data["predictedColumn1Parameter"] : null;
            this.predictedColumn2Parameter = _data["predictedColumn2Parameter"] !== undefined ? _data["predictedColumn2Parameter"] : null;
            this.predictedColumn3Parameter = _data["predictedColumn3Parameter"] !== undefined ? _data["predictedColumn3Parameter"] : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStringLifeQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["ageMethod"] = this.ageMethod !== undefined ? this.ageMethod : null;
        data["ageColumn1Parameter"] = this.ageColumn1Parameter !== undefined ? this.ageColumn1Parameter : null;
        data["ageColumn2Parameter"] = this.ageColumn2Parameter !== undefined ? this.ageColumn2Parameter : null;
        data["ageColumn3Parameter"] = this.ageColumn3Parameter !== undefined ? this.ageColumn3Parameter : null;
        data["replacementColumn1Parameter"] = this.replacementColumn1Parameter !== undefined ? this.replacementColumn1Parameter : null;
        data["replacementColumn2Parameter"] = this.replacementColumn2Parameter !== undefined ? this.replacementColumn2Parameter : null;
        data["replacementColumn3Parameter"] = this.replacementColumn3Parameter !== undefined ? this.replacementColumn3Parameter : null;
        data["ohmicRiseColumn1Parameter"] = this.ohmicRiseColumn1Parameter !== undefined ? this.ohmicRiseColumn1Parameter : null;
        data["ohmicRiseColumn2Parameter"] = this.ohmicRiseColumn2Parameter !== undefined ? this.ohmicRiseColumn2Parameter : null;
        data["ohmicRiseColumn3Parameter"] = this.ohmicRiseColumn3Parameter !== undefined ? this.ohmicRiseColumn3Parameter : null;
        data["predictedColumn1Parameter"] = this.predictedColumn1Parameter !== undefined ? this.predictedColumn1Parameter : null;
        data["predictedColumn2Parameter"] = this.predictedColumn2Parameter !== undefined ? this.predictedColumn2Parameter : null;
        data["predictedColumn3Parameter"] = this.predictedColumn3Parameter !== undefined ? this.predictedColumn3Parameter : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetBatteryReplacementEstimationQueryAndBatteryReplacementEstimationModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetBatteryReplacementEstimationQueryAndBatteryReplacementEstimationModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetBatteryReplacementEstimationQuery extends BaseQueryOfGetBatteryReplacementEstimationQueryAndBatteryReplacementEstimationModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.periodInMonths = _data["periodInMonths"] !== undefined ? _data["periodInMonths"] : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
            this.includeOhmicColumns = _data["includeOhmicColumns"] !== undefined ? _data["includeOhmicColumns"] : null;
            this.ohmicRiseThreshold = _data["ohmicRiseThreshold"] !== undefined ? _data["ohmicRiseThreshold"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBatteryReplacementEstimationQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["periodInMonths"] = this.periodInMonths !== undefined ? this.periodInMonths : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        data["includeOhmicColumns"] = this.includeOhmicColumns !== undefined ? this.includeOhmicColumns : null;
        data["ohmicRiseThreshold"] = this.ohmicRiseThreshold !== undefined ? this.ohmicRiseThreshold : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetBlockStatusQueryAndBlockStatusModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetBlockStatusQueryAndBlockStatusModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetBlockStatusQuery extends BaseQueryOfGetBlockStatusQueryAndBlockStatusModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.filterStringsWithNoAlarmOnDetails = _data["filterStringsWithNoAlarmOnDetails"] !== undefined ? _data["filterStringsWithNoAlarmOnDetails"] : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlockStatusQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["filterStringsWithNoAlarmOnDetails"] = this.filterStringsWithNoAlarmOnDetails !== undefined ? this.filterStringsWithNoAlarmOnDetails : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        super.toJSON(data);
        return data;
    }
}
export class BlockTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.blockTypeId = _data["blockTypeId"] !== undefined ? _data["blockTypeId"] : null;
            this.blockTypeName = _data["blockTypeName"] !== undefined ? _data["blockTypeName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BlockTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["blockTypeId"] = this.blockTypeId !== undefined ? this.blockTypeId : null;
        data["blockTypeName"] = this.blockTypeName !== undefined ? this.blockTypeName : null;
        return data;
    }
}
export class PaginatedEnumerableOfBlockTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(BlockTypeModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfBlockTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetBlockTypeListPaginatedQueryAndPaginatedEnumerableOfBlockTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetBlockTypeListPaginatedQueryAndPaginatedEnumerableOfBlockTypeModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetBlockTypeListPaginatedQuery extends BaseQueryOfGetBlockTypeListPaginatedQueryAndPaginatedEnumerableOfBlockTypeModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlockTypeListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfBlockTypeModelAndInteger {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? BlockTypeModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfBlockTypeModelAndInteger' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateBlockTypeCommand extends BaseCommandOfBlockTypeModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBlockTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateBlockTypeCommand extends BaseCommandOfBlockTypeModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBlockTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class CompanyModel extends BaseAuthoredModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.companyTypeId = _data["companyTypeId"] !== undefined ? _data["companyTypeId"] : null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null;
            this.currencyId = _data["currencyId"] !== undefined ? _data["currencyId"] : null;
            this.primaryAddressId = _data["primaryAddressId"] !== undefined ? _data["primaryAddressId"] : null;
            this.primarySiteId = _data["primarySiteId"] !== undefined ? _data["primarySiteId"] : null;
            this.companyCode = _data["companyCode"] !== undefined ? _data["companyCode"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.website = _data["website"] !== undefined ? _data["website"] : null;
            this.taxId = _data["taxId"] !== undefined ? _data["taxId"] : null;
            this.companyTypeName = _data["companyTypeName"] !== undefined ? _data["companyTypeName"] : null;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null;
            this.currencyCode = _data["currencyCode"] !== undefined ? _data["currencyCode"] : null;
            this.maxDailyAlarmEmailLimitPerSystem = _data["maxDailyAlarmEmailLimitPerSystem"] !== undefined ? _data["maxDailyAlarmEmailLimitPerSystem"] : null;
            this.maxDailyAlarmSmsLimitPerSystem = _data["maxDailyAlarmSmsLimitPerSystem"] !== undefined ? _data["maxDailyAlarmSmsLimitPerSystem"] : null;
            this.awsAccessKey = _data["awsAccessKey"] !== undefined ? _data["awsAccessKey"] : null;
            this.awsAccessKeySecret = _data["awsAccessKeySecret"] !== undefined ? _data["awsAccessKeySecret"] : null;
            this.awsRegion = _data["awsRegion"] !== undefined ? _data["awsRegion"] : null;
            this.companyLogo = _data["companyLogo"] !== undefined ? _data["companyLogo"] : null;
            this.reportFooterCustomMessage = _data["reportFooterCustomMessage"] !== undefined ? _data["reportFooterCustomMessage"] : null;
            this.allowClientUsersToScheduleReportsToAllContacts = _data["allowClientUsersToScheduleReportsToAllContacts"] !== undefined ? _data["allowClientUsersToScheduleReportsToAllContacts"] : null;
            this.primaryAddress = _data["primaryAddress"] ? AddressModel.fromJS(_data["primaryAddress"]) : null;
            this.primarySite = _data["primarySite"] ? SiteModel.fromJS(_data["primarySite"]) : null;
            if (Array.isArray(_data["twoFactorAuthMethods"])) {
                this.twoFactorAuthMethods = [];
                for (let item of _data["twoFactorAuthMethods"])
                    this.twoFactorAuthMethods.push(item);
            }
            else {
                this.twoFactorAuthMethods = null;
            }
            this.accountStatus = _data["accountStatus"] !== undefined ? _data["accountStatus"] : null;
            this.accountDueDate = _data["accountDueDate"] ? new Date(_data["accountDueDate"].toString()) : null;
            this.ssoConfiguration = _data["ssoConfiguration"] ? SsoConfiguration.fromJS(_data["ssoConfiguration"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["companyTypeId"] = this.companyTypeId !== undefined ? this.companyTypeId : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["currencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        data["primaryAddressId"] = this.primaryAddressId !== undefined ? this.primaryAddressId : null;
        data["primarySiteId"] = this.primarySiteId !== undefined ? this.primarySiteId : null;
        data["companyCode"] = this.companyCode !== undefined ? this.companyCode : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["website"] = this.website !== undefined ? this.website : null;
        data["taxId"] = this.taxId !== undefined ? this.taxId : null;
        data["companyTypeName"] = this.companyTypeName !== undefined ? this.companyTypeName : null;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null;
        data["currencyCode"] = this.currencyCode !== undefined ? this.currencyCode : null;
        data["maxDailyAlarmEmailLimitPerSystem"] = this.maxDailyAlarmEmailLimitPerSystem !== undefined ? this.maxDailyAlarmEmailLimitPerSystem : null;
        data["maxDailyAlarmSmsLimitPerSystem"] = this.maxDailyAlarmSmsLimitPerSystem !== undefined ? this.maxDailyAlarmSmsLimitPerSystem : null;
        data["awsAccessKey"] = this.awsAccessKey !== undefined ? this.awsAccessKey : null;
        data["awsAccessKeySecret"] = this.awsAccessKeySecret !== undefined ? this.awsAccessKeySecret : null;
        data["awsRegion"] = this.awsRegion !== undefined ? this.awsRegion : null;
        data["companyLogo"] = this.companyLogo !== undefined ? this.companyLogo : null;
        data["reportFooterCustomMessage"] = this.reportFooterCustomMessage !== undefined ? this.reportFooterCustomMessage : null;
        data["allowClientUsersToScheduleReportsToAllContacts"] = this.allowClientUsersToScheduleReportsToAllContacts !== undefined ? this.allowClientUsersToScheduleReportsToAllContacts : null;
        data["primaryAddress"] = this.primaryAddress ? this.primaryAddress.toJSON() : null;
        data["primarySite"] = this.primarySite ? this.primarySite.toJSON() : null;
        if (Array.isArray(this.twoFactorAuthMethods)) {
            data["twoFactorAuthMethods"] = [];
            for (let item of this.twoFactorAuthMethods)
                data["twoFactorAuthMethods"].push(item);
        }
        data["accountStatus"] = this.accountStatus !== undefined ? this.accountStatus : null;
        data["accountDueDate"] = this.accountDueDate ? this.accountDueDate.toISOString() : null;
        data["ssoConfiguration"] = this.ssoConfiguration ? this.ssoConfiguration.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export var AccountStatusEnum;
(function (AccountStatusEnum) {
    AccountStatusEnum[AccountStatusEnum["Active"] = 0] = "Active";
    AccountStatusEnum[AccountStatusEnum["Overdue"] = 1] = "Overdue";
    AccountStatusEnum[AccountStatusEnum["Suspended"] = 2] = "Suspended";
})(AccountStatusEnum || (AccountStatusEnum = {}));
export class SsoConfiguration {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.ssoEnabled = _data["ssoEnabled"] !== undefined ? _data["ssoEnabled"] : null;
            this.authority = _data["authority"] !== undefined ? _data["authority"] : null;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null;
            this.clientSecret = _data["clientSecret"] !== undefined ? _data["clientSecret"] : null;
            this.callbackPath = _data["callbackPath"] !== undefined ? _data["callbackPath"] : null;
            this.subdomain = _data["subdomain"] !== undefined ? _data["subdomain"] : null;
            this.userNameClaimType = _data["userNameClaimType"] !== undefined ? _data["userNameClaimType"] : null;
            this.emailClaimType = _data["emailClaimType"] !== undefined ? _data["emailClaimType"] : null;
            this.firstNameClaimType = _data["firstNameClaimType"] !== undefined ? _data["firstNameClaimType"] : null;
            this.lastNameClaimType = _data["lastNameClaimType"] !== undefined ? _data["lastNameClaimType"] : null;
            this.rolesClaimType = _data["rolesClaimType"] !== undefined ? _data["rolesClaimType"] : null;
            if (_data["roles"]) {
                this.roles = {};
                for (let key in _data["roles"]) {
                    if (_data["roles"].hasOwnProperty(key))
                        this.roles[key] = _data["roles"][key] !== undefined ? _data["roles"][key] : null;
                }
            }
            else {
                this.roles = null;
            }
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [];
                for (let item of _data["scopes"])
                    this.scopes.push(item);
            }
            else {
                this.scopes = null;
            }
            this.autoAssignAllSitesAndSystems = _data["autoAssignAllSitesAndSystems"] !== undefined ? _data["autoAssignAllSitesAndSystems"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SsoConfiguration();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["ssoEnabled"] = this.ssoEnabled !== undefined ? this.ssoEnabled : null;
        data["authority"] = this.authority !== undefined ? this.authority : null;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null;
        data["clientSecret"] = this.clientSecret !== undefined ? this.clientSecret : null;
        data["callbackPath"] = this.callbackPath !== undefined ? this.callbackPath : null;
        data["subdomain"] = this.subdomain !== undefined ? this.subdomain : null;
        data["userNameClaimType"] = this.userNameClaimType !== undefined ? this.userNameClaimType : null;
        data["emailClaimType"] = this.emailClaimType !== undefined ? this.emailClaimType : null;
        data["firstNameClaimType"] = this.firstNameClaimType !== undefined ? this.firstNameClaimType : null;
        data["lastNameClaimType"] = this.lastNameClaimType !== undefined ? this.lastNameClaimType : null;
        data["rolesClaimType"] = this.rolesClaimType !== undefined ? this.rolesClaimType : null;
        if (this.roles) {
            data["roles"] = {};
            for (let key in this.roles) {
                if (this.roles.hasOwnProperty(key))
                    data["roles"][key] = this.roles[key] !== undefined ? this.roles[key] : null;
            }
        }
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        data["autoAssignAllSitesAndSystems"] = this.autoAssignAllSitesAndSystems !== undefined ? this.autoAssignAllSitesAndSystems : null;
        return data;
    }
}
export class BaseQueryOfGetCompanyListQueryAndIListOfCompanyModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetCompanyListQueryAndIListOfCompanyModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetCompanyListQuery extends BaseQueryOfGetCompanyListQueryAndIListOfCompanyModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyListQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfCompanyModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(CompanyModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfCompanyModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetCompanyListPaginatedQueryAndPaginatedEnumerableOfCompanyModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetCompanyListPaginatedQueryAndPaginatedEnumerableOfCompanyModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetCompanyListPaginatedQuery extends BaseQueryOfGetCompanyListPaginatedQueryAndPaginatedEnumerableOfCompanyModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfCompanyQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(CompanyQuery.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfCompanyQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class CompanyQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.companyTypeId = _data["companyTypeId"] !== undefined ? _data["companyTypeId"] : null;
            this.authorId = _data["authorId"] !== undefined ? _data["authorId"] : null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null;
            this.primaryAddressId = _data["primaryAddressId"] !== undefined ? _data["primaryAddressId"] : null;
            this.primarySiteId = _data["primarySiteId"] !== undefined ? _data["primarySiteId"] : null;
            this.companyCode = _data["companyCode"] !== undefined ? _data["companyCode"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.website = _data["website"] !== undefined ? _data["website"] : null;
            this.authorName = _data["authorName"] !== undefined ? _data["authorName"] : null;
            this.companyTypeName = _data["companyTypeName"] !== undefined ? _data["companyTypeName"] : null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : null;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null;
            this.addressName = _data["addressName"] !== undefined ? _data["addressName"] : null;
            this.streetAddress1 = _data["streetAddress1"] !== undefined ? _data["streetAddress1"] : null;
            this.streetAddress2 = _data["streetAddress2"] !== undefined ? _data["streetAddress2"] : null;
            this.streetAddress3 = _data["streetAddress3"] !== undefined ? _data["streetAddress3"] : null;
            this.streetAddress4 = _data["streetAddress4"] !== undefined ? _data["streetAddress4"] : null;
            this.postAddress1 = _data["postAddress1"] !== undefined ? _data["postAddress1"] : null;
            this.postAddress2 = _data["postAddress2"] !== undefined ? _data["postAddress2"] : null;
            this.postAddress3 = _data["postAddress3"] !== undefined ? _data["postAddress3"] : null;
            this.postAddress4 = _data["postAddress4"] !== undefined ? _data["postAddress4"] : null;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null;
            this.siteCode = _data["siteCode"] !== undefined ? _data["siteCode"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.numberOfSystemsAtPrimarySite = _data["numberOfSystemsAtPrimarySite"] !== undefined ? _data["numberOfSystemsAtPrimarySite"] : null;
            this.numberOfCriticalSystemsAtPrimarySite = _data["numberOfCriticalSystemsAtPrimarySite"] !== undefined ? _data["numberOfCriticalSystemsAtPrimarySite"] : null;
            this.numberOfWarningSystemsAtPrimarySite = _data["numberOfWarningSystemsAtPrimarySite"] !== undefined ? _data["numberOfWarningSystemsAtPrimarySite"] : null;
            this.totalNumberOfSites = _data["totalNumberOfSites"] !== undefined ? _data["totalNumberOfSites"] : null;
            this.totalNumberOfSystems = _data["totalNumberOfSystems"] !== undefined ? _data["totalNumberOfSystems"] : null;
            this.totalNumberOfCriticalSystems = _data["totalNumberOfCriticalSystems"] !== undefined ? _data["totalNumberOfCriticalSystems"] : null;
            this.totalNumberOfWarningSystems = _data["totalNumberOfWarningSystems"] !== undefined ? _data["totalNumberOfWarningSystems"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : null;
            this.accountStatus = _data["accountStatus"] !== undefined ? _data["accountStatus"] : null;
            this.accountDueDate = _data["accountDueDate"] ? new Date(_data["accountDueDate"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["companyTypeId"] = this.companyTypeId !== undefined ? this.companyTypeId : null;
        data["authorId"] = this.authorId !== undefined ? this.authorId : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["primaryAddressId"] = this.primaryAddressId !== undefined ? this.primaryAddressId : null;
        data["primarySiteId"] = this.primarySiteId !== undefined ? this.primarySiteId : null;
        data["companyCode"] = this.companyCode !== undefined ? this.companyCode : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["website"] = this.website !== undefined ? this.website : null;
        data["authorName"] = this.authorName !== undefined ? this.authorName : null;
        data["companyTypeName"] = this.companyTypeName !== undefined ? this.companyTypeName : null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : null;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null;
        data["addressName"] = this.addressName !== undefined ? this.addressName : null;
        data["streetAddress1"] = this.streetAddress1 !== undefined ? this.streetAddress1 : null;
        data["streetAddress2"] = this.streetAddress2 !== undefined ? this.streetAddress2 : null;
        data["streetAddress3"] = this.streetAddress3 !== undefined ? this.streetAddress3 : null;
        data["streetAddress4"] = this.streetAddress4 !== undefined ? this.streetAddress4 : null;
        data["postAddress1"] = this.postAddress1 !== undefined ? this.postAddress1 : null;
        data["postAddress2"] = this.postAddress2 !== undefined ? this.postAddress2 : null;
        data["postAddress3"] = this.postAddress3 !== undefined ? this.postAddress3 : null;
        data["postAddress4"] = this.postAddress4 !== undefined ? this.postAddress4 : null;
        data["postCode"] = this.postCode !== undefined ? this.postCode : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null;
        data["siteCode"] = this.siteCode !== undefined ? this.siteCode : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["numberOfSystemsAtPrimarySite"] = this.numberOfSystemsAtPrimarySite !== undefined ? this.numberOfSystemsAtPrimarySite : null;
        data["numberOfCriticalSystemsAtPrimarySite"] = this.numberOfCriticalSystemsAtPrimarySite !== undefined ? this.numberOfCriticalSystemsAtPrimarySite : null;
        data["numberOfWarningSystemsAtPrimarySite"] = this.numberOfWarningSystemsAtPrimarySite !== undefined ? this.numberOfWarningSystemsAtPrimarySite : null;
        data["totalNumberOfSites"] = this.totalNumberOfSites !== undefined ? this.totalNumberOfSites : null;
        data["totalNumberOfSystems"] = this.totalNumberOfSystems !== undefined ? this.totalNumberOfSystems : null;
        data["totalNumberOfCriticalSystems"] = this.totalNumberOfCriticalSystems !== undefined ? this.totalNumberOfCriticalSystems : null;
        data["totalNumberOfWarningSystems"] = this.totalNumberOfWarningSystems !== undefined ? this.totalNumberOfWarningSystems : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : null;
        data["accountStatus"] = this.accountStatus !== undefined ? this.accountStatus : null;
        data["accountDueDate"] = this.accountDueDate ? this.accountDueDate.toISOString() : null;
        return data;
    }
}
export class BaseQueryOfGetCompanyViewPaginatedQueryAndPaginatedEnumerableOfCompanyQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetCompanyViewPaginatedQueryAndPaginatedEnumerableOfCompanyQuery' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetCompanyViewPaginatedQuery extends BaseQueryOfGetCompanyViewPaginatedQueryAndPaginatedEnumerableOfCompanyQuery {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.showUnhealthyOnly = _data["showUnhealthyOnly"] !== undefined ? _data["showUnhealthyOnly"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyViewPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["showUnhealthyOnly"] = this.showUnhealthyOnly !== undefined ? this.showUnhealthyOnly : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class CompanySystemOverviewModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.totalNumberOfSystems = _data["totalNumberOfSystems"] !== undefined ? _data["totalNumberOfSystems"] : null;
            this.totalNumberOfCriticalSystems = _data["totalNumberOfCriticalSystems"] !== undefined ? _data["totalNumberOfCriticalSystems"] : null;
            this.totalNumberOfWarningSystems = _data["totalNumberOfWarningSystems"] !== undefined ? _data["totalNumberOfWarningSystems"] : null;
            this.totalNumberOfUnknownSystems = _data["totalNumberOfUnknownSystems"] !== undefined ? _data["totalNumberOfUnknownSystems"] : null;
            this.totalNumberOfHealthySystems = _data["totalNumberOfHealthySystems"] !== undefined ? _data["totalNumberOfHealthySystems"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySystemOverviewModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["totalNumberOfSystems"] = this.totalNumberOfSystems !== undefined ? this.totalNumberOfSystems : null;
        data["totalNumberOfCriticalSystems"] = this.totalNumberOfCriticalSystems !== undefined ? this.totalNumberOfCriticalSystems : null;
        data["totalNumberOfWarningSystems"] = this.totalNumberOfWarningSystems !== undefined ? this.totalNumberOfWarningSystems : null;
        data["totalNumberOfUnknownSystems"] = this.totalNumberOfUnknownSystems !== undefined ? this.totalNumberOfUnknownSystems : null;
        data["totalNumberOfHealthySystems"] = this.totalNumberOfHealthySystems !== undefined ? this.totalNumberOfHealthySystems : null;
        return data;
    }
}
export class BaseCommandOfCompanyModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? CompanyModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfCompanyModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateCompanyCommand extends BaseCommandOfCompanyModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateCompanyCommand extends BaseCommandOfCompanyModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [];
                for (let item of _data["notifications"])
                    this.notifications.push(ArtificialNotificationAddressModel.fromJS(item));
            }
            else {
                this.notifications = null;
            }
            this.batteryLifePredictionSettings = _data["batteryLifePredictionSettings"] ? BatteryLifePredictionSettingsModel.fromJS(_data["batteryLifePredictionSettings"]) : null;
            this.issueSettings = _data["issueSettings"] ? IssueSettingsModel.fromJS(_data["issueSettings"]) : null;
            this.companyServicesSettings = _data["companyServicesSettings"] ? CompanyServicesSettingsModel.fromJS(_data["companyServicesSettings"]) : null;
            this.alarmsSettings = _data["alarmsSettings"] ? AlarmsSettingsModel.fromJS(_data["alarmsSettings"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item ? item.toJSON() : null);
        }
        data["batteryLifePredictionSettings"] = this.batteryLifePredictionSettings ? this.batteryLifePredictionSettings.toJSON() : null;
        data["issueSettings"] = this.issueSettings ? this.issueSettings.toJSON() : null;
        data["companyServicesSettings"] = this.companyServicesSettings ? this.companyServicesSettings.toJSON() : null;
        data["alarmsSettings"] = this.alarmsSettings ? this.alarmsSettings.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class ArtificialNotificationAddressModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.notificationGroupId = _data["notificationGroupId"] !== undefined ? _data["notificationGroupId"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null;
            this.mobilePhone = _data["mobilePhone"] !== undefined ? _data["mobilePhone"] : null;
            this.sendSystemDigestEmails = _data["sendSystemDigestEmails"] !== undefined ? _data["sendSystemDigestEmails"] : null;
            this.systemDigestNotificationInterval = _data["systemDigestNotificationInterval"] !== undefined ? _data["systemDigestNotificationInterval"] : null;
            this.minEventDuration = _data["minEventDuration"] !== undefined ? _data["minEventDuration"] : null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null;
            this.systemDigestNotificationIntervalInDays = _data["systemDigestNotificationIntervalInDays"] !== undefined ? _data["systemDigestNotificationIntervalInDays"] : null;
            this.systemDigestNotificationIntervalInMinutes = _data["systemDigestNotificationIntervalInMinutes"] !== undefined ? _data["systemDigestNotificationIntervalInMinutes"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtificialNotificationAddressModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["notificationGroupId"] = this.notificationGroupId !== undefined ? this.notificationGroupId : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null;
        data["mobilePhone"] = this.mobilePhone !== undefined ? this.mobilePhone : null;
        data["sendSystemDigestEmails"] = this.sendSystemDigestEmails !== undefined ? this.sendSystemDigestEmails : null;
        data["systemDigestNotificationInterval"] = this.systemDigestNotificationInterval !== undefined ? this.systemDigestNotificationInterval : null;
        data["minEventDuration"] = this.minEventDuration !== undefined ? this.minEventDuration : null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null;
        data["systemDigestNotificationIntervalInDays"] = this.systemDigestNotificationIntervalInDays !== undefined ? this.systemDigestNotificationIntervalInDays : null;
        data["systemDigestNotificationIntervalInMinutes"] = this.systemDigestNotificationIntervalInMinutes !== undefined ? this.systemDigestNotificationIntervalInMinutes : null;
        return data;
    }
}
export class IssueSettingsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.createIssueForOhmicCriticalAlarm = _data["createIssueForOhmicCriticalAlarm"] !== undefined ? _data["createIssueForOhmicCriticalAlarm"] : null;
            this.ohmicCriticalAlarmDescription = _data["ohmicCriticalAlarmDescription"] !== undefined ? _data["ohmicCriticalAlarmDescription"] : null;
            this.ohmicCriticalAlarmTask = _data["ohmicCriticalAlarmTask"] !== undefined ? _data["ohmicCriticalAlarmTask"] : null;
            this.createIssueForAmbTempCriticalAlarm = _data["createIssueForAmbTempCriticalAlarm"] !== undefined ? _data["createIssueForAmbTempCriticalAlarm"] : null;
            this.ambTempCriticalAlarmDescription = _data["ambTempCriticalAlarmDescription"] !== undefined ? _data["ambTempCriticalAlarmDescription"] : null;
            this.ambTempCriticalAlarmTask = _data["ambTempCriticalAlarmTask"] !== undefined ? _data["ambTempCriticalAlarmTask"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSettingsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["createIssueForOhmicCriticalAlarm"] = this.createIssueForOhmicCriticalAlarm !== undefined ? this.createIssueForOhmicCriticalAlarm : null;
        data["ohmicCriticalAlarmDescription"] = this.ohmicCriticalAlarmDescription !== undefined ? this.ohmicCriticalAlarmDescription : null;
        data["ohmicCriticalAlarmTask"] = this.ohmicCriticalAlarmTask !== undefined ? this.ohmicCriticalAlarmTask : null;
        data["createIssueForAmbTempCriticalAlarm"] = this.createIssueForAmbTempCriticalAlarm !== undefined ? this.createIssueForAmbTempCriticalAlarm : null;
        data["ambTempCriticalAlarmDescription"] = this.ambTempCriticalAlarmDescription !== undefined ? this.ambTempCriticalAlarmDescription : null;
        data["ambTempCriticalAlarmTask"] = this.ambTempCriticalAlarmTask !== undefined ? this.ambTempCriticalAlarmTask : null;
        return data;
    }
}
export class CompanyServicesSettingsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.isAssurePlusCustomer = _data["isAssurePlusCustomer"] !== undefined ? _data["isAssurePlusCustomer"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyServicesSettingsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["isAssurePlusCustomer"] = this.isAssurePlusCustomer !== undefined ? this.isAssurePlusCustomer : null;
        return data;
    }
}
export class AlarmsSettingsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.requireCommentOnAcknowledge = _data["requireCommentOnAcknowledge"] !== undefined ? _data["requireCommentOnAcknowledge"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmsSettingsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["requireCommentOnAcknowledge"] = this.requireCommentOnAcknowledge !== undefined ? this.requireCommentOnAcknowledge : null;
        return data;
    }
}
export class BaseQueryOfGetCompanySystemsQueryAndCompanySystemsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetCompanySystemsQueryAndCompanySystemsModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetCompanySystemsQuery extends BaseQueryOfGetCompanySystemsQueryAndCompanySystemsModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.hideSiteName = _data["hideSiteName"] !== undefined ? _data["hideSiteName"] : null;
            this.countPerSite = _data["countPerSite"] !== undefined ? _data["countPerSite"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanySystemsQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["hideSiteName"] = this.hideSiteName !== undefined ? this.hideSiteName : null;
        data["countPerSite"] = this.countPerSite !== undefined ? this.countPerSite : null;
        super.toJSON(data);
        return data;
    }
}
export class CompanyPaymentStatus {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.blockAccess = _data["blockAccess"] !== undefined ? _data["blockAccess"] : null;
            this.accountStatus = _data["accountStatus"] !== undefined ? _data["accountStatus"] : null;
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPaymentStatus();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["blockAccess"] = this.blockAccess !== undefined ? this.blockAccess : null;
        data["accountStatus"] = this.accountStatus !== undefined ? this.accountStatus : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["message"] = this.message !== undefined ? this.message : null;
        return data;
    }
}
export class BaseQueryOfGetCompanySummaryPDFReportQueryAndByteOf {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetCompanySummaryPDFReportQueryAndByteOf' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetCompanySummaryPDFReportQuery extends BaseQueryOfGetCompanySummaryPDFReportQueryAndByteOf {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.query = _data["query"] ? GetCompanySummaryDataQuery.fromJS(_data["query"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanySummaryPDFReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetCompanySummaryDataQueryAndCompanySummaryDataModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetCompanySummaryDataQueryAndCompanySummaryDataModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetCompanySummaryDataQuery extends BaseQueryOfGetCompanySummaryDataQueryAndCompanySummaryDataModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.reportFromDate = _data["reportFromDate"] ? new Date(_data["reportFromDate"].toString()) : null;
            this.reportToDate = _data["reportToDate"] ? new Date(_data["reportToDate"].toString()) : null;
            this.groupBySite = _data["groupBySite"] !== undefined ? _data["groupBySite"] : null;
            this.groupByCategory = _data["groupByCategory"] !== undefined ? _data["groupByCategory"] : null;
            this.alarmStrategy = _data["alarmStrategy"] !== undefined ? _data["alarmStrategy"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanySummaryDataQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["reportFromDate"] = this.reportFromDate ? this.reportFromDate.toISOString() : null;
        data["reportToDate"] = this.reportToDate ? this.reportToDate.toISOString() : null;
        data["groupBySite"] = this.groupBySite !== undefined ? this.groupBySite : null;
        data["groupByCategory"] = this.groupByCategory !== undefined ? this.groupByCategory : null;
        data["alarmStrategy"] = this.alarmStrategy !== undefined ? this.alarmStrategy : null;
        super.toJSON(data);
        return data;
    }
}
export var AlarmStrategyEnum;
(function (AlarmStrategyEnum) {
    AlarmStrategyEnum[AlarmStrategyEnum["Database"] = 0] = "Database";
    AlarmStrategyEnum[AlarmStrategyEnum["LimitBased"] = 1] = "LimitBased";
})(AlarmStrategyEnum || (AlarmStrategyEnum = {}));
export class CompanyEditionModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.editionId = _data["editionId"] !== undefined ? _data["editionId"] : null;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyEditionModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["editionId"] = this.editionId !== undefined ? this.editionId : null;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : null;
        return data;
    }
}
export class BaseCommandOfCompanyEditionModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? CompanyEditionModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfCompanyEditionModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpdateCompanyEditionCommand extends BaseCommandOfCompanyEditionModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyEditionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class CompanyArchiveImpactModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sitesCount = _data["sitesCount"] !== undefined ? _data["sitesCount"] : null;
            this.systemsCount = _data["systemsCount"] !== undefined ? _data["systemsCount"] : null;
            this.usersCount = _data["usersCount"] !== undefined ? _data["usersCount"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyArchiveImpactModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sitesCount"] = this.sitesCount !== undefined ? this.sitesCount : null;
        data["systemsCount"] = this.systemsCount !== undefined ? this.systemsCount : null;
        data["usersCount"] = this.usersCount !== undefined ? this.usersCount : null;
        return data;
    }
}
export class PaginatedEnumerableOfComponentTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(ComponentTypeModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfComponentTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetComponentTypeListPaginatedQueryAndPaginatedEnumerableOfComponentTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetComponentTypeListPaginatedQueryAndPaginatedEnumerableOfComponentTypeModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetComponentTypeListPaginatedQuery extends BaseQueryOfGetComponentTypeListPaginatedQueryAndPaginatedEnumerableOfComponentTypeModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetComponentTypeListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfComponentTypeModelAndInteger {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? ComponentTypeModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfComponentTypeModelAndInteger' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateComponentTypeCommand extends BaseCommandOfComponentTypeModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateComponentTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateComponentTypeCommand extends BaseCommandOfComponentTypeModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateComponentTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class CountryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : null;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CountryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : null;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null;
        return data;
    }
}
export class PaginatedEnumerableOfCountryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(CountryModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfCountryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class CurrencyModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.currencyId = _data["currencyId"] !== undefined ? _data["currencyId"] : null;
            this.currencyCode = _data["currencyCode"] !== undefined ? _data["currencyCode"] : null;
            this.currencyName = _data["currencyName"] !== undefined ? _data["currencyName"] : null;
            this.symbol = _data["symbol"] !== undefined ? _data["symbol"] : null;
            this.decimalPlaces = _data["decimalPlaces"] !== undefined ? _data["decimalPlaces"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        data["currencyCode"] = this.currencyCode !== undefined ? this.currencyCode : null;
        data["currencyName"] = this.currencyName !== undefined ? this.currencyName : null;
        data["symbol"] = this.symbol !== undefined ? this.symbol : null;
        data["decimalPlaces"] = this.decimalPlaces !== undefined ? this.decimalPlaces : null;
        return data;
    }
}
export class PaginatedEnumerableOfDataCollectorRegisterModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(DataCollectorRegisterModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfDataCollectorRegisterModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class DataCollectorRegisterModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : null;
            this.file = _data["file"] !== undefined ? _data["file"] : null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : null;
            this.apiReponse = _data["apiReponse"] !== undefined ? _data["apiReponse"] : null;
            this.batchId = _data["batchId"] !== undefined ? _data["batchId"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.statusDisplayName = _data["statusDisplayName"] !== undefined ? _data["statusDisplayName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DataCollectorRegisterModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["fileType"] = this.fileType !== undefined ? this.fileType : null;
        data["file"] = this.file !== undefined ? this.file : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : null;
        data["apiReponse"] = this.apiReponse !== undefined ? this.apiReponse : null;
        data["batchId"] = this.batchId !== undefined ? this.batchId : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["statusDisplayName"] = this.statusDisplayName !== undefined ? this.statusDisplayName : null;
        super.toJSON(data);
        return data;
    }
}
export var DataCollectorRegisterFileTypeEnum;
(function (DataCollectorRegisterFileTypeEnum) {
    DataCollectorRegisterFileTypeEnum[DataCollectorRegisterFileTypeEnum["Controller"] = 1] = "Controller";
    DataCollectorRegisterFileTypeEnum[DataCollectorRegisterFileTypeEnum["CellWatch"] = 2] = "CellWatch";
})(DataCollectorRegisterFileTypeEnum || (DataCollectorRegisterFileTypeEnum = {}));
export var DataCollectorRegisterStatusEnum;
(function (DataCollectorRegisterStatusEnum) {
    DataCollectorRegisterStatusEnum[DataCollectorRegisterStatusEnum["Pending"] = 0] = "Pending";
    DataCollectorRegisterStatusEnum[DataCollectorRegisterStatusEnum["Succeeded"] = 1] = "Succeeded";
    DataCollectorRegisterStatusEnum[DataCollectorRegisterStatusEnum["Failed"] = 2] = "Failed";
})(DataCollectorRegisterStatusEnum || (DataCollectorRegisterStatusEnum = {}));
export class BaseQueryOfGetDataCollectorRegisterListPaginatedQueryAndPaginatedEnumerableOfDataCollectorRegisterModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetDataCollectorRegisterListPaginatedQueryAndPaginatedEnumerableOfDataCollectorRegisterModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetDataCollectorRegisterListPaginatedQuery extends BaseQueryOfGetDataCollectorRegisterListPaginatedQueryAndPaginatedEnumerableOfDataCollectorRegisterModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataCollectorRegisterListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfDataCollectorRegisterModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? DataCollectorRegisterModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfDataCollectorRegisterModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class AddDataCollectorRegisterCommand extends BaseCommandOfDataCollectorRegisterModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddDataCollectorRegisterCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class DataCollectorRegisterBatchResultModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.batchId = _data["batchId"] !== undefined ? _data["batchId"] : null;
            if (Array.isArray(_data["succeeded"])) {
                this.succeeded = [];
                for (let item of _data["succeeded"])
                    this.succeeded.push(DataCollectorRegisterBatchItemResultModel.fromJS(item));
            }
            else {
                this.succeeded = null;
            }
            if (Array.isArray(_data["failed"])) {
                this.failed = [];
                for (let item of _data["failed"])
                    this.failed.push(DataCollectorRegisterBatchItemResultModel.fromJS(item));
            }
            else {
                this.failed = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DataCollectorRegisterBatchResultModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId !== undefined ? this.batchId : null;
        if (Array.isArray(this.succeeded)) {
            data["succeeded"] = [];
            for (let item of this.succeeded)
                data["succeeded"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.failed)) {
            data["failed"] = [];
            for (let item of this.failed)
                data["failed"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class DataCollectorRegisterBatchItemResultModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.registerId = _data["registerId"] !== undefined ? _data["registerId"] : null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DataCollectorRegisterBatchItemResultModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["registerId"] = this.registerId !== undefined ? this.registerId : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null;
        return data;
    }
}
export class BaseCommandOfAddDataCollectorRegistersRequestModelAndDataCollectorRegisterBatchResultModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? AddDataCollectorRegistersRequestModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfAddDataCollectorRegistersRequestModelAndDataCollectorRegisterBatchResultModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class AddDataCollectorRegistersCommand extends BaseCommandOfAddDataCollectorRegistersRequestModelAndDataCollectorRegisterBatchResultModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddDataCollectorRegistersCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class AddDataCollectorRegistersRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            if (Array.isArray(_data["files"])) {
                this.files = [];
                for (let item of _data["files"])
                    this.files.push(DataCollectorRegisterModel.fromJS(item));
            }
            else {
                this.files = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddDataCollectorRegistersRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseCommandOfRetryDataCollectorRegisterRequestModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? RetryDataCollectorRegisterRequestModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfRetryDataCollectorRegisterRequestModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class RetryDataCollectorRegisterCommand extends BaseCommandOfRetryDataCollectorRegisterRequestModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RetryDataCollectorRegisterCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class RetryDataCollectorRegisterRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.newFile = _data["newFile"] ? DataCollectorRegisterModel.fromJS(_data["newFile"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RetryDataCollectorRegisterRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["newFile"] = this.newFile ? this.newFile.toJSON() : null;
        return data;
    }
}
export class BaseQueryOfGetDischargeDetailsQueryAndDischargeDetailsData {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetDischargeDetailsQueryAndDischargeDetailsData' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetDischargeDetailsQuery extends BaseQueryOfGetDischargeDetailsQueryAndDischargeDetailsData {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.currentTimezoneOffset = _data["currentTimezoneOffset"] !== undefined ? _data["currentTimezoneOffset"] : null;
            this.startTimezoneOffset = _data["startTimezoneOffset"] !== undefined ? _data["startTimezoneOffset"] : null;
            this.endTimezoneOffset = _data["endTimezoneOffset"] !== undefined ? _data["endTimezoneOffset"] : null;
            this.imperialMeasurements = _data["imperialMeasurements"] !== undefined ? _data["imperialMeasurements"] : null;
            this.dischargeSnapshotId = _data["dischargeSnapshotId"] !== undefined ? _data["dischargeSnapshotId"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
            if (Array.isArray(_data["stringIds"])) {
                this.stringIds = [];
                for (let item of _data["stringIds"])
                    this.stringIds.push(item);
            }
            else {
                this.stringIds = null;
            }
            this.overrideLimits = _data["overrideLimits"] !== undefined ? _data["overrideLimits"] : null;
            this.blockVoltageLowLimit = _data["blockVoltageLowLimit"] !== undefined ? _data["blockVoltageLowLimit"] : null;
            this.blockTemperatureHighLimit = _data["blockTemperatureHighLimit"] !== undefined ? _data["blockTemperatureHighLimit"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDischargeDetailsQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["currentTimezoneOffset"] = this.currentTimezoneOffset !== undefined ? this.currentTimezoneOffset : null;
        data["startTimezoneOffset"] = this.startTimezoneOffset !== undefined ? this.startTimezoneOffset : null;
        data["endTimezoneOffset"] = this.endTimezoneOffset !== undefined ? this.endTimezoneOffset : null;
        data["imperialMeasurements"] = this.imperialMeasurements !== undefined ? this.imperialMeasurements : null;
        data["dischargeSnapshotId"] = this.dischargeSnapshotId !== undefined ? this.dischargeSnapshotId : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        if (Array.isArray(this.stringIds)) {
            data["stringIds"] = [];
            for (let item of this.stringIds)
                data["stringIds"].push(item);
        }
        data["overrideLimits"] = this.overrideLimits !== undefined ? this.overrideLimits : null;
        data["blockVoltageLowLimit"] = this.blockVoltageLowLimit !== undefined ? this.blockVoltageLowLimit : null;
        data["blockTemperatureHighLimit"] = this.blockTemperatureHighLimit !== undefined ? this.blockTemperatureHighLimit : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetDischargeActivityQueryAndDischargeActivityModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetDischargeActivityQueryAndDischargeActivityModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetDischargeActivityQuery extends BaseQueryOfGetDischargeActivityQueryAndDischargeActivityModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null;
            this.currentTimezoneOffset = _data["currentTimezoneOffset"] !== undefined ? _data["currentTimezoneOffset"] : null;
            this.startTimezoneOffset = _data["startTimezoneOffset"] !== undefined ? _data["startTimezoneOffset"] : null;
            this.endTimezoneOffset = _data["endTimezoneOffset"] !== undefined ? _data["endTimezoneOffset"] : null;
            this.dischargeMinSeconds = _data["dischargeMinSeconds"] !== undefined ? _data["dischargeMinSeconds"] : null;
            this.breakByString = _data["breakByString"] !== undefined ? _data["breakByString"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDischargeActivityQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["currentTimezoneOffset"] = this.currentTimezoneOffset !== undefined ? this.currentTimezoneOffset : null;
        data["startTimezoneOffset"] = this.startTimezoneOffset !== undefined ? this.startTimezoneOffset : null;
        data["endTimezoneOffset"] = this.endTimezoneOffset !== undefined ? this.endTimezoneOffset : null;
        data["dischargeMinSeconds"] = this.dischargeMinSeconds !== undefined ? this.dischargeMinSeconds : null;
        data["breakByString"] = this.breakByString !== undefined ? this.breakByString : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfEventQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(EventQuery.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfEventQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class EventQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.eventTypeId = _data["eventTypeId"] !== undefined ? _data["eventTypeId"] : null;
            this.eventTypeName = _data["eventTypeName"] !== undefined ? _data["eventTypeName"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.whenFirstAlarmRaised = _data["whenFirstAlarmRaised"] ? new Date(_data["whenFirstAlarmRaised"].toString()) : null;
            this.whenLastAlarmRaised = _data["whenLastAlarmRaised"] ? new Date(_data["whenLastAlarmRaised"].toString()) : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EventQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId !== undefined ? this.eventId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["eventTypeId"] = this.eventTypeId !== undefined ? this.eventTypeId : null;
        data["eventTypeName"] = this.eventTypeName !== undefined ? this.eventTypeName : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["whenFirstAlarmRaised"] = this.whenFirstAlarmRaised ? this.whenFirstAlarmRaised.toISOString() : null;
        data["whenLastAlarmRaised"] = this.whenLastAlarmRaised ? this.whenLastAlarmRaised.toISOString() : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : null;
        return data;
    }
}
export class BaseQueryOfGetEventListPaginatedQueryAndPaginatedEnumerableOfEventQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetEventListPaginatedQueryAndPaginatedEnumerableOfEventQuery' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetEventListPaginatedQuery extends BaseQueryOfGetEventListPaginatedQueryAndPaginatedEnumerableOfEventQuery {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class EventBaseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.eventName = _data["eventName"] !== undefined ? _data["eventName"] : null;
            this.whenEventStarted = _data["whenEventStarted"] ? new Date(_data["whenEventStarted"].toString()) : null;
            this.whenEventFinished = _data["whenEventFinished"] ? new Date(_data["whenEventFinished"].toString()) : null;
            this.hasOrphanedAlarms = _data["hasOrphanedAlarms"] !== undefined ? _data["hasOrphanedAlarms"] : null;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null;
            this.durationText = _data["durationText"] !== undefined ? _data["durationText"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EventBaseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId !== undefined ? this.eventId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["eventName"] = this.eventName !== undefined ? this.eventName : null;
        data["whenEventStarted"] = this.whenEventStarted ? this.whenEventStarted.toISOString() : null;
        data["whenEventFinished"] = this.whenEventFinished ? this.whenEventFinished.toISOString() : null;
        data["hasOrphanedAlarms"] = this.hasOrphanedAlarms !== undefined ? this.hasOrphanedAlarms : null;
        data["duration"] = this.duration !== undefined ? this.duration : null;
        data["durationText"] = this.durationText !== undefined ? this.durationText : null;
        return data;
    }
}
export class EventModel extends EventBaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null;
            this.eventTypeId = _data["eventTypeId"] !== undefined ? _data["eventTypeId"] : null;
            this.eventTypeName = _data["eventTypeName"] !== undefined ? _data["eventTypeName"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.whenLastAlarmRaised = _data["whenLastAlarmRaised"] ? new Date(_data["whenLastAlarmRaised"].toString()) : null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null;
            this.alarmsDurationText = _data["alarmsDurationText"] !== undefined ? _data["alarmsDurationText"] : null;
            if (Array.isArray(_data["alarms"])) {
                this.alarms = [];
                for (let item of _data["alarms"])
                    this.alarms.push(AlarmQuery.fromJS(item));
            }
            else {
                this.alarms = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EventModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId !== undefined ? this.eventId : null;
        data["eventTypeId"] = this.eventTypeId !== undefined ? this.eventTypeId : null;
        data["eventTypeName"] = this.eventTypeName !== undefined ? this.eventTypeName : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["whenLastAlarmRaised"] = this.whenLastAlarmRaised ? this.whenLastAlarmRaised.toISOString() : null;
        data["notes"] = this.notes !== undefined ? this.notes : null;
        data["alarmsDurationText"] = this.alarmsDurationText !== undefined ? this.alarmsDurationText : null;
        if (Array.isArray(this.alarms)) {
            data["alarms"] = [];
            for (let item of this.alarms)
                data["alarms"].push(item ? item.toJSON() : null);
        }
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfEventModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? EventModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfEventModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpdateEventCommand extends BaseCommandOfEventModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEventCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ChargeCycleEventModel extends EventBaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.alarmGroupId = _data["alarmGroupId"] !== undefined ? _data["alarmGroupId"] : null;
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
            this.alarmDefinitionId = _data["alarmDefinitionId"] !== undefined ? _data["alarmDefinitionId"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.isDischarge = _data["isDischarge"] !== undefined ? _data["isDischarge"] : null;
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [];
                for (let item of _data["measurements"])
                    this.measurements.push(MeasurementModel.fromJS(item));
            }
            else {
                this.measurements = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeCycleEventModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["alarmGroupId"] = this.alarmGroupId !== undefined ? this.alarmGroupId : null;
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        data["alarmDefinitionId"] = this.alarmDefinitionId !== undefined ? this.alarmDefinitionId : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["isDischarge"] = this.isDischarge !== undefined ? this.isDischarge : null;
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item ? item.toJSON() : null);
        }
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfChargeCycleEventModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(ChargeCycleEventModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfChargeCycleEventModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetChargeCycleEventListPaginatedQueryAndPaginatedEnumerableOfChargeCycleEventModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetChargeCycleEventListPaginatedQueryAndPaginatedEnumerableOfChargeCycleEventModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetChargeCycleEventListPaginatedQuery extends BaseQueryOfGetChargeCycleEventListPaginatedQueryAndPaginatedEnumerableOfChargeCycleEventModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.alarmGroupId = _data["alarmGroupId"] !== undefined ? _data["alarmGroupId"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
            if (Array.isArray(_data["stringIds"])) {
                this.stringIds = [];
                for (let item of _data["stringIds"])
                    this.stringIds.push(item);
            }
            else {
                this.stringIds = null;
            }
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetChargeCycleEventListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["alarmGroupId"] = this.alarmGroupId !== undefined ? this.alarmGroupId : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        if (Array.isArray(this.stringIds)) {
            data["stringIds"] = [];
            for (let item of this.stringIds)
                data["stringIds"].push(item);
        }
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfChargeCycleSnapshotModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(ChargeCycleSnapshotModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfChargeCycleSnapshotModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class ChargeCycleSnapshotModel extends EventBaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.snapshotId = _data["snapshotId"] !== undefined ? _data["snapshotId"] : null;
            this.stringStatusId = _data["stringStatusId"] !== undefined ? _data["stringStatusId"] : null;
            this.alarmGroupId = _data["alarmGroupId"] !== undefined ? _data["alarmGroupId"] : null;
            this.componentNames = _data["componentNames"] !== undefined ? _data["componentNames"] : null;
            this.componentIds = _data["componentIds"] !== undefined ? _data["componentIds"] : null;
            this.yearMonth = _data["yearMonth"] !== undefined ? _data["yearMonth"] : null;
            this.hasMeasurementData = _data["hasMeasurementData"] !== undefined ? _data["hasMeasurementData"] : null;
            this.snapshotDate = _data["snapshotDate"] ? new Date(_data["snapshotDate"].toString()) : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeCycleSnapshotModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["snapshotId"] = this.snapshotId !== undefined ? this.snapshotId : null;
        data["stringStatusId"] = this.stringStatusId !== undefined ? this.stringStatusId : null;
        data["alarmGroupId"] = this.alarmGroupId !== undefined ? this.alarmGroupId : null;
        data["componentNames"] = this.componentNames !== undefined ? this.componentNames : null;
        data["componentIds"] = this.componentIds !== undefined ? this.componentIds : null;
        data["yearMonth"] = this.yearMonth !== undefined ? this.yearMonth : null;
        data["hasMeasurementData"] = this.hasMeasurementData !== undefined ? this.hasMeasurementData : null;
        data["snapshotDate"] = this.snapshotDate ? this.snapshotDate.toISOString() : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetChargeCycleSnapshotListPaginatedQueryAndPaginatedEnumerableOfChargeCycleSnapshotModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetChargeCycleSnapshotListPaginatedQueryAndPaginatedEnumerableOfChargeCycleSnapshotModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetChargeCycleSnapshotListPaginatedQuery extends BaseQueryOfGetChargeCycleSnapshotListPaginatedQueryAndPaginatedEnumerableOfChargeCycleSnapshotModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.includeSnapshotsWithoutMeasurements = _data["includeSnapshotsWithoutMeasurements"] !== undefined ? _data["includeSnapshotsWithoutMeasurements"] : null;
            this.onlyDischargeEvents = _data["onlyDischargeEvents"] !== undefined ? _data["onlyDischargeEvents"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetChargeCycleSnapshotListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["includeSnapshotsWithoutMeasurements"] = this.includeSnapshotsWithoutMeasurements !== undefined ? this.includeSnapshotsWithoutMeasurements : null;
        data["onlyDischargeEvents"] = this.onlyDischargeEvents !== undefined ? this.onlyDischargeEvents : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetChargeCycleEventsForSnapshotQueryAndListOfChargeCycleEventModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetChargeCycleEventsForSnapshotQueryAndListOfChargeCycleEventModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetChargeCycleEventsForSnapshotQuery extends BaseQueryOfGetChargeCycleEventsForSnapshotQueryAndListOfChargeCycleEventModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.chargeCycleSnapshotId = _data["chargeCycleSnapshotId"] !== undefined ? _data["chargeCycleSnapshotId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetChargeCycleEventsForSnapshotQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["chargeCycleSnapshotId"] = this.chargeCycleSnapshotId !== undefined ? this.chargeCycleSnapshotId : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfEventTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(EventTypeModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfEventTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class EventTypeModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.eventTypeId = _data["eventTypeId"] !== undefined ? _data["eventTypeId"] : null;
            this.eventTypeName = _data["eventTypeName"] !== undefined ? _data["eventTypeName"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null;
            if (Array.isArray(_data["alarmDefinitionIds"])) {
                this.alarmDefinitionIds = [];
                for (let item of _data["alarmDefinitionIds"])
                    this.alarmDefinitionIds.push(item);
            }
            else {
                this.alarmDefinitionIds = null;
            }
            this.groupByScopeId = _data["groupByScopeId"] !== undefined ? _data["groupByScopeId"] : null;
            this.scopeName = _data["scopeName"] !== undefined ? _data["scopeName"] : null;
            this.timeWindowMinutes = _data["timeWindowMinutes"] !== undefined ? _data["timeWindowMinutes"] : null;
            this.sendNotificationsOnFirstAlarm = _data["sendNotificationsOnFirstAlarm"] !== undefined ? _data["sendNotificationsOnFirstAlarm"] : null;
            this.sendNotificationsAfterTimeWindow = _data["sendNotificationsAfterTimeWindow"] !== undefined ? _data["sendNotificationsAfterTimeWindow"] : null;
            this.sendEmail = _data["sendEmail"] !== undefined ? _data["sendEmail"] : null;
            this.sendSms = _data["sendSms"] !== undefined ? _data["sendSms"] : null;
            this.minEventDuration = _data["minEventDuration"] !== undefined ? _data["minEventDuration"] : null;
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [];
                for (let item of _data["contactIds"])
                    this.contactIds.push(item);
            }
            else {
                this.contactIds = null;
            }
            if (Array.isArray(_data["contactGroupIds"])) {
                this.contactGroupIds = [];
                for (let item of _data["contactGroupIds"])
                    this.contactGroupIds.push(item);
            }
            else {
                this.contactGroupIds = null;
            }
            if (Array.isArray(_data["contactNames"])) {
                this.contactNames = [];
                for (let item of _data["contactNames"])
                    this.contactNames.push(item);
            }
            else {
                this.contactNames = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EventTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["eventTypeId"] = this.eventTypeId !== undefined ? this.eventTypeId : null;
        data["eventTypeName"] = this.eventTypeName !== undefined ? this.eventTypeName : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null;
        if (Array.isArray(this.alarmDefinitionIds)) {
            data["alarmDefinitionIds"] = [];
            for (let item of this.alarmDefinitionIds)
                data["alarmDefinitionIds"].push(item);
        }
        data["groupByScopeId"] = this.groupByScopeId !== undefined ? this.groupByScopeId : null;
        data["scopeName"] = this.scopeName !== undefined ? this.scopeName : null;
        data["timeWindowMinutes"] = this.timeWindowMinutes !== undefined ? this.timeWindowMinutes : null;
        data["sendNotificationsOnFirstAlarm"] = this.sendNotificationsOnFirstAlarm !== undefined ? this.sendNotificationsOnFirstAlarm : null;
        data["sendNotificationsAfterTimeWindow"] = this.sendNotificationsAfterTimeWindow !== undefined ? this.sendNotificationsAfterTimeWindow : null;
        data["sendEmail"] = this.sendEmail !== undefined ? this.sendEmail : null;
        data["sendSms"] = this.sendSms !== undefined ? this.sendSms : null;
        data["minEventDuration"] = this.minEventDuration !== undefined ? this.minEventDuration : null;
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        if (Array.isArray(this.contactGroupIds)) {
            data["contactGroupIds"] = [];
            for (let item of this.contactGroupIds)
                data["contactGroupIds"].push(item);
        }
        if (Array.isArray(this.contactNames)) {
            data["contactNames"] = [];
            for (let item of this.contactNames)
                data["contactNames"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetEventTypeListPaginatedQueryAndPaginatedEnumerableOfEventTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetEventTypeListPaginatedQueryAndPaginatedEnumerableOfEventTypeModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetEventTypeListPaginatedQuery extends BaseQueryOfGetEventTypeListPaginatedQueryAndPaginatedEnumerableOfEventTypeModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventTypeListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfEventTypeModelAndInteger {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? EventTypeModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfEventTypeModelAndInteger' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateEventTypeCommand extends BaseCommandOfEventTypeModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEventTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateEventTypeCommand extends BaseCommandOfEventTypeModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEventTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetAlarmDefinitionsInUseQueryAndListOfInteger {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetAlarmDefinitionsInUseQueryAndListOfInteger' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetAlarmDefinitionsInUseQuery extends BaseQueryOfGetAlarmDefinitionsInUseQueryAndListOfInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.eventTypeId = _data["eventTypeId"] !== undefined ? _data["eventTypeId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlarmDefinitionsInUseQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["eventTypeId"] = this.eventTypeId !== undefined ? this.eventTypeId : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfIssueModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(IssueModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfIssueModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class IssueModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.issueId = _data["issueId"] !== undefined ? _data["issueId"] : null;
            this.issueNumber = _data["issueNumber"] !== undefined ? _data["issueNumber"] : null;
            this.description = _data["description"] !== undefined ? _data["description"] : null;
            this.severity = _data["severity"] !== undefined ? _data["severity"] : null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null;
            this.action = _data["action"] !== undefined ? _data["action"] : null;
            this.actionName = _data["actionName"] !== undefined ? _data["actionName"] : null;
            this.internal = _data["internal"] !== undefined ? _data["internal"] : null;
            this.task = _data["task"] !== undefined ? _data["task"] : null;
            this.resolved = _data["resolved"] ? new Date(_data["resolved"].toString()) : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
            if (Array.isArray(_data["components"])) {
                this.components = [];
                for (let item of _data["components"])
                    this.components.push(item);
            }
            else {
                this.components = null;
            }
            if (Array.isArray(_data["alarmIds"])) {
                this.alarmIds = [];
                for (let item of _data["alarmIds"])
                    this.alarmIds.push(item);
            }
            else {
                this.alarmIds = null;
            }
            this.location = _data["location"] !== undefined ? _data["location"] : null;
            this.string = _data["string"] !== undefined ? _data["string"] : null;
            this.block = _data["block"] !== undefined ? _data["block"] : null;
            this.createdById = _data["createdById"] !== undefined ? _data["createdById"] : null;
            this.createdByName = _data["createdByName"] !== undefined ? _data["createdByName"] : null;
            this.updatedById = _data["updatedById"] !== undefined ? _data["updatedById"] : null;
            this.updatedByName = _data["updatedByName"] !== undefined ? _data["updatedByName"] : null;
            this.assignedId = _data["assignedId"] !== undefined ? _data["assignedId"] : null;
            this.assignedName = _data["assignedName"] !== undefined ? _data["assignedName"] : null;
            this.whenUpdated = _data["whenUpdated"] ? new Date(_data["whenUpdated"].toString()) : null;
            if (Array.isArray(_data["urls"])) {
                this.urls = [];
                for (let item of _data["urls"])
                    this.urls.push(item);
            }
            else {
                this.urls = null;
            }
            this.origin = _data["origin"] !== undefined ? _data["origin"] : null;
            this.issueUrl = _data["issueUrl"] !== undefined ? _data["issueUrl"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IssueModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId !== undefined ? this.issueId : null;
        data["issueNumber"] = this.issueNumber !== undefined ? this.issueNumber : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["severity"] = this.severity !== undefined ? this.severity : null;
        data["notes"] = this.notes !== undefined ? this.notes : null;
        data["action"] = this.action !== undefined ? this.action : null;
        data["actionName"] = this.actionName !== undefined ? this.actionName : null;
        data["internal"] = this.internal !== undefined ? this.internal : null;
        data["task"] = this.task !== undefined ? this.task : null;
        data["resolved"] = this.resolved ? this.resolved.toISOString() : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item);
        }
        if (Array.isArray(this.alarmIds)) {
            data["alarmIds"] = [];
            for (let item of this.alarmIds)
                data["alarmIds"].push(item);
        }
        data["location"] = this.location !== undefined ? this.location : null;
        data["string"] = this.string !== undefined ? this.string : null;
        data["block"] = this.block !== undefined ? this.block : null;
        data["createdById"] = this.createdById !== undefined ? this.createdById : null;
        data["createdByName"] = this.createdByName !== undefined ? this.createdByName : null;
        data["updatedById"] = this.updatedById !== undefined ? this.updatedById : null;
        data["updatedByName"] = this.updatedByName !== undefined ? this.updatedByName : null;
        data["assignedId"] = this.assignedId !== undefined ? this.assignedId : null;
        data["assignedName"] = this.assignedName !== undefined ? this.assignedName : null;
        data["whenUpdated"] = this.whenUpdated ? this.whenUpdated.toISOString() : null;
        if (Array.isArray(this.urls)) {
            data["urls"] = [];
            for (let item of this.urls)
                data["urls"].push(item);
        }
        data["origin"] = this.origin !== undefined ? this.origin : null;
        data["issueUrl"] = this.issueUrl !== undefined ? this.issueUrl : null;
        super.toJSON(data);
        return data;
    }
}
export var IssueSeverity;
(function (IssueSeverity) {
    IssueSeverity[IssueSeverity["Critical"] = 1] = "Critical";
    IssueSeverity[IssueSeverity["Warning"] = 2] = "Warning";
    IssueSeverity[IssueSeverity["Info"] = 3] = "Info";
    IssueSeverity[IssueSeverity["Ok"] = 4] = "Ok";
})(IssueSeverity || (IssueSeverity = {}));
export var IssueAction;
(function (IssueAction) {
    IssueAction[IssueAction["Watch"] = 1] = "Watch";
    IssueAction[IssueAction["Task"] = 2] = "Task";
    IssueAction[IssueAction["Resolved"] = 3] = "Resolved";
})(IssueAction || (IssueAction = {}));
export class BaseQueryOfGetIssueListPaginatedQueryAndPaginatedEnumerableOfIssueModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetIssueListPaginatedQueryAndPaginatedEnumerableOfIssueModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetIssueListPaginatedQuery extends BaseQueryOfGetIssueListPaginatedQueryAndPaginatedEnumerableOfIssueModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.page = _data["page"] !== undefined ? _data["page"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.createdById = _data["createdById"] !== undefined ? _data["createdById"] : null;
            this.assignedId = _data["assignedId"] !== undefined ? _data["assignedId"] : null;
            this.action = _data["action"] !== undefined ? _data["action"] : null;
            this.severity = _data["severity"] !== undefined ? _data["severity"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page !== undefined ? this.page : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["createdById"] = this.createdById !== undefined ? this.createdById : null;
        data["assignedId"] = this.assignedId !== undefined ? this.assignedId : null;
        data["action"] = this.action !== undefined ? this.action : null;
        data["severity"] = this.severity !== undefined ? this.severity : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetIssueSuggestionsQueryAndListOfString {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetIssueSuggestionsQueryAndListOfString' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetIssueSuggestionsQuery extends BaseQueryOfGetIssueSuggestionsQueryAndListOfString {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.fieldType = _data["fieldType"] !== undefined ? _data["fieldType"] : null;
            this.searchTerm = _data["searchTerm"] !== undefined ? _data["searchTerm"] : null;
            this.maxResults = _data["maxResults"] !== undefined ? _data["maxResults"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueSuggestionsQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fieldType"] = this.fieldType !== undefined ? this.fieldType : null;
        data["searchTerm"] = this.searchTerm !== undefined ? this.searchTerm : null;
        data["maxResults"] = this.maxResults !== undefined ? this.maxResults : null;
        super.toJSON(data);
        return data;
    }
}
export var IssueFieldType;
(function (IssueFieldType) {
    IssueFieldType[IssueFieldType["Description"] = 1] = "Description";
    IssueFieldType[IssueFieldType["Task"] = 2] = "Task";
})(IssueFieldType || (IssueFieldType = {}));
export class BaseQueryOfGetIssueSiteSummaryQueryAndIssueSiteSummaryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetIssueSiteSummaryQueryAndIssueSiteSummaryModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetIssueSiteSummaryQuery extends BaseQueryOfGetIssueSiteSummaryQueryAndIssueSiteSummaryModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.rangeColumn1 = _data["rangeColumn1"] !== undefined ? _data["rangeColumn1"] : null;
            this.rangeColumn2 = _data["rangeColumn2"] !== undefined ? _data["rangeColumn2"] : null;
            this.rangeColumn3 = _data["rangeColumn3"] !== undefined ? _data["rangeColumn3"] : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueSiteSummaryQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["rangeColumn1"] = this.rangeColumn1 !== undefined ? this.rangeColumn1 : null;
        data["rangeColumn2"] = this.rangeColumn2 !== undefined ? this.rangeColumn2 : null;
        data["rangeColumn3"] = this.rangeColumn3 !== undefined ? this.rangeColumn3 : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetIssuesQueryAndIssuesReportModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetIssuesQueryAndIssuesReportModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetIssuesQuery extends BaseQueryOfGetIssuesQueryAndIssuesReportModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.createdById = _data["createdById"] !== undefined ? _data["createdById"] : null;
            this.assignedId = _data["assignedId"] !== undefined ? _data["assignedId"] : null;
            this.action = _data["action"] !== undefined ? _data["action"] : null;
            this.severity = _data["severity"] !== undefined ? _data["severity"] : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssuesQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["createdById"] = this.createdById !== undefined ? this.createdById : null;
        data["assignedId"] = this.assignedId !== undefined ? this.assignedId : null;
        data["action"] = this.action !== undefined ? this.action : null;
        data["severity"] = this.severity !== undefined ? this.severity : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        super.toJSON(data);
        return data;
    }
}
export class MaintenanceLogModel extends BaseAuthoredModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.logId = _data["logId"] !== undefined ? _data["logId"] : null;
            this.logTypeId = _data["logTypeId"] !== undefined ? _data["logTypeId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null;
            this.whenEntered = _data["whenEntered"] ? new Date(_data["whenEntered"].toString()) : null;
            this.notifySiteContactGroup = _data["notifySiteContactGroup"] !== undefined ? _data["notifySiteContactGroup"] : null;
            if (Array.isArray(_data["alarmIds"])) {
                this.alarmIds = [];
                for (let item of _data["alarmIds"])
                    this.alarmIds.push(item);
            }
            else {
                this.alarmIds = null;
            }
            if (Array.isArray(_data["alarms"])) {
                this.alarms = [];
                for (let item of _data["alarms"])
                    this.alarms.push(AlarmQuery.fromJS(item));
            }
            else {
                this.alarms = null;
            }
            this.event = _data["event"] ? EventQuery.fromJS(_data["event"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceLogModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["logId"] = this.logId !== undefined ? this.logId : null;
        data["logTypeId"] = this.logTypeId !== undefined ? this.logTypeId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["notes"] = this.notes !== undefined ? this.notes : null;
        data["whenEntered"] = this.whenEntered ? this.whenEntered.toISOString() : null;
        data["notifySiteContactGroup"] = this.notifySiteContactGroup !== undefined ? this.notifySiteContactGroup : null;
        if (Array.isArray(this.alarmIds)) {
            data["alarmIds"] = [];
            for (let item of this.alarmIds)
                data["alarmIds"].push(item);
        }
        if (Array.isArray(this.alarms)) {
            data["alarms"] = [];
            for (let item of this.alarms)
                data["alarms"].push(item ? item.toJSON() : null);
        }
        data["event"] = this.event ? this.event.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfMaintenanceLogQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(MaintenanceLogQuery.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfMaintenanceLogQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class MaintenanceLogQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.logId = _data["logId"] !== undefined ? _data["logId"] : null;
            this.authorId = _data["authorId"] !== undefined ? _data["authorId"] : null;
            this.logTypeId = _data["logTypeId"] !== undefined ? _data["logTypeId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.logTypeName = _data["logTypeName"] !== undefined ? _data["logTypeName"] : null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null;
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.whenEntered = _data["whenEntered"] ? new Date(_data["whenEntered"].toString()) : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : null;
            this.whenSystemDeleted = _data["whenSystemDeleted"] ? new Date(_data["whenSystemDeleted"].toString()) : null;
            this.whenComponentDeleted = _data["whenComponentDeleted"] ? new Date(_data["whenComponentDeleted"].toString()) : null;
            this.whenSystemComponentDeleted = _data["whenSystemComponentDeleted"] ? new Date(_data["whenSystemComponentDeleted"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceLogQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["logId"] = this.logId !== undefined ? this.logId : null;
        data["authorId"] = this.authorId !== undefined ? this.authorId : null;
        data["logTypeId"] = this.logTypeId !== undefined ? this.logTypeId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["logTypeName"] = this.logTypeName !== undefined ? this.logTypeName : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["notes"] = this.notes !== undefined ? this.notes : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["whenEntered"] = this.whenEntered ? this.whenEntered.toISOString() : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : null;
        data["whenSystemDeleted"] = this.whenSystemDeleted ? this.whenSystemDeleted.toISOString() : null;
        data["whenComponentDeleted"] = this.whenComponentDeleted ? this.whenComponentDeleted.toISOString() : null;
        data["whenSystemComponentDeleted"] = this.whenSystemComponentDeleted ? this.whenSystemComponentDeleted.toISOString() : null;
        return data;
    }
}
export class BaseQueryOfGetMaintenanceLogViewPaginatedQueryAndPaginatedEnumerableOfMaintenanceLogQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetMaintenanceLogViewPaginatedQueryAndPaginatedEnumerableOfMaintenanceLogQuery' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetMaintenanceLogViewPaginatedQuery extends BaseQueryOfGetMaintenanceLogViewPaginatedQueryAndPaginatedEnumerableOfMaintenanceLogQuery {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.authorId = _data["authorId"] !== undefined ? _data["authorId"] : null;
            this.logTypeId = _data["logTypeId"] !== undefined ? _data["logTypeId"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaintenanceLogViewPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["authorId"] = this.authorId !== undefined ? this.authorId : null;
        data["logTypeId"] = this.logTypeId !== undefined ? this.logTypeId : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfMaintenanceLogModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(MaintenanceLogModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfMaintenanceLogModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetAlarmsLogPaginatedQueryAndPaginatedEnumerableOfMaintenanceLogModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetAlarmsLogPaginatedQueryAndPaginatedEnumerableOfMaintenanceLogModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetAlarmsLogPaginatedQuery extends BaseQueryOfGetAlarmsLogPaginatedQueryAndPaginatedEnumerableOfMaintenanceLogModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["alarmIds"])) {
                this.alarmIds = [];
                for (let item of _data["alarmIds"])
                    this.alarmIds.push(item);
            }
            else {
                this.alarmIds = null;
            }
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlarmsLogPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.alarmIds)) {
            data["alarmIds"] = [];
            for (let item of this.alarmIds)
                data["alarmIds"].push(item);
        }
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfMaintenanceLogModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? MaintenanceLogModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfMaintenanceLogModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateMaintenanceLogCommand extends BaseCommandOfMaintenanceLogModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMaintenanceLogCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateMaintenanceLogCommand extends BaseCommandOfMaintenanceLogModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMaintenanceLogCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfManufacturerModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(ManufacturerModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfManufacturerModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetManufacturerListPaginatedQueryAndPaginatedEnumerableOfManufacturerModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetManufacturerListPaginatedQueryAndPaginatedEnumerableOfManufacturerModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetManufacturerListPaginatedQuery extends BaseQueryOfGetManufacturerListPaginatedQueryAndPaginatedEnumerableOfManufacturerModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.manufacturerTypeId = _data["manufacturerTypeId"] !== undefined ? _data["manufacturerTypeId"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["manufacturerTypeId"] = this.manufacturerTypeId !== undefined ? this.manufacturerTypeId : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class CreateManufacturerRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.manufacturerName = _data["manufacturerName"] !== undefined ? _data["manufacturerName"] : null;
            this.manufacturerTypeId = _data["manufacturerTypeId"] !== undefined ? _data["manufacturerTypeId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManufacturerRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["manufacturerTypeId"] = this.manufacturerTypeId !== undefined ? this.manufacturerTypeId : null;
        return data;
    }
}
export class PaginatedEnumerableOfModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(Model.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetModelListPaginatedQueryAndPaginatedEnumerableOfModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetModelListPaginatedQueryAndPaginatedEnumerableOfModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetModelListPaginatedQuery extends BaseQueryOfGetModelListPaginatedQueryAndPaginatedEnumerableOfModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetModelListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class CompanyNotificationSummaryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.emailNotificationSnapshot = _data["emailNotificationSnapshot"] ? NotificationSnapshotModel.fromJS(_data["emailNotificationSnapshot"]) : null;
            this.smsNotificationSnapshot = _data["smsNotificationSnapshot"] ? NotificationSnapshotModel.fromJS(_data["smsNotificationSnapshot"]) : null;
            this.notificationPreferences = _data["notificationPreferences"] ? CompanyNotificationPreferencesModel.fromJS(_data["notificationPreferences"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyNotificationSummaryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["emailNotificationSnapshot"] = this.emailNotificationSnapshot ? this.emailNotificationSnapshot.toJSON() : null;
        data["smsNotificationSnapshot"] = this.smsNotificationSnapshot ? this.smsNotificationSnapshot.toJSON() : null;
        data["notificationPreferences"] = this.notificationPreferences ? this.notificationPreferences.toJSON() : null;
        return data;
    }
}
export class NotificationSnapshotModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.snapshotId = _data["snapshotId"] !== undefined ? _data["snapshotId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.notificationChannelId = _data["notificationChannelId"] !== undefined ? _data["notificationChannelId"] : null;
            this.snapshotDate = _data["snapshotDate"] ? new Date(_data["snapshotDate"].toString()) : null;
            this.quotaUsed = _data["quotaUsed"] !== undefined ? _data["quotaUsed"] : null;
            this.numberOfEmails = _data["numberOfEmails"] !== undefined ? _data["numberOfEmails"] : null;
            this.lastAlarmEmailId = _data["lastAlarmEmailId"] !== undefined ? _data["lastAlarmEmailId"] : null;
            this.lastSystemSummaryEmailId = _data["lastSystemSummaryEmailId"] !== undefined ? _data["lastSystemSummaryEmailId"] : null;
            this.whenLastAlarmEmailCreated = _data["whenLastAlarmEmailCreated"] ? new Date(_data["whenLastAlarmEmailCreated"].toString()) : null;
            this.whenLastSystemSummaryEmailCreated = _data["whenLastSystemSummaryEmailCreated"] ? new Date(_data["whenLastSystemSummaryEmailCreated"].toString()) : null;
            this.whenLastResetLimits = _data["whenLastResetLimits"] ? new Date(_data["whenLastResetLimits"].toString()) : null;
            if (Array.isArray(_data["snapshotItems"])) {
                this.snapshotItems = [];
                for (let item of _data["snapshotItems"])
                    this.snapshotItems.push(NotificationSnapshotItemModel.fromJS(item));
            }
            else {
                this.snapshotItems = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSnapshotModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["snapshotId"] = this.snapshotId !== undefined ? this.snapshotId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["notificationChannelId"] = this.notificationChannelId !== undefined ? this.notificationChannelId : null;
        data["snapshotDate"] = this.snapshotDate ? this.snapshotDate.toISOString() : null;
        data["quotaUsed"] = this.quotaUsed !== undefined ? this.quotaUsed : null;
        data["numberOfEmails"] = this.numberOfEmails !== undefined ? this.numberOfEmails : null;
        data["lastAlarmEmailId"] = this.lastAlarmEmailId !== undefined ? this.lastAlarmEmailId : null;
        data["lastSystemSummaryEmailId"] = this.lastSystemSummaryEmailId !== undefined ? this.lastSystemSummaryEmailId : null;
        data["whenLastAlarmEmailCreated"] = this.whenLastAlarmEmailCreated ? this.whenLastAlarmEmailCreated.toISOString() : null;
        data["whenLastSystemSummaryEmailCreated"] = this.whenLastSystemSummaryEmailCreated ? this.whenLastSystemSummaryEmailCreated.toISOString() : null;
        data["whenLastResetLimits"] = this.whenLastResetLimits ? this.whenLastResetLimits.toISOString() : null;
        if (Array.isArray(this.snapshotItems)) {
            data["snapshotItems"] = [];
            for (let item of this.snapshotItems)
                data["snapshotItems"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class NotificationSnapshotItemModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.snapshotId = _data["snapshotId"] !== undefined ? _data["snapshotId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.notificationAddressId = _data["notificationAddressId"] !== undefined ? _data["notificationAddressId"] : null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null;
            this.notificationTypeId = _data["notificationTypeId"] !== undefined ? _data["notificationTypeId"] : null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null;
            this.quotaUsed = _data["quotaUsed"] !== undefined ? _data["quotaUsed"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSnapshotItemModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["snapshotId"] = this.snapshotId !== undefined ? this.snapshotId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["notificationAddressId"] = this.notificationAddressId !== undefined ? this.notificationAddressId : null;
        data["personId"] = this.personId !== undefined ? this.personId : null;
        data["notificationTypeId"] = this.notificationTypeId !== undefined ? this.notificationTypeId : null;
        data["priority"] = this.priority !== undefined ? this.priority : null;
        data["quotaUsed"] = this.quotaUsed !== undefined ? this.quotaUsed : null;
        return data;
    }
}
export class CompanyNotificationPreferencesModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.maxDailyAlarmEmailLimitPerSystem = _data["maxDailyAlarmEmailLimitPerSystem"] !== undefined ? _data["maxDailyAlarmEmailLimitPerSystem"] : null;
            this.maxDailyAlarmSmsLimitPerSystem = _data["maxDailyAlarmSmsLimitPerSystem"] !== undefined ? _data["maxDailyAlarmSmsLimitPerSystem"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyNotificationPreferencesModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["maxDailyAlarmEmailLimitPerSystem"] = this.maxDailyAlarmEmailLimitPerSystem !== undefined ? this.maxDailyAlarmEmailLimitPerSystem : null;
        data["maxDailyAlarmSmsLimitPerSystem"] = this.maxDailyAlarmSmsLimitPerSystem !== undefined ? this.maxDailyAlarmSmsLimitPerSystem : null;
        return data;
    }
}
export class BaseQueryOfGetArtificialNotificationAddressListQueryAndIListOfArtificialNotificationAddressModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetArtificialNotificationAddressListQueryAndIListOfArtificialNotificationAddressModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetArtificialNotificationAddressListQuery extends BaseQueryOfGetArtificialNotificationAddressListQueryAndIListOfArtificialNotificationAddressModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtificialNotificationAddressListQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfCompanyNotificationPreferencesModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? CompanyNotificationPreferencesModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfCompanyNotificationPreferencesModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpdateCompanyNotificationPreferencesCommand extends BaseCommandOfCompanyNotificationPreferencesModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyNotificationPreferencesCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfResetCompanyNotificationLimitsRequestModelAndCompanyNotificationSummaryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? ResetCompanyNotificationLimitsRequestModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfResetCompanyNotificationLimitsRequestModelAndCompanyNotificationSummaryModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class ResetCompanyNotificationLimitsCommand extends BaseCommandOfResetCompanyNotificationLimitsRequestModelAndCompanyNotificationSummaryModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ResetCompanyNotificationLimitsCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ResetCompanyNotificationLimitsRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.snapshotId = _data["snapshotId"] !== undefined ? _data["snapshotId"] : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
            this.companyPreferences = _data["companyPreferences"] ? CompanyNotificationPreferencesModel.fromJS(_data["companyPreferences"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ResetCompanyNotificationLimitsRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["snapshotId"] = this.snapshotId !== undefined ? this.snapshotId : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        data["companyPreferences"] = this.companyPreferences ? this.companyPreferences.toJSON() : null;
        return data;
    }
}
export class NotificationModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.notificationId = _data["notificationId"] !== undefined ? _data["notificationId"] : null;
            this.messageId = _data["messageId"] !== undefined ? _data["messageId"] : null;
            this.providerMessageId = _data["providerMessageId"] !== undefined ? _data["providerMessageId"] : null;
            this.notificationTypeId = _data["notificationTypeId"] !== undefined ? _data["notificationTypeId"] : null;
            this.notificationSubtypeId = _data["notificationSubtypeId"] !== undefined ? _data["notificationSubtypeId"] : null;
            this.notificationChannelId = _data["notificationChannelId"] !== undefined ? _data["notificationChannelId"] : null;
            this.notificationAddressId = _data["notificationAddressId"] !== undefined ? _data["notificationAddressId"] : null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.alarmId = _data["alarmId"] !== undefined ? _data["alarmId"] : null;
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null;
            this.destinationAddress = _data["destinationAddress"] !== undefined ? _data["destinationAddress"] : null;
            this.fromName = _data["fromName"] !== undefined ? _data["fromName"] : null;
            this.fromAddress = _data["fromAddress"] !== undefined ? _data["fromAddress"] : null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null;
            this.content = _data["content"] !== undefined ? _data["content"] : null;
            this.isSuccessful = _data["isSuccessful"] !== undefined ? _data["isSuccessful"] : null;
            this.isLastNofitication = _data["isLastNofitication"] !== undefined ? _data["isLastNofitication"] : null;
            this.providerStatus = _data["providerStatus"] !== undefined ? _data["providerStatus"] : null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null;
            this.numberOfAttempts = _data["numberOfAttempts"] !== undefined ? _data["numberOfAttempts"] : null;
            this.deliveryDelay = _data["deliveryDelay"] !== undefined ? _data["deliveryDelay"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : null;
            this.whenSent = _data["whenSent"] ? new Date(_data["whenSent"].toString()) : null;
            this.whenToSend = _data["whenToSend"] ? new Date(_data["whenToSend"].toString()) : null;
            this.whenAttempted = _data["whenAttempted"] ? new Date(_data["whenAttempted"].toString()) : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.notificationChannelName = _data["notificationChannelName"] !== undefined ? _data["notificationChannelName"] : null;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["notificationId"] = this.notificationId !== undefined ? this.notificationId : null;
        data["messageId"] = this.messageId !== undefined ? this.messageId : null;
        data["providerMessageId"] = this.providerMessageId !== undefined ? this.providerMessageId : null;
        data["notificationTypeId"] = this.notificationTypeId !== undefined ? this.notificationTypeId : null;
        data["notificationSubtypeId"] = this.notificationSubtypeId !== undefined ? this.notificationSubtypeId : null;
        data["notificationChannelId"] = this.notificationChannelId !== undefined ? this.notificationChannelId : null;
        data["notificationAddressId"] = this.notificationAddressId !== undefined ? this.notificationAddressId : null;
        data["personId"] = this.personId !== undefined ? this.personId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["alarmId"] = this.alarmId !== undefined ? this.alarmId : null;
        data["eventId"] = this.eventId !== undefined ? this.eventId : null;
        data["destinationAddress"] = this.destinationAddress !== undefined ? this.destinationAddress : null;
        data["fromName"] = this.fromName !== undefined ? this.fromName : null;
        data["fromAddress"] = this.fromAddress !== undefined ? this.fromAddress : null;
        data["subject"] = this.subject !== undefined ? this.subject : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["isSuccessful"] = this.isSuccessful !== undefined ? this.isSuccessful : null;
        data["isLastNofitication"] = this.isLastNofitication !== undefined ? this.isLastNofitication : null;
        data["providerStatus"] = this.providerStatus !== undefined ? this.providerStatus : null;
        data["priority"] = this.priority !== undefined ? this.priority : null;
        data["numberOfAttempts"] = this.numberOfAttempts !== undefined ? this.numberOfAttempts : null;
        data["deliveryDelay"] = this.deliveryDelay !== undefined ? this.deliveryDelay : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : null;
        data["whenSent"] = this.whenSent ? this.whenSent.toISOString() : null;
        data["whenToSend"] = this.whenToSend ? this.whenToSend.toISOString() : null;
        data["whenAttempted"] = this.whenAttempted ? this.whenAttempted.toISOString() : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["notificationChannelName"] = this.notificationChannelName !== undefined ? this.notificationChannelName : null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null;
        return data;
    }
}
export class PaginatedEnumerableOfNotificationModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(NotificationModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfNotificationModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetNotificationListPaginatedQueryAndPaginatedEnumerableOfNotificationModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetNotificationListPaginatedQueryAndPaginatedEnumerableOfNotificationModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetNotificationListPaginatedQuery extends BaseQueryOfGetNotificationListPaginatedQueryAndPaginatedEnumerableOfNotificationModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.channelId = _data["channelId"] !== undefined ? _data["channelId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.includeUnsent = _data["includeUnsent"] !== undefined ? _data["includeUnsent"] : null;
            this.whenCreatedFrom = _data["whenCreatedFrom"] ? new Date(_data["whenCreatedFrom"].toString()) : null;
            this.whenCreatedTo = _data["whenCreatedTo"] ? new Date(_data["whenCreatedTo"].toString()) : null;
            this.whenToSendFrom = _data["whenToSendFrom"] ? new Date(_data["whenToSendFrom"].toString()) : null;
            this.whenToSendTo = _data["whenToSendTo"] ? new Date(_data["whenToSendTo"].toString()) : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["channelId"] = this.channelId !== undefined ? this.channelId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["includeUnsent"] = this.includeUnsent !== undefined ? this.includeUnsent : null;
        data["whenCreatedFrom"] = this.whenCreatedFrom ? this.whenCreatedFrom.toISOString() : null;
        data["whenCreatedTo"] = this.whenCreatedTo ? this.whenCreatedTo.toISOString() : null;
        data["whenToSendFrom"] = this.whenToSendFrom ? this.whenToSendFrom.toISOString() : null;
        data["whenToSendTo"] = this.whenToSendTo ? this.whenToSendTo.toISOString() : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class RegionModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null;
            this.regionName = _data["regionName"] !== undefined ? _data["regionName"] : null;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RegionModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["regionName"] = this.regionName !== undefined ? this.regionName : null;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null;
        return data;
    }
}
export class PaginatedEnumerableOfRegionModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(RegionModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfRegionModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetRegionListPaginatedQueryAndPaginatedEnumerableOfRegionModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetRegionListPaginatedQueryAndPaginatedEnumerableOfRegionModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetRegionListPaginatedQuery extends BaseQueryOfGetRegionListPaginatedQueryAndPaginatedEnumerableOfRegionModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfRegionModelAndInteger {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? RegionModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfRegionModelAndInteger' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateRegionCommand extends BaseCommandOfRegionModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateRegionCommand extends BaseCommandOfRegionModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetSiteListQueryAndIListOfSiteModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSiteListQueryAndIListOfSiteModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSiteListQuery extends BaseQueryOfGetSiteListQueryAndIListOfSiteModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteListQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfSiteModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(SiteModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfSiteModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetSiteListPaginatedQueryAndPaginatedEnumerableOfSiteModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSiteListPaginatedQueryAndPaginatedEnumerableOfSiteModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSiteListPaginatedQuery extends BaseQueryOfGetSiteListPaginatedQueryAndPaginatedEnumerableOfSiteModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfSiteModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? SiteModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfSiteModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateSiteCommand extends BaseCommandOfSiteModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSiteCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateSiteCommand extends BaseCommandOfSiteModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSiteCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SiteArchiveImpactModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemsCount = _data["systemsCount"] !== undefined ? _data["systemsCount"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SiteArchiveImpactModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemsCount"] = this.systemsCount !== undefined ? this.systemsCount : null;
        return data;
    }
}
export class BaseQueryOfGetStringLifeStatusQueryAndStringLifeStatusModelBase {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetStringLifeStatusQueryAndStringLifeStatusModelBase' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetStringLifeStatusQuery extends BaseQueryOfGetStringLifeStatusQueryAndStringLifeStatusModelBase {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.batteryType = _data["batteryType"] !== undefined ? _data["batteryType"] : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
            this.ohmicRiseColumn1 = _data["ohmicRiseColumn1"] !== undefined ? _data["ohmicRiseColumn1"] : null;
            this.ohmicRiseColumn2 = _data["ohmicRiseColumn2"] !== undefined ? _data["ohmicRiseColumn2"] : null;
            this.ohmicRiseColumn3 = _data["ohmicRiseColumn3"] !== undefined ? _data["ohmicRiseColumn3"] : null;
            this.ohmicRiseColumn4 = _data["ohmicRiseColumn4"] !== undefined ? _data["ohmicRiseColumn4"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStringLifeStatusQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["batteryType"] = this.batteryType !== undefined ? this.batteryType : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        data["ohmicRiseColumn1"] = this.ohmicRiseColumn1 !== undefined ? this.ohmicRiseColumn1 : null;
        data["ohmicRiseColumn2"] = this.ohmicRiseColumn2 !== undefined ? this.ohmicRiseColumn2 : null;
        data["ohmicRiseColumn3"] = this.ohmicRiseColumn3 !== undefined ? this.ohmicRiseColumn3 : null;
        data["ohmicRiseColumn4"] = this.ohmicRiseColumn4 !== undefined ? this.ohmicRiseColumn4 : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetLatestStringSnapshotQueryAndStringSnapshotModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetLatestStringSnapshotQueryAndStringSnapshotModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetLatestStringSnapshotQuery extends BaseQueryOfGetLatestStringSnapshotQueryAndStringSnapshotModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestStringSnapshotQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetLatestStringSnapshotStatusQueryAndStringSnapshotStatusModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetLatestStringSnapshotStatusQueryAndStringSnapshotStatusModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetLatestStringSnapshotStatusQuery extends BaseQueryOfGetLatestStringSnapshotStatusQueryAndStringSnapshotStatusModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestStringSnapshotStatusQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetStringSnapshotsQueryAndIListOfStringSnapshotModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetStringSnapshotsQueryAndIListOfStringSnapshotModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetStringSnapshotsQuery extends BaseQueryOfGetStringSnapshotsQueryAndIListOfStringSnapshotModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
            this.measurementDate = _data["measurementDate"] ? new Date(_data["measurementDate"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStringSnapshotsQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        data["measurementDate"] = this.measurementDate ? this.measurementDate.toISOString() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetStringSnapshotsGroupedByTimestampQueryAndIListOfDateSnapshotModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetStringSnapshotsGroupedByTimestampQueryAndIListOfDateSnapshotModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetStringSnapshotsGroupedByTimestampQuery extends BaseQueryOfGetStringSnapshotsGroupedByTimestampQueryAndIListOfDateSnapshotModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.measurementDate = _data["measurementDate"] ? new Date(_data["measurementDate"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStringSnapshotsGroupedByTimestampQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["measurementDate"] = this.measurementDate ? this.measurementDate.toISOString() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetStringSnapshotChartQueryAndIListOfChart {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetStringSnapshotChartQueryAndIListOfChart' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetStringSnapshotChartQuery extends BaseQueryOfGetStringSnapshotChartQueryAndIListOfChart {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.measurementTime = _data["measurementTime"] ? new Date(_data["measurementTime"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStringSnapshotChartQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["measurementTime"] = this.measurementTime ? this.measurementTime.toISOString() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetStringSnapshotTableQueryAndIListOfStringSnapshotTableModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetStringSnapshotTableQueryAndIListOfStringSnapshotTableModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetStringSnapshotTableQuery extends BaseQueryOfGetStringSnapshotTableQueryAndIListOfStringSnapshotTableModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.measurementTime = _data["measurementTime"] ? new Date(_data["measurementTime"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStringSnapshotTableQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["measurementTime"] = this.measurementTime ? this.measurementTime.toISOString() : null;
        super.toJSON(data);
        return data;
    }
}
export class SystemSampleRateModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.sampleRate = _data["sampleRate"] !== undefined ? _data["sampleRate"] : null;
            this.samplePeriod = _data["samplePeriod"] !== undefined ? _data["samplePeriod"] : null;
            this.whenUpdatedSampleRateConfiguration = _data["whenUpdatedSampleRateConfiguration"] ? new Date(_data["whenUpdatedSampleRateConfiguration"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemSampleRateModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["sampleRate"] = this.sampleRate !== undefined ? this.sampleRate : null;
        data["samplePeriod"] = this.samplePeriod !== undefined ? this.samplePeriod : null;
        data["whenUpdatedSampleRateConfiguration"] = this.whenUpdatedSampleRateConfiguration ? this.whenUpdatedSampleRateConfiguration.toISOString() : null;
        return data;
    }
}
export class PaginatedEnumerableOfSystemQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(SystemQuery.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfSystemQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class SystemQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.authorId = _data["authorId"] !== undefined ? _data["authorId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null;
            this.manufacturerId = _data["manufacturerId"] !== undefined ? _data["manufacturerId"] : null;
            this.batteryTypeId = _data["batteryTypeId"] !== undefined ? _data["batteryTypeId"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null;
            this.systemCode = _data["systemCode"] !== undefined ? _data["systemCode"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.authorName = _data["authorName"] !== undefined ? _data["authorName"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : null;
            this.streetAddress1 = _data["streetAddress1"] !== undefined ? _data["streetAddress1"] : null;
            this.streetAddress2 = _data["streetAddress2"] !== undefined ? _data["streetAddress2"] : null;
            this.streetAddress3 = _data["streetAddress3"] !== undefined ? _data["streetAddress3"] : null;
            this.streetAddress4 = _data["streetAddress4"] !== undefined ? _data["streetAddress4"] : null;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null;
            this.manufacturerName = _data["manufacturerName"] !== undefined ? _data["manufacturerName"] : null;
            this.blockTypeName = _data["blockTypeName"] !== undefined ? _data["blockTypeName"] : null;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null;
            this.serialNumberKeywords = _data["serialNumberKeywords"] !== undefined ? _data["serialNumberKeywords"] : null;
            this.numberOfStrings = _data["numberOfStrings"] !== undefined ? _data["numberOfStrings"] : null;
            this.numberOfCriticalStrings = _data["numberOfCriticalStrings"] !== undefined ? _data["numberOfCriticalStrings"] : null;
            this.numberOfWarningStrings = _data["numberOfWarningStrings"] !== undefined ? _data["numberOfWarningStrings"] : null;
            this.numberOfBlocks = _data["numberOfBlocks"] !== undefined ? _data["numberOfBlocks"] : null;
            this.numberOfCriticalBlocks = _data["numberOfCriticalBlocks"] !== undefined ? _data["numberOfCriticalBlocks"] : null;
            this.numberOfWarningBlocks = _data["numberOfWarningBlocks"] !== undefined ? _data["numberOfWarningBlocks"] : null;
            this.numberOfCriticalAlarms = _data["numberOfCriticalAlarms"] !== undefined ? _data["numberOfCriticalAlarms"] : null;
            this.numberOfWarningAlarms = _data["numberOfWarningAlarms"] !== undefined ? _data["numberOfWarningAlarms"] : null;
            this.lastSignalStrength = _data["lastSignalStrength"] !== undefined ? _data["lastSignalStrength"] : null;
            this.numberOfDroppedConnections = _data["numberOfDroppedConnections"] !== undefined ? _data["numberOfDroppedConnections"] : null;
            this.cellularConnectionQuality = _data["cellularConnectionQuality"] !== undefined ? _data["cellularConnectionQuality"] : null;
            this.modemFirmwareVersion = _data["modemFirmwareVersion"] !== undefined ? _data["modemFirmwareVersion"] : null;
            this.monitorFirmwareVersion = _data["monitorFirmwareVersion"] !== undefined ? _data["monitorFirmwareVersion"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenManufactured = _data["whenManufactured"] ? new Date(_data["whenManufactured"].toString()) : null;
            this.whenLastInspected = _data["whenLastInspected"] ? new Date(_data["whenLastInspected"].toString()) : null;
            this.whenLastDataReceived = _data["whenLastDataReceived"] ? new Date(_data["whenLastDataReceived"].toString()) : null;
            this.whenLastComms = _data["whenLastComms"] ? new Date(_data["whenLastComms"].toString()) : null;
            this.lastCommsSourceId = _data["lastCommsSourceId"] !== undefined ? _data["lastCommsSourceId"] : null;
            this.whenFirstDataReceived = _data["whenFirstDataReceived"] ? new Date(_data["whenFirstDataReceived"].toString()) : null;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : null;
            this.ipAddress = _data["ipAddress"] !== undefined ? _data["ipAddress"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["authorId"] = this.authorId !== undefined ? this.authorId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null;
        data["personId"] = this.personId !== undefined ? this.personId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["batteryTypeId"] = this.batteryTypeId !== undefined ? this.batteryTypeId : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["systemCode"] = this.systemCode !== undefined ? this.systemCode : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["authorName"] = this.authorName !== undefined ? this.authorName : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : null;
        data["streetAddress1"] = this.streetAddress1 !== undefined ? this.streetAddress1 : null;
        data["streetAddress2"] = this.streetAddress2 !== undefined ? this.streetAddress2 : null;
        data["streetAddress3"] = this.streetAddress3 !== undefined ? this.streetAddress3 : null;
        data["streetAddress4"] = this.streetAddress4 !== undefined ? this.streetAddress4 : null;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["blockTypeName"] = this.blockTypeName !== undefined ? this.blockTypeName : null;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null;
        data["serialNumberKeywords"] = this.serialNumberKeywords !== undefined ? this.serialNumberKeywords : null;
        data["numberOfStrings"] = this.numberOfStrings !== undefined ? this.numberOfStrings : null;
        data["numberOfCriticalStrings"] = this.numberOfCriticalStrings !== undefined ? this.numberOfCriticalStrings : null;
        data["numberOfWarningStrings"] = this.numberOfWarningStrings !== undefined ? this.numberOfWarningStrings : null;
        data["numberOfBlocks"] = this.numberOfBlocks !== undefined ? this.numberOfBlocks : null;
        data["numberOfCriticalBlocks"] = this.numberOfCriticalBlocks !== undefined ? this.numberOfCriticalBlocks : null;
        data["numberOfWarningBlocks"] = this.numberOfWarningBlocks !== undefined ? this.numberOfWarningBlocks : null;
        data["numberOfCriticalAlarms"] = this.numberOfCriticalAlarms !== undefined ? this.numberOfCriticalAlarms : null;
        data["numberOfWarningAlarms"] = this.numberOfWarningAlarms !== undefined ? this.numberOfWarningAlarms : null;
        data["lastSignalStrength"] = this.lastSignalStrength !== undefined ? this.lastSignalStrength : null;
        data["numberOfDroppedConnections"] = this.numberOfDroppedConnections !== undefined ? this.numberOfDroppedConnections : null;
        data["cellularConnectionQuality"] = this.cellularConnectionQuality !== undefined ? this.cellularConnectionQuality : null;
        data["modemFirmwareVersion"] = this.modemFirmwareVersion !== undefined ? this.modemFirmwareVersion : null;
        data["monitorFirmwareVersion"] = this.monitorFirmwareVersion !== undefined ? this.monitorFirmwareVersion : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenManufactured"] = this.whenManufactured ? this.whenManufactured.toISOString() : null;
        data["whenLastInspected"] = this.whenLastInspected ? this.whenLastInspected.toISOString() : null;
        data["whenLastDataReceived"] = this.whenLastDataReceived ? this.whenLastDataReceived.toISOString() : null;
        data["whenLastComms"] = this.whenLastComms ? this.whenLastComms.toISOString() : null;
        data["lastCommsSourceId"] = this.lastCommsSourceId !== undefined ? this.lastCommsSourceId : null;
        data["whenFirstDataReceived"] = this.whenFirstDataReceived ? this.whenFirstDataReceived.toISOString() : null;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : null;
        data["ipAddress"] = this.ipAddress !== undefined ? this.ipAddress : null;
        return data;
    }
}
export class BaseQueryOfGetSystemCommunicationsViewPaginatedQueryAndPaginatedEnumerableOfSystemQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemCommunicationsViewPaginatedQueryAndPaginatedEnumerableOfSystemQuery' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemCommunicationsViewPaginatedQuery extends BaseQueryOfGetSystemCommunicationsViewPaginatedQueryAndPaginatedEnumerableOfSystemQuery {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemCommunicationsViewPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfSystemSampleRateModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? SystemSampleRateModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfSystemSampleRateModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpdateSystemSampleRateCommand extends BaseCommandOfSystemSampleRateModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSystemSampleRateCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class RequestControllerDataResponseModel extends DataTransferResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.apiRequest = _data["apiRequest"] ? ApiRequestModel.fromJS(_data["apiRequest"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RequestControllerDataResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["apiRequest"] = this.apiRequest ? this.apiRequest.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfRequestControllerDataRequestModelAndRequestControllerDataResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? RequestControllerDataRequestModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfRequestControllerDataRequestModelAndRequestControllerDataResponseModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class RequestControllerDataCommand extends BaseCommandOfRequestControllerDataRequestModelAndRequestControllerDataResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RequestControllerDataCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class RequestControllerDataRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RequestControllerDataRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        return data;
    }
}
export class ConnectivityTestLookupModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.matchedOn = _data["matchedOn"] !== undefined ? _data["matchedOn"] : null;
            if (Array.isArray(_data["results"])) {
                this.results = [];
                for (let item of _data["results"])
                    this.results.push(ConnectivityTestResultModel.fromJS(item));
            }
            else {
                this.results = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectivityTestLookupModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null;
        data["matchedOn"] = this.matchedOn !== undefined ? this.matchedOn : null;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export var ConnectivityTestLookupStatus;
(function (ConnectivityTestLookupStatus) {
    ConnectivityTestLookupStatus[ConnectivityTestLookupStatus["Invalid"] = 0] = "Invalid";
    ConnectivityTestLookupStatus[ConnectivityTestLookupStatus["NotReceived"] = 1] = "NotReceived";
    ConnectivityTestLookupStatus[ConnectivityTestLookupStatus["Ambiguous"] = 2] = "Ambiguous";
    ConnectivityTestLookupStatus[ConnectivityTestLookupStatus["Received"] = 3] = "Received";
})(ConnectivityTestLookupStatus || (ConnectivityTestLookupStatus = {}));
export var ConnectivityTestMatchedOn;
(function (ConnectivityTestMatchedOn) {
    ConnectivityTestMatchedOn[ConnectivityTestMatchedOn["Code"] = 0] = "Code";
    ConnectivityTestMatchedOn[ConnectivityTestMatchedOn["SerialNumber"] = 1] = "SerialNumber";
    ConnectivityTestMatchedOn[ConnectivityTestMatchedOn["ControllerName"] = 2] = "ControllerName";
})(ConnectivityTestMatchedOn || (ConnectivityTestMatchedOn = {}));
export class ConnectivityTestResultModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null;
            this.label = _data["label"] !== undefined ? _data["label"] : null;
            this.receivedAt = _data["receivedAt"] ? new Date(_data["receivedAt"].toString()) : null;
            this.processedAt = _data["processedAt"] ? new Date(_data["processedAt"].toString()) : null;
            this.isIncomplete = _data["isIncomplete"] !== undefined ? _data["isIncomplete"] : null;
            this.isTrusted = _data["isTrusted"] !== undefined ? _data["isTrusted"] : null;
            this.controllerSerialNumber = _data["controllerSerialNumber"] !== undefined ? _data["controllerSerialNumber"] : null;
            this.controllerName = _data["controllerName"] !== undefined ? _data["controllerName"] : null;
            this.controllerFacility = _data["controllerFacility"] !== undefined ? _data["controllerFacility"] : null;
            this.controllerCreatedAt = _data["controllerCreatedAt"] ? new Date(_data["controllerCreatedAt"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectivityTestResultModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null;
        data["label"] = this.label !== undefined ? this.label : null;
        data["receivedAt"] = this.receivedAt ? this.receivedAt.toISOString() : null;
        data["processedAt"] = this.processedAt ? this.processedAt.toISOString() : null;
        data["isIncomplete"] = this.isIncomplete !== undefined ? this.isIncomplete : null;
        data["isTrusted"] = this.isTrusted !== undefined ? this.isTrusted : null;
        data["controllerSerialNumber"] = this.controllerSerialNumber !== undefined ? this.controllerSerialNumber : null;
        data["controllerName"] = this.controllerName !== undefined ? this.controllerName : null;
        data["controllerFacility"] = this.controllerFacility !== undefined ? this.controllerFacility : null;
        data["controllerCreatedAt"] = this.controllerCreatedAt ? this.controllerCreatedAt.toISOString() : null;
        return data;
    }
}
export class BaseQueryOfGetConnectivityTestByIdentifierQueryAndConnectivityTestLookupModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetConnectivityTestByIdentifierQueryAndConnectivityTestLookupModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetConnectivityTestByIdentifierQuery extends BaseQueryOfGetConnectivityTestByIdentifierQueryAndConnectivityTestLookupModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.identifier = _data["identifier"] !== undefined ? _data["identifier"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetConnectivityTestByIdentifierQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier !== undefined ? this.identifier : null;
        super.toJSON(data);
        return data;
    }
}
export class GetComponentBySerialNumberResultModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.result = _data["result"] !== undefined ? _data["result"] : null;
            this.canBeAssignedToExistingSystem = _data["canBeAssignedToExistingSystem"] !== undefined ? _data["canBeAssignedToExistingSystem"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetComponentBySerialNumberResultModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["result"] = this.result !== undefined ? this.result : null;
        data["canBeAssignedToExistingSystem"] = this.canBeAssignedToExistingSystem !== undefined ? this.canBeAssignedToExistingSystem : null;
        return data;
    }
}
export var GetComponentBySerialNumberResultEnum;
(function (GetComponentBySerialNumberResultEnum) {
    GetComponentBySerialNumberResultEnum[GetComponentBySerialNumberResultEnum["NotFound"] = 0] = "NotFound";
    GetComponentBySerialNumberResultEnum[GetComponentBySerialNumberResultEnum["AssignedToCurrentSystem"] = 1] = "AssignedToCurrentSystem";
    GetComponentBySerialNumberResultEnum[GetComponentBySerialNumberResultEnum["AssignedToAnotherSystem"] = 2] = "AssignedToAnotherSystem";
    GetComponentBySerialNumberResultEnum[GetComponentBySerialNumberResultEnum["AssignedToPlaceholderSystem"] = 3] = "AssignedToPlaceholderSystem";
})(GetComponentBySerialNumberResultEnum || (GetComponentBySerialNumberResultEnum = {}));
export class BaseQueryOfGetComponentBySerialNumberQueryAndGetComponentBySerialNumberResultModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetComponentBySerialNumberQueryAndGetComponentBySerialNumberResultModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetComponentBySerialNumberQuery extends BaseQueryOfGetComponentBySerialNumberQueryAndGetComponentBySerialNumberResultModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetComponentBySerialNumberQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetSystemComponentViewListQueryAndIListOfSystemComponentQueryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemComponentViewListQueryAndIListOfSystemComponentQueryModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemComponentViewListQuery extends BaseQueryOfGetSystemComponentViewListQueryAndIListOfSystemComponentQueryModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentTypeId = _data["componentTypeId"] !== undefined ? _data["componentTypeId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemComponentViewListQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentTypeId"] = this.componentTypeId !== undefined ? this.componentTypeId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfSystemComponentModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? SystemComponentModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfSystemComponentModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateSystemComponentCommand extends BaseCommandOfSystemComponentModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSystemComponentCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateSystemComponentCommand extends BaseCommandOfSystemComponentModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSystemComponentCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfRegistrationKeyRequestModelAndRegistrationKeyResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? RegistrationKeyRequestModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfRegistrationKeyRequestModelAndRegistrationKeyResponseModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class RequestRegistrationKeyCommand extends BaseCommandOfRegistrationKeyRequestModelAndRegistrationKeyResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RequestRegistrationKeyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class RegistrationKeyRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationKeyRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        return data;
    }
}
export class SystemComponentTreeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            if (Array.isArray(_data["children"])) {
                this.children = [];
                for (let item of _data["children"])
                    this.children.push(SystemComponentQueryModel.fromJS(item));
            }
            else {
                this.children = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemComponentTreeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetSystemComponentTreeQueryAndSystemComponentTreeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemComponentTreeQueryAndSystemComponentTreeModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemComponentTreeQuery extends BaseQueryOfGetSystemComponentTreeQueryAndSystemComponentTreeModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.includeOrphans = _data["includeOrphans"] !== undefined ? _data["includeOrphans"] : null;
            if (Array.isArray(_data["componentTypes"])) {
                this.componentTypes = [];
                for (let item of _data["componentTypes"])
                    this.componentTypes.push(item);
            }
            else {
                this.componentTypes = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemComponentTreeQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["includeOrphans"] = this.includeOrphans !== undefined ? this.includeOrphans : null;
        if (Array.isArray(this.componentTypes)) {
            data["componentTypes"] = [];
            for (let item of this.componentTypes)
                data["componentTypes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfSystemComponentTreeNodeModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? SystemComponentTreeNodeModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfSystemComponentTreeNodeModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateSystemComponentTreeNodeCommand extends BaseCommandOfSystemComponentTreeNodeModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSystemComponentTreeNodeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SystemComponentTreeNodeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.parentComponentId = _data["parentComponentId"] !== undefined ? _data["parentComponentId"] : null;
            this.childComponentId = _data["childComponentId"] !== undefined ? _data["childComponentId"] : null;
            this.parentComponentCode = _data["parentComponentCode"] !== undefined ? _data["parentComponentCode"] : null;
            this.parentComponentName = _data["parentComponentName"] !== undefined ? _data["parentComponentName"] : null;
            this.childComponentCode = _data["childComponentCode"] !== undefined ? _data["childComponentCode"] : null;
            this.childComponentName = _data["childComponentName"] !== undefined ? _data["childComponentName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemComponentTreeNodeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["parentComponentId"] = this.parentComponentId !== undefined ? this.parentComponentId : null;
        data["childComponentId"] = this.childComponentId !== undefined ? this.childComponentId : null;
        data["parentComponentCode"] = this.parentComponentCode !== undefined ? this.parentComponentCode : null;
        data["parentComponentName"] = this.parentComponentName !== undefined ? this.parentComponentName : null;
        data["childComponentCode"] = this.childComponentCode !== undefined ? this.childComponentCode : null;
        data["childComponentName"] = this.childComponentName !== undefined ? this.childComponentName : null;
        return data;
    }
}
export class BaseCommandOfMoveSystemCoponentTreeNodeCommandAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? MoveSystemCoponentTreeNodeCommand.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfMoveSystemCoponentTreeNodeCommandAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class MoveSystemCoponentTreeNodeCommand extends BaseCommandOfMoveSystemCoponentTreeNodeCommandAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.parentComponentId = _data["parentComponentId"] !== undefined ? _data["parentComponentId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MoveSystemCoponentTreeNodeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["parentComponentId"] = this.parentComponentId !== undefined ? this.parentComponentId : null;
        super.toJSON(data);
        return data;
    }
}
export var Feature;
(function (Feature) {
    Feature[Feature["Authentication_LDAP"] = 0] = "Authentication_LDAP";
    Feature[Feature["Analytics_BlockPredictions"] = 1] = "Analytics_BlockPredictions";
    Feature[Feature["Address_View"] = 2] = "Address_View";
    Feature[Feature["Address_Create"] = 3] = "Address_Create";
    Feature[Feature["Address_Update"] = 4] = "Address_Update";
    Feature[Feature["Address_Delete"] = 5] = "Address_Delete";
    Feature[Feature["Address_Restore"] = 6] = "Address_Restore";
    Feature[Feature["Alarm_View"] = 7] = "Alarm_View";
    Feature[Feature["Alarm_Clear"] = 8] = "Alarm_Clear";
    Feature[Feature["Alarm_Acknowledge"] = 9] = "Alarm_Acknowledge";
    Feature[Feature["AlarmDefinition_View"] = 10] = "AlarmDefinition_View";
    Feature[Feature["AlarmDefinition_Create"] = 11] = "AlarmDefinition_Create";
    Feature[Feature["AlarmDefinition_Update"] = 12] = "AlarmDefinition_Update";
    Feature[Feature["AlarmDefinition_Delete"] = 13] = "AlarmDefinition_Delete";
    Feature[Feature["AlarmDefinition_Restore"] = 14] = "AlarmDefinition_Restore";
    Feature[Feature["AlarmEvent_View"] = 15] = "AlarmEvent_View";
    Feature[Feature["AlarmEvent_Create"] = 16] = "AlarmEvent_Create";
    Feature[Feature["AlarmEvent_Update"] = 17] = "AlarmEvent_Update";
    Feature[Feature["AlarmEventType_View"] = 18] = "AlarmEventType_View";
    Feature[Feature["AlarmEventType_Create"] = 19] = "AlarmEventType_Create";
    Feature[Feature["AlarmEventType_Update"] = 20] = "AlarmEventType_Update";
    Feature[Feature["AlarmEventType_Delete"] = 21] = "AlarmEventType_Delete";
    Feature[Feature["AlarmEventType_Restore"] = 22] = "AlarmEventType_Restore";
    Feature[Feature["AlarmType_View"] = 23] = "AlarmType_View";
    Feature[Feature["AlarmType_Create"] = 24] = "AlarmType_Create";
    Feature[Feature["AlarmType_Update"] = 25] = "AlarmType_Update";
    Feature[Feature["AlarmType_Delete"] = 26] = "AlarmType_Delete";
    Feature[Feature["AlarmType_Restore"] = 27] = "AlarmType_Restore";
    Feature[Feature["Application_View"] = 28] = "Application_View";
    Feature[Feature["Application_Create"] = 29] = "Application_Create";
    Feature[Feature["Application_Update"] = 30] = "Application_Update";
    Feature[Feature["Application_Delete"] = 31] = "Application_Delete";
    Feature[Feature["Application_Restore"] = 32] = "Application_Restore";
    Feature[Feature["Application_RotateKey"] = 33] = "Application_RotateKey";
    Feature[Feature["Audit_View"] = 34] = "Audit_View";
    Feature[Feature["BlockType_View"] = 35] = "BlockType_View";
    Feature[Feature["BlockType_Create"] = 36] = "BlockType_Create";
    Feature[Feature["BlockType_Update"] = 37] = "BlockType_Update";
    Feature[Feature["BlockType_Delete"] = 38] = "BlockType_Delete";
    Feature[Feature["BlockType_Restore"] = 39] = "BlockType_Restore";
    Feature[Feature["ComponentLimit_View"] = 40] = "ComponentLimit_View";
    Feature[Feature["ComponentLimit_Create"] = 41] = "ComponentLimit_Create";
    Feature[Feature["ComponentLimit_Update"] = 42] = "ComponentLimit_Update";
    Feature[Feature["ComponentLimit_Delete"] = 43] = "ComponentLimit_Delete";
    Feature[Feature["ComponentLimit_Restore"] = 44] = "ComponentLimit_Restore";
    Feature[Feature["ComponentType_View"] = 45] = "ComponentType_View";
    Feature[Feature["ComponentType_Create"] = 46] = "ComponentType_Create";
    Feature[Feature["ComponentType_Update"] = 47] = "ComponentType_Update";
    Feature[Feature["ComponentType_Delete"] = 48] = "ComponentType_Delete";
    Feature[Feature["ComponentType_Restore"] = 49] = "ComponentType_Restore";
    Feature[Feature["Company_View"] = 50] = "Company_View";
    Feature[Feature["Company_Create"] = 51] = "Company_Create";
    Feature[Feature["Company_Update"] = 52] = "Company_Update";
    Feature[Feature["Company_Delete"] = 53] = "Company_Delete";
    Feature[Feature["Company_Restore"] = 54] = "Company_Restore";
    Feature[Feature["CompanyEdition_View"] = 55] = "CompanyEdition_View";
    Feature[Feature["CompanyEdition_Update"] = 56] = "CompanyEdition_Update";
    Feature[Feature["CompanyServices_GetSettings"] = 57] = "CompanyServices_GetSettings";
    Feature[Feature["Comments_View"] = 58] = "Comments_View";
    Feature[Feature["Comments_Create"] = 59] = "Comments_Create";
    Feature[Feature["Comments_Update"] = 60] = "Comments_Update";
    Feature[Feature["Comments_Delete"] = 61] = "Comments_Delete";
    Feature[Feature["Comments_Restore"] = 62] = "Comments_Restore";
    Feature[Feature["Comms"] = 63] = "Comms";
    Feature[Feature["ContactGroup_View"] = 64] = "ContactGroup_View";
    Feature[Feature["ContactGroup_Create"] = 65] = "ContactGroup_Create";
    Feature[Feature["ContactGroup_Update"] = 66] = "ContactGroup_Update";
    Feature[Feature["ContactGroup_Delete"] = 67] = "ContactGroup_Delete";
    Feature[Feature["ContactGroup_Restore"] = 68] = "ContactGroup_Restore";
    Feature[Feature["DataGaps_View"] = 69] = "DataGaps_View";
    Feature[Feature["DataGaps_Configure"] = 70] = "DataGaps_Configure";
    Feature[Feature["DischargeEvent_View"] = 71] = "DischargeEvent_View";
    Feature[Feature["DischargeEvent_Create"] = 72] = "DischargeEvent_Create";
    Feature[Feature["DischargeEvent_Update"] = 73] = "DischargeEvent_Update";
    Feature[Feature["DischargeGraph"] = 74] = "DischargeGraph";
    Feature[Feature["Issue_View"] = 75] = "Issue_View";
    Feature[Feature["Issue_Create"] = 76] = "Issue_Create";
    Feature[Feature["Issue_Update"] = 77] = "Issue_Update";
    Feature[Feature["Issue_Delete"] = 78] = "Issue_Delete";
    Feature[Feature["Issue_Restore"] = 79] = "Issue_Restore";
    Feature[Feature["Issue_GetSuggestions"] = 80] = "Issue_GetSuggestions";
    Feature[Feature["Issue_GetSettings"] = 81] = "Issue_GetSettings";
    Feature[Feature["MeasurementType_View"] = 82] = "MeasurementType_View";
    Feature[Feature["MeasurementType_Create"] = 83] = "MeasurementType_Create";
    Feature[Feature["MeasurementType_Update"] = 84] = "MeasurementType_Update";
    Feature[Feature["MeasurementType_Delete"] = 85] = "MeasurementType_Delete";
    Feature[Feature["MeasurementType_Restore"] = 86] = "MeasurementType_Restore";
    Feature[Feature["MFA"] = 87] = "MFA";
    Feature[Feature["Notification_View"] = 88] = "Notification_View";
    Feature[Feature["Notification_SMS"] = 89] = "Notification_SMS";
    Feature[Feature["Notification_Email"] = 90] = "Notification_Email";
    Feature[Feature["Notification_Send"] = 91] = "Notification_Send";
    Feature[Feature["NotificationPreferences_ViewSummary"] = 92] = "NotificationPreferences_ViewSummary";
    Feature[Feature["NotificationPreferences_ListAddresses"] = 93] = "NotificationPreferences_ListAddresses";
    Feature[Feature["NotificationPreferences_Update"] = 94] = "NotificationPreferences_Update";
    Feature[Feature["NotificationPreferences_ResetLimits"] = 95] = "NotificationPreferences_ResetLimits";
    Feature[Feature["RealTime"] = 96] = "RealTime";
    Feature[Feature["Recaptcha"] = 97] = "Recaptcha";
    Feature[Feature["Region_View"] = 98] = "Region_View";
    Feature[Feature["Region_Create"] = 99] = "Region_Create";
    Feature[Feature["Region_Update"] = 100] = "Region_Update";
    Feature[Feature["Region_Delete"] = 101] = "Region_Delete";
    Feature[Feature["Report_Scheduling"] = 102] = "Report_Scheduling";
    Feature[Feature["Report_Permissions"] = 103] = "Report_Permissions";
    Feature[Feature["Report_View"] = 104] = "Report_View";
    Feature[Feature["Report_AssurePlus"] = 105] = "Report_AssurePlus";
    Feature[Feature["Report_BlockStatus"] = 106] = "Report_BlockStatus";
    Feature[Feature["Report_CompanySystems"] = 107] = "Report_CompanySystems";
    Feature[Feature["Report_Dashboard"] = 108] = "Report_Dashboard";
    Feature[Feature["Report_DischargeGraph"] = 109] = "Report_DischargeGraph";
    Feature[Feature["Report_DischargeDetailed"] = 110] = "Report_DischargeDetailed";
    Feature[Feature["Report_DischargeActivity"] = 111] = "Report_DischargeActivity";
    Feature[Feature["Report_BatteryReplacement"] = 112] = "Report_BatteryReplacement";
    Feature[Feature["Report_OhmicTrend"] = 113] = "Report_OhmicTrend";
    Feature[Feature["Report_SiteIssueSummary"] = 114] = "Report_SiteIssueSummary";
    Feature[Feature["Report_Issues"] = 115] = "Report_Issues";
    Feature[Feature["Report_StringStatus"] = 116] = "Report_StringStatus";
    Feature[Feature["Report_StringLife"] = 117] = "Report_StringLife";
    Feature[Feature["Report_TrendGraph"] = 118] = "Report_TrendGraph";
    Feature[Feature["Snapshot"] = 119] = "Snapshot";
    Feature[Feature["Site_View"] = 120] = "Site_View";
    Feature[Feature["Site_Create"] = 121] = "Site_Create";
    Feature[Feature["Site_Update"] = 122] = "Site_Update";
    Feature[Feature["Site_Delete"] = 123] = "Site_Delete";
    Feature[Feature["Site_Restore"] = 124] = "Site_Restore";
    Feature[Feature["SMTPImporter"] = 125] = "SMTPImporter";
    Feature[Feature["System_View"] = 126] = "System_View";
    Feature[Feature["System_Create"] = 127] = "System_Create";
    Feature[Feature["System_Update"] = 128] = "System_Update";
    Feature[Feature["System_Delete"] = 129] = "System_Delete";
    Feature[Feature["System_Restore"] = 130] = "System_Restore";
    Feature[Feature["TrendGraph"] = 131] = "TrendGraph";
    Feature[Feature["User_View"] = 132] = "User_View";
    Feature[Feature["User_Create"] = 133] = "User_Create";
    Feature[Feature["User_Update"] = 134] = "User_Update";
    Feature[Feature["User_Delete"] = 135] = "User_Delete";
    Feature[Feature["User_Restore"] = 136] = "User_Restore";
    Feature[Feature["User_LockUnlock"] = 137] = "User_LockUnlock";
    Feature[Feature["UserCompanyAccess_View"] = 138] = "UserCompanyAccess_View";
    Feature[Feature["UserCompanyAccess_Create"] = 139] = "UserCompanyAccess_Create";
    Feature[Feature["UserCompanyAccess_Update"] = 140] = "UserCompanyAccess_Update";
    Feature[Feature["UserCompanyAccess_Delete"] = 141] = "UserCompanyAccess_Delete";
    Feature[Feature["System_ImportFromZip"] = 142] = "System_ImportFromZip";
    Feature[Feature["UserGroup_Manage"] = 143] = "UserGroup_Manage";
})(Feature || (Feature = {}));
export class SystemStatesModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.totalNumberOfSystems = _data["totalNumberOfSystems"] !== undefined ? _data["totalNumberOfSystems"] : null;
            this.totalNumberOfGeoMappedSystems = _data["totalNumberOfGeoMappedSystems"] !== undefined ? _data["totalNumberOfGeoMappedSystems"] : null;
            this.totalNumberOfCriticalSystems = _data["totalNumberOfCriticalSystems"] !== undefined ? _data["totalNumberOfCriticalSystems"] : null;
            this.totalNumberOfWarningSystems = _data["totalNumberOfWarningSystems"] !== undefined ? _data["totalNumberOfWarningSystems"] : null;
            this.totalNumberOfHealthySystems = _data["totalNumberOfHealthySystems"] !== undefined ? _data["totalNumberOfHealthySystems"] : null;
            this.totalNumberOfUnknownSystems = _data["totalNumberOfUnknownSystems"] !== undefined ? _data["totalNumberOfUnknownSystems"] : null;
            if (Array.isArray(_data["systems"])) {
                this.systems = [];
                for (let item of _data["systems"])
                    this.systems.push(SystemStatusModel.fromJS(item));
            }
            else {
                this.systems = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemStatesModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["totalNumberOfSystems"] = this.totalNumberOfSystems !== undefined ? this.totalNumberOfSystems : null;
        data["totalNumberOfGeoMappedSystems"] = this.totalNumberOfGeoMappedSystems !== undefined ? this.totalNumberOfGeoMappedSystems : null;
        data["totalNumberOfCriticalSystems"] = this.totalNumberOfCriticalSystems !== undefined ? this.totalNumberOfCriticalSystems : null;
        data["totalNumberOfWarningSystems"] = this.totalNumberOfWarningSystems !== undefined ? this.totalNumberOfWarningSystems : null;
        data["totalNumberOfHealthySystems"] = this.totalNumberOfHealthySystems !== undefined ? this.totalNumberOfHealthySystems : null;
        data["totalNumberOfUnknownSystems"] = this.totalNumberOfUnknownSystems !== undefined ? this.totalNumberOfUnknownSystems : null;
        if (Array.isArray(this.systems)) {
            data["systems"] = [];
            for (let item of this.systems)
                data["systems"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class SystemStatusModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.addressName = _data["addressName"] !== undefined ? _data["addressName"] : null;
            this.streetAddress1 = _data["streetAddress1"] !== undefined ? _data["streetAddress1"] : null;
            this.streetAddress2 = _data["streetAddress2"] !== undefined ? _data["streetAddress2"] : null;
            this.streetAddress3 = _data["streetAddress3"] !== undefined ? _data["streetAddress3"] : null;
            this.streetAddress4 = _data["streetAddress4"] !== undefined ? _data["streetAddress4"] : null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null;
            this.numberOfCriticalAlarmsAck = _data["numberOfCriticalAlarmsAck"] !== undefined ? _data["numberOfCriticalAlarmsAck"] : null;
            this.numberOfWarningAlarmsAck = _data["numberOfWarningAlarmsAck"] !== undefined ? _data["numberOfWarningAlarmsAck"] : null;
            this.numberOfCriticalAlarmsNack = _data["numberOfCriticalAlarmsNack"] !== undefined ? _data["numberOfCriticalAlarmsNack"] : null;
            this.numberOfWarningAlarmsNack = _data["numberOfWarningAlarmsNack"] !== undefined ? _data["numberOfWarningAlarmsNack"] : null;
            this.hasRealTime = _data["hasRealTime"] !== undefined ? _data["hasRealTime"] : null;
            this.batteryTypeId = _data["batteryTypeId"] !== undefined ? _data["batteryTypeId"] : null;
            this.hasAlarms = _data["hasAlarms"] !== undefined ? _data["hasAlarms"] : null;
            this.hasCriticalAlarms = _data["hasCriticalAlarms"] !== undefined ? _data["hasCriticalAlarms"] : null;
            this.hasWarningAlarms = _data["hasWarningAlarms"] !== undefined ? _data["hasWarningAlarms"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemStatusModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["addressName"] = this.addressName !== undefined ? this.addressName : null;
        data["streetAddress1"] = this.streetAddress1 !== undefined ? this.streetAddress1 : null;
        data["streetAddress2"] = this.streetAddress2 !== undefined ? this.streetAddress2 : null;
        data["streetAddress3"] = this.streetAddress3 !== undefined ? this.streetAddress3 : null;
        data["streetAddress4"] = this.streetAddress4 !== undefined ? this.streetAddress4 : null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null;
        data["numberOfCriticalAlarmsAck"] = this.numberOfCriticalAlarmsAck !== undefined ? this.numberOfCriticalAlarmsAck : null;
        data["numberOfWarningAlarmsAck"] = this.numberOfWarningAlarmsAck !== undefined ? this.numberOfWarningAlarmsAck : null;
        data["numberOfCriticalAlarmsNack"] = this.numberOfCriticalAlarmsNack !== undefined ? this.numberOfCriticalAlarmsNack : null;
        data["numberOfWarningAlarmsNack"] = this.numberOfWarningAlarmsNack !== undefined ? this.numberOfWarningAlarmsNack : null;
        data["hasRealTime"] = this.hasRealTime !== undefined ? this.hasRealTime : null;
        data["batteryTypeId"] = this.batteryTypeId !== undefined ? this.batteryTypeId : null;
        data["hasAlarms"] = this.hasAlarms !== undefined ? this.hasAlarms : null;
        data["hasCriticalAlarms"] = this.hasCriticalAlarms !== undefined ? this.hasCriticalAlarms : null;
        data["hasWarningAlarms"] = this.hasWarningAlarms !== undefined ? this.hasWarningAlarms : null;
        return data;
    }
}
export class SystemStatesByStringModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.batteryTypeId = _data["batteryTypeId"] !== undefined ? _data["batteryTypeId"] : null;
            this.isSystemOffline = _data["isSystemOffline"] !== undefined ? _data["isSystemOffline"] : null;
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
            this.stringName = _data["stringName"] !== undefined ? _data["stringName"] : null;
            this.stringCode = _data["stringCode"] !== undefined ? _data["stringCode"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null;
            this.numberOfHealthyBlocks = _data["numberOfHealthyBlocks"] !== undefined ? _data["numberOfHealthyBlocks"] : null;
            this.numberOfCriticalAlarmsAck = _data["numberOfCriticalAlarmsAck"] !== undefined ? _data["numberOfCriticalAlarmsAck"] : null;
            this.numberOfWarningAlarmsAck = _data["numberOfWarningAlarmsAck"] !== undefined ? _data["numberOfWarningAlarmsAck"] : null;
            this.numberOfCriticalAlarmsNack = _data["numberOfCriticalAlarmsNack"] !== undefined ? _data["numberOfCriticalAlarmsNack"] : null;
            this.numberOfWarningAlarmsNack = _data["numberOfWarningAlarmsNack"] !== undefined ? _data["numberOfWarningAlarmsNack"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemStatesByStringModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["batteryTypeId"] = this.batteryTypeId !== undefined ? this.batteryTypeId : null;
        data["isSystemOffline"] = this.isSystemOffline !== undefined ? this.isSystemOffline : null;
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        data["stringName"] = this.stringName !== undefined ? this.stringName : null;
        data["stringCode"] = this.stringCode !== undefined ? this.stringCode : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null;
        data["numberOfHealthyBlocks"] = this.numberOfHealthyBlocks !== undefined ? this.numberOfHealthyBlocks : null;
        data["numberOfCriticalAlarmsAck"] = this.numberOfCriticalAlarmsAck !== undefined ? this.numberOfCriticalAlarmsAck : null;
        data["numberOfWarningAlarmsAck"] = this.numberOfWarningAlarmsAck !== undefined ? this.numberOfWarningAlarmsAck : null;
        data["numberOfCriticalAlarmsNack"] = this.numberOfCriticalAlarmsNack !== undefined ? this.numberOfCriticalAlarmsNack : null;
        data["numberOfWarningAlarmsNack"] = this.numberOfWarningAlarmsNack !== undefined ? this.numberOfWarningAlarmsNack : null;
        return data;
    }
}
export class BaseQueryOfGetSystemViewPaginatedQueryAndPaginatedEnumerableOfSystemQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemViewPaginatedQueryAndPaginatedEnumerableOfSystemQuery' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemViewPaginatedQuery extends BaseQueryOfGetSystemViewPaginatedQueryAndPaginatedEnumerableOfSystemQuery {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.city = _data["city"] !== undefined ? _data["city"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.showUnhealthyOnly = _data["showUnhealthyOnly"] !== undefined ? _data["showUnhealthyOnly"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemViewPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["showUnhealthyOnly"] = this.showUnhealthyOnly !== undefined ? this.showUnhealthyOnly : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfCreateSystemCommandModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? CreateSystemCommandModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfCreateSystemCommandModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateSystemCommand extends BaseCommandOfCreateSystemCommandModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSystemCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class CreateSystemCommandModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.system = _data["system"] ? SystemModel.fromJS(_data["system"]) : null;
            this.createController = _data["createController"] !== undefined ? _data["createController"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSystemCommandModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["system"] = this.system ? this.system.toJSON() : null;
        data["createController"] = this.createController !== undefined ? this.createController : null;
        return data;
    }
}
export class BaseCommandOfCreateSystemCommandModelAndRegisterSystemResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? CreateSystemCommandModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfCreateSystemCommandModelAndRegisterSystemResponseModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class RegisterSystemCommand extends BaseCommandOfCreateSystemCommandModelAndRegisterSystemResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterSystemCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfSystemModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? SystemModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfSystemModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpdateSystemCommand extends BaseCommandOfSystemModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSystemCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetBatteryDashboardPDFReportQueryAndByteOf {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetBatteryDashboardPDFReportQueryAndByteOf' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetBatteryDashboardPDFReportQuery extends BaseQueryOfGetBatteryDashboardPDFReportQueryAndByteOf {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.currentTimezoneOffset = _data["currentTimezoneOffset"] !== undefined ? _data["currentTimezoneOffset"] : null;
            this.startTimezoneOffset = _data["startTimezoneOffset"] !== undefined ? _data["startTimezoneOffset"] : null;
            if (Array.isArray(_data["companyIds"])) {
                this.companyIds = [];
                for (let item of _data["companyIds"])
                    this.companyIds.push(item);
            }
            else {
                this.companyIds = null;
            }
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.hideSiteName = _data["hideSiteName"] !== undefined ? _data["hideSiteName"] : null;
            this.recentAlarmsPeriod = _data["recentAlarmsPeriod"] !== undefined ? _data["recentAlarmsPeriod"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBatteryDashboardPDFReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["currentTimezoneOffset"] = this.currentTimezoneOffset !== undefined ? this.currentTimezoneOffset : null;
        data["startTimezoneOffset"] = this.startTimezoneOffset !== undefined ? this.startTimezoneOffset : null;
        if (Array.isArray(this.companyIds)) {
            data["companyIds"] = [];
            for (let item of this.companyIds)
                data["companyIds"].push(item);
        }
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["hideSiteName"] = this.hideSiteName !== undefined ? this.hideSiteName : null;
        data["recentAlarmsPeriod"] = this.recentAlarmsPeriod !== undefined ? this.recentAlarmsPeriod : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetBatteryDashboardCSVReportQueryAndBatteryDashboardReport {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetBatteryDashboardCSVReportQueryAndBatteryDashboardReport' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetBatteryDashboardCSVReportQuery extends BaseQueryOfGetBatteryDashboardCSVReportQueryAndBatteryDashboardReport {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.currentTimezoneOffset = _data["currentTimezoneOffset"] !== undefined ? _data["currentTimezoneOffset"] : null;
            this.startTimezoneOffset = _data["startTimezoneOffset"] !== undefined ? _data["startTimezoneOffset"] : null;
            if (Array.isArray(_data["companyIds"])) {
                this.companyIds = [];
                for (let item of _data["companyIds"])
                    this.companyIds.push(item);
            }
            else {
                this.companyIds = null;
            }
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.hideSiteName = _data["hideSiteName"] !== undefined ? _data["hideSiteName"] : null;
            this.recentAlarmsPeriod = _data["recentAlarmsPeriod"] !== undefined ? _data["recentAlarmsPeriod"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBatteryDashboardCSVReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["currentTimezoneOffset"] = this.currentTimezoneOffset !== undefined ? this.currentTimezoneOffset : null;
        data["startTimezoneOffset"] = this.startTimezoneOffset !== undefined ? this.startTimezoneOffset : null;
        if (Array.isArray(this.companyIds)) {
            data["companyIds"] = [];
            for (let item of this.companyIds)
                data["companyIds"].push(item);
        }
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["hideSiteName"] = this.hideSiteName !== undefined ? this.hideSiteName : null;
        data["recentAlarmsPeriod"] = this.recentAlarmsPeriod !== undefined ? this.recentAlarmsPeriod : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfSystemAttachmentsModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? SystemAttachmentsModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfSystemAttachmentsModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UploadSystemAttachmentsCommand extends BaseCommandOfSystemAttachmentsModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadSystemAttachmentsCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SystemAttachmentsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [];
                for (let item of _data["attachments"])
                    this.attachments.push(SystemAttachmentModel.fromJS(item));
            }
            else {
                this.attachments = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemAttachmentsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class SystemAttachmentModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemAttachmentId = _data["systemAttachmentId"] !== undefined ? _data["systemAttachmentId"] : null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : null;
            this.fileData = _data["fileData"] !== undefined ? _data["fileData"] : null;
            this.fileSize = _data["fileSize"] !== undefined ? _data["fileSize"] : null;
            this.uploadedAt = _data["uploadedAt"] ? new Date(_data["uploadedAt"].toString()) : null;
            this.uploadedBy = _data["uploadedBy"] !== undefined ? _data["uploadedBy"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemAttachmentModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemAttachmentId"] = this.systemAttachmentId !== undefined ? this.systemAttachmentId : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["fileType"] = this.fileType !== undefined ? this.fileType : null;
        data["fileData"] = this.fileData !== undefined ? this.fileData : null;
        data["fileSize"] = this.fileSize !== undefined ? this.fileSize : null;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : null;
        data["uploadedBy"] = this.uploadedBy !== undefined ? this.uploadedBy : null;
        return data;
    }
}
export class PreviewControllerImportResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null;
            this.stagingId = _data["stagingId"] !== undefined ? _data["stagingId"] : null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            else {
                this.errors = null;
            }
            this.errorReference = _data["errorReference"] !== undefined ? _data["errorReference"] : null;
            this.existingSystemFound = _data["existingSystemFound"] !== undefined ? _data["existingSystemFound"] : null;
            this.existingSystemInDifferentLocation = _data["existingSystemInDifferentLocation"] !== undefined ? _data["existingSystemInDifferentLocation"] : null;
            this.existingSystem = _data["existingSystem"] ? ExistingSystemInfo.fromJS(_data["existingSystem"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewControllerImportResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null;
        data["stagingId"] = this.stagingId !== undefined ? this.stagingId : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["errorReference"] = this.errorReference !== undefined ? this.errorReference : null;
        data["existingSystemFound"] = this.existingSystemFound !== undefined ? this.existingSystemFound : null;
        data["existingSystemInDifferentLocation"] = this.existingSystemInDifferentLocation !== undefined ? this.existingSystemInDifferentLocation : null;
        data["existingSystem"] = this.existingSystem ? this.existingSystem.toJSON() : null;
        return data;
    }
}
export class ExistingSystemInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExistingSystemInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        return data;
    }
}
export class BaseCommandOfPreviewControllerImportRequestModelAndPreviewControllerImportResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? PreviewControllerImportRequestModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfPreviewControllerImportRequestModelAndPreviewControllerImportResponseModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class PreviewControllerImportCommand extends BaseCommandOfPreviewControllerImportRequestModelAndPreviewControllerImportResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewControllerImportCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class PreviewControllerImportRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.zipFileBase64 = _data["zipFileBase64"] !== undefined ? _data["zipFileBase64"] : null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewControllerImportRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["zipFileBase64"] = this.zipFileBase64 !== undefined ? this.zipFileBase64 : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        return data;
    }
}
export class EnqueueControllerImportResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null;
            this.progressMessageId = _data["progressMessageId"] !== undefined ? _data["progressMessageId"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            else {
                this.errors = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EnqueueControllerImportResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null;
        data["progressMessageId"] = this.progressMessageId !== undefined ? this.progressMessageId : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}
export class BaseCommandOfEnqueueControllerImportRequestModelAndEnqueueControllerImportResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? EnqueueControllerImportRequestModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfEnqueueControllerImportRequestModelAndEnqueueControllerImportResponseModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class EnqueueControllerImportCommand extends BaseCommandOfEnqueueControllerImportRequestModelAndEnqueueControllerImportResponseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EnqueueControllerImportCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class EnqueueControllerImportRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            if (Array.isArray(_data["files"])) {
                this.files = [];
                for (let item of _data["files"])
                    this.files.push(EnqueueControllerImportFileModel.fromJS(item));
            }
            else {
                this.files = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EnqueueControllerImportRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class EnqueueControllerImportFileModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.stagingId = _data["stagingId"] !== undefined ? _data["stagingId"] : null;
            this.archiveExistingSystem = _data["archiveExistingSystem"] !== undefined ? _data["archiveExistingSystem"] : null;
            this.overrideExistingSystem = _data["overrideExistingSystem"] !== undefined ? _data["overrideExistingSystem"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EnqueueControllerImportFileModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["stagingId"] = this.stagingId !== undefined ? this.stagingId : null;
        data["archiveExistingSystem"] = this.archiveExistingSystem !== undefined ? this.archiveExistingSystem : null;
        data["overrideExistingSystem"] = this.overrideExistingSystem !== undefined ? this.overrideExistingSystem : null;
        return data;
    }
}
export class BaseQueryOfGetSystemSnapshotChartQueryAndIListOfChart {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemSnapshotChartQueryAndIListOfChart' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemSnapshotChartQuery extends BaseQueryOfGetSystemSnapshotChartQueryAndIListOfChart {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.measurementTime = _data["measurementTime"] ? new Date(_data["measurementTime"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemSnapshotChartQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["measurementTime"] = this.measurementTime ? this.measurementTime.toISOString() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetSystemSnapshotCSVReportQueryAndStringSnapshotCSVReport {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemSnapshotCSVReportQueryAndStringSnapshotCSVReport' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemSnapshotCSVReportQuery extends BaseQueryOfGetSystemSnapshotCSVReportQueryAndStringSnapshotCSVReport {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.timezoneOffSet = _data["timezoneOffSet"] !== undefined ? _data["timezoneOffSet"] : null;
            this.currentTimezoneOffSet = _data["currentTimezoneOffSet"] !== undefined ? _data["currentTimezoneOffSet"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.measurementTime = _data["measurementTime"] ? new Date(_data["measurementTime"].toString()) : null;
            this.realTimeData = _data["realTimeData"] !== undefined ? _data["realTimeData"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemSnapshotCSVReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["timezoneOffSet"] = this.timezoneOffSet !== undefined ? this.timezoneOffSet : null;
        data["currentTimezoneOffSet"] = this.currentTimezoneOffSet !== undefined ? this.currentTimezoneOffSet : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["measurementTime"] = this.measurementTime ? this.measurementTime.toISOString() : null;
        data["realTimeData"] = this.realTimeData !== undefined ? this.realTimeData : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetSystemSnapshotPDFReportQueryAndByteOf {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemSnapshotPDFReportQueryAndByteOf' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemSnapshotPDFReportQuery extends BaseQueryOfGetSystemSnapshotPDFReportQueryAndByteOf {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.timezoneOffSet = _data["timezoneOffSet"] !== undefined ? _data["timezoneOffSet"] : null;
            this.reportTimezoneOffSet = _data["reportTimezoneOffSet"] !== undefined ? _data["reportTimezoneOffSet"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.measurementTime = _data["measurementTime"] ? new Date(_data["measurementTime"].toString()) : null;
            this.tables = _data["tables"] !== undefined ? _data["tables"] : null;
            this.alarms = _data["alarms"] !== undefined ? _data["alarms"] : null;
            this.limits = _data["limits"] !== undefined ? _data["limits"] : null;
            if (Array.isArray(_data["stringIds"])) {
                this.stringIds = [];
                for (let item of _data["stringIds"])
                    this.stringIds.push(item);
            }
            else {
                this.stringIds = null;
            }
            this.realTimeData = _data["realTimeData"] !== undefined ? _data["realTimeData"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemSnapshotPDFReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["timezoneOffSet"] = this.timezoneOffSet !== undefined ? this.timezoneOffSet : null;
        data["reportTimezoneOffSet"] = this.reportTimezoneOffSet !== undefined ? this.reportTimezoneOffSet : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["measurementTime"] = this.measurementTime ? this.measurementTime.toISOString() : null;
        data["tables"] = this.tables !== undefined ? this.tables : null;
        data["alarms"] = this.alarms !== undefined ? this.alarms : null;
        data["limits"] = this.limits !== undefined ? this.limits : null;
        if (Array.isArray(this.stringIds)) {
            data["stringIds"] = [];
            for (let item of this.stringIds)
                data["stringIds"].push(item);
        }
        data["realTimeData"] = this.realTimeData !== undefined ? this.realTimeData : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetPointInTimeSystemStatusQueryAndIListOfPointInTimeStatusModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetPointInTimeSystemStatusQueryAndIListOfPointInTimeStatusModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetPointInTimeSystemStatusQuery extends BaseQueryOfGetPointInTimeSystemStatusQueryAndIListOfPointInTimeStatusModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            if (Array.isArray(_data["componentIds"])) {
                this.componentIds = [];
                for (let item of _data["componentIds"])
                    this.componentIds.push(item);
            }
            else {
                this.componentIds = null;
            }
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null;
            this.componentStatusStategy = _data["componentStatusStategy"] !== undefined ? _data["componentStatusStategy"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPointInTimeSystemStatusQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        if (Array.isArray(this.componentIds)) {
            data["componentIds"] = [];
            for (let item of this.componentIds)
                data["componentIds"].push(item);
        }
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null;
        data["componentStatusStategy"] = this.componentStatusStategy !== undefined ? this.componentStatusStategy : null;
        super.toJSON(data);
        return data;
    }
}
export class TimeseriesChart extends Chart {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.displayUnit = _data["displayUnit"] !== undefined ? _data["displayUnit"] : null;
            this.showMarkers = _data["showMarkers"] !== undefined ? _data["showMarkers"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TimeseriesChart();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayUnit"] = this.displayUnit !== undefined ? this.displayUnit : null;
        data["showMarkers"] = this.showMarkers !== undefined ? this.showMarkers : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetSystemTrendChartQueryAndTimeseriesChart {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemTrendChartQueryAndTimeseriesChart' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemTrendChartQuery extends BaseQueryOfGetSystemTrendChartQueryAndTimeseriesChart {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.forFeature = _data["forFeature"] !== undefined ? _data["forFeature"] : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
            this.currentTimezoneOffset = _data["currentTimezoneOffset"] !== undefined ? _data["currentTimezoneOffset"] : null;
            if (Array.isArray(_data["axes"])) {
                this.axes = [];
                for (let item of _data["axes"])
                    this.axes.push(GetSystemTrendChartQueryModel.fromJS(item));
            }
            else {
                this.axes = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemTrendChartQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["forFeature"] = this.forFeature !== undefined ? this.forFeature : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        data["currentTimezoneOffset"] = this.currentTimezoneOffset !== undefined ? this.currentTimezoneOffset : null;
        if (Array.isArray(this.axes)) {
            data["axes"] = [];
            for (let item of this.axes)
                data["axes"].push(item ? item.toJSON() : null);
        }
        super.toJSON(data);
        return data;
    }
}
export class GetSystemTrendChartQueryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.measurementTypeId = _data["measurementTypeId"] !== undefined ? _data["measurementTypeId"] : null;
            this.measurementTypeName = _data["measurementTypeName"] !== undefined ? _data["measurementTypeName"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
            this.alarmGroupId = _data["alarmGroupId"] !== undefined ? _data["alarmGroupId"] : null;
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [];
                for (let item of _data["nodes"])
                    this.nodes.push(item);
            }
            else {
                this.nodes = null;
            }
            this.dataSource = _data["dataSource"] !== undefined ? _data["dataSource"] : null;
            this.limitQuery = _data["limitQuery"] ? GetSystemTrendChartLimitQueryModel.fromJS(_data["limitQuery"]) : null;
            this.snapshotDayInterval = _data["snapshotDayInterval"] !== undefined ? _data["snapshotDayInterval"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemTrendChartQueryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["measurementTypeId"] = this.measurementTypeId !== undefined ? this.measurementTypeId : null;
        data["measurementTypeName"] = this.measurementTypeName !== undefined ? this.measurementTypeName : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        data["alarmGroupId"] = this.alarmGroupId !== undefined ? this.alarmGroupId : null;
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item);
        }
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null;
        data["limitQuery"] = this.limitQuery ? this.limitQuery.toJSON() : null;
        data["snapshotDayInterval"] = this.snapshotDayInterval !== undefined ? this.snapshotDayInterval : null;
        return data;
    }
}
export var MeasurementDataSourceEnum;
(function (MeasurementDataSourceEnum) {
    MeasurementDataSourceEnum[MeasurementDataSourceEnum["Snapshot"] = 0] = "Snapshot";
    MeasurementDataSourceEnum[MeasurementDataSourceEnum["Measurement"] = 1] = "Measurement";
})(MeasurementDataSourceEnum || (MeasurementDataSourceEnum = {}));
export class GetSystemTrendChartLimitQueryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.nodeId = _data["nodeId"] !== undefined ? _data["nodeId"] : null;
            this.stringStatusId = _data["stringStatusId"] !== undefined ? _data["stringStatusId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemTrendChartLimitQueryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId !== undefined ? this.nodeId : null;
        data["stringStatusId"] = this.stringStatusId !== undefined ? this.stringStatusId : null;
        return data;
    }
}
export class BaseQueryOfGetTrendPDFReportQueryAndByteOf {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetTrendPDFReportQueryAndByteOf' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetTrendPDFReportQuery extends BaseQueryOfGetTrendPDFReportQueryAndByteOf {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
            this.trendQuery = _data["trendQuery"] ? GetSystemTrendChartQuery.fromJS(_data["trendQuery"]) : null;
            if (Array.isArray(_data["dataSelectSelectedIndex"])) {
                this.dataSelectSelectedIndex = [];
                for (let item of _data["dataSelectSelectedIndex"])
                    this.dataSelectSelectedIndex.push(item);
            }
            else {
                this.dataSelectSelectedIndex = null;
            }
            this.chartImage = _data["chartImage"] !== undefined ? _data["chartImage"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrendPDFReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        data["trendQuery"] = this.trendQuery ? this.trendQuery.toJSON() : null;
        if (Array.isArray(this.dataSelectSelectedIndex)) {
            data["dataSelectSelectedIndex"] = [];
            for (let item of this.dataSelectSelectedIndex)
                data["dataSelectSelectedIndex"].push(item);
        }
        data["chartImage"] = this.chartImage !== undefined ? this.chartImage : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetSystemDischargeCSVQueryAndTimeseriesChart {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemDischargeCSVQueryAndTimeseriesChart' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemDischargeCSVQuery extends BaseQueryOfGetSystemDischargeCSVQueryAndTimeseriesChart {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
            this.currentTimezoneOffset = _data["currentTimezoneOffset"] !== undefined ? _data["currentTimezoneOffset"] : null;
            if (Array.isArray(_data["axes"])) {
                this.axes = [];
                for (let item of _data["axes"])
                    this.axes.push(GetSystemDischargeCSVQueryModel.fromJS(item));
            }
            else {
                this.axes = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemDischargeCSVQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        data["currentTimezoneOffset"] = this.currentTimezoneOffset !== undefined ? this.currentTimezoneOffset : null;
        if (Array.isArray(this.axes)) {
            data["axes"] = [];
            for (let item of this.axes)
                data["axes"].push(item ? item.toJSON() : null);
        }
        super.toJSON(data);
        return data;
    }
}
export class GetSystemDischargeCSVQueryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.measurementTypeId = _data["measurementTypeId"] !== undefined ? _data["measurementTypeId"] : null;
            this.measurementTypeName = _data["measurementTypeName"] !== undefined ? _data["measurementTypeName"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
            this.alarmGroupId = _data["alarmGroupId"] !== undefined ? _data["alarmGroupId"] : null;
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [];
                for (let item of _data["nodes"])
                    this.nodes.push(item);
            }
            else {
                this.nodes = null;
            }
            this.dataSource = _data["dataSource"] !== undefined ? _data["dataSource"] : null;
            this.limitQuery = _data["limitQuery"] ? GetSystemDischargeCSVLimitQueryModel.fromJS(_data["limitQuery"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemDischargeCSVQueryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["measurementTypeId"] = this.measurementTypeId !== undefined ? this.measurementTypeId : null;
        data["measurementTypeName"] = this.measurementTypeName !== undefined ? this.measurementTypeName : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        data["alarmGroupId"] = this.alarmGroupId !== undefined ? this.alarmGroupId : null;
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item);
        }
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null;
        data["limitQuery"] = this.limitQuery ? this.limitQuery.toJSON() : null;
        return data;
    }
}
export class GetSystemDischargeCSVLimitQueryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.nodeId = _data["nodeId"] !== undefined ? _data["nodeId"] : null;
            this.stringStatusId = _data["stringStatusId"] !== undefined ? _data["stringStatusId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemDischargeCSVLimitQueryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId !== undefined ? this.nodeId : null;
        data["stringStatusId"] = this.stringStatusId !== undefined ? this.stringStatusId : null;
        return data;
    }
}
export class BaseQueryOfGetDischargePDFReportQueryAndByteOf {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetDischargePDFReportQueryAndByteOf' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetDischargePDFReportQuery extends BaseQueryOfGetDischargePDFReportQueryAndByteOf {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
            this.dischargeQuery = _data["dischargeQuery"] ? GetSystemTrendChartQuery.fromJS(_data["dischargeQuery"]) : null;
            if (Array.isArray(_data["dataSelectSelectedIndex"])) {
                this.dataSelectSelectedIndex = [];
                for (let item of _data["dataSelectSelectedIndex"])
                    this.dataSelectSelectedIndex.push(item);
            }
            else {
                this.dataSelectSelectedIndex = null;
            }
            this.chartImage = _data["chartImage"] !== undefined ? _data["chartImage"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDischargePDFReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        data["dischargeQuery"] = this.dischargeQuery ? this.dischargeQuery.toJSON() : null;
        if (Array.isArray(this.dataSelectSelectedIndex)) {
            data["dataSelectSelectedIndex"] = [];
            for (let item of this.dataSelectSelectedIndex)
                data["dataSelectSelectedIndex"].push(item);
        }
        data["chartImage"] = this.chartImage !== undefined ? this.chartImage : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetOhmicTrendPDFReportQueryAndByteOf {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetOhmicTrendPDFReportQueryAndByteOf' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetOhmicTrendPDFReportQuery extends BaseQueryOfGetOhmicTrendPDFReportQueryAndByteOf {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null;
            this.isDefaultPeriod = _data["isDefaultPeriod"] !== undefined ? _data["isDefaultPeriod"] : null;
            if (Array.isArray(_data["stringIds"])) {
                this.stringIds = [];
                for (let item of _data["stringIds"])
                    this.stringIds.push(item);
            }
            else {
                this.stringIds = null;
            }
            this.hidePredictionColumn = _data["hidePredictionColumn"] !== undefined ? _data["hidePredictionColumn"] : null;
            this.totalOhmicRiseLimit = _data["totalOhmicRiseLimit"] !== undefined ? _data["totalOhmicRiseLimit"] : null;
            this.quarterOhmicRiseLimit = _data["quarterOhmicRiseLimit"] !== undefined ? _data["quarterOhmicRiseLimit"] : null;
            this.fourWeeksOhmicRiseLimit = _data["fourWeeksOhmicRiseLimit"] !== undefined ? _data["fourWeeksOhmicRiseLimit"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetOhmicTrendPDFReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["isDefaultPeriod"] = this.isDefaultPeriod !== undefined ? this.isDefaultPeriod : null;
        if (Array.isArray(this.stringIds)) {
            data["stringIds"] = [];
            for (let item of this.stringIds)
                data["stringIds"].push(item);
        }
        data["hidePredictionColumn"] = this.hidePredictionColumn !== undefined ? this.hidePredictionColumn : null;
        data["totalOhmicRiseLimit"] = this.totalOhmicRiseLimit !== undefined ? this.totalOhmicRiseLimit : null;
        data["quarterOhmicRiseLimit"] = this.quarterOhmicRiseLimit !== undefined ? this.quarterOhmicRiseLimit : null;
        data["fourWeeksOhmicRiseLimit"] = this.fourWeeksOhmicRiseLimit !== undefined ? this.fourWeeksOhmicRiseLimit : null;
        super.toJSON(data);
        return data;
    }
}
export class BlockPredictionModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.blockId = _data["blockId"] !== undefined ? _data["blockId"] : null;
            this.blockEndOfLifePrediction = _data["blockEndOfLifePrediction"] ? new Date(_data["blockEndOfLifePrediction"].toString()) : null;
            this.apiPrediction = _data["apiPrediction"] !== undefined ? _data["apiPrediction"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BlockPredictionModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["blockId"] = this.blockId !== undefined ? this.blockId : null;
        data["blockEndOfLifePrediction"] = this.blockEndOfLifePrediction ? this.blockEndOfLifePrediction.toISOString() : null;
        data["apiPrediction"] = this.apiPrediction !== undefined ? this.apiPrediction : null;
        return data;
    }
}
export class BaseQueryOfGetBlockPredictionQueryAndBlockPredictionModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetBlockPredictionQueryAndBlockPredictionModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetBlockPredictionQuery extends BaseQueryOfGetBlockPredictionQueryAndBlockPredictionModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.blockId = _data["blockId"] !== undefined ? _data["blockId"] : null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlockPredictionQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["blockId"] = this.blockId !== undefined ? this.blockId : null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null;
        super.toJSON(data);
        return data;
    }
}
export class UserAuthModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.authenticated = _data["authenticated"] !== undefined ? _data["authenticated"] : null;
            this.requires2FA = _data["requires2FA"] !== undefined ? _data["requires2FA"] : null;
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : null;
            if (Array.isArray(_data["authenticationContexts"])) {
                this.authenticationContexts = [];
                for (let item of _data["authenticationContexts"])
                    this.authenticationContexts.push(AuthenticationContext.fromJS(item));
            }
            else {
                this.authenticationContexts = null;
            }
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [];
                for (let item of _data["identifiers"])
                    this.identifiers.push(Identifier.fromJS(item));
            }
            else {
                this.identifiers = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuthModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["authenticated"] = this.authenticated !== undefined ? this.authenticated : null;
        data["requires2FA"] = this.requires2FA !== undefined ? this.requires2FA : null;
        data["user"] = this.user ? this.user.toJSON() : null;
        if (Array.isArray(this.authenticationContexts)) {
            data["authenticationContexts"] = [];
            for (let item of this.authenticationContexts)
                data["authenticationContexts"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class AuthenticationContext {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.contextId = _data["contextId"] !== undefined ? _data["contextId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.description = _data["description"] !== undefined ? _data["description"] : null;
            this.kind = _data["kind"] !== undefined ? _data["kind"] : null;
            this.locale = _data["locale"] !== undefined ? _data["locale"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationContext();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["contextId"] = this.contextId !== undefined ? this.contextId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["kind"] = this.kind !== undefined ? this.kind : null;
        data["locale"] = this.locale !== undefined ? this.locale : null;
        return data;
    }
}
export class Identifier {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.kind = _data["kind"] !== undefined ? _data["kind"] : null;
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.key = _data["key"] !== undefined ? _data["key"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Identifier();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind !== undefined ? this.kind : null;
        data["id"] = this.id !== undefined ? this.id : null;
        data["key"] = this.key !== undefined ? this.key : null;
        return data;
    }
}
export class UserLoginAttemptModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null;
            this.password = _data["password"] !== undefined ? _data["password"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["password"] = this.password !== undefined ? this.password : null;
        return data;
    }
}
export class SsoCompanyDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.subdomain = _data["subdomain"] !== undefined ? _data["subdomain"] : null;
            this.ssoEnabled = _data["ssoEnabled"] !== undefined ? _data["ssoEnabled"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SsoCompanyDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["subdomain"] = this.subdomain !== undefined ? this.subdomain : null;
        data["ssoEnabled"] = this.ssoEnabled !== undefined ? this.ssoEnabled : null;
        return data;
    }
}
export class SsoCheckResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ssoAvailable = _data["ssoAvailable"] !== undefined ? _data["ssoAvailable"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.subdomain = _data["subdomain"] !== undefined ? _data["subdomain"] : null;
            this.requiresCompanySelection = _data["requiresCompanySelection"] !== undefined ? _data["requiresCompanySelection"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SsoCheckResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ssoAvailable"] = this.ssoAvailable !== undefined ? this.ssoAvailable : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["subdomain"] = this.subdomain !== undefined ? this.subdomain : null;
        data["requiresCompanySelection"] = this.requiresCompanySelection !== undefined ? this.requiresCompanySelection : null;
        data["message"] = this.message !== undefined ? this.message : null;
        return data;
    }
}
export class AccessTokenModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : null;
            this.refreshToken = _data["refreshToken"] !== undefined ? _data["refreshToken"] : null;
            this.expiresIn = _data["expiresIn"] !== undefined ? _data["expiresIn"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : null;
        data["refreshToken"] = this.refreshToken !== undefined ? this.refreshToken : null;
        data["expiresIn"] = this.expiresIn !== undefined ? this.expiresIn : null;
        return data;
    }
}
export class BaseCommandOfUserTokenRenewalRequestModelAndAccessTokenModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? UserTokenRenewalRequestModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfUserTokenRenewalRequestModelAndAccessTokenModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class RefreshUserTokenCommand extends BaseCommandOfUserTokenRenewalRequestModelAndAccessTokenModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshUserTokenCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UserTokenRenewalRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.refreshToken = _data["refreshToken"] !== undefined ? _data["refreshToken"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserTokenRenewalRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken !== undefined ? this.refreshToken : null;
        return data;
    }
}
export class BaseCommandOfUserPasswordResetRequestModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? UserPasswordResetRequestModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfUserPasswordResetRequestModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class RequestUserPasswordResetCommand extends BaseCommandOfUserPasswordResetRequestModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RequestUserPasswordResetCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UserPasswordResetRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null;
            this.clearPreviousPassword = _data["clearPreviousPassword"] !== undefined ? _data["clearPreviousPassword"] : null;
            this.ipAddress = _data["ipAddress"] !== undefined ? _data["ipAddress"] : null;
            this.location = _data["location"] !== undefined ? _data["location"] : null;
            this.userAgent = _data["userAgent"] !== undefined ? _data["userAgent"] : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordResetRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["clearPreviousPassword"] = this.clearPreviousPassword !== undefined ? this.clearPreviousPassword : null;
        data["ipAddress"] = this.ipAddress !== undefined ? this.ipAddress : null;
        data["location"] = this.location !== undefined ? this.location : null;
        data["userAgent"] = this.userAgent !== undefined ? this.userAgent : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        return data;
    }
}
export class BaseCommandOfUserPasswordResetConfirmationModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? UserPasswordResetConfirmationModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfUserPasswordResetConfirmationModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class ConfirmUserPasswordResetCommand extends BaseCommandOfUserPasswordResetConfirmationModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmUserPasswordResetCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UserPasswordResetConfirmationModel extends UserPasswordResetRequestModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.passwordResetToken = _data["passwordResetToken"] !== undefined ? _data["passwordResetToken"] : null;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : null;
            this.newPasswordConfirmation = _data["newPasswordConfirmation"] !== undefined ? _data["newPasswordConfirmation"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordResetConfirmationModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["passwordResetToken"] = this.passwordResetToken !== undefined ? this.passwordResetToken : null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        data["newPasswordConfirmation"] = this.newPasswordConfirmation !== undefined ? this.newPasswordConfirmation : null;
        super.toJSON(data);
        return data;
    }
}
export class TwoFactorAuthModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.method = _data["method"] !== undefined ? _data["method"] : null;
            if (Array.isArray(_data["allowedMethods"])) {
                this.allowedMethods = [];
                for (let item of _data["allowedMethods"])
                    this.allowedMethods.push(item);
            }
            else {
                this.allowedMethods = null;
            }
            this.barcodeImageBase64 = _data["barcodeImageBase64"] !== undefined ? _data["barcodeImageBase64"] : null;
            this.secret = _data["secret"] !== undefined ? _data["secret"] : null;
            this.userEmail = _data["userEmail"] !== undefined ? _data["userEmail"] : null;
            this.userDisplayedName = _data["userDisplayedName"] !== undefined ? _data["userDisplayedName"] : null;
            this.secondsToUserTokenExpire = _data["secondsToUserTokenExpire"] !== undefined ? _data["secondsToUserTokenExpire"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorAuthModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method !== undefined ? this.method : null;
        if (Array.isArray(this.allowedMethods)) {
            data["allowedMethods"] = [];
            for (let item of this.allowedMethods)
                data["allowedMethods"].push(item);
        }
        data["barcodeImageBase64"] = this.barcodeImageBase64 !== undefined ? this.barcodeImageBase64 : null;
        data["secret"] = this.secret !== undefined ? this.secret : null;
        data["userEmail"] = this.userEmail !== undefined ? this.userEmail : null;
        data["userDisplayedName"] = this.userDisplayedName !== undefined ? this.userDisplayedName : null;
        data["secondsToUserTokenExpire"] = this.secondsToUserTokenExpire !== undefined ? this.secondsToUserTokenExpire : null;
        return data;
    }
}
export class TwoFactorAuthVerificationModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.method = _data["method"] !== undefined ? _data["method"] : null;
            this.userToken = _data["userToken"] !== undefined ? _data["userToken"] : null;
            this.secret = _data["secret"] !== undefined ? _data["secret"] : null;
            this.code = _data["code"] !== undefined ? _data["code"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorAuthVerificationModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method !== undefined ? this.method : null;
        data["userToken"] = this.userToken !== undefined ? this.userToken : null;
        data["secret"] = this.secret !== undefined ? this.secret : null;
        data["code"] = this.code !== undefined ? this.code : null;
        return data;
    }
}
export class RecaptchaResponseViewModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tokenProperties = _data["tokenProperties"] ? RecaptchaResponseTokenProperties.fromJS(_data["tokenProperties"]) : null;
            this.riskAnalysis = _data["riskAnalysis"] ? RecaptchaResponseRiskAnalysis.fromJS(_data["riskAnalysis"]) : null;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecaptchaResponseViewModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tokenProperties"] = this.tokenProperties ? this.tokenProperties.toJSON() : null;
        data["riskAnalysis"] = this.riskAnalysis ? this.riskAnalysis.toJSON() : null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : null;
        return data;
    }
}
export class RecaptchaResponseTokenProperties {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.valid = _data["valid"] !== undefined ? _data["valid"] : null;
            this.invalidReason = _data["invalidReason"] !== undefined ? _data["invalidReason"] : null;
            this.hostName = _data["hostName"] !== undefined ? _data["hostName"] : null;
            this.action = _data["action"] !== undefined ? _data["action"] : null;
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecaptchaResponseTokenProperties();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["valid"] = this.valid !== undefined ? this.valid : null;
        data["invalidReason"] = this.invalidReason !== undefined ? this.invalidReason : null;
        data["hostName"] = this.hostName !== undefined ? this.hostName : null;
        data["action"] = this.action !== undefined ? this.action : null;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : null;
        return data;
    }
}
export class RecaptchaResponseRiskAnalysis {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.score = _data["score"] !== undefined ? _data["score"] : null;
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [];
                for (let item of _data["reasons"])
                    this.reasons.push(item);
            }
            else {
                this.reasons = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecaptchaResponseRiskAnalysis();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score !== undefined ? this.score : null;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item);
        }
        return data;
    }
}
export class RecaptchaRequestViewModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null;
            this.response = _data["response"] !== undefined ? _data["response"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecaptchaRequestViewModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null;
        data["response"] = this.response !== undefined ? this.response : null;
        return data;
    }
}
export class AboutSystemInfoModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.machineName = _data["machineName"] !== undefined ? _data["machineName"] : null;
            this.operatingSystem = _data["operatingSystem"] !== undefined ? _data["operatingSystem"] : null;
            this.processor = _data["processor"] !== undefined ? _data["processor"] : null;
            this.totalMemoryMb = _data["totalMemoryMb"] !== undefined ? _data["totalMemoryMb"] : null;
            this.availableDiskSpaceGb = _data["availableDiskSpaceGb"] !== undefined ? _data["availableDiskSpaceGb"] : null;
            this.dataCollectUrl = _data["dataCollectUrl"] !== undefined ? _data["dataCollectUrl"] : null;
            this.malwareScanMode = _data["malwareScanMode"] !== undefined ? _data["malwareScanMode"] : null;
            this.malwareScannerAvailable = _data["malwareScannerAvailable"] !== undefined ? _data["malwareScannerAvailable"] : null;
            this.malwareScannerStatus = _data["malwareScannerStatus"] !== undefined ? _data["malwareScannerStatus"] : null;
            this.lastUpdatedUnix = _data["lastUpdatedUnix"] !== undefined ? _data["lastUpdatedUnix"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AboutSystemInfoModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["machineName"] = this.machineName !== undefined ? this.machineName : null;
        data["operatingSystem"] = this.operatingSystem !== undefined ? this.operatingSystem : null;
        data["processor"] = this.processor !== undefined ? this.processor : null;
        data["totalMemoryMb"] = this.totalMemoryMb !== undefined ? this.totalMemoryMb : null;
        data["availableDiskSpaceGb"] = this.availableDiskSpaceGb !== undefined ? this.availableDiskSpaceGb : null;
        data["dataCollectUrl"] = this.dataCollectUrl !== undefined ? this.dataCollectUrl : null;
        data["malwareScanMode"] = this.malwareScanMode !== undefined ? this.malwareScanMode : null;
        data["malwareScannerAvailable"] = this.malwareScannerAvailable !== undefined ? this.malwareScannerAvailable : null;
        data["malwareScannerStatus"] = this.malwareScannerStatus !== undefined ? this.malwareScannerStatus : null;
        data["lastUpdatedUnix"] = this.lastUpdatedUnix !== undefined ? this.lastUpdatedUnix : null;
        return data;
    }
}
export class AboutSystemStatsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.cpuUsagePercent = _data["cpuUsagePercent"] !== undefined ? _data["cpuUsagePercent"] : null;
            this.memoryUsedMb = _data["memoryUsedMb"] !== undefined ? _data["memoryUsedMb"] : null;
            this.memoryTotalMb = _data["memoryTotalMb"] !== undefined ? _data["memoryTotalMb"] : null;
            this.lastUpdatedUnix = _data["lastUpdatedUnix"] !== undefined ? _data["lastUpdatedUnix"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AboutSystemStatsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["cpuUsagePercent"] = this.cpuUsagePercent !== undefined ? this.cpuUsagePercent : null;
        data["memoryUsedMb"] = this.memoryUsedMb !== undefined ? this.memoryUsedMb : null;
        data["memoryTotalMb"] = this.memoryTotalMb !== undefined ? this.memoryTotalMb : null;
        data["lastUpdatedUnix"] = this.lastUpdatedUnix !== undefined ? this.lastUpdatedUnix : null;
        return data;
    }
}
export class PaginatedEnumerableOfActivityAuditModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(ActivityAuditModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfActivityAuditModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class ActivityAuditModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.activityAuditId = _data["activityAuditId"] !== undefined ? _data["activityAuditId"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.actorUserId = _data["actorUserId"] !== undefined ? _data["actorUserId"] : null;
            this.actorName = _data["actorName"] !== undefined ? _data["actorName"] : null;
            this.actorEmail = _data["actorEmail"] !== undefined ? _data["actorEmail"] : null;
            this.actorRole = _data["actorRole"] !== undefined ? _data["actorRole"] : null;
            this.source = _data["source"] !== undefined ? _data["source"] : null;
            this.sourceDescription = _data["sourceDescription"] !== undefined ? _data["sourceDescription"] : null;
            this.action = _data["action"] !== undefined ? _data["action"] : null;
            this.actionDescription = _data["actionDescription"] !== undefined ? _data["actionDescription"] : null;
            this.entityArea = _data["entityArea"] !== undefined ? _data["entityArea"] : null;
            this.entityAreaDescription = _data["entityAreaDescription"] !== undefined ? _data["entityAreaDescription"] : null;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : null;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : null;
            this.entityName = _data["entityName"] !== undefined ? _data["entityName"] : null;
            this.description = _data["description"] !== undefined ? _data["description"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.correlationId = _data["correlationId"] !== undefined ? _data["correlationId"] : null;
            this.remoteIPAddress = _data["remoteIPAddress"] !== undefined ? _data["remoteIPAddress"] : null;
            if (Array.isArray(_data["details"])) {
                this.details = [];
                for (let item of _data["details"])
                    this.details.push(ActivityAuditDetailModel.fromJS(item));
            }
            else {
                this.details = null;
            }
            this.detailCount = _data["detailCount"] !== undefined ? _data["detailCount"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAuditModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["activityAuditId"] = this.activityAuditId !== undefined ? this.activityAuditId : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["actorUserId"] = this.actorUserId !== undefined ? this.actorUserId : null;
        data["actorName"] = this.actorName !== undefined ? this.actorName : null;
        data["actorEmail"] = this.actorEmail !== undefined ? this.actorEmail : null;
        data["actorRole"] = this.actorRole !== undefined ? this.actorRole : null;
        data["source"] = this.source !== undefined ? this.source : null;
        data["sourceDescription"] = this.sourceDescription !== undefined ? this.sourceDescription : null;
        data["action"] = this.action !== undefined ? this.action : null;
        data["actionDescription"] = this.actionDescription !== undefined ? this.actionDescription : null;
        data["entityArea"] = this.entityArea !== undefined ? this.entityArea : null;
        data["entityAreaDescription"] = this.entityAreaDescription !== undefined ? this.entityAreaDescription : null;
        data["entityType"] = this.entityType !== undefined ? this.entityType : null;
        data["entityId"] = this.entityId !== undefined ? this.entityId : null;
        data["entityName"] = this.entityName !== undefined ? this.entityName : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["correlationId"] = this.correlationId !== undefined ? this.correlationId : null;
        data["remoteIPAddress"] = this.remoteIPAddress !== undefined ? this.remoteIPAddress : null;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : null);
        }
        data["detailCount"] = this.detailCount !== undefined ? this.detailCount : null;
        return data;
    }
}
export var AuditSourceEnum;
(function (AuditSourceEnum) {
    AuditSourceEnum[AuditSourceEnum["Portal"] = 1] = "Portal";
    AuditSourceEnum[AuditSourceEnum["Api"] = 2] = "Api";
    AuditSourceEnum[AuditSourceEnum["Integration"] = 3] = "Integration";
    AuditSourceEnum[AuditSourceEnum["Automation"] = 4] = "Automation";
})(AuditSourceEnum || (AuditSourceEnum = {}));
export var AuditActionEnum;
(function (AuditActionEnum) {
    AuditActionEnum[AuditActionEnum["Create"] = 1] = "Create";
    AuditActionEnum[AuditActionEnum["Update"] = 2] = "Update";
    AuditActionEnum[AuditActionEnum["Delete"] = 3] = "Delete";
    AuditActionEnum[AuditActionEnum["Restore"] = 4] = "Restore";
    AuditActionEnum[AuditActionEnum["Archive"] = 5] = "Archive";
    AuditActionEnum[AuditActionEnum["Export"] = 6] = "Export";
    AuditActionEnum[AuditActionEnum["Grant"] = 7] = "Grant";
    AuditActionEnum[AuditActionEnum["Revoke"] = 8] = "Revoke";
    AuditActionEnum[AuditActionEnum["SignIn"] = 9] = "SignIn";
    AuditActionEnum[AuditActionEnum["SignOut"] = 10] = "SignOut";
    AuditActionEnum[AuditActionEnum["SignInFailed"] = 11] = "SignInFailed";
    AuditActionEnum[AuditActionEnum["SessionExpired"] = 12] = "SessionExpired";
})(AuditActionEnum || (AuditActionEnum = {}));
export var AuditAreaEnum;
(function (AuditAreaEnum) {
    AuditAreaEnum[AuditAreaEnum["Issues"] = 1] = "Issues";
    AuditAreaEnum[AuditAreaEnum["Comments"] = 2] = "Comments";
    AuditAreaEnum[AuditAreaEnum["Company"] = 3] = "Company";
    AuditAreaEnum[AuditAreaEnum["System"] = 4] = "System";
    AuditAreaEnum[AuditAreaEnum["User"] = 5] = "User";
    AuditAreaEnum[AuditAreaEnum["UserGroups"] = 6] = "UserGroups";
})(AuditAreaEnum || (AuditAreaEnum = {}));
export class ActivityAuditDetailModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.activityAuditDetailId = _data["activityAuditDetailId"] !== undefined ? _data["activityAuditDetailId"] : null;
            this.fieldLabel = _data["fieldLabel"] !== undefined ? _data["fieldLabel"] : null;
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : null;
            this.oldValue = _data["oldValue"] !== undefined ? _data["oldValue"] : null;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : null;
            this.isSensitive = _data["isSensitive"] !== undefined ? _data["isSensitive"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAuditDetailModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["activityAuditDetailId"] = this.activityAuditDetailId !== undefined ? this.activityAuditDetailId : null;
        data["fieldLabel"] = this.fieldLabel !== undefined ? this.fieldLabel : null;
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : null;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : null;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null;
        data["isSensitive"] = this.isSensitive !== undefined ? this.isSensitive : null;
        return data;
    }
}
export class BaseQueryOfGetActivityAuditPaginatedQueryAndPaginatedEnumerableOfActivityAuditModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetActivityAuditPaginatedQueryAndPaginatedEnumerableOfActivityAuditModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetActivityAuditPaginatedQuery extends BaseQueryOfGetActivityAuditPaginatedQueryAndPaginatedEnumerableOfActivityAuditModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.page = _data["page"] !== undefined ? _data["page"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
            this.actorUserId = _data["actorUserId"] !== undefined ? _data["actorUserId"] : null;
            this.action = _data["action"] !== undefined ? _data["action"] : null;
            this.entityArea = _data["entityArea"] !== undefined ? _data["entityArea"] : null;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.source = _data["source"] !== undefined ? _data["source"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityAuditPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page !== undefined ? this.page : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        data["actorUserId"] = this.actorUserId !== undefined ? this.actorUserId : null;
        data["action"] = this.action !== undefined ? this.action : null;
        data["entityArea"] = this.entityArea !== undefined ? this.entityArea : null;
        data["entityType"] = this.entityType !== undefined ? this.entityType : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["source"] = this.source !== undefined ? this.source : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetActivityAuditForEntityQueryAndPaginatedEnumerableOfActivityAuditModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetActivityAuditForEntityQueryAndPaginatedEnumerableOfActivityAuditModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetActivityAuditForEntityQuery extends BaseQueryOfGetActivityAuditForEntityQueryAndPaginatedEnumerableOfActivityAuditModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : null;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : null;
            this.page = _data["page"] !== undefined ? _data["page"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityAuditForEntityQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType !== undefined ? this.entityType : null;
        data["entityId"] = this.entityId !== undefined ? this.entityId : null;
        data["page"] = this.page !== undefined ? this.page : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetActivityAuditCSVReportQueryAndActivityAuditCSVReport {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetActivityAuditCSVReportQueryAndActivityAuditCSVReport' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetActivityAuditCSVReportQuery extends BaseQueryOfGetActivityAuditCSVReportQueryAndActivityAuditCSVReport {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.query = _data["query"] ? GetActivityAuditPaginatedQuery.fromJS(_data["query"]) : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityAuditCSVReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        super.toJSON(data);
        return data;
    }
}
export class ActivityAuditSettingsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.daysToRetain = _data["daysToRetain"] !== undefined ? _data["daysToRetain"] : null;
            this.inheritedDaysToRetain = _data["inheritedDaysToRetain"] !== undefined ? _data["inheritedDaysToRetain"] : null;
            this.effectiveDaysToRetain = _data["effectiveDaysToRetain"] !== undefined ? _data["effectiveDaysToRetain"] : null;
            this.minimumDaysToRetain = _data["minimumDaysToRetain"] !== undefined ? _data["minimumDaysToRetain"] : null;
            this.maximumDaysToRetain = _data["maximumDaysToRetain"] !== undefined ? _data["maximumDaysToRetain"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAuditSettingsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["daysToRetain"] = this.daysToRetain !== undefined ? this.daysToRetain : null;
        data["inheritedDaysToRetain"] = this.inheritedDaysToRetain !== undefined ? this.inheritedDaysToRetain : null;
        data["effectiveDaysToRetain"] = this.effectiveDaysToRetain !== undefined ? this.effectiveDaysToRetain : null;
        data["minimumDaysToRetain"] = this.minimumDaysToRetain !== undefined ? this.minimumDaysToRetain : null;
        data["maximumDaysToRetain"] = this.maximumDaysToRetain !== undefined ? this.maximumDaysToRetain : null;
        return data;
    }
}
export class ActivityAuditApplicationSettingsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.defaultCompanyDaysToRetain = _data["defaultCompanyDaysToRetain"] !== undefined ? _data["defaultCompanyDaysToRetain"] : null;
            this.applicationDaysToRetain = _data["applicationDaysToRetain"] !== undefined ? _data["applicationDaysToRetain"] : null;
            this.minimumDaysToRetain = _data["minimumDaysToRetain"] !== undefined ? _data["minimumDaysToRetain"] : null;
            this.maximumDaysToRetain = _data["maximumDaysToRetain"] !== undefined ? _data["maximumDaysToRetain"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAuditApplicationSettingsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["defaultCompanyDaysToRetain"] = this.defaultCompanyDaysToRetain !== undefined ? this.defaultCompanyDaysToRetain : null;
        data["applicationDaysToRetain"] = this.applicationDaysToRetain !== undefined ? this.applicationDaysToRetain : null;
        data["minimumDaysToRetain"] = this.minimumDaysToRetain !== undefined ? this.minimumDaysToRetain : null;
        data["maximumDaysToRetain"] = this.maximumDaysToRetain !== undefined ? this.maximumDaysToRetain : null;
        return data;
    }
}
export class ActivityAuditRetentionImpactModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.currentDaysToRetain = _data["currentDaysToRetain"] !== undefined ? _data["currentDaysToRetain"] : null;
            this.proposedDaysToRetain = _data["proposedDaysToRetain"] !== undefined ? _data["proposedDaysToRetain"] : null;
            this.isReduction = _data["isReduction"] !== undefined ? _data["isReduction"] : null;
            this.entriesAffected = _data["entriesAffected"] !== undefined ? _data["entriesAffected"] : null;
            this.proposedCutoff = _data["proposedCutoff"] ? new Date(_data["proposedCutoff"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAuditRetentionImpactModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["currentDaysToRetain"] = this.currentDaysToRetain !== undefined ? this.currentDaysToRetain : null;
        data["proposedDaysToRetain"] = this.proposedDaysToRetain !== undefined ? this.proposedDaysToRetain : null;
        data["isReduction"] = this.isReduction !== undefined ? this.isReduction : null;
        data["entriesAffected"] = this.entriesAffected !== undefined ? this.entriesAffected : null;
        data["proposedCutoff"] = this.proposedCutoff ? this.proposedCutoff.toISOString() : null;
        return data;
    }
}
export class ActivityAuditFilterOptionsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["actors"])) {
                this.actors = [];
                for (let item of _data["actors"])
                    this.actors.push(ActivityAuditFilterOptionModel.fromJS(item));
            }
            else {
                this.actors = null;
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [];
                for (let item of _data["actions"])
                    this.actions.push(ActivityAuditFilterOptionModel.fromJS(item));
            }
            else {
                this.actions = null;
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [];
                for (let item of _data["areas"])
                    this.areas.push(ActivityAuditFilterOptionModel.fromJS(item));
            }
            else {
                this.areas = null;
            }
            if (Array.isArray(_data["sources"])) {
                this.sources = [];
                for (let item of _data["sources"])
                    this.sources.push(ActivityAuditFilterOptionModel.fromJS(item));
            }
            else {
                this.sources = null;
            }
            if (Array.isArray(_data["entityTypes"])) {
                this.entityTypes = [];
                for (let item of _data["entityTypes"])
                    this.entityTypes.push(ActivityAuditFilterOptionModel.fromJS(item));
            }
            else {
                this.entityTypes = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAuditFilterOptionsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actors)) {
            data["actors"] = [];
            for (let item of this.actors)
                data["actors"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.entityTypes)) {
            data["entityTypes"] = [];
            for (let item of this.entityTypes)
                data["entityTypes"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class ActivityAuditFilterOptionModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null;
            this.label = _data["label"] !== undefined ? _data["label"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAuditFilterOptionModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null;
        data["label"] = this.label !== undefined ? this.label : null;
        return data;
    }
}
export class BaseQueryOfGetActivityAuditFilterOptionsQueryAndActivityAuditFilterOptionsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetActivityAuditFilterOptionsQueryAndActivityAuditFilterOptionsModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetActivityAuditFilterOptionsQuery extends BaseQueryOfGetActivityAuditFilterOptionsQueryAndActivityAuditFilterOptionsModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.daysToConsider = _data["daysToConsider"] !== undefined ? _data["daysToConsider"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityAuditFilterOptionsQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["daysToConsider"] = this.daysToConsider !== undefined ? this.daysToConsider : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfAddressModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(AddressModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfAddressModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetAddressListPaginatedQueryAndPaginatedEnumerableOfAddressModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetAddressListPaginatedQueryAndPaginatedEnumerableOfAddressModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetAddressListPaginatedQuery extends BaseQueryOfGetAddressListPaginatedQueryAndPaginatedEnumerableOfAddressModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAddressListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfAddressModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? AddressModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfAddressModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateAddressCommand extends BaseCommandOfAddressModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateAddressCommand extends BaseCommandOfAddressModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddressCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfAlarmDefinitionModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? AlarmDefinitionModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfAlarmDefinitionModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateAlarmDefinitionCommand extends BaseCommandOfAlarmDefinitionModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlarmDefinitionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateAlarmDefinitionCommand extends BaseCommandOfAlarmDefinitionModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAlarmDefinitionCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfAlarmTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(AlarmTypeModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfAlarmTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetAlarmTypeListPaginatedQueryAndPaginatedEnumerableOfAlarmTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetAlarmTypeListPaginatedQueryAndPaginatedEnumerableOfAlarmTypeModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetAlarmTypeListPaginatedQuery extends BaseQueryOfGetAlarmTypeListPaginatedQueryAndPaginatedEnumerableOfAlarmTypeModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlarmTypeListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfAlarmTypeModelAndInteger {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? AlarmTypeModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfAlarmTypeModelAndInteger' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateAlarmTypeCommand extends BaseCommandOfAlarmTypeModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlarmTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateAlarmTypeCommand extends BaseCommandOfAlarmTypeModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAlarmTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ApplicationModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null;
            this.authorId = _data["authorId"] !== undefined ? _data["authorId"] : null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.applicationName = _data["applicationName"] !== undefined ? _data["applicationName"] : null;
            this.applicationDescription = _data["applicationDescription"] !== undefined ? _data["applicationDescription"] : null;
            this.applicationSecret = _data["applicationSecret"] !== undefined ? _data["applicationSecret"] : null;
            this.tokenLifetime = _data["tokenLifetime"] !== undefined ? _data["tokenLifetime"] : null;
            this.whenLastActive = _data["whenLastActive"] ? new Date(_data["whenLastActive"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null;
        data["authorId"] = this.authorId !== undefined ? this.authorId : null;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["applicationName"] = this.applicationName !== undefined ? this.applicationName : null;
        data["applicationDescription"] = this.applicationDescription !== undefined ? this.applicationDescription : null;
        data["applicationSecret"] = this.applicationSecret !== undefined ? this.applicationSecret : null;
        data["tokenLifetime"] = this.tokenLifetime !== undefined ? this.tokenLifetime : null;
        data["whenLastActive"] = this.whenLastActive ? this.whenLastActive.toISOString() : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfApplicationModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(ApplicationModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfApplicationModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetApplicationListPaginatedQueryAndPaginatedEnumerableOfApplicationModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetApplicationListPaginatedQueryAndPaginatedEnumerableOfApplicationModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetApplicationListPaginatedQuery extends BaseQueryOfGetApplicationListPaginatedQueryAndPaginatedEnumerableOfApplicationModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfApplicationModelAndApplicationModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? ApplicationModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfApplicationModelAndApplicationModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateApplicationCommand extends BaseCommandOfApplicationModelAndApplicationModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApplicationCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfApplicationModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? ApplicationModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfApplicationModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpdateApplicationCommand extends BaseCommandOfApplicationModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateApplicationCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfUserCompanyAccessQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(UserCompanyAccessQuery.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfUserCompanyAccessQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class UserCompanyAccessQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null;
            this.numberOfSystems = _data["numberOfSystems"] !== undefined ? _data["numberOfSystems"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenGrantedAccessToAllSystems = _data["whenGrantedAccessToAllSystems"] ? new Date(_data["whenGrantedAccessToAllSystems"].toString()) : null;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : null;
            this.whenLockoutEnds = _data["whenLockoutEnds"] ? new Date(_data["whenLockoutEnds"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserCompanyAccessQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null;
        data["numberOfSystems"] = this.numberOfSystems !== undefined ? this.numberOfSystems : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenGrantedAccessToAllSystems"] = this.whenGrantedAccessToAllSystems ? this.whenGrantedAccessToAllSystems.toISOString() : null;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : null;
        data["whenLockoutEnds"] = this.whenLockoutEnds ? this.whenLockoutEnds.toISOString() : null;
        return data;
    }
}
export class BaseQueryOfGetUserCompanyAccessViewPaginatedQueryAndPaginatedEnumerableOfUserCompanyAccessQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetUserCompanyAccessViewPaginatedQueryAndPaginatedEnumerableOfUserCompanyAccessQuery' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetUserCompanyAccessViewPaginatedQuery extends BaseQueryOfGetUserCompanyAccessViewPaginatedQueryAndPaginatedEnumerableOfUserCompanyAccessQuery {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserCompanyAccessViewPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfUserCompanyAccessModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? UserCompanyAccessModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfUserCompanyAccessModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateUserCompanyAccessCommand extends BaseCommandOfUserCompanyAccessModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCompanyAccessCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UserCompanyAccessModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.whenGrantedAccessToAllSystems = _data["whenGrantedAccessToAllSystems"] ? new Date(_data["whenGrantedAccessToAllSystems"].toString()) : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserCompanyAccessModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["whenGrantedAccessToAllSystems"] = this.whenGrantedAccessToAllSystems ? this.whenGrantedAccessToAllSystems.toISOString() : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        return data;
    }
}
export class UpdateUserCompanyAccessCommand extends BaseCommandOfUserCompanyAccessModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.updateCompanyAndSiteIds = _data["updateCompanyAndSiteIds"] !== undefined ? _data["updateCompanyAndSiteIds"] : null;
            this.previousCompanyId = _data["previousCompanyId"] !== undefined ? _data["previousCompanyId"] : null;
            this.previousSiteId = _data["previousSiteId"] !== undefined ? _data["previousSiteId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCompanyAccessCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["updateCompanyAndSiteIds"] = this.updateCompanyAndSiteIds !== undefined ? this.updateCompanyAndSiteIds : null;
        data["previousCompanyId"] = this.previousCompanyId !== undefined ? this.previousCompanyId : null;
        data["previousSiteId"] = this.previousSiteId !== undefined ? this.previousSiteId : null;
        super.toJSON(data);
        return data;
    }
}
export class DeleteUserCompanyAccessCommand extends BaseCommandOfUserCompanyAccessModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.forceDelete = _data["forceDelete"] !== undefined ? _data["forceDelete"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserCompanyAccessCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["forceDelete"] = this.forceDelete !== undefined ? this.forceDelete : null;
        super.toJSON(data);
        return data;
    }
}
export class CompanyTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyTypeId = _data["companyTypeId"] !== undefined ? _data["companyTypeId"] : null;
            this.companyTypeName = _data["companyTypeName"] !== undefined ? _data["companyTypeName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyTypeId"] = this.companyTypeId !== undefined ? this.companyTypeId : null;
        data["companyTypeName"] = this.companyTypeName !== undefined ? this.companyTypeName : null;
        return data;
    }
}
export class PaginatedEnumerableOfCompanyTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(CompanyTypeModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfCompanyTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetCompanyTypeListPaginatedQueryAndPaginatedEnumerableOfCompanyTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetCompanyTypeListPaginatedQueryAndPaginatedEnumerableOfCompanyTypeModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetCompanyTypeListPaginatedQuery extends BaseQueryOfGetCompanyTypeListPaginatedQueryAndPaginatedEnumerableOfCompanyTypeModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyTypeListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class ComponentLimitModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.limitId = _data["limitId"] !== undefined ? _data["limitId"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.componentTypeId = _data["componentTypeId"] !== undefined ? _data["componentTypeId"] : null;
            this.componentTypeName = _data["componentTypeName"] !== undefined ? _data["componentTypeName"] : null;
            this.alarmTypeId = _data["alarmTypeId"] !== undefined ? _data["alarmTypeId"] : null;
            this.alarmTypeName = _data["alarmTypeName"] !== undefined ? _data["alarmTypeName"] : null;
            this.measurementTypeId = _data["measurementTypeId"] !== undefined ? _data["measurementTypeId"] : null;
            this.measurementTypeName = _data["measurementTypeName"] !== undefined ? _data["measurementTypeName"] : null;
            this.stringStatusId = _data["stringStatusId"] !== undefined ? _data["stringStatusId"] : null;
            this.stringStatusName = _data["stringStatusName"] !== undefined ? _data["stringStatusName"] : null;
            this.lowCritical = _data["lowCritical"] !== undefined ? _data["lowCritical"] : null;
            this.lowWarning = _data["lowWarning"] !== undefined ? _data["lowWarning"] : null;
            this.highWarning = _data["highWarning"] !== undefined ? _data["highWarning"] : null;
            this.highCritical = _data["highCritical"] !== undefined ? _data["highCritical"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentLimitModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["limitId"] = this.limitId !== undefined ? this.limitId : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["componentTypeId"] = this.componentTypeId !== undefined ? this.componentTypeId : null;
        data["componentTypeName"] = this.componentTypeName !== undefined ? this.componentTypeName : null;
        data["alarmTypeId"] = this.alarmTypeId !== undefined ? this.alarmTypeId : null;
        data["alarmTypeName"] = this.alarmTypeName !== undefined ? this.alarmTypeName : null;
        data["measurementTypeId"] = this.measurementTypeId !== undefined ? this.measurementTypeId : null;
        data["measurementTypeName"] = this.measurementTypeName !== undefined ? this.measurementTypeName : null;
        data["stringStatusId"] = this.stringStatusId !== undefined ? this.stringStatusId : null;
        data["stringStatusName"] = this.stringStatusName !== undefined ? this.stringStatusName : null;
        data["lowCritical"] = this.lowCritical !== undefined ? this.lowCritical : null;
        data["lowWarning"] = this.lowWarning !== undefined ? this.lowWarning : null;
        data["highWarning"] = this.highWarning !== undefined ? this.highWarning : null;
        data["highCritical"] = this.highCritical !== undefined ? this.highCritical : null;
        return data;
    }
}
export class BaseQueryOfGetComponentLimitListQueryAndIListOfComponentLimitModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetComponentLimitListQueryAndIListOfComponentLimitModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetComponentLimitListQuery extends BaseQueryOfGetComponentLimitListQueryAndIListOfComponentLimitModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.stringId = _data["stringId"] !== undefined ? _data["stringId"] : null;
            this.componentTypeId = _data["componentTypeId"] !== undefined ? _data["componentTypeId"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.alarmTypeId = _data["alarmTypeId"] !== undefined ? _data["alarmTypeId"] : null;
            this.measurementTypeId = _data["measurementTypeId"] !== undefined ? _data["measurementTypeId"] : null;
            this.stringStateId = _data["stringStateId"] !== undefined ? _data["stringStateId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetComponentLimitListQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["stringId"] = this.stringId !== undefined ? this.stringId : null;
        data["componentTypeId"] = this.componentTypeId !== undefined ? this.componentTypeId : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["alarmTypeId"] = this.alarmTypeId !== undefined ? this.alarmTypeId : null;
        data["measurementTypeId"] = this.measurementTypeId !== undefined ? this.measurementTypeId : null;
        data["stringStateId"] = this.stringStateId !== undefined ? this.stringStateId : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetComponentListQueryAndIListOfComponentModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetComponentListQueryAndIListOfComponentModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetComponentListQuery extends BaseQueryOfGetComponentListQueryAndIListOfComponentModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetComponentListQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfComponentModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(ComponentModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfComponentModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetComponentListPaginatedQueryAndPaginatedEnumerableOfComponentModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetComponentListPaginatedQueryAndPaginatedEnumerableOfComponentModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetComponentListPaginatedQuery extends BaseQueryOfGetComponentListPaginatedQueryAndPaginatedEnumerableOfComponentModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetComponentListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfComponentModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? ComponentModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfComponentModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateComponentCommand extends BaseCommandOfComponentModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateComponentCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateComponentCommand extends BaseCommandOfComponentModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateComponentCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfUpdateComponentDatesCommandAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? UpdateComponentDatesCommand.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfUpdateComponentDatesCommandAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpdateComponentDatesCommand extends BaseCommandOfUpdateComponentDatesCommandAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["components"])) {
                this.components = [];
                for (let item of _data["components"])
                    this.components.push(ComponentModel.fromJS(item));
            }
            else {
                this.components = null;
            }
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateComponentDatesCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item ? item.toJSON() : null);
        }
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        super.toJSON(data);
        return data;
    }
}
export class ComponentStatusModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.componentStatusId = _data["componentStatusId"] !== undefined ? _data["componentStatusId"] : null;
            this.componentStatusName = _data["componentStatusName"] !== undefined ? _data["componentStatusName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentStatusModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["componentStatusId"] = this.componentStatusId !== undefined ? this.componentStatusId : null;
        data["componentStatusName"] = this.componentStatusName !== undefined ? this.componentStatusName : null;
        return data;
    }
}
export class PaginatedEnumerableOfComponentStatusModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(ComponentStatusModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfComponentStatusModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetComponentStatusListPaginatedQueryAndPaginatedEnumerableOfComponentStatusModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetComponentStatusListPaginatedQueryAndPaginatedEnumerableOfComponentStatusModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetComponentStatusListPaginatedQuery extends BaseQueryOfGetComponentStatusListPaginatedQueryAndPaginatedEnumerableOfComponentStatusModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetComponentStatusListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfComponentStatusModelAndInteger {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? ComponentStatusModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfComponentStatusModelAndInteger' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateComponentStatusCommand extends BaseCommandOfComponentStatusModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateComponentStatusCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateComponentStatusCommand extends BaseCommandOfComponentStatusModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateComponentStatusCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ContactGroupModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.contactGroupId = _data["contactGroupId"] !== undefined ? _data["contactGroupId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.description = _data["description"] !== undefined ? _data["description"] : null;
            if (Array.isArray(_data["persons"])) {
                this.persons = [];
                for (let item of _data["persons"])
                    this.persons.push(PersonModel.fromJS(item));
            }
            else {
                this.persons = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContactGroupModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["contactGroupId"] = this.contactGroupId !== undefined ? this.contactGroupId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["description"] = this.description !== undefined ? this.description : null;
        if (Array.isArray(this.persons)) {
            data["persons"] = [];
            for (let item of this.persons)
                data["persons"].push(item ? item.toJSON() : null);
        }
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetContactGroupListQueryAndIListOfContactGroupModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetContactGroupListQueryAndIListOfContactGroupModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetContactGroupListQuery extends BaseQueryOfGetContactGroupListQueryAndIListOfContactGroupModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactGroupListQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfContactGroupModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(ContactGroupModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfContactGroupModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetContactGroupListPaginatedQueryAndPaginatedEnumerableOfContactGroupModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetContactGroupListPaginatedQueryAndPaginatedEnumerableOfContactGroupModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetContactGroupListPaginatedQuery extends BaseQueryOfGetContactGroupListPaginatedQueryAndPaginatedEnumerableOfContactGroupModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactGroupListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfContactGroupModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? ContactGroupModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfContactGroupModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateContactGroupCommand extends BaseCommandOfContactGroupModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactGroupCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateContactGroupCommand extends BaseCommandOfContactGroupModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactGroupCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class LicenseDetailsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.activeLicense = _data["activeLicense"] ? LicenseInfoModel.fromJS(_data["activeLicense"]) : null;
            this.rejectedLicense = _data["rejectedLicense"] ? LicenseInfoModel.fromJS(_data["rejectedLicense"]) : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.statusMessage = _data["statusMessage"] !== undefined ? _data["statusMessage"] : null;
            this.isExpired = _data["isExpired"] !== undefined ? _data["isExpired"] : null;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : null;
            this.isPastGracePeriod = _data["isPastGracePeriod"] !== undefined ? _data["isPastGracePeriod"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseDetailsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["activeLicense"] = this.activeLicense ? this.activeLicense.toJSON() : null;
        data["rejectedLicense"] = this.rejectedLicense ? this.rejectedLicense.toJSON() : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["statusMessage"] = this.statusMessage !== undefined ? this.statusMessage : null;
        data["isExpired"] = this.isExpired !== undefined ? this.isExpired : null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : null;
        data["isPastGracePeriod"] = this.isPastGracePeriod !== undefined ? this.isPastGracePeriod : null;
        return data;
    }
}
export class LicenseInfoModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.licenseId = _data["licenseId"] !== undefined ? _data["licenseId"] : null;
            this.issuedFor = _data["issuedFor"] !== undefined ? _data["issuedFor"] : null;
            if (Array.isArray(_data["stringCounts"])) {
                this.stringCounts = [];
                for (let item of _data["stringCounts"])
                    this.stringCounts.push(MonitorBatteryTypeStringCountModel.fromJS(item));
            }
            else {
                this.stringCounts = null;
            }
            this.assureEdition = _data["assureEdition"] !== undefined ? _data["assureEdition"] : null;
            this.whenCreated = _data["whenCreated"] !== undefined ? _data["whenCreated"] : null;
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : null;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : null;
            this.gracePeriodSecs = _data["gracePeriodSecs"] !== undefined ? _data["gracePeriodSecs"] : null;
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseInfoModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId !== undefined ? this.licenseId : null;
        data["issuedFor"] = this.issuedFor !== undefined ? this.issuedFor : null;
        if (Array.isArray(this.stringCounts)) {
            data["stringCounts"] = [];
            for (let item of this.stringCounts)
                data["stringCounts"].push(item ? item.toJSON() : null);
        }
        data["assureEdition"] = this.assureEdition !== undefined ? this.assureEdition : null;
        data["whenCreated"] = this.whenCreated !== undefined ? this.whenCreated : null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : null;
        data["gracePeriodSecs"] = this.gracePeriodSecs !== undefined ? this.gracePeriodSecs : null;
        data["productCode"] = this.productCode !== undefined ? this.productCode : null;
        return data;
    }
}
export class MonitorBatteryTypeStringCountModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.monitorType = _data["monitorType"] !== undefined ? _data["monitorType"] : null;
            this.batteryType = _data["batteryType"] !== undefined ? _data["batteryType"] : null;
            this.stringCount = _data["stringCount"] !== undefined ? _data["stringCount"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MonitorBatteryTypeStringCountModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["monitorType"] = this.monitorType !== undefined ? this.monitorType : null;
        data["batteryType"] = this.batteryType !== undefined ? this.batteryType : null;
        data["stringCount"] = this.stringCount !== undefined ? this.stringCount : null;
        return data;
    }
}
export var MonitorTypeEnum;
(function (MonitorTypeEnum) {
    MonitorTypeEnum[MonitorTypeEnum["Sentinel"] = 1] = "Sentinel";
    MonitorTypeEnum[MonitorTypeEnum["Controller"] = 2] = "Controller";
    MonitorTypeEnum[MonitorTypeEnum["Cellwatch"] = 3] = "Cellwatch";
})(MonitorTypeEnum || (MonitorTypeEnum = {}));
export var AssureEditionEnum;
(function (AssureEditionEnum) {
    AssureEditionEnum[AssureEditionEnum["OnPremBasic"] = 0] = "OnPremBasic";
    AssureEditionEnum[AssureEditionEnum["OnPremStandard"] = 1] = "OnPremStandard";
    AssureEditionEnum[AssureEditionEnum["OnPremPremium"] = 2] = "OnPremPremium";
    AssureEditionEnum[AssureEditionEnum["PowershieldCloudStandard"] = 100] = "PowershieldCloudStandard";
    AssureEditionEnum[AssureEditionEnum["Unknown"] = -1] = "Unknown";
})(AssureEditionEnum || (AssureEditionEnum = {}));
export var LicenseStatus;
(function (LicenseStatus) {
    LicenseStatus[LicenseStatus["NotChecked"] = 0] = "NotChecked";
    LicenseStatus[LicenseStatus["Valid"] = 1] = "Valid";
    LicenseStatus[LicenseStatus["InGracePeriod"] = 2] = "InGracePeriod";
    LicenseStatus[LicenseStatus["FileNotFound"] = 3] = "FileNotFound";
    LicenseStatus[LicenseStatus["DecryptionFailed"] = 4] = "DecryptionFailed";
    LicenseStatus[LicenseStatus["TamperedOrInvalidSignature"] = 5] = "TamperedOrInvalidSignature";
    LicenseStatus[LicenseStatus["ExpiredPastGracePeriod"] = 6] = "ExpiredPastGracePeriod";
    LicenseStatus[LicenseStatus["NotYetValid"] = 7] = "NotYetValid";
    LicenseStatus[LicenseStatus["InvalidEdition"] = 8] = "InvalidEdition";
    LicenseStatus[LicenseStatus["WrongMachine"] = 9] = "WrongMachine";
    LicenseStatus[LicenseStatus["DefaultLicense"] = 10] = "DefaultLicense";
    LicenseStatus[LicenseStatus["ClockTampered"] = 11] = "ClockTampered";
})(LicenseStatus || (LicenseStatus = {}));
export class LicenseSummaryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.appEdition = _data["appEdition"] !== undefined ? _data["appEdition"] : null;
            this.hostingOption = _data["hostingOption"] !== undefined ? _data["hostingOption"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.statusDisplayLabel = _data["statusDisplayLabel"] !== undefined ? _data["statusDisplayLabel"] : null;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : null;
            this.isDefaultLicense = _data["isDefaultLicense"] !== undefined ? _data["isDefaultLicense"] : null;
            this.remainingDays = _data["remainingDays"] !== undefined ? _data["remainingDays"] : null;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : null;
            this.gracePeriodSecs = _data["gracePeriodSecs"] !== undefined ? _data["gracePeriodSecs"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseSummaryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["appEdition"] = this.appEdition !== undefined ? this.appEdition : null;
        data["hostingOption"] = this.hostingOption !== undefined ? this.hostingOption : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["statusDisplayLabel"] = this.statusDisplayLabel !== undefined ? this.statusDisplayLabel : null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : null;
        data["isDefaultLicense"] = this.isDefaultLicense !== undefined ? this.isDefaultLicense : null;
        data["remainingDays"] = this.remainingDays !== undefined ? this.remainingDays : null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : null;
        data["gracePeriodSecs"] = this.gracePeriodSecs !== undefined ? this.gracePeriodSecs : null;
        return data;
    }
}
export var HostingOptionEnum;
(function (HostingOptionEnum) {
    HostingOptionEnum[HostingOptionEnum["OnPrem"] = 0] = "OnPrem";
    HostingOptionEnum[HostingOptionEnum["PowershieldCloud"] = 1] = "PowershieldCloud";
    HostingOptionEnum[HostingOptionEnum["Unknown"] = -1] = "Unknown";
})(HostingOptionEnum || (HostingOptionEnum = {}));
export class FeatureConstraintsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["constrainedFeatures"])) {
                this.constrainedFeatures = [];
                for (let item of _data["constrainedFeatures"])
                    this.constrainedFeatures.push(item);
            }
            else {
                this.constrainedFeatures = null;
            }
            if (Array.isArray(_data["constrainedEditions"])) {
                this.constrainedEditions = [];
                for (let item of _data["constrainedEditions"])
                    this.constrainedEditions.push(item);
            }
            else {
                this.constrainedEditions = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureConstraintsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.constrainedFeatures)) {
            data["constrainedFeatures"] = [];
            for (let item of this.constrainedFeatures)
                data["constrainedFeatures"].push(item);
        }
        if (Array.isArray(this.constrainedEditions)) {
            data["constrainedEditions"] = [];
            for (let item of this.constrainedEditions)
                data["constrainedEditions"].push(item);
        }
        return data;
    }
}
export class SystemCoverageModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.totalSystemCount = _data["totalSystemCount"] !== undefined ? _data["totalSystemCount"] : null;
            this.licensedSystemCount = _data["licensedSystemCount"] !== undefined ? _data["licensedSystemCount"] : null;
            this.unlicensedSystemCount = _data["unlicensedSystemCount"] !== undefined ? _data["unlicensedSystemCount"] : null;
            if (Array.isArray(_data["systems"])) {
                this.systems = [];
                for (let item of _data["systems"])
                    this.systems.push(SystemCoverageInfo.fromJS(item));
            }
            else {
                this.systems = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemCoverageModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["totalSystemCount"] = this.totalSystemCount !== undefined ? this.totalSystemCount : null;
        data["licensedSystemCount"] = this.licensedSystemCount !== undefined ? this.licensedSystemCount : null;
        data["unlicensedSystemCount"] = this.unlicensedSystemCount !== undefined ? this.unlicensedSystemCount : null;
        if (Array.isArray(this.systems)) {
            data["systems"] = [];
            for (let item of this.systems)
                data["systems"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class SystemCoverageInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null;
            this.isLicensed = _data["isLicensed"] !== undefined ? _data["isLicensed"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemCoverageInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null;
        data["isLicensed"] = this.isLicensed !== undefined ? this.isLicensed : null;
        return data;
    }
}
export class DataGapModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.includesMeasurements = _data["includesMeasurements"] !== undefined ? _data["includesMeasurements"] : null;
            if (Array.isArray(_data["stringSnapshotGaps"])) {
                this.stringSnapshotGaps = [];
                for (let item of _data["stringSnapshotGaps"])
                    this.stringSnapshotGaps.push(SnapshotDataGapModel.fromJS(item));
            }
            else {
                this.stringSnapshotGaps = null;
            }
            if (Array.isArray(_data["blockSnapshotGaps"])) {
                this.blockSnapshotGaps = [];
                for (let item of _data["blockSnapshotGaps"])
                    this.blockSnapshotGaps.push(SnapshotDataGapModel.fromJS(item));
            }
            else {
                this.blockSnapshotGaps = null;
            }
            if (Array.isArray(_data["measurementGaps"])) {
                this.measurementGaps = [];
                for (let item of _data["measurementGaps"])
                    this.measurementGaps.push(MeasurementDataGapModel.fromJS(item));
            }
            else {
                this.measurementGaps = null;
            }
            this.hasGaps = _data["hasGaps"] !== undefined ? _data["hasGaps"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DataGapModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["includesMeasurements"] = this.includesMeasurements !== undefined ? this.includesMeasurements : null;
        if (Array.isArray(this.stringSnapshotGaps)) {
            data["stringSnapshotGaps"] = [];
            for (let item of this.stringSnapshotGaps)
                data["stringSnapshotGaps"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.blockSnapshotGaps)) {
            data["blockSnapshotGaps"] = [];
            for (let item of this.blockSnapshotGaps)
                data["blockSnapshotGaps"].push(item ? item.toJSON() : null);
        }
        if (Array.isArray(this.measurementGaps)) {
            data["measurementGaps"] = [];
            for (let item of this.measurementGaps)
                data["measurementGaps"].push(item ? item.toJSON() : null);
        }
        data["hasGaps"] = this.hasGaps !== undefined ? this.hasGaps : null;
        return data;
    }
}
export class SnapshotDataGapModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : null;
            this.componentName = _data["componentName"] !== undefined ? _data["componentName"] : null;
            this.gapStart = _data["gapStart"] ? new Date(_data["gapStart"].toString()) : null;
            this.gapEnd = _data["gapEnd"] ? new Date(_data["gapEnd"].toString()) : null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SnapshotDataGapModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["componentId"] = this.componentId !== undefined ? this.componentId : null;
        data["componentName"] = this.componentName !== undefined ? this.componentName : null;
        data["gapStart"] = this.gapStart ? this.gapStart.toISOString() : null;
        data["gapEnd"] = this.gapEnd ? this.gapEnd.toISOString() : null;
        data["reason"] = this.reason !== undefined ? this.reason : null;
        return data;
    }
}
export class MeasurementDataGapModel extends SnapshotDataGapModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.measurementTypeId = _data["measurementTypeId"] !== undefined ? _data["measurementTypeId"] : null;
            this.measurementName = _data["measurementName"] !== undefined ? _data["measurementName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementDataGapModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["measurementTypeId"] = this.measurementTypeId !== undefined ? this.measurementTypeId : null;
        data["measurementName"] = this.measurementName !== undefined ? this.measurementName : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetDataGapsQueryAndDataGapModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetDataGapsQueryAndDataGapModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetDataGapsQuery extends BaseQueryOfGetDataGapsQueryAndDataGapModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : null;
            this.includeMeasurements = _data["includeMeasurements"] !== undefined ? _data["includeMeasurements"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataGapsQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        data["includeMeasurements"] = this.includeMeasurements !== undefined ? this.includeMeasurements : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfDataGapSettingsModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? DataGapSettingsModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfDataGapSettingsModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpsertDataGapsSettingsCommand extends BaseCommandOfDataGapSettingsModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertDataGapsSettingsCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class DataGapSettingsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null;
            this.timeScheduled = _data["timeScheduled"] !== undefined ? _data["timeScheduled"] : null;
            this.emailAddresses = _data["emailAddresses"] !== undefined ? _data["emailAddresses"] : null;
            if (Array.isArray(_data["companyIdsToExclude"])) {
                this.companyIdsToExclude = [];
                for (let item of _data["companyIdsToExclude"])
                    this.companyIdsToExclude.push(item);
            }
            else {
                this.companyIdsToExclude = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DataGapSettingsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled !== undefined ? this.enabled : null;
        data["timeScheduled"] = this.timeScheduled !== undefined ? this.timeScheduled : null;
        data["emailAddresses"] = this.emailAddresses !== undefined ? this.emailAddresses : null;
        if (Array.isArray(this.companyIdsToExclude)) {
            data["companyIdsToExclude"] = [];
            for (let item of this.companyIdsToExclude)
                data["companyIdsToExclude"].push(item);
        }
        return data;
    }
}
export class PaginatedEnumerableOfMeasurementTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(MeasurementTypeModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfMeasurementTypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetMeasurementTypeListPaginatedQueryAndPaginatedEnumerableOfMeasurementTypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetMeasurementTypeListPaginatedQueryAndPaginatedEnumerableOfMeasurementTypeModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetMeasurementTypeListPaginatedQuery extends BaseQueryOfGetMeasurementTypeListPaginatedQueryAndPaginatedEnumerableOfMeasurementTypeModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasurementTypeListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfMeasurementTypeModelAndInteger {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? MeasurementTypeModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfMeasurementTypeModelAndInteger' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateMeasurementTypeCommand extends BaseCommandOfMeasurementTypeModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeasurementTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateMeasurementTypeCommand extends BaseCommandOfMeasurementTypeModelAndInteger {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeasurementTypeCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetPersonListQueryAndIListOfPersonModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetPersonListQueryAndIListOfPersonModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetPersonListQuery extends BaseQueryOfGetPersonListQueryAndIListOfPersonModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonListQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfPersonModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(PersonModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfPersonModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetPersonListPaginatedQueryAndPaginatedEnumerableOfPersonModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetPersonListPaginatedQueryAndPaginatedEnumerableOfPersonModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetPersonListPaginatedQuery extends BaseQueryOfGetPersonListPaginatedQueryAndPaginatedEnumerableOfPersonModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfPersonModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? PersonModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfPersonModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreatePersonCommand extends BaseCommandOfPersonModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdatePersonCommand extends BaseCommandOfPersonModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfRegistrationKeyModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(RegistrationKeyModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfRegistrationKeyModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetRegistrationKeyListPaginatedQueryAndPaginatedEnumerableOfRegistrationKeyModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetRegistrationKeyListPaginatedQueryAndPaginatedEnumerableOfRegistrationKeyModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetRegistrationKeyListPaginatedQuery extends BaseQueryOfGetRegistrationKeyListPaginatedQueryAndPaginatedEnumerableOfRegistrationKeyModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.availableOnly = _data["availableOnly"] !== undefined ? _data["availableOnly"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationKeyListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["availableOnly"] = this.availableOnly !== undefined ? this.availableOnly : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfRegistrationKeyModelAndGuid {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? RegistrationKeyModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfRegistrationKeyModelAndGuid' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateRegistrationKeyCommand extends BaseCommandOfRegistrationKeyModelAndGuid {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationKeyCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class RoleModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId !== undefined ? this.roleId : null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null;
        return data;
    }
}
export class PaginatedEnumerableOfRoleModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(RoleModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfRoleModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetRoleListPaginatedQueryAndPaginatedEnumerableOfRoleModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetRoleListPaginatedQueryAndPaginatedEnumerableOfRoleModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetRoleListPaginatedQuery extends BaseQueryOfGetRoleListPaginatedQueryAndPaginatedEnumerableOfRoleModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class SystemCategoryModel extends BaseModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SystemCategoryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetSystemCategoryListQueryAndIListOfSystemCategoryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemCategoryListQueryAndIListOfSystemCategoryModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemCategoryListQuery extends BaseQueryOfGetSystemCategoryListQueryAndIListOfSystemCategoryModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemCategoryListQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfSystemCategoryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(SystemCategoryModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfSystemCategoryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetSystemCategoryListPaginatedQueryAndPaginatedEnumerableOfSystemCategoryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemCategoryListPaginatedQueryAndPaginatedEnumerableOfSystemCategoryModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemCategoryListPaginatedQuery extends BaseQueryOfGetSystemCategoryListPaginatedQueryAndPaginatedEnumerableOfSystemCategoryModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemCategoryListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfSystemCategoryModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? SystemCategoryModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfSystemCategoryModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateSystemCategoryCommand extends BaseCommandOfSystemCategoryModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSystemCategoryCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateSystemCategoryCommand extends BaseCommandOfSystemCategoryModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSystemCategoryCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfSystemAccessQueryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(SystemAccessQueryModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfSystemAccessQueryModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetSystemAccessViewPaginatedQueryAndPaginatedEnumerableOfSystemAccessQueryModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetSystemAccessViewPaginatedQueryAndPaginatedEnumerableOfSystemAccessQueryModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetSystemAccessViewPaginatedQuery extends BaseQueryOfGetSystemAccessViewPaginatedQueryAndPaginatedEnumerableOfSystemAccessQueryModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.authorizationStatus = _data["authorizationStatus"] !== undefined ? _data["authorizationStatus"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemAccessViewPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["authorizationStatus"] = this.authorizationStatus !== undefined ? this.authorizationStatus : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export var SystemAuthorizationStatusEnum;
(function (SystemAuthorizationStatusEnum) {
    SystemAuthorizationStatusEnum[SystemAuthorizationStatusEnum["All"] = 0] = "All";
    SystemAuthorizationStatusEnum[SystemAuthorizationStatusEnum["Authorized"] = 1] = "Authorized";
    SystemAuthorizationStatusEnum[SystemAuthorizationStatusEnum["Unauthorized"] = 2] = "Unauthorized";
})(SystemAuthorizationStatusEnum || (SystemAuthorizationStatusEnum = {}));
export class BaseCommandOfUserSystemAccessModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? UserSystemAccessModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfUserSystemAccessModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateUserSystemAccessCommand extends BaseCommandOfUserSystemAccessModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserSystemAccessCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UserSystemAccessModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.systemId = _data["systemId"] !== undefined ? _data["systemId"] : null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null;
            this.systemName = _data["systemName"] !== undefined ? _data["systemName"] : null;
            this.filterQuery = _data["filterQuery"] ? GetSystemAccessViewPaginatedQuery.fromJS(_data["filterQuery"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserSystemAccessModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["systemId"] = this.systemId !== undefined ? this.systemId : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["systemName"] = this.systemName !== undefined ? this.systemName : null;
        data["filterQuery"] = this.filterQuery ? this.filterQuery.toJSON() : null;
        return data;
    }
}
export class DeleteUserSystemAccessCommand extends BaseCommandOfUserSystemAccessModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserSystemAccessCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UserGroupListItemModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userGroupId = _data["userGroupId"] !== undefined ? _data["userGroupId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.description = _data["description"] !== undefined ? _data["description"] : null;
            this.featureCount = _data["featureCount"] !== undefined ? _data["featureCount"] : null;
            this.memberCount = _data["memberCount"] !== undefined ? _data["memberCount"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupListItemModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userGroupId"] = this.userGroupId !== undefined ? this.userGroupId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["featureCount"] = this.featureCount !== undefined ? this.featureCount : null;
        data["memberCount"] = this.memberCount !== undefined ? this.memberCount : null;
        return data;
    }
}
export class UserGroupModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userGroupId = _data["userGroupId"] !== undefined ? _data["userGroupId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.description = _data["description"] !== undefined ? _data["description"] : null;
            if (Array.isArray(_data["featureNames"])) {
                this.featureNames = [];
                for (let item of _data["featureNames"])
                    this.featureNames.push(item);
            }
            else {
                this.featureNames = null;
            }
            if (Array.isArray(_data["members"])) {
                this.members = [];
                for (let item of _data["members"])
                    this.members.push(UserGroupMemberModel.fromJS(item));
            }
            else {
                this.members = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userGroupId"] = this.userGroupId !== undefined ? this.userGroupId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["description"] = this.description !== undefined ? this.description : null;
        if (Array.isArray(this.featureNames)) {
            data["featureNames"] = [];
            for (let item of this.featureNames)
                data["featureNames"].push(item);
        }
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class UserGroupMemberModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null;
            if (Array.isArray(_data["companyNames"])) {
                this.companyNames = [];
                for (let item of _data["companyNames"])
                    this.companyNames.push(item);
            }
            else {
                this.companyNames = null;
            }
            this.allCompanies = _data["allCompanies"] !== undefined ? _data["allCompanies"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupMemberModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null;
        if (Array.isArray(this.companyNames)) {
            data["companyNames"] = [];
            for (let item of this.companyNames)
                data["companyNames"].push(item);
        }
        data["allCompanies"] = this.allCompanies !== undefined ? this.allCompanies : null;
        return data;
    }
}
export class GroupControlledFeatureModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GroupControlledFeatureModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null;
        return data;
    }
}
export class UserGroupEditModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userGroupId = _data["userGroupId"] !== undefined ? _data["userGroupId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.description = _data["description"] !== undefined ? _data["description"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupEditModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userGroupId"] = this.userGroupId !== undefined ? this.userGroupId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["description"] = this.description !== undefined ? this.description : null;
        return data;
    }
}
export class UserGroupFeaturesModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userGroupId = _data["userGroupId"] !== undefined ? _data["userGroupId"] : null;
            if (Array.isArray(_data["featureNames"])) {
                this.featureNames = [];
                for (let item of _data["featureNames"])
                    this.featureNames.push(item);
            }
            else {
                this.featureNames = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupFeaturesModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userGroupId"] = this.userGroupId !== undefined ? this.userGroupId : null;
        if (Array.isArray(this.featureNames)) {
            data["featureNames"] = [];
            for (let item of this.featureNames)
                data["featureNames"].push(item);
        }
        return data;
    }
}
export class UserGroupMemberChangeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userGroupId = _data["userGroupId"] !== undefined ? _data["userGroupId"] : null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupMemberChangeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userGroupId"] = this.userGroupId !== undefined ? this.userGroupId : null;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        return data;
    }
}
export class BaseQueryOfGetUserListQueryAndIListOfUserModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetUserListQueryAndIListOfUserModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetUserListQuery extends BaseQueryOfGetUserListQueryAndIListOfUserModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [];
                for (let item of _data["roleIds"])
                    this.roleIds.push(item);
            }
            else {
                this.roleIds = null;
            }
            this.sortByName = _data["sortByName"] !== undefined ? _data["sortByName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserListQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["sortByName"] = this.sortByName !== undefined ? this.sortByName : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfUserModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(UserModel.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfUserModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class BaseQueryOfGetUserListPaginatedQueryAndPaginatedEnumerableOfUserModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetUserListPaginatedQueryAndPaginatedEnumerableOfUserModel' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetUserListPaginatedQuery extends BaseQueryOfGetUserListPaginatedQueryAndPaginatedEnumerableOfUserModel {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserListPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class PaginatedEnumerableOfUserQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayedPage = _data["displayedPage"] !== undefined ? _data["displayedPage"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (let item of _data["records"])
                    this.records.push(UserQuery.fromJS(item));
            }
            else {
                this.records = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedEnumerableOfUserQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayedPage"] = this.displayedPage !== undefined ? this.displayedPage : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class UserQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.companies = _data["companies"] !== undefined ? _data["companies"] : null;
            this.sites = _data["sites"] !== undefined ? _data["sites"] : null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : null;
            this.mobilePhone = _data["mobilePhone"] !== undefined ? _data["mobilePhone"] : null;
            this.position = _data["position"] !== undefined ? _data["position"] : null;
            this.imperialMeasurementSystem = _data["imperialMeasurementSystem"] !== undefined ? _data["imperialMeasurementSystem"] : null;
            this.whenCreated = _data["whenCreated"] ? new Date(_data["whenCreated"].toString()) : null;
            this.whenLastLoggedIn = _data["whenLastLoggedIn"] ? new Date(_data["whenLastLoggedIn"].toString()) : null;
            this.whenLastSeen = _data["whenLastSeen"] ? new Date(_data["whenLastSeen"].toString()) : null;
            this.whenDeleted = _data["whenDeleted"] ? new Date(_data["whenDeleted"].toString()) : null;
            this.whenLockoutEnds = _data["whenLockoutEnds"] ? new Date(_data["whenLockoutEnds"].toString()) : null;
            this.whenLockout = _data["whenLockout"] ? new Date(_data["whenLockout"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["personId"] = this.personId !== undefined ? this.personId : null;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["companies"] = this.companies !== undefined ? this.companies : null;
        data["sites"] = this.sites !== undefined ? this.sites : null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : null;
        data["mobilePhone"] = this.mobilePhone !== undefined ? this.mobilePhone : null;
        data["position"] = this.position !== undefined ? this.position : null;
        data["imperialMeasurementSystem"] = this.imperialMeasurementSystem !== undefined ? this.imperialMeasurementSystem : null;
        data["whenCreated"] = this.whenCreated ? this.whenCreated.toISOString() : null;
        data["whenLastLoggedIn"] = this.whenLastLoggedIn ? this.whenLastLoggedIn.toISOString() : null;
        data["whenLastSeen"] = this.whenLastSeen ? this.whenLastSeen.toISOString() : null;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : null;
        data["whenLockoutEnds"] = this.whenLockoutEnds ? this.whenLockoutEnds.toISOString() : null;
        data["whenLockout"] = this.whenLockout ? this.whenLockout.toISOString() : null;
        return data;
    }
}
export class BaseQueryOfGetUserViewPaginatedQueryAndPaginatedEnumerableOfUserQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetUserViewPaginatedQueryAndPaginatedEnumerableOfUserQuery' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetUserViewPaginatedQuery extends BaseQueryOfGetUserViewPaginatedQueryAndPaginatedEnumerableOfUserQuery {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null;
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : null;
            this.pageNo = _data["pageNo"] !== undefined ? _data["pageNo"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.sort = _data["sort"] ? SortDescription.fromJS(_data["sort"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserViewPaginatedQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["companyId"] = this.companyId !== undefined ? this.companyId : null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null;
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : null;
        data["pageNo"] = this.pageNo !== undefined ? this.pageNo : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["sort"] = this.sort ? this.sort.toJSON() : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfCreateUserModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? CreateUserModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfCreateUserModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateUserCommand extends BaseCommandOfCreateUserModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class CreateUserModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userModel = _data["userModel"] ? UserModel.fromJS(_data["userModel"]) : null;
            this.userPasswordModel = _data["userPasswordModel"] ? UserPasswordModel.fromJS(_data["userPasswordModel"]) : null;
            this.authorizedCompanyId = _data["authorizedCompanyId"] !== undefined ? _data["authorizedCompanyId"] : null;
            this.generateRandomPassword = _data["generateRandomPassword"] !== undefined ? _data["generateRandomPassword"] : null;
            this.sendAccountInvitation = _data["sendAccountInvitation"] !== undefined ? _data["sendAccountInvitation"] : null;
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userModel"] = this.userModel ? this.userModel.toJSON() : null;
        data["userPasswordModel"] = this.userPasswordModel ? this.userPasswordModel.toJSON() : null;
        data["authorizedCompanyId"] = this.authorizedCompanyId !== undefined ? this.authorizedCompanyId : null;
        data["generateRandomPassword"] = this.generateRandomPassword !== undefined ? this.generateRandomPassword : null;
        data["sendAccountInvitation"] = this.sendAccountInvitation !== undefined ? this.sendAccountInvitation : null;
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        return data;
    }
}
export class UserPasswordModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.password = _data["password"] !== undefined ? _data["password"] : null;
            this.passwordConfirmation = _data["passwordConfirmation"] !== undefined ? _data["passwordConfirmation"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["password"] = this.password !== undefined ? this.password : null;
        data["passwordConfirmation"] = this.passwordConfirmation !== undefined ? this.passwordConfirmation : null;
        return data;
    }
}
export class BaseCommandOfUserModelAndLong {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? UserModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfUserModelAndLong' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class UpdateUserCommand extends BaseCommandOfUserModelAndLong {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfUserPasswordModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? UserPasswordModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfUserPasswordModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class CreateUserPasswordCommand extends BaseCommandOfUserPasswordModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserPasswordCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BaseQueryOfGetUsersContactsCSVReportQueryAndUsersContactsCSVReport {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseQueryOfGetUsersContactsCSVReportQueryAndUsersContactsCSVReport' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetUsersContactsCSVReportQuery extends BaseQueryOfGetUsersContactsCSVReportQueryAndUsersContactsCSVReport {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.timezoneOffset = _data["timezoneOffset"] !== undefined ? _data["timezoneOffset"] : null;
            this.exportUsers = _data["exportUsers"] !== undefined ? _data["exportUsers"] : null;
            this.exportContacts = _data["exportContacts"] !== undefined ? _data["exportContacts"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersContactsCSVReportQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["timezoneOffset"] = this.timezoneOffset !== undefined ? this.timezoneOffset : null;
        data["exportUsers"] = this.exportUsers !== undefined ? this.exportUsers : null;
        data["exportContacts"] = this.exportContacts !== undefined ? this.exportContacts : null;
        super.toJSON(data);
        return data;
    }
}
export class BaseCommandOfLockUnlockUsersModelAndBoolean {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestModel = _data["requestModel"] ? LockUnlockUsersModel.fromJS(_data["requestModel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCommandOfLockUnlockUsersModelAndBoolean' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestModel"] = this.requestModel ? this.requestModel.toJSON() : null;
        return data;
    }
}
export class LockUnlockUsersCommand extends BaseCommandOfLockUnlockUsersModelAndBoolean {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LockUnlockUsersCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class LockUnlockUsersModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null;
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [];
                for (let item of _data["userIds"])
                    this.userIds.push(item);
            }
            else {
                this.userIds = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LockUnlockUsersModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}
export var LockUnlockActionEnum;
(function (LockUnlockActionEnum) {
    LockUnlockActionEnum[LockUnlockActionEnum["Lock"] = 0] = "Lock";
    LockUnlockActionEnum[LockUnlockActionEnum["Unlock"] = 1] = "Unlock";
})(LockUnlockActionEnum || (LockUnlockActionEnum = {}));
export class SwaggerException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isSwaggerException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isSwaggerException(obj) {
        return obj.isSwaggerException === true;
    }
}
function throwException(message, status, response, headers, result) {
    throw new SwaggerException(message, status, response, headers, result);
}
